<template>
    <div>
        <!-- <div class="collect-btn">
            <el-button type="primary" @click="allNoCheck">取消全选</el-button>
            <el-button type="primary" style="background-color: #ff861a;border: 1px solid white;" @click="deleteSchool">删除</el-button>
            <el-button type="danger" style="background-color: #de3b21c9;border: 1px solid white;" @click="openYxzyz">已保存的院校专业组</el-button>
            <el-button type="primary" style="background-color: #ff861a;border: 1px solid white;" @click="moveFirst"><i class="el-icon-d-arrow-left" style="color:blue"></i> 移 动 到 第 一 行 </el-button>
            <el-button type="primary" style="background-color: #ff861a;border: 1px solid white;" @click="movePrev"><i class="el-icon-arrow-left" style="color:blue"></i> 前 移 一 行 </el-button>
        </div>
        <div class="collect-btn">
            <el-button type="primary" style="width:97px;" @click="allCheck">  全  选  </el-button>
            <el-button type="primary" style="background-color: #ff861a;border: 1px solid white;" @click="saveYxzyz">保存</el-button>
            <el-button type="primary" style="background-color: #ff861a;border: 1px solid white;" @click="ascTableData">升序</el-button>
            <el-button type="primary" style="background-color: #ff861a;border: 1px solid white;margin-left:26px;" @click="descTableData">  降  序  </el-button>
            <el-button type="primary" style="background-color: #ff861a;border: 1px solid white;" @click="moveEnd"><i class="el-icon-d-arrow-right" style="color:blue"></i> 移 动到最后一行</el-button>
            <el-button type="primary" style="background-color: #ff861a;border: 1px solid white;" @click="moveNext"><i class="el-icon-arrow-right" style="color:blue"></i> 后 移 一 行 </el-button>
        </div> -->
        <div v-show="false">
            <div style="float:left">
            <!-- <el-button type="primary" @click="allNoCheck">取消全选</el-button>
            <el-button type="primary" style="background-color: #ff861a;border: 1px solid white;" @click="deleteSchool">删除</el-button> -->
            </div>
            <div style="float:right">
            <!-- <el-button type="primary" style="background-color: #ff861a;border: 1px solid white;" @click="moveFirst"><i class="el-icon-d-arrow-left" style="color:blue"></i> 移 动 到 第 一 行 </el-button> -->
            <!-- <el-button type="primary" style="background-color: #ff861a;border: 1px solid white;" @click="movePrev"><i class="el-icon-arrow-left" style="color:blue"></i> 前 移 一 行 </el-button> -->
            </div>
        </div>
        <div style="clear:both;"></div>
            <div class="info">
                <div>
                <div class="inputlist">
                    <div class="input-div">
                        考生名：
                    <input class="myinput" v-model="inputObj.xm" disabled/>
                    </div>
                </div>
                <div class="inputlist" style="margin-left:53px;">
                    <div class="input-div">
                        手机号码：
                    <input class="myinput" disabled v-if="userInfo.sjhm" v-model="userInfo.sjhm"/>
                    <input class="myinput" disabled v-else/>
                    </div>
                </div>
                <div class="inputlist" style="margin-left:63px;">
                    <div class="input-div">
                        就读中学：
                    <input class="myinput" style="width:180px;" v-model="inputObj.school"/>
                    </div>
                </div>
                <div v-if="userInfo.yhlb===7||userInfo.yhlb===9" class="inputlist" style="float:right;">
                    备注&nbsp;：&nbsp;
                    <textarea id="dt_bz" rows="4" cols="38"
                    style="resize:none;float:none;border: 1px solid #c2c2c2;height:100px;"
                    v-model="inputObj.bz"></textarea>
                </div>
                <div v-if="userInfo.yhlb===2||userInfo.yhlb===4" class="inputlist" style="float: right;">
                    <img src="../../../assets/images/fontImage/长方形2.jpg" style="width:330px;height:110px;"/>
                </div>
                </div>
                <div>
                    <div class="inputlist">
                        <div class="input-div">
                            高考总分：
                            <input style="width:26px;" class="myinput" disabled v-if="userInfo.gkfs" v-model="userInfo.gkfs"/>
                            <input style="width:26px;" class="myinput" disabled v-else/>
                        </div>
                    </div>
                    <div class="inputlist" style="margin-left:15px;">
                        <div class="input-div">
                            语文：
                        <input style="width:26px;" class="myinput" disabled v-if="userInfo.ywcj" v-model="userInfo.ywcj"/>
                        <input style="width:26px;" class="myinput" disabled v-else/>
                        </div>
                    </div>
                    <div class="inputlist" style="margin-left:15px;">
                        <div class="input-div">
                            数学：
                        <input style="width:26px;" class="myinput" disabled v-if="userInfo.sxcj" v-model="userInfo.sxcj"/>
                        <input style="width:26px;" class="myinput" disabled v-else/>
                        </div>
                    </div>
                    <div class="inputlist" style="margin-left:15px;">
                        <div class="input-div">
                            英语：
                            <input style="width:26px;" class="myinput" disabled v-if="userInfo.wycj" v-model="userInfo.wycj"/>
                            <input style="width:26px;" class="myinput" disabled v-else/>
                        </div>
                    </div>
                    <div class="inputlist" style="margin-left:15px;">
                        <div class="input-div">
                        <span v-if="userInfo.sxkm===2">物理：</span>
                        <span v-if="userInfo.sxkm===1">历史：</span>
                        <input style="width:26px;" class="myinput" disabled v-if="userInfo.sxkmcj" v-model="userInfo.sxkmcj"/>
                        <input style="width:26px;" class="myinput" disabled v-else/>
                        </div>
                    </div>
                    <div class="inputlist" style="margin-left:15px;">
                        <div class="input-div">
                            <span v-if="userInfo.zxkma===1">政治：</span>
                            <span v-if="userInfo.zxkma===2">地理：</span>
                            <span v-if="userInfo.zxkma===3">化学：</span>
                            <span v-if="userInfo.zxkma===4">生物：</span>
                            <input style="width:26px;" class="myinput" disabled v-if="userInfo.zxkmacj" v-model="userInfo.zxkmacj"/>
                            <input style="width:26px;" class="myinput" disabled v-else/>
                        </div>
                    </div>
                    <div class="inputlist" style="margin-left:20px;">
                        <div class="input-div">
                            <span v-if="userInfo.zxkmb===1">政治：</span>
                            <span v-if="userInfo.zxkmb===2">地理：</span>
                            <span v-if="userInfo.zxkmb===3">化学：</span>
                            <span v-if="userInfo.zxkmb===4">生物：</span>
                            <input style="width:26px;" class="myinput" disabled v-if="userInfo.zxkmbcj" v-model="userInfo.zxkmbcj"/>
                            <input style="width:26px;" class="myinput" disabled v-else/>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="inputlist">
                        <div class="input-div">
                            <span>省份：</span>
                            <span v-if="userInfo.sssf===43">湖南省</span>
                            <span v-if="userInfo.sssf===44">广东省</span>
                            <span v-if="userInfo.sssf===51">四川省</span>
                        </div>
                    </div>
                    <div class="inputlist" style="margin-left:32px;">
                        <div class="input-div">
                            性别：
                            <select class="myinput" style="width:50px;" disabled v-model="userInfo.xb">
                                <option v-for="(item,index) in xbs" :key="index"
                                :value="item.value">{{item.name}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="inputlist" style="margin-left:17px;">
                        <div class="input-div">
                            是否有加分：
                            <input class="myinput" style="width:50px;" disabled v-if="userInfo.yfjf>=0" v-model="userInfo.yfjf"/>
                            <input class="myinput" style="width:50px;" disabled v-else/>
                        </div>
                    </div>
                    <div class="inputlist" style="margin-left:17px;">
                        <div class="input-div">
                            是否有相关资格：
                        <input type="checkbox" checked disabled v-if="userInfo.gjzxzg===1"/><span v-if="userInfo.gjzxzg===1" style="margin-right:5px;">国家专项</span>
                        <input type="checkbox"  disabled v-if="userInfo.gjzxzg===0"/><span v-if="userInfo.gjzxzg===0" style="margin-right:5px;">国家专项</span>
                        <input type="checkbox" checked disabled v-if="userInfo.dfzxzg===1"/><span v-if="userInfo.dfzxzg===1" style="margin-right:5px;">地方专项</span>
                        <input type="checkbox"  disabled v-if="userInfo.dfzxzg===0"/><span v-if="userInfo.dfzxzg===0" style="margin-right:5px;">地方专项</span>
                        <input type="checkbox" checked disabled v-if="userInfo.gxzx===1"/><span v-if="userInfo.gxzx===1">高校专项</span>
                        <input type="checkbox"  disabled v-if="userInfo.gxzx===0"/><span v-if="userInfo.gxzx===0">高校专项</span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- margin-left:26px; -->
        <div class="float-btn">
            <div style="float:left;">
            <!-- <el-button type="danger" style="background-color: #de3b21c9;border: 1px solid white;" @click="openYxzyz">已保存的志愿方案</el-button> -->
            <el-button type="danger" style="background-color: #de3b21c9;border: 1px solid white;" @click="openYxzyz">已保存的志愿方案</el-button>
            <el-button type="primary" style="width:97px;" @click="allCheck">  全  选  </el-button>
            <el-button type="primary" @click="allNoCheck">取消全选</el-button>
            <el-button type="primary" style="background-color: #ff861a;border: 1px solid white;" @click="saveYxzyz">保存</el-button>
            <el-button type="primary" style="background-color: #ff861a;border: 1px solid white;" @click="deleteSchool">删除</el-button>
            <el-button type="primary" style="background-color: #ff861a;border: 1px solid white;" @click="ascTableData">升序</el-button>
            <el-button type="primary" style="background-color: #ff861a;border: 1px solid white;" @click="descTableData">  降  序  </el-button>
            </div>
            <div style="float:right;">
            <el-button type="primary" style="background-color: #ff861a;border: 1px solid white;" @click="moveEnd"><i class="el-icon-d-arrow-right" style="color:blue"></i> 移 动到最后一行</el-button>
            <!-- <el-button type="primary" style="background-color: #ff861a;border: 1px solid white;" @click="moveNext"><i class="el-icon-arrow-right" style="color:blue"></i> 后 移 一 行 </el-button> -->
            </div>
        </div>
        <div style="clear: both;"></div>
        <div class="collect-title" style="border-top:1px solid #1f4778;
        border-bottom:1px solid #1f4778;margin: 20px 0;padding: 10px 0;width: 1200px;justify-content: space-between;">
            <div style="width:400px;margin-left: 20px;">文件名：<span>{{planObj.plan}}</span></div>
            <div style="width:200px;">时间：<span>{{planObj.time}}</span></div>
        </div>
        <div style="clear:both;margin-bottom:10px;"></div>
        <el-dialog title="已保存的志愿方案列表" :visible.sync="dialogTableVisible">
            <div style="margin-bottom: 20px;">
                <el-button type="primary" @click="allDialogChecked">全选</el-button>
                <el-button type="primary" @click="allDialogNoChecked">取消全选</el-button>
                <el-button type="primary" @click="deleteDialogChecked">删除</el-button>
            </div>
        <el-table :data="yxzyzList" border
                :header-cell-style="{'background-color':'#5287c6','border': '1px solid #1f4778'
                ,'color': '#FFF','text-align':'center'}"
                :cell-style="{'border': '1px solid #1f4778','text-align':'center'}" size="small">
                <el-table-column show-overflow-tooltip prop="checked" width="60" label="选择">
                    <template slot-scope="scope">
                        <el-checkbox v-model="scope.row.checked" @change="planCheckChange"></el-checkbox>
                    </template>
                </el-table-column>
            <el-table-column show-overflow-tooltip type="index" :resizable="false" label="序号"></el-table-column>
            <el-table-column show-overflow-tooltip property="plan" label="方案名称" :resizable="false"></el-table-column>
            <!-- <el-table-column show-overflow-tooltip property="date" label="保存时间" :resizable="false"></el-table-column> -->
            <el-table-column show-overflow-tooltip property="updatetime" label="保存时间" :resizable="false"></el-table-column>
            <el-table-column show-overflow-tooltip  label="操作" :resizable="false">
                <template slot-scope="scope">
                    <el-button type="text" @click="watchYxzyz(scope.row.id,scope.row.pc,scope.row.plan)">修改</el-button>
                    <el-button type="text" @click="deleteCode(scope.row.id)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        </el-dialog>
        <el-dialog title="请选择要替换的方案" :visible.sync="dialogPlanVisible" width="25%">
            <div class="dialog-div" style="margin-bottom:20px;">
                <el-select v-model="selectedYxzyz" :filterable="true">
                <el-option v-for="(item,index) in yxzyzList"
                :key="index" :label="item.plan" :value="item.id"></el-option>
            </el-select>
            </div>
            <div class="dialog-div">
            <el-button type="primary" @click="savePlan">确定</el-button>
            <el-button @click="openOther">另存为</el-button>
            </div>
        </el-dialog>
        <el-dialog title="请输入名字" :visible.sync="dialogOtherVisible" width="25%">
        <div class="dialog-div" style="margin-bottom:20px;">
            <el-input v-model="otherPlan" style="width:200px;"></el-input>
        </div>
        <div class="dialog-div">
            <el-button type="primary" @click="saveOtherCode2">确定</el-button>
            <el-button @click="closeOther">取消</el-button>
        </div>
        </el-dialog>
        <el-dialog :visible.sync="dialogProVisble" width="20%" title="提示">
                <div>方案正在提交，请耐心等待</div>
        </el-dialog>
        <el-dialog
            title="请输入评估的方案名"
            width="20%"
            :visible.sync="dialogPgPlanZyVisible"  :destroy-on-close="true" center>
            <el-input v-model="pgPlan" style="width:95%;"></el-input>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="runZypg">确定</el-button>
                <el-button @click="closePgPlan">取消</el-button>
            </div>
        </el-dialog>
        <div>
        <div id="out-load-tab">
            <el-tabs v-model="activePcName" type="card"  @tab-click="handleClick">
            <el-tab-pane label="本科批" name="6">
                        <!-- <el-checkbox v-model="scope.row.checked" @change="bkCheckChange($event,scope.row)"></el-checkbox> -->
                <!-- <el-table-column show-overflow-tooltip type="index" label="序号" width="40"></el-table-column> -->
            <div id="bk-data">
                <el-table border :data="bkCollectYx" max-height="600" ref="bkTab"
                highlight-current-row @current-change="handleTabCurrentChange"
                :header-cell-style="{'background-color':'#5287c6','border': '1px solid #1f4778',
                'color': '#FFF','text-align':'center','font-size':'14px'}"
                :cell-style="{'border': '1px solid #1f4778','text-align':'center'}" size="small">
                <el-table-column show-overflow-tooltip label="选择" width="62" prop="checked">
                    <template slot-scope="scope">
                            <el-tag type="info" @click="tableCheckChange($event,scope.row)"
                                    v-if="!scope.row.checked" style="cursor: pointer;">
                                    {{ scope.row.index }}</el-tag>
                            <el-tag @click="tableCheckChange($event,scope.row)"
                                    v-if="scope.row.checked" style="cursor: pointer;border:2px solid black;">
                                    {{ scope.row.index }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="院校代码" width="60" prop="sb">
                    <template slot-scope="scope">
                        <div v-if="scope.row.yxmc">
                            <a-popover 
                                placement="bottomLeft"
                                trigger="click"
                                :visible="scope.row.inputSbVisible"
                                @visibleChange="clickShowInputSbPopover($event,scope.row)">
                            <div style="display: flex;align-items: center;" slot="content">
                                <el-input style="width: 80px;" type="number"
                                v-model="scope.row.writeSb" size="mini"
                                @input="changeTabSb($event,scope.row)"
                                @change="setSbNoSave($event,scope.row)"></el-input>
                                <div>
                                    <el-button type="primary" size="small"
                                    style="margin-left: 6px;" @click="submitUpdateSb(scope.row)">确定</el-button>
                                </div>
                            </div>
                                <el-button type="primary" size="mini"
                                     style="width: 40px;display: flex;justify-content: center;
                                     text-overflow:ellipsis;overflow: hidden;white-space: nowrap;"
                                    >
                                    {{ scope.row.submitSb?scope.row.submitSb+'(未保存)'
                                    :scope.row.submitSb||scope.row.sb }}
                                </el-button>
                            </a-popover>
                        </div>
                        <!-- <div v-else>
                            <a-popover 
                                placement="bottomLeft"
                                trigger="click"
                                :visible="scope.row.inputSbVisible"
                                @visibleChange="clickShowInputSbPopover($event,scope.row)">
                            <div style="display: flex;align-items: center;" slot="content">
                                <el-input style="width: 80px;" type="number"
                                v-model="scope.row.writeSb" size="mini"
                                @input="changeTabSb($event,scope.row)"
                                @change="setSbNoSave($event,scope.row)"></el-input>
                                <div>
                                <el-button type="primary" size="small" style="margin-left: 6px;" @click="submitUpdateSb(scope.row)">确认</el-button>
                                </div>
                            </div>
                                <el-button type="primary" size="mini"
                                     style="width: 40px;display: flex;justify-content: center;
                                     text-overflow:ellipsis;overflow: hidden;white-space: nowrap;"
                                    >
                                    {{ scope.row.submitSb?scope.row.submitSb+'(未保存)'
                                    :scope.row.submitSb||scope.row.sb||'添加' }}
                                </el-button>
                            </a-popover>
                        </div> -->
                        <div v-else></div>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="院校名称" width="120" prop="yxmc"
                >
                    <template slot-scope="scope">
                        <!-- <router-link
                        tag="a"
                        target="_blank"
                        :to="{
                            path: '/main/schoolDetail',
                            query: { gbdm: scope.row.gbdm,pc:scope.row.pc,yxmc:scope.row.yxmc,yxxh:scope.row.yxxh }
                        }"
                        v-if="scope.row.yxmc"
                        >{{scope.row.yxmc}}</router-link> -->
                        <div v-if="scope.row.yxmc">
                            <el-popover 
                                placement="bottom-start"
                                trigger="click"
                                v-model="scope.row.chooseYxxhVisible"
                                :tabindex="scope.row.index+Math.random()*10"
                                >
                            <div style="display: flex;align-items: center;">
                                <el-select v-model="scope.row.selectedYxxh" style="width: 100px;" size="mini"
                                @change="changeSelectedYxxh($event,scope.row)" @click.capture="$event.stopPropagation();">
                                    <template v-if="scope.row.yxmcs.length>0">
                                        <el-option v-for="(item,index) in scope.row.yxmcs" :key="index"
                                        :label="item.yxmc" :value="item.yxxh" @click.capture="$event.stopPropagation();"></el-option>
                                    </template>
                                </el-select>
                                <el-tooltip placement="top">
                                    <div slot="content">{{scope.row.yxmc}}</div>
                                <div
                                    style="width: 60px;display: flex;justify-content: flex-start;
                                    text-overflow:ellipsis;overflow: hidden;white-space: nowrap;margin-left: 10px;">
                                    <router-link
                                    tag="a"
                                    target="_blank"
                                    :to="{
                                        path: '/main/schoolDetail',
                                        query: { gbdm: scope.row.gbdm,pc:scope.row.pc,yxmc:scope.row.yxmc,yxxh:scope.row.yxxh,
                                            type:scope.row.type
                                         }
                                    }"
                                     @click="$store.commit('initIsUpdateToken');"
                                    v-if="scope.row.yxmc"
                                    >院校详情</router-link>
                                </div>
                                </el-tooltip>
                                <el-button type="primary" size="small" style="margin-left: 6px;"
                                @click="submitUpdateYxxh(scope.row)">确认</el-button>
                            </div>
                                <div slot="reference">
                                    <el-button type="primary" size="small"
                                        style="width: 100px;display: flex;justify-content: center;
                                        text-overflow:ellipsis;overflow: hidden;white-space: nowrap;padding: 7px 0;"
                                        :ref="'editYxmc'+scope.row.index"
                                        @click="clickShowChooseYxxhPopover($event,scope.row)">
                                        {{ scope.row.submitYxmc?scope.row.submitYxmc+'(未保存)'
                                        :scope.row.submitYxmc||scope.row.yxmc }}
                                    </el-button>
                                </div>
                            </el-popover>
                        </div>
                        <!-- <div v-else>
                            <el-popover 
                                placement="bottom-start"
                                trigger="click"
                                v-model="scope.row.chooseYxxhVisible"
                                :tabindex="scope.row.index+Math.random()*10"
                                >
                            <div style="display: flex;align-items: center;">
                                <el-select v-model="scope.row.selectedYxxh" style="width: 100px;" size="mini"
                                @change="changeSelectedYxxh($event,scope.row)" @click.capture="$event.stopPropagation();">
                                    <template v-if="scope.row.yxmcs.length>0">
                                        <el-option v-for="(item,index) in scope.row.yxmcs" :key="index"
                                        :label="item.yxmc" :value="item.yxxh" @click.capture="$event.stopPropagation();"></el-option>
                                    </template>
                                </el-select>
                                <el-button type="primary" size="small" style="margin-left: 6px;"
                                @click="submitUpdateYxxh(scope.row)">确认</el-button>
                            </div>
                                <div slot="reference">
                                    <el-button type="primary" size="mini"
                                        style="width: 100px;display: flex;justify-content: center;
                                        text-overflow:ellipsis;overflow: hidden;white-space: nowrap;padding: 7px 0;"
                                        :ref="'editYxmc'+scope.row.index"
                                        @click="clickShowChooseYxxhPopover($event,scope.row)">
                                        {{ scope.row.submitYxmc?scope.row.submitYxmc+'(未保存)'
                                        :scope.row.submitYxmc||scope.row.yxmc||'空' }}
                                    </el-button>
                                </div>
                            </el-popover>
                        </div> -->
                        <div v-else></div>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="专业组" width="90" prop="zyz"
                :key="bkZyzUpdateKey">
                    <template slot-scope="scope">
                        <div v-if="scope.row.yxmc">
                            <el-popover 
                                placement="bottom-start"
                                trigger="click"
                                v-model="scope.row.chooseZyzVisible"
                                :tabindex="scope.row.index+Math.random()*10+new Date().getTime()"
                                >
                            <div style="display: flex;align-items: center;">
                                <el-select v-model="scope.row.selectedZyz"
                                style="width: 100px;" size="mini"
                                @change="changeSelectedZyz($event,scope.row)" @click.capture="$event.stopPropagation();"
                                >
                                    <template v-if="scope.row.zyzs.length>0">
                                        <el-option v-for="(item,index) in scope.row.zyzs" :key="index"
                                        :label="item.zyz" :value="item.zyz" @click.capture="$event.stopPropagation();"></el-option>
                                    </template>
                                </el-select>
                                <el-button type="primary" size="small" style="margin-left: 6px;"
                                @click="submitUpdateZyz(scope.row)">保存</el-button>
                            </div>
                                <div slot="reference">
                                    <el-button type="primary" size="mini"
                                        style="width: 70px;display: flex;justify-content: center;
                                        text-overflow:ellipsis;overflow: hidden;white-space: nowrap;"
                                         :ref="'editZyz'+scope.row.index"
                                        @click="clickShowChooseZyzPopover($event,scope.row)"
                                        >
                                        {{ scope.row.submitZyz?scope.row.submitZyz+'(未保存)'
                                        :scope.row.submitZyz||scope.row.zyz }}
                                    </el-button>
                                </div>
                            </el-popover>
                        </div>
                        <!-- <div v-else>
                            <el-popover 
                                placement="bottom-start"
                                trigger="click"
                                v-model="scope.row.chooseZyzVisible"
                                :tabindex="scope.row.index+Math.random()*10+new Date().getTime()"
                                >
                            <div style="display: flex;align-items: center;">
                                <el-select v-model="scope.row.selectedZyz"
                                style="width: 100px;" size="mini"
                                @change="changeSelectedZyz($event,scope.row)" @click.capture="$event.stopPropagation();">
                                    <template v-if="scope.row.zyzs.length>0">
                                        <el-option v-for="(item,index) in scope.row.zyzs" :key="index"
                                        :label="item.zyz" :value="item.zyz" @click.capture="$event.stopPropagation();"></el-option>
                                    </template>
                                </el-select>
                                <el-button type="primary" size="small" style="margin-left: 6px;"
                                @click="submitUpdateZyz(scope.row)">保存</el-button>
                            </div>
                                <div slot="reference">
                                    <el-button type="primary" size="mini"
                                        style="width: 70px;display: flex;justify-content: center;
                                        text-overflow:ellipsis;overflow: hidden;white-space: nowrap;"
                                        :ref="'editZyz'+scope.row.index"
                                        @click="clickShowChooseZyzPopover($event,scope.row)">
                                        {{ scope.row.submitZyz?scope.row.submitZyz+'(未保存)':
                                        scope.row.submitZyz||scope.row.zyz||'空' }}
                                    </el-button>
                                </div>
                            </el-popover>
                        </div> -->
                        <div v-else></div>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="开设专业" width="100">
                    <template slot-scope="scope">
                        <div v-if="scope.row.yxmc">
                            <el-button v-if="scope.row.chooseFlag"
                            type="primary" size="small"  style="background-color: #ff861a;border: 1px solid white;"
                            @click="chooseZy2(scope.row)">选择专业</el-button>
                            <el-button v-else type="primary" size="small" @click="chooseZy2(scope.row)">选择专业</el-button>
                        </div>
                        <div v-else></div>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="所在省市" width="60" prop="szdqmc"></el-table-column>
                <el-table-column show-overflow-tooltip label="985" width="50" prop="sf985">
                    <template slot-scope="scope">
                        <img v-if="scope.row.sf985===1"
                        src="../../../assets/images/gou.png" width="20" height="20"/>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="211" width="50" prop="sf211">
                    <template slot-scope="scope">
                        <img v-if="scope.row.sf211===1"
                        src="../../../assets/images/gou.png" width="20" height="20"/>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="招生计划">
                    <el-table-column show-overflow-tooltip label="上年" width="50" prop="snjhs"></el-table-column>
                    <el-table-column show-overflow-tooltip label="当年" width="50" prop="jnjhs"></el-table-column>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="入档位次" >
                    <el-table-column show-overflow-tooltip label="上年" width="50" prop="snrdwc"></el-table-column>
                    <el-table-column show-overflow-tooltip label="平均" width="50" prop="rdwc"></el-table-column>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="投档线">
                    <el-table-column show-overflow-tooltip label="上年" width="70" prop="tdx"></el-table-column>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="等效分">
                    <el-table-column show-overflow-tooltip label="最低" width="50" prop="zdtwf"></el-table-column>
                    <el-table-column show-overflow-tooltip label="平均" width="50" prop="pjtwf"></el-table-column>
                    <el-table-column show-overflow-tooltip label="最高" width="50" prop="zgtwf"></el-table-column>
                </el-table-column>
                <el-table-column width="114" label="操作">
                    <template slot-scope="scope">
                        <div v-if="scope.row.yxmc">
                            <div style="display: flex;justify-content: center;">
                            <el-button type="primary" size="small" @click="tableMovePrev(scope.row)">
                                <span class="el-icon-top"></span>
                            </el-button>
                            <el-button type="primary" size="small" @click="tableMoveNext(scope.row)" style="margin-left: 6px;">
                                <span class="el-icon-bottom"></span>
                            </el-button>
                            <!-- <a-popover 
                                placement="bottomLeft"
                                trigger="click"
                                :visible="scope.row.moveTrVisible"
                                @visibleChange="clickShowMoveWherePopover(scope.row)">
                            <div style="display: flex;align-items: center;" slot="content">
                                    将院校移动到
                                <el-input v-model="moveToTr" size="small" style="width: 60px;margin:0 6px;" @input="changeMoveToTr"></el-input>
                                                行
                                <el-button type="primary" size="small" style="margin-left: 6px;" @click.capture="moveToWhereTr(scope.row,$event)">确定</el-button>
                            </div>
                                <el-button type="primary" size="small" style="margin-left: 6px;"
                                    >
                                    <span class="el-icon-thumb"></span>
                                </el-button>
                            </a-popover> -->
                            </div>
                        </div>
                        <div v-else></div>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="专业服从" width="60" prop="sffc">
                    <!-- <template slot-scope="scope">
                        <el-select v-model="scope.row.sffc" @change="changeSffc($event,scope.row.index)" size="small">
                            <el-option label="服从" value="1"></el-option>
                            <el-option label="不服从" value="0"></el-option>
                        </el-select>
                    </template> -->
                    <template slot-scope="scope">
                        <span v-if="scope.row.yxmc">服从</span>
                        <span v-else></span>
                    </template>
                </el-table-column>
                </el-table>
                
                <div style="display: flex;flex-direction: column;">
                <!-- <div style="display: flex;padding-left: 20px;background-color: rgba(192, 192, 192, 0.1);
                padding-bottom: 10px;padding-top: 10px;">
                    <div style="width: 64px;text-align: left;">序号</div>
                    <div style="width: 75px;text-align: left;">院校代码</div>
                    <div style="width: 75px;text-align: center;">院校信息</div>
                    <div style="width: 64px;text-align: center;">专业组</div>
                    <div style="width: 100px;text-align: center;">开设专业</div>
                    <div style="width: 150px;text-align: center;">招生计划</div>
                    <div style="width: 150px;text-align: center;">入档位次</div>
                    <div style="width: 225px;text-align: center;">等效分</div>
                    <div style="width: 160px;text-align: center;">操作</div>
                    <div style="width: 90px;text-align: center;">专业服从</div>
                </div> -->
                <!-- <div style="display: flex;padding-left: 20px;background-color: rgba(192, 192, 192, 0.1);padding-bottom: 10px;">
                    <div style="width: 64px;text-align: left;"></div>
                    <div style="width: 75px;text-align: center;"></div>
                    <div style="width: 75px;text-align: center;"></div>
                    <div style="width: 64px;text-align: center;"></div>
                    <div style="width: 100px;text-align: center;"></div>
                    <div style="width:75px;text-align: center;">上年</div>
                    <div style="width:75px;text-align: center;">当年</div>
                    <div style="width:75px;text-align: center;">上年</div>
                    <div style="width:75px;text-align: center;">当年</div>
                    <div style="width:75px;text-align: center;">最低</div>
                    <div style="width:75px;text-align: center;">平均</div>
                    <div style="width:75px;text-align: center;">最高</div>
                    <div style="width: 160px;text-align: center;"></div>
                    <div style="width: 90px;text-align: center;"></div>
                </div> -->
                <div style="max-height: 500px;overflow-y: auto;">
                    <!-- <el-collapse v-model="bkHandleYx" accordion>
                        <el-collapse-item v-for="(item,index) in bkCollectYx" :key="index" :name="item.yxmc+item.zyz+index">
                                <template slot="title">
                                    <div style="width: 64px;text-align:  center;" :class="item.radioChecked?'radio-row-checked':
                                            item.checked?'checkBox-row-checked':''">
                                        {{ item.index }}</div>
                                     <div style="width: 75px;text-align: center;padding-left: 10px;" :class="item.radioChecked?'radio-row-checked':
                                            item.checked?'checkBox-row-checked':''">{{ item.sb }}</div>
                                    <el-tooltip placement="top">
                                        <div slot="content">{{ item.yxmc }}</div>
                                        <div style="width: 75px;text-align: left;overflow: hidden;
                                        text-overflow: ellipsis;white-space: nowrap;margin-left: 32px;">{{ item.yxmc }}</div>
                                    </el-tooltip>
                                    <div style="width: 64px;text-align: left;padding-left: 8px;">{{ item.zyz }}</div>
                                </template>
                                <div style="display: flex;align-items: center;" :class="item.radioChecked?'radio-row-checked':
                                item.checked?'checkBox-row-checked':''" @click="tableRadioChange($event,item)">
                                    <div style="width: 64px;text-align:  center;cursor: pointer;">
                                        {{ item.index }}
                                    </div>
                                    <div style="width: 75px;text-align: center;padding-left: 10px;">
                                        {{ item.sb }}
                                    </div>
                                    <div style="width: 75px;text-align: center;margin-left: 32px;">
                                        <el-tooltip placement="top">
                                            <div slot="content">{{ item.yxmc }}</div>
                                            <div style="width: 75px;text-align: left;">
                                                <router-link
                                                tag="a"
                                                target="_blank"
                                                :to="{
                                                    path: '/main/schoolDetail',
                                                    query: { gbdm: item.gbdm,pc:item.pc,yxmc:item.yxmc,yxxh:item.yxxh }
                                                }"
                                                v-if="item.yxmc"
                                                >{{ item.yxmc }}</router-link>
                                            </div>
                                        </el-tooltip>
                                        <div style="width: 75px;text-align: left;">
                                            <img src="../../../assets/images/ico2.png" width="24" alt="985" title="985" v-if="item.sf985&&item.sf985===1">
                                            <img src="../../../assets/images/ico1.png" width="24" alt="211" title="211" v-if="item.sf211&&item.sf211===1">
                                        </div>
                                    </div>
                                    <div style="width: 64px;text-align: left;padding-left: 8px;">
                                        {{ item.zyz }}
                                    </div>
                                    <div style="width: 100px;text-align: left;">
                                        <el-button type="primary" size="small" v-if="item.yxmc" @click="chooseZy(item)">选择专业</el-button>
                                    </div>
                                    <el-tooltip placement="top">
                                        <div slot="content">{{ item.snjhs }}</div>
                                        <div style="width:75px;text-align: left;padding-left: 16px;overflow: hidden;
                                        text-overflow: ellipsis;white-space: nowrap;">{{ item.snjhs }}</div>
                                    </el-tooltip>
                                    <el-tooltip placement="top">
                                        <div slot="content">{{ item.jnjhs }}</div>
                                        <div style="width:75px;text-align: left;padding-left: 16px;overflow: hidden;
                                        text-overflow: ellipsis;white-space: nowrap;">{{ item.jnjhs }}</div>
                                    </el-tooltip>
                                    <el-tooltip placement="top">
                                        <div slot="content">{{ item.snrdwc }}</div>
                                        <div style="width:75px;text-align: left;overflow: hidden;
                                        text-overflow: ellipsis;white-space: nowrap;padding-left: 8px;">{{ item.snrdwc }}</div>
                                    </el-tooltip>
                                    <el-tooltip placement="top">
                                        <div slot="content">{{ item.rdwc }}</div>     
                                        <div style="width:75px;text-align: left;overflow: hidden;
                                        text-overflow: ellipsis;white-space: nowrap;padding-left: 8px;">{{ item.rdwc }}</div>
                                    </el-tooltip>
                                    <el-tooltip placement="top">
                                        <div slot="content">{{ item.zdtwf }}</div>
                                        <div style="width:75px;text-align: left;overflow: hidden;
                                        text-overflow: ellipsis;white-space: nowrap;padding-left: 14px;">{{ item.zdtwf }}</div>
                                    </el-tooltip>
                                    <el-tooltip placement="top">
                                        <div slot="content">{{ item.pjtwf }}</div>
                                        <div style="width:75px;text-align: left;overflow: hidden;
                                        text-overflow: ellipsis;white-space: nowrap;padding-left: 14px;">{{ item.pjtwf }}</div>
                                    </el-tooltip>
                                    <el-tooltip placement="top">
                                        <div slot="content">{{ item.zgtwf }}</div>
                                        <div style="width:75px;text-align: left;overflow: hidden;
                                        text-overflow: ellipsis;white-space: nowrap;padding-left: 14px;">{{ item.zgtwf }}</div>
                                    </el-tooltip>
                                    <div style="width: 90px;text-align: left;">
                                        <el-select v-model="item.sffc" style="width: 80px;" size="small">
                                            <el-option label="服从" value="1"></el-option>
                                            <el-option label="不服从" value="0"></el-option>
                                        </el-select>
                                    </div>
                                    <div style="width: 160px;text-align: left;">
                                        <el-button type="primary" size="small" v-if="item.yxmc" @click="tableMovePrev(item)">
                                            <span class="el-icon-top"></span>
                                        </el-button>
                                        <el-button type="primary" size="small" v-if="item.yxmc" @click="tableMoveNext(item)">
                                            <span class="el-icon-bottom"></span>
                                        </el-button>
                                        <el-popover 
                                            placement="bottom-start"
                                            trigger="manual"
                                            v-model="moveTrVisibleabc" :tabindex="index">
                                            <div style="display: flex;align-items: center;">
                                                将院校移动到
                                                <el-input v-model="moveToTr" size="small" style="width: 40px;margin:0 6px;"></el-input>
                                                行
                                                <el-button type="primary" size="small" style="margin-left: 6px;" @click="moveToWhereTr(item)">确定</el-button>
                                            </div>
                                            <el-button type="primary" size="small" slot="reference" style="margin-left: 10px;"
                                            @click="moveTrVisibleabc=!moveTrVisibleabc">
                                                <span class="el-icon-thumb"></span>
                                            </el-button>
                                        </el-popover>
                                    </div>
                                </div>
                        </el-collapse-item>
                    </el-collapse> -->
                    
                                <!-- <div style="display: flex;align-items: center;padding: 20px 0;
                                border-bottom: 1px solid #F2F2F2;"
                                :class="item.radioChecked?'radio-row-checked':''"
                                 v-for="(item,index) in bkCollectYx" :key="index"
                                @click="tableRadioChange($event,item)">
                                  <div style="width: 64px;text-align:  center;cursor: pointer;overflow: hidden;
                                        text-overflow: ellipsis;white-space: nowrap;">
                                        <el-tag type="info" @click="tableCheckChange($event,item)"
                                        v-if="!item.checked">
                                        {{ item.index }}</el-tag>
                                        <el-tag @click="tableCheckChange($event,item)"
                                        v-if="item.checked">
                                        {{ item.index }}</el-tag>
                                    </div>
                                    <div style="width: 75px;text-align: center;padding-left: 10px;">
                                        {{ item.sb }}
                                    </div>
                                    <div style="width: 75px;text-align: center;margin-left: 32px;
                                        overflow: hidden; text-overflow: ellipsis;
                                        white-space: nowrap;">
                                        <el-tooltip placement="top">
                                            <div slot="content">
                                                {{ item.yxmc }}
                                                <el-divider direction="vertical"></el-divider>
                                                <div style="width: auto;text-align: left;display: inline-block;">{{ item.szdqmc }}</div>
                                                <el-divider direction="vertical" v-if="item.sf985===1||item.sf211===1"></el-divider>
                                                <div style="width: 50px;text-align: left;display: inline-block;" v-if="item.sf985===1||item.sf211===1">
                                                    <img src="../../../assets/images/ico2.png" width="24" alt="985" title="985" v-if="item.sf985&&item.sf985===1">
                                                    <img src="../../../assets/images/ico1.png" width="24" alt="211" title="211" v-if="item.sf211&&item.sf211===1">
                                                </div>
                                            </div>
                                            <div style="width: 75px;text-align: left;
                                        overflow: hidden; text-overflow: ellipsis;
                                        white-space: nowrap;">
                                                <router-link
                                                tag="a"
                                                target="_blank"
                                                :to="{
                                                    path: '/main/schoolDetail',
                                                    query: { gbdm: item.gbdm,pc:item.pc,yxmc:item.yxmc,yxxh:item.yxxh }
                                                }"
                                                v-if="item.yxmc"
                                                >
                                                {{ item.yxmc }} |
                                                <div style="width: 50px;text-align: left;display: inline-block;">{{ item.szdqmc }}</div>
                                                <div style="width: 50px;text-align: left;display: inline-block;" v-if="item.sf985===1||item.sf211===1">
                                                     | 
                                                    <img src="../../../assets/images/ico2.png" width="24" alt="985" title="985" v-if="item.sf985&&item.sf985===1">
                                                    <img src="../../../assets/images/ico1.png" width="24" alt="211" title="211" v-if="item.sf211&&item.sf211===1">
                                                </div>
                                            </router-link>
                                            </div>
                                        </el-tooltip>
                                    </div>
                                    <div style="width: 64px;text-align: left;padding-left: 8px;">
                                        {{ item.zyz }}
                                    </div>
                                    <div style="width: 100px;text-align: left;">
                                        <el-button type="primary" size="small" v-if="item.yxmc" @click="chooseZy(item)">选择专业</el-button>
                                    </div>
                                    <el-tooltip placement="top">
                                        <div slot="content">{{ item.snjhs }}</div>
                                        <div style="width:75px;text-align: left;padding-left: 16px;
                                        overflow: hidden; text-overflow: ellipsis;
                                        white-space: nowrap;">{{ item.snjhs }}</div>
                                    </el-tooltip>
                                    <el-tooltip placement="top">
                                        <div slot="content">{{ item.jnjhs }}</div>
                                        <div style="width:75px;text-align: left;padding-left: 16px;
                                                overflow: hidden;text-overflow: ellipsis;
                                                white-space: nowrap;">{{ item.jnjhs }}</div>
                                    </el-tooltip>
                                    <el-tooltip placement="top">
                                        <div slot="content">{{ item.snrdwc }}</div>
                                        <div style="width:75px;text-align: left;overflow: hidden;
                                        text-overflow: ellipsis;white-space: nowrap;padding-left: 8px;">{{ item.snrdwc }}</div>
                                    </el-tooltip>
                                    <el-tooltip placement="top">
                                        <div slot="content">{{ item.rdwc }}</div>     
                                        <div style="width:75px;text-align: left;overflow: hidden;
                                        text-overflow: ellipsis;white-space: nowrap;padding-left: 8px;">{{ item.rdwc }}</div>
                                    </el-tooltip>
                                    <el-tooltip placement="top">
                                        <div slot="content">{{ item.zdtwf }}</div>
                                        <div style="width:75px;text-align: left;overflow: hidden;
                                        text-overflow: ellipsis;white-space: nowrap;padding-left: 14px;">{{ item.zdtwf }}</div>
                                    </el-tooltip>
                                    <el-tooltip placement="top">
                                        <div slot="content">{{ item.pjtwf }}</div>
                                        <div style="width:75px;text-align: left;overflow: hidden;
                                        text-overflow: ellipsis;white-space: nowrap;padding-left: 14px;">{{ item.pjtwf }}</div>
                                    </el-tooltip>
                                    <el-tooltip placement="top">
                                        <div slot="content">{{ item.zgtwf }}</div>
                                        <div style="width:75px;text-align: left;overflow: hidden;
                                        text-overflow: ellipsis;white-space: nowrap;padding-left: 14px;">{{ item.zgtwf }}</div>
                                    </el-tooltip>
                                    <div style="width: 160px;text-align: left;">
                                        <el-button type="primary" size="small" v-if="item.yxmc" @click="tableMovePrev(item)">
                                            <span class="el-icon-top"></span>
                                        </el-button>
                                        <el-button type="primary" size="small" v-if="item.yxmc" @click="tableMoveNext(item)">
                                            <span class="el-icon-bottom"></span>
                                        </el-button>
                                        <el-popover 
                                            placement="bottom-start"
                                            trigger="manual"
                                            v-if="item.yxmc"
                                            v-model="item.moveTrVisible" :tabindex="index">
                                            <div style="display: flex;align-items: center;">
                                                将院校移动到
                                                <el-input v-model="moveToTr" size="small" style="width: 60px;margin:0 6px;"></el-input>
                                                行
                                                <el-button type="primary" size="small" style="margin-left: 6px;" @click="moveToWhereTr(item)">确定</el-button>
                                            </div>
                                            <el-button type="primary" size="small" slot="reference" style="margin-left: 10px;"
                                            @click="clickShowMoveWherePopover(item)">
                                                <span class="el-icon-thumb"></span>
                                            </el-button>
                                        </el-popover>
                                    </div>
                                    <div style="width: 90px;text-align: left;">
                                        <el-select v-model="item.sffc" style="width: 80px;" size="small" v-if="item.yxmc">
                                            <el-option label="服从" value="1"></el-option>
                                            <el-option label="不服从" value="0"></el-option>
                                        </el-select>
                                    </div>
                                </div> -->
                </div>
                </div>
            </div>
            
                        <!-- <el-button type="primary" size="mini">选专业</el-button> -->
            </el-tab-pane>
            <!--  highlight-current-row
                    @current-change="handleZkCurrentChange" -->
                        <!-- <el-checkbox v-model="scope.row.checked" @change="zkCheckChange($event,scope.row)">
                        </el-checkbox> -->
                <!-- <el-table-column show-overflow-tooltip type="index" label="序号" width="40"></el-table-column> -->
            <el-tab-pane label="专科批" name="7">
                <div id="zk-data">
                <el-table :data="zkCollectYx" max-height="600" :key="updateZk" ref="zkTab"
                 highlight-current-row @current-change="handleTabCurrentChange"
                :header-cell-style="{'background-color':'#5287c6','border': '1px solid #1f4778',
                'color': '#FFF','text-align':'center','font-size':'14px'}"
                :cell-style="{'border': '1px solid #1f4778','text-align':'center'}" size="small">
                <el-table-column show-overflow-tooltip label="选择" width="62" prop="checked">
                    <template slot-scope="scope">
                            <el-tag type="info" @click="tableCheckChange($event,scope.row)"
                                    v-if="!scope.row.checked" style="cursor: pointer;">
                                    {{ scope.row.index }}</el-tag>
                            <el-tag @click="tableCheckChange($event,scope.row)"
                                    v-if="scope.row.checked" style="cursor: pointer;border:2px solid black;">
                                    {{ scope.row.index }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="院校代码" width="60" prop="sb">
                    <template slot-scope="scope">
                        <div v-if="scope.row.yxmc">
                            <a-popover 
                                placement="bottomLeft"
                                trigger="click"
                                :visible="scope.row.inputSbVisible"
                                @visibleChange="clickShowInputSbPopover($event,scope.row)">
                            <div style="display: flex;align-items: center;" slot="content">
                                <el-input style="width: 80px;" type="number"
                                v-model="scope.row.writeSb" size="mini"
                                @input="changeTabSb($event,scope.row)"
                                @change="setSbNoSave($event,scope.row)"></el-input>
                                <div>
                                    <el-button type="primary" size="small" style="margin-left: 6px;" @click="submitUpdateSb(scope.row)">确定</el-button>
                                </div>
                            </div>
                                <el-button type="primary" size="mini"
                                     style="width: 40px;display: flex;justify-content: center;
                                     text-overflow:ellipsis;overflow: hidden;white-space: nowrap;"
                                    >
                                    {{ scope.row.submitSb?scope.row.submitSb+'(未保存)'
                                    :scope.row.submitSb||scope.row.sb }}
                                </el-button>
                            </a-popover>
                        </div>
                        <!-- <div v-else>
                            <a-popover 
                                placement="bottomLeft"
                                trigger="click"
                                :visible="scope.row.inputSbVisible"
                                @visibleChange="clickShowInputSbPopover($event,scope.row)">
                            <div style="display: flex;align-items: center;" slot="content">
                                <el-input style="width: 80px;" type="number"
                                v-model="scope.row.writeSb" size="mini"
                                @input="changeTabSb($event,scope.row)"
                                @change="setSbNoSave($event,scope.row)"></el-input>
                                <div>
                                <el-button type="primary" size="small" style="margin-left: 6px;" @click="submitUpdateSb(scope.row)">确认</el-button>
                                </div>
                            </div>
                                <el-button type="primary" size="mini"
                                     style="width: 40px;display: flex;justify-content: center;
                                     text-overflow:ellipsis;overflow: hidden;white-space: nowrap;"
                                    >
                                    {{ scope.row.submitSb?scope.row.submitSb+'(未保存)'
                                    :scope.row.submitSb||scope.row.sb||'添加' }}
                                </el-button>
                            </a-popover>
                        </div> -->
                        <div v-else></div>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="院校名称" width="120" prop="yxmc">
                    <template slot-scope="scope">
                        <!-- <router-link
                        tag="a"
                        target="_blank"
                        :to="{
                            path: '/main/schoolDetail',
                            query: { gbdm: scope.row.gbdm,pc:scope.row.pc,yxmc:scope.row.yxmc,yxxh:scope.row.yxxh }
                        }"
                        v-if="scope.row.yxmc"
                        >{{scope.row.yxmc}}</router-link> -->
                        <div v-if="scope.row.yxmc">
                            <el-popover 
                                placement="bottom-start"
                                trigger="click"
                                v-model="scope.row.chooseYxxhVisible"
                                :tabindex="scope.row.index+Math.random()*10"
                                >
                            <div style="display: flex;align-items: center;">
                                <el-select v-model="scope.row.selectedYxxh" style="width: 100px;" size="mini"
                                @change="changeSelectedYxxh($event,scope.row)" @click.capture="$event.stopPropagation();">
                                    <template v-if="scope.row.yxmcs.length>0">
                                        <el-option v-for="(item,index) in scope.row.yxmcs" :key="index"
                                        :label="item.yxmc" :value="item.yxxh" @click.capture="$event.stopPropagation();"></el-option>
                                    </template>
                                </el-select>
                                <el-tooltip placement="top">
                                    <div slot="content">{{scope.row.yxmc}}</div>
                                <div
                                    style="width: 60px;display: flex;justify-content: flex-start;
                                    text-overflow:ellipsis;overflow: hidden;white-space: nowrap;margin-left: 10px;">
                                    <router-link
                                    tag="a"
                                    target="_blank"
                                    :to="{
                                        path: '/main/schoolDetail',
                                        query: { gbdm: scope.row.gbdm,pc:scope.row.pc,yxmc:scope.row.yxmc,yxxh:scope.row.yxxh,
                                            type:scope.row.type
                                         }
                                    }"
                                    @click="$store.commit('initIsUpdateToken');"
                                    v-if="scope.row.yxmc"
                                    >院校详情</router-link>
                                </div>
                                </el-tooltip>
                                <el-button type="primary" size="small" style="margin-left: 6px;"
                                @click="submitUpdateYxxh(scope.row)">确认</el-button>
                            </div>
                                <div slot="reference">
                                    <el-button type="primary" size="mini"
                                        style="width: 100px;display: flex;justify-content: center;
                                        text-overflow:ellipsis;overflow: hidden;white-space: nowrap;padding: 7px 0;"
                                        :ref="'editYxmc'+scope.row.index"
                                        @click="clickShowChooseYxxhPopover($event,scope.row)">
                                        {{ scope.row.submitYxmc?scope.row.submitYxmc+'(未保存)'
                                        :scope.row.submitYxmc||scope.row.yxmc }}
                                    </el-button>
                                </div>
                            </el-popover>
                        </div>
                        <!-- <div v-else>
                            <el-popover 
                                placement="bottom-start"
                                trigger="click"
                                v-model="scope.row.chooseYxxhVisible"
                                :tabindex="scope.row.index+Math.random()*10"
                                >
                            <div style="display: flex;align-items: center;">
                                <el-select v-model="scope.row.selectedYxxh" style="width: 100px;" size="mini"
                                @change="changeSelectedYxxh($event,scope.row)" @click.capture="$event.stopPropagation();">
                                    <template v-if="scope.row.yxmcs.length>0">
                                        <el-option v-for="(item,index) in scope.row.yxmcs" :key="index"
                                        :label="item.yxmc" :value="item.yxxh" @click.capture="$event.stopPropagation();"></el-option>
                                    </template>
                                </el-select>
                                <el-button type="primary" size="small" style="margin-left: 6px;"
                                @click="submitUpdateYxxh(scope.row)">确认</el-button>
                            </div>
                                <div slot="reference">
                                    <el-button type="primary" size="mini"
                                        style="width: 100px;display: flex;justify-content: center;
                                        text-overflow:ellipsis;overflow: hidden;white-space: nowrap;padding: 7px 0;"
                                        :ref="'editYxmc'+scope.row.index"
                                        @click="clickShowChooseYxxhPopover($event,scope.row)">
                                        {{ scope.row.submitYxmc?scope.row.submitYxmc+'(未保存)'
                                        :scope.row.submitYxmc||scope.row.yxmc||'空' }}
                                    </el-button>
                                </div>
                            </el-popover>
                        </div> -->
                        <div v-else></div>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="专业组" width="90" prop="zyz">
                    <template slot-scope="scope">
                        <div v-if="scope.row.yxmc">
                            <el-popover 
                                placement="bottom-start"
                                trigger="click"
                                v-model="scope.row.chooseZyzVisible"
                                :tabindex="scope.row.index+Math.random()*10"
                                >
                            <div style="display: flex;align-items: center;">
                                <el-select v-model="scope.row.selectedZyz"
                                style="width: 100px;" size="mini"
                                @change="changeSelectedZyz($event,scope.row)" @click.capture="$event.stopPropagation();"
                                >
                                    <template v-if="scope.row.zyzs.length>0">
                                        <el-option v-for="(item,index) in scope.row.zyzs" :key="index"
                                        :label="item.zyz" :value="item.zyz" @click.capture="$event.stopPropagation();"></el-option>
                                    </template>
                                </el-select>
                                <el-button type="primary" size="small" style="margin-left: 6px;"
                                @click="submitUpdateZyz(scope.row)">保存</el-button>
                            </div>
                                <div slot="reference">
                                    <el-button type="primary" size="mini"
                                        style="width: 70px;display: flex;justify-content: center;
                                        text-overflow:ellipsis;overflow: hidden;white-space: nowrap;"
                                         :ref="'editZyz'+scope.row.index"
                                        @click="clickShowChooseZyzPopover($event,scope.row)"
                                        >
                                        {{ scope.row.submitZyz?scope.row.submitZyz+'(未保存)'
                                        :scope.row.submitZyz||scope.row.zyz }}
                                    </el-button>
                                </div>
                            </el-popover>
                        </div>
                        <!-- <div v-else>
                            <el-popover 
                                placement="bottom-start"
                                trigger="click"
                                v-model="scope.row.chooseZyzVisible"
                                :tabindex="scope.row.index+Math.random()*10"
                                >
                            <div style="display: flex;align-items: center;">
                                <el-select v-model="scope.row.selectedZyz"
                                style="width: 100px;" size="mini"
                                @change="changeSelectedZyz($event,scope.row)" @click.capture="$event.stopPropagation();">
                                    <template v-if="scope.row.zyzs.length>0">
                                        <el-option v-for="(item,index) in scope.row.zyzs" :key="index"
                                        :label="item.zyz" :value="item.zyz" @click.capture="$event.stopPropagation();"></el-option>
                                    </template>
                                </el-select>
                                <el-button type="primary" size="small" style="margin-left: 6px;"
                                @click="submitUpdateZyz(scope.row)">保存</el-button>
                            </div>
                                <div slot="reference">
                                    <el-button type="primary" size="mini"
                                        style="width: 70px;display: flex;justify-content: center;
                                        text-overflow:ellipsis;overflow: hidden;white-space: nowrap;"
                                        :ref="'editZyz'+scope.row.index"
                                        @click="clickShowChooseZyzPopover($event,scope.row)">
                                        {{ scope.row.submitZyz?scope.row.submitZyz+'(未保存)'
                                        :scope.row.submitZyz||scope.row.zyz||'空' }}
                                    </el-button>
                                </div>
                            </el-popover>
                        </div> -->
                        <div v-else></div>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="开设专业" width="100">
                    <template slot-scope="scope">
                        <div v-if="scope.row.yxmc">
                            <el-button v-if="scope.row.chooseFlag" type="primary" size="small"
                            style="background-color: #ff861a;border: 1px solid white;"
                            @click="chooseZy2(scope.row)">选择专业</el-button>
                            <el-button v-else type="primary" size="small"
                            @click="chooseZy2(scope.row)">选择专业</el-button>
                        </div>
                        <div v-else></div>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="所在省市" width="60" prop="szdqmc"></el-table-column>
                <el-table-column show-overflow-tooltip label="985" width="50" prop="sf985">
                    <template slot-scope="scope">
                        <img v-if="scope.row.sf985===1"
                        src="../../../assets/images/gou.png" width="20" height="20"/>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="211" width="50" prop="sf211">
                    <template slot-scope="scope">
                        <img v-if="scope.row.sf211===1"
                        src="../../../assets/images/gou.png" width="20" height="20"/>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="招生计划">
                    <el-table-column show-overflow-tooltip label="上年" width="50" prop="snjhs"></el-table-column>
                    <el-table-column show-overflow-tooltip label="当年" width="50" prop="jnjhs"></el-table-column>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="入档位次">
                    <el-table-column show-overflow-tooltip label="上年" width="50" prop="snrdwc"></el-table-column>
                    <el-table-column show-overflow-tooltip label="平均" width="50" prop="rdwc"></el-table-column>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="投档线">
                    <el-table-column show-overflow-tooltip label="上年" width="70" prop="tdx"></el-table-column>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="等效分">
                    <el-table-column show-overflow-tooltip label="最低" width="50" prop="zdtwf"></el-table-column>
                    <el-table-column show-overflow-tooltip label="平均" width="50" prop="pjtwf"></el-table-column>
                    <el-table-column show-overflow-tooltip label="最高" width="50" prop="zgtwf"></el-table-column>
                </el-table-column>
                <el-table-column width="114" label="操作">
                    <template slot-scope="scope">
                        <div v-if="scope.row.yxmc">
                            <div style="display: flex;justify-content: center;">
                            <el-button type="primary" size="small" @click="tableMovePrev(scope.row)">
                                <span class="el-icon-top"></span>
                            </el-button>
                            <el-button type="primary" size="small" @click="tableMoveNext(scope.row)" style="margin-left: 6px;">
                                <span class="el-icon-bottom"></span>
                            </el-button>
                            <!-- <a-popover
                                placement="bottomLeft"
                                trigger="click"
                                :visible="scope.row.moveTrVisible"
                                @visibleChange="clickShowMoveWherePopover(scope.row)"
                                :tabindex="scope.row.index-1">
                            <div style="display: flex;align-items: center;" slot="content">
                                    将院校移动到
                                <el-input v-model="moveToTr" size="small" style="width: 60px;margin:0 6px;" @input="changeMoveToTr"></el-input>
                                                行
                                <el-button type="primary" size="small" style="margin-left: 6px;" @click="moveToWhereTr(scope.row,$event)">确定</el-button>
                            </div>
                                <el-button type="primary" size="small" style="margin-left: 6px;"
                                    >
                                    <span class="el-icon-thumb"></span>
                                </el-button>
                            </a-popover> -->
                            </div>
                        </div>
                        <div v-else></div>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="专业服从" width="60" prop="sffc">
                    <!-- <template slot-scope="scope">
                        <el-select v-model="scope.row.sffc" @change="changeSffc($event,scope.row.index)" size="small">
                            <el-option label="服从" value="1"></el-option>
                            <el-option label="不服从" value="0"></el-option>
                        </el-select>
                    </template> -->
                    <template slot-scope="scope">
                        <span v-if="scope.row.yxmc">服从</span>
                        <span v-else></span>
                    </template>
                </el-table-column>
            </el-table>
                       
                <div style="display: flex;flex-direction: column;">
                <!-- <div style="display: flex;padding-left: 20px;background-color: rgba(192, 192, 192, 0.1);
                padding-bottom: 10px;padding-top: 10px;">
                    <div style="width: 64px;text-align: left;">序号</div>
                    <div style="width: 75px;text-align: left;">院校代码</div>
                    <div style="width: 75px;text-align: center;">院校信息</div>
                    <div style="width: 64px;text-align: center;">专业组</div>
                    <div style="width: 100px;text-align: center;">开设专业</div>
                    <div style="width: 150px;text-align: center;">招生计划</div>
                    <div style="width: 150px;text-align: center;">入档位次</div>
                    <div style="width: 225px;text-align: center;">等效分</div>
                    <div style="width: 160px;text-align: center;">操作</div>
                    <div style="width: 90px;text-align: center;">专业服从</div>
                </div> -->
                <!-- <div style="display: flex;padding-left: 20px;background-color: rgba(192, 192, 192, 0.1);padding-bottom: 10px;">
                    <div style="width: 64px;text-align: left;"></div>
                    <div style="width: 75px;text-align: center;"></div>
                    <div style="width: 75px;text-align: center;"></div>
                    <div style="width: 64px;text-align: center;"></div>
                    <div style="width: 100px;text-align: center;"></div>
                    <div style="width:75px;text-align: center;">上年</div>
                    <div style="width:75px;text-align: center;">当年</div>
                    <div style="width:75px;text-align: center;">上年</div>
                    <div style="width:75px;text-align: center;">当年</div>
                    <div style="width:75px;text-align: center;">最低</div>
                    <div style="width:75px;text-align: center;">平均</div>
                    <div style="width:75px;text-align: center;">最高</div>
                    <div style="width: 160px;text-align: center;"></div>
                    <div style="width: 90px;text-align: center;"></div>
                </div> -->
                <div style="max-height: 500px;overflow-y: auto;">
                    <!-- <el-collapse v-model="bkHandleYx" accordion>
                        <el-collapse-item v-for="(item,index) in bkCollectYx" :key="index" :name="item.yxmc+item.zyz+index">
                                <template slot="title">
                                    <div style="width: 64px;text-align:  center;" :class="item.radioChecked?'radio-row-checked':
                                            item.checked?'checkBox-row-checked':''">
                                        {{ item.index }}</div>
                                     <div style="width: 75px;text-align: center;padding-left: 10px;" :class="item.radioChecked?'radio-row-checked':
                                            item.checked?'checkBox-row-checked':''">{{ item.sb }}</div>
                                    <el-tooltip placement="top">
                                        <div slot="content">{{ item.yxmc }}</div>
                                        <div style="width: 75px;text-align: left;overflow: hidden;
                                        text-overflow: ellipsis;white-space: nowrap;margin-left: 32px;">{{ item.yxmc }}</div>
                                    </el-tooltip>
                                    <div style="width: 64px;text-align: left;padding-left: 8px;">{{ item.zyz }}</div>
                                </template>
                                <div style="display: flex;align-items: center;" :class="item.radioChecked?'radio-row-checked':
                                item.checked?'checkBox-row-checked':''" @click="tableRadioChange($event,item)">
                                    <div style="width: 64px;text-align:  center;cursor: pointer;">
                                        {{ item.index }}
                                    </div>
                                    <div style="width: 75px;text-align: center;padding-left: 10px;">
                                        {{ item.sb }}
                                    </div>
                                    <div style="width: 75px;text-align: center;margin-left: 32px;">
                                        <el-tooltip placement="top">
                                            <div slot="content">{{ item.yxmc }}</div>
                                            <div style="width: 75px;text-align: left;">
                                                <router-link
                                                tag="a"
                                                target="_blank"
                                                :to="{
                                                    path: '/main/schoolDetail',
                                                    query: { gbdm: item.gbdm,pc:item.pc,yxmc:item.yxmc,yxxh:item.yxxh }
                                                }"
                                                v-if="item.yxmc"
                                                >{{ item.yxmc }}</router-link>
                                            </div>
                                        </el-tooltip>
                                        <div style="width: 75px;text-align: left;">
                                            <img src="../../../assets/images/ico2.png" width="24" alt="985" title="985" v-if="item.sf985&&item.sf985===1">
                                            <img src="../../../assets/images/ico1.png" width="24" alt="211" title="211" v-if="item.sf211&&item.sf211===1">
                                        </div>
                                    </div>
                                    <div style="width: 64px;text-align: left;padding-left: 8px;">
                                        {{ item.zyz }}
                                    </div>
                                    <div style="width: 100px;text-align: left;">
                                        <el-button type="primary" size="small" v-if="item.yxmc" @click="chooseZy(item)">选择专业</el-button>
                                    </div>
                                    <el-tooltip placement="top">
                                        <div slot="content">{{ item.snjhs }}</div>
                                        <div style="width:75px;text-align: left;padding-left: 16px;overflow: hidden;
                                        text-overflow: ellipsis;white-space: nowrap;">{{ item.snjhs }}</div>
                                    </el-tooltip>
                                    <el-tooltip placement="top">
                                        <div slot="content">{{ item.jnjhs }}</div>
                                        <div style="width:75px;text-align: left;padding-left: 16px;overflow: hidden;
                                        text-overflow: ellipsis;white-space: nowrap;">{{ item.jnjhs }}</div>
                                    </el-tooltip>
                                    <el-tooltip placement="top">
                                        <div slot="content">{{ item.snrdwc }}</div>
                                        <div style="width:75px;text-align: left;overflow: hidden;
                                        text-overflow: ellipsis;white-space: nowrap;padding-left: 8px;">{{ item.snrdwc }}</div>
                                    </el-tooltip>
                                    <el-tooltip placement="top">
                                        <div slot="content">{{ item.rdwc }}</div>     
                                        <div style="width:75px;text-align: left;overflow: hidden;
                                        text-overflow: ellipsis;white-space: nowrap;padding-left: 8px;">{{ item.rdwc }}</div>
                                    </el-tooltip>
                                    <el-tooltip placement="top">
                                        <div slot="content">{{ item.zdtwf }}</div>
                                        <div style="width:75px;text-align: left;overflow: hidden;
                                        text-overflow: ellipsis;white-space: nowrap;padding-left: 14px;">{{ item.zdtwf }}</div>
                                    </el-tooltip>
                                    <el-tooltip placement="top">
                                        <div slot="content">{{ item.pjtwf }}</div>
                                        <div style="width:75px;text-align: left;overflow: hidden;
                                        text-overflow: ellipsis;white-space: nowrap;padding-left: 14px;">{{ item.pjtwf }}</div>
                                    </el-tooltip>
                                    <el-tooltip placement="top">
                                        <div slot="content">{{ item.zgtwf }}</div>
                                        <div style="width:75px;text-align: left;overflow: hidden;
                                        text-overflow: ellipsis;white-space: nowrap;padding-left: 14px;">{{ item.zgtwf }}</div>
                                    </el-tooltip>
                                    <div style="width: 90px;text-align: left;">
                                        <el-select v-model="item.sffc" style="width: 80px;" size="small">
                                            <el-option label="服从" value="1"></el-option>
                                            <el-option label="不服从" value="0"></el-option>
                                        </el-select>
                                    </div>
                                    <div style="width: 160px;text-align: left;">
                                        <el-button type="primary" size="small" v-if="item.yxmc" @click="tableMovePrev(item)">
                                            <span class="el-icon-top"></span>
                                        </el-button>
                                        <el-button type="primary" size="small" v-if="item.yxmc" @click="tableMoveNext(item)">
                                            <span class="el-icon-bottom"></span>
                                        </el-button>
                                        <el-popover 
                                            placement="bottom-start"
                                            trigger="manual"
                                            v-model="moveTrVisibleabc" :tabindex="index">
                                            <div style="display: flex;align-items: center;">
                                                将院校移动到
                                                <el-input v-model="moveToTr" size="small" style="width: 40px;margin:0 6px;"></el-input>
                                                行
                                                <el-button type="primary" size="small" style="margin-left: 6px;" @click="moveToWhereTr(item)">确定</el-button>
                                            </div>
                                            <el-button type="primary" size="small" slot="reference" style="margin-left: 10px;"
                                            @click="moveTrVisibleabc=!moveTrVisibleabc">
                                                <span class="el-icon-thumb"></span>
                                            </el-button>
                                        </el-popover>
                                    </div>
                                </div>
                        </el-collapse-item>
                    </el-collapse> -->
                    
                    <!-- <div style="display: flex;align-items: center;padding: 20px 0;
                                border-bottom: 1px solid #F2F2F2;"
                                :class="item.radioChecked?'radio-row-checked':''"
                                 v-for="(item,index) in zkCollectYx" :key="index"
                                @click="tableRadioChange($event,item)">
                                  <div style="width: 64px;text-align:  center;cursor: pointer;overflow: hidden;
                                        text-overflow: ellipsis;white-space: nowrap;">
                                        <el-tag type="info" @click="tableCheckChange($event,item)"
                                        v-if="!item.checked">
                                        {{ item.index }}</el-tag>
                                        <el-tag @click="tableCheckChange($event,item)"
                                        v-if="item.checked">
                                        {{ item.index }}</el-tag>
                                    </div>
                                    <div style="width: 75px;text-align: center;padding-left: 10px;">
                                        {{ item.sb }}
                                    </div>
                                    <div style="width: 75px;text-align: center;margin-left: 32px;
                                        overflow: hidden; text-overflow: ellipsis;
                                        white-space: nowrap;">
                                        <el-tooltip placement="top">
                                            <div slot="content">
                                                {{ item.yxmc }}
                                                <el-divider direction="vertical"></el-divider>
                                                <div style="width: auto;text-align: left;display: inline-block;">{{ item.szdqmc }}</div>
                                                <el-divider direction="vertical" v-if="item.sf985===1||item.sf211===1"></el-divider>
                                                <div style="width: 50px;text-align: left;display: inline-block;" v-if="item.sf985===1||item.sf211===1">
                                                    <img src="../../../assets/images/ico2.png" width="24" alt="985" title="985" v-if="item.sf985&&item.sf985===1">
                                                    <img src="../../../assets/images/ico1.png" width="24" alt="211" title="211" v-if="item.sf211&&item.sf211===1">
                                                </div>
                                            </div>
                                            <div style="width: 75px;text-align: left;
                                        overflow: hidden; text-overflow: ellipsis;
                                        white-space: nowrap;">
                                                <router-link
                                                tag="a"
                                                target="_blank"
                                                :to="{
                                                    path: '/main/schoolDetail',
                                                    query: { gbdm: item.gbdm,pc:item.pc,yxmc:item.yxmc,yxxh:item.yxxh }
                                                }"
                                                v-if="item.yxmc"
                                                >
                                                {{ item.yxmc }} |
                                                <div style="width: 50px;text-align: left;display: inline-block;">{{ item.szdqmc }}</div>
                                                <div style="width: 50px;text-align: left;display: inline-block;" v-if="item.sf985===1||item.sf211===1">
                                                     | 
                                                    <img src="../../../assets/images/ico2.png" width="24" alt="985" title="985" v-if="item.sf985&&item.sf985===1">
                                                    <img src="../../../assets/images/ico1.png" width="24" alt="211" title="211" v-if="item.sf211&&item.sf211===1">
                                                </div>
                                            </router-link>
                                            </div>
                                        </el-tooltip>
                                    </div>
                                    <div style="width: 64px;text-align: left;padding-left: 8px;">
                                        {{ item.zyz }}
                                    </div>
                                    <div style="width: 100px;text-align: left;">
                                        <el-button type="primary" size="small" v-if="item.yxmc" @click="chooseZy(item)">选择专业</el-button>
                                    </div>
                                    <el-tooltip placement="top">
                                        <div slot="content">{{ item.snjhs }}</div>
                                        <div style="width:75px;text-align: left;padding-left: 16px;
                                        overflow: hidden; text-overflow: ellipsis;
                                        white-space: nowrap;">{{ item.snjhs }}</div>
                                    </el-tooltip>
                                    <el-tooltip placement="top">
                                        <div slot="content">{{ item.jnjhs }}</div>
                                        <div style="width:75px;text-align: left;padding-left: 16px;
                                                overflow: hidden;text-overflow: ellipsis;
                                                white-space: nowrap;">{{ item.jnjhs }}</div>
                                    </el-tooltip>
                                    <el-tooltip placement="top">
                                        <div slot="content">{{ item.snrdwc }}</div>
                                        <div style="width:75px;text-align: left;overflow: hidden;
                                        text-overflow: ellipsis;white-space: nowrap;padding-left: 8px;">{{ item.snrdwc }}</div>
                                    </el-tooltip>
                                    <el-tooltip placement="top">
                                        <div slot="content">{{ item.rdwc }}</div>     
                                        <div style="width:75px;text-align: left;overflow: hidden;
                                        text-overflow: ellipsis;white-space: nowrap;padding-left: 8px;">{{ item.rdwc }}</div>
                                    </el-tooltip>
                                    <el-tooltip placement="top">
                                        <div slot="content">{{ item.zdtwf }}</div>
                                        <div style="width:75px;text-align: left;overflow: hidden;
                                        text-overflow: ellipsis;white-space: nowrap;padding-left: 14px;">{{ item.zdtwf }}</div>
                                    </el-tooltip>
                                    <el-tooltip placement="top">
                                        <div slot="content">{{ item.pjtwf }}</div>
                                        <div style="width:75px;text-align: left;overflow: hidden;
                                        text-overflow: ellipsis;white-space: nowrap;padding-left: 14px;">{{ item.pjtwf }}</div>
                                    </el-tooltip>
                                    <el-tooltip placement="top">
                                        <div slot="content">{{ item.zgtwf }}</div>
                                        <div style="width:75px;text-align: left;overflow: hidden;
                                        text-overflow: ellipsis;white-space: nowrap;padding-left: 14px;">{{ item.zgtwf }}</div>
                                    </el-tooltip>
                                    <div style="width: 160px;text-align: left;">
                                        <el-button type="primary" size="small" v-if="item.yxmc" @click="tableMovePrev(item)">
                                            <span class="el-icon-top"></span>
                                        </el-button>
                                        <el-button type="primary" size="small" v-if="item.yxmc" @click="tableMoveNext(item)">
                                            <span class="el-icon-bottom"></span>
                                        </el-button>
                                        <el-popover 
                                            placement="bottom-start"
                                            trigger="manual"
                                            v-if="item.yxmc"
                                            v-model="item.moveTrVisible" :tabindex="index">
                                            <div style="display: flex;align-items: center;">
                                                将院校移动到
                                                <el-input v-model="moveToTr" size="small" style="width: 60px;margin:0 6px;"></el-input>
                                                行
                                                <el-button type="primary" size="small" style="margin-left: 6px;" @click="moveToWhereTr(item)">确定</el-button>
                                            </div>
                                            <el-button type="primary" size="small" slot="reference" style="margin-left: 10px;"
                                            @click="clickShowMoveWherePopover(item)">
                                                <span class="el-icon-thumb"></span>
                                            </el-button>
                                        </el-popover>
                                    </div>
                                    <div style="width: 90px;text-align: left;">
                                        <el-select v-model="item.sffc" style="width: 80px;" size="small" v-if="item.yxmc">
                                            <el-option label="服从" value="1"></el-option>
                                            <el-option label="不服从" value="0"></el-option>
                                        </el-select>
                                    </div>
                    </div> -->
                </div>
                </div>
                </div>
            </el-tab-pane>
            <el-tab-pane label="本科提前批" name="0">
                <div id="bkTqp-data">
                        <!-- <el-checkbox v-model="scope.row.checked" @change="zkCheckChange($event,scope.row)">
                        </el-checkbox> -->
                <!-- <el-table-column show-overflow-tooltip type="index" label="序号" width="40"></el-table-column> -->
                <el-table :data="bkTqpCollectYx" max-height="600" :key="updateBKTqp" ref="bkTqpTab"
                 highlight-current-row @current-change="handleTabCurrentChange"
                :header-cell-style="{'background-color':'#5287c6','border': '1px solid #1f4778',
                'color': '#FFF','text-align':'center','font-size':'14px'}"
                :cell-style="{'border': '1px solid #1f4778','text-align':'center'}" size="small">
                <el-table-column show-overflow-tooltip label="选择" width="62" prop="checked">
                    <template slot-scope="scope">
                            <el-tag type="info" @click="tableCheckChange($event,scope.row)"
                                    v-if="!scope.row.checked" style="cursor: pointer;">
                                    {{ scope.row.index }}</el-tag>
                            <el-tag @click="tableCheckChange($event,scope.row)"
                                    v-if="scope.row.checked" style="cursor: pointer;border:2px solid black;">
                                    {{ scope.row.index }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="院校代码" width="60" prop="sb">
                    <template slot-scope="scope">
                        <div v-if="scope.row.yxmc">
                            <a-popover 
                                placement="bottomLeft"
                                trigger="click"
                                :visible="scope.row.inputSbVisible"
                                @visibleChange="clickShowInputSbPopover($event,scope.row)">
                            <div style="display: flex;align-items: center;" slot="content">
                                <el-input style="width: 80px;" type="number"
                                v-model="scope.row.writeSb" size="mini"
                                @input="changeTabSb($event,scope.row)"
                                @change="setSbNoSave($event,scope.row)"></el-input>
                                <div>
                                    <el-button type="primary" size="small" style="margin-left: 6px;" @click="submitUpdateSb(scope.row)">确定</el-button>
                                </div>
                            </div>
                                <el-button type="primary" size="mini"
                                     style="width: 40px;display: flex;justify-content: center;
                                     text-overflow:ellipsis;overflow: hidden;white-space: nowrap;"
                                    >
                                    {{ scope.row.submitSb?scope.row.submitSb+'(未保存)'
                                    :scope.row.submitSb||scope.row.sb }}
                                </el-button>
                            </a-popover>
                        </div>
                        <!-- <div v-else>
                            <a-popover 
                                placement="bottomLeft"
                                trigger="click"
                                :visible="scope.row.inputSbVisible"
                                @visibleChange="clickShowInputSbPopover($event,scope.row)">
                            <div style="display: flex;align-items: center;" slot="content">
                                <el-input style="width: 80px;" type="number"
                                v-model="scope.row.writeSb" size="mini"
                                @input="changeTabSb($event,scope.row)"
                                @change="setSbNoSave($event,scope.row)"></el-input>
                                <div>
                                <el-button type="primary" size="small" style="margin-left: 6px;" @click="submitUpdateSb(scope.row)">确认</el-button>
                                </div>
                            </div>
                                <el-button type="primary" size="mini"
                                     style="width: 40px;display: flex;justify-content: center;
                                     text-overflow:ellipsis;overflow: hidden;white-space: nowrap;"
                                    >
                                    {{ scope.row.submitSb?scope.row.submitSb+'(未保存)'
                                    :scope.row.submitSb||scope.row.sb||'添加' }}
                                </el-button>
                            </a-popover>
                        </div> -->
                        <div v-else></div>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="院校名称" width="120" prop="yxmc">
                    <template slot-scope="scope">
                        <!-- <router-link
                        tag="a"
                        target="_blank"
                        :to="{
                            path: '/main/schoolDetail',
                            query: { gbdm: scope.row.gbdm,pc:scope.row.pc,yxmc:scope.row.yxmc,yxxh:scope.row.yxxh }
                        }"
                        v-if="scope.row.yxmc"
                        >{{scope.row.yxmc}}</router-link> -->
                        <div v-if="scope.row.yxmc">
                            <el-popover 
                                placement="bottom-start"
                                trigger="click"
                                v-model="scope.row.chooseYxxhVisible"
                                :tabindex="scope.row.index+Math.random()*10"
                                >
                            <div style="display: flex;align-items: center;">
                                <el-select v-model="scope.row.selectedYxxh" style="width: 100px;" size="mini"
                                @change="changeSelectedYxxh($event,scope.row)" @click.capture="$event.stopPropagation();">
                                    <template v-if="scope.row.yxmcs.length>0">
                                        <el-option v-for="(item,index) in scope.row.yxmcs" :key="index"
                                        :label="item.yxmc" :value="item.yxxh" @click.capture="$event.stopPropagation();"></el-option>
                                    </template>
                                </el-select>
                                <el-tooltip placement="top">
                                    <div slot="content">{{scope.row.yxmc}}</div>
                                <div
                                    style="width: 60px;display: flex;justify-content: flex-start;
                                    text-overflow:ellipsis;overflow: hidden;white-space: nowrap;margin-left: 10px;">
                                    <router-link
                                    tag="a"
                                    target="_blank"
                                    :to="{
                                        path: '/main/schoolDetail',
                                        query: { gbdm: scope.row.gbdm,pc:scope.row.pc,yxmc:scope.row.yxmc,yxxh:scope.row.yxxh,
                                            type:scope.row.type
                                         }
                                    }"
                                    @click="$store.commit('initIsUpdateToken');"
                                    v-if="scope.row.yxmc"
                                    >院校详情</router-link>
                                </div>
                                </el-tooltip>
                                <el-button type="primary" size="small" style="margin-left: 6px;"
                                @click="submitUpdateYxxh(scope.row)">确认</el-button>
                            </div>
                                <div slot="reference">
                                    <el-button type="primary" size="mini"
                                        style="width: 100px;display: flex;justify-content: center;
                                        text-overflow:ellipsis;overflow: hidden;white-space: nowrap;padding: 7px 0;"
                                        :ref="'editYxmc'+scope.row.index"
                                        @click="clickShowChooseYxxhPopover($event,scope.row)">
                                        {{ scope.row.submitYxmc?scope.row.submitYxmc+'(未保存)'
                                        :scope.row.submitYxmc||scope.row.yxmc }}
                                    </el-button>
                                </div>
                            </el-popover>
                        </div>
                        <!-- <div v-else>
                            <el-popover 
                                placement="bottom-start"
                                trigger="click"
                                v-model="scope.row.chooseYxxhVisible"
                                :tabindex="scope.row.index+Math.random()*10"
                                >
                            <div style="display: flex;align-items: center;">
                                <el-select v-model="scope.row.selectedYxxh" style="width: 100px;" size="mini"
                                @change="changeSelectedYxxh($event,scope.row)" @click.capture="$event.stopPropagation();">
                                    <template v-if="scope.row.yxmcs.length>0">
                                        <el-option v-for="(item,index) in scope.row.yxmcs" :key="index"
                                        :label="item.yxmc" :value="item.yxxh" @click.capture="$event.stopPropagation();"></el-option>
                                    </template>
                                </el-select>
                                <el-button type="primary" size="small" style="margin-left: 6px;"
                                @click="submitUpdateYxxh(scope.row)">确认</el-button>
                            </div>
                                <div slot="reference">
                                    <el-button type="primary" size="mini"
                                        style="width: 100px;display: flex;justify-content: center;
                                        text-overflow:ellipsis;overflow: hidden;white-space: nowrap;padding: 7px 0;"
                                        :ref="'editYxmc'+scope.row.index"
                                        @click="clickShowChooseYxxhPopover($event,scope.row)">
                                        {{ scope.row.submitYxmc?scope.row.submitYxmc+'(未保存)'
                                        :scope.row.submitYxmc||scope.row.yxmc||'空' }}
                                    </el-button>
                                </div>
                            </el-popover>
                        </div> -->
                        <div v-else></div>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="专业组" width="90" prop="zyz">
                    <template slot-scope="scope">
                        <div v-if="scope.row.yxmc">
                            <el-popover 
                                placement="bottom-start"
                                trigger="click"
                                v-model="scope.row.chooseZyzVisible"
                                :tabindex="scope.row.index+Math.random()*10"
                                >
                            <div style="display: flex;align-items: center;">
                                <el-select v-model="scope.row.selectedZyz"
                                style="width: 100px;" size="mini"
                                @change="changeSelectedZyz($event,scope.row)" @click.capture="$event.stopPropagation();"
                                >
                                    <template v-if="scope.row.zyzs.length>0">
                                        <el-option v-for="(item,index) in scope.row.zyzs" :key="index"
                                        :label="item.zyz" :value="item.zyz" @click.capture="$event.stopPropagation();"></el-option>
                                    </template>
                                </el-select>
                                <el-button type="primary" size="small" style="margin-left: 6px;"
                                @click="submitUpdateZyz(scope.row)">保存</el-button>
                            </div>
                                <div slot="reference">
                                    <el-button type="primary" size="mini"
                                        style="width: 70px;display: flex;justify-content: center;
                                        text-overflow:ellipsis;overflow: hidden;white-space: nowrap;"
                                         :ref="'editZyz'+scope.row.index"
                                        @click="clickShowChooseZyzPopover($event,scope.row)"
                                        >
                                        {{ scope.row.submitZyz?scope.row.submitZyz+'(未保存)'
                                        :scope.row.submitZyz||scope.row.zyz }}
                                    </el-button>
                                </div>
                            </el-popover>
                        </div>
                        <!-- <div v-else>
                            <el-popover 
                                placement="bottom-start"
                                trigger="click"
                                v-model="scope.row.chooseZyzVisible"
                                :tabindex="scope.row.index+Math.random()*10"
                                >
                            <div style="display: flex;align-items: center;">
                                <el-select v-model="scope.row.selectedZyz"
                                style="width: 100px;" size="mini"
                                @change="changeSelectedZyz($event,scope.row)" @click.capture="$event.stopPropagation();">
                                    <template v-if="scope.row.zyzs.length>0">
                                        <el-option v-for="(item,index) in scope.row.zyzs" :key="index"
                                        :label="item.zyz" :value="item.zyz" @click.capture="$event.stopPropagation();"></el-option>
                                    </template>
                                </el-select>
                                <el-button type="primary" size="small" style="margin-left: 6px;"
                                @click="submitUpdateZyz(scope.row)">保存</el-button>
                            </div>
                                <div slot="reference">
                                    <el-button type="primary" size="mini"
                                        style="width: 70px;display: flex;justify-content: center;
                                        text-overflow:ellipsis;overflow: hidden;white-space: nowrap;"
                                        :ref="'editZyz'+scope.row.index"
                                        @click="clickShowChooseZyzPopover($event,scope.row)">
                                        {{ scope.row.submitZyz?scope.row.submitZyz+'(未保存)'
                                        :scope.row.submitZyz||scope.row.zyz||'空' }}
                                    </el-button>
                                </div>
                            </el-popover>
                        </div> -->
                        <div v-else></div>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="开设专业" width="100">
                    <template slot-scope="scope">
                        <div v-if="scope.row.yxmc">
                            <el-button v-if="scope.row.chooseFlag" type="primary" size="small"
                            style="background-color: #ff861a;border: 1px solid white;"
                            @click="chooseZy2(scope.row)">选择专业</el-button>
                            <el-button v-else type="primary" size="small"
                            @click="chooseZy2(scope.row)">选择专业</el-button>
                        </div>
                        <div v-else></div>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="所在省市" width="60" prop="szdqmc"></el-table-column>
                <el-table-column show-overflow-tooltip label="985" width="50" prop="sf985">
                    <template slot-scope="scope">
                        <img v-if="scope.row.sf985===1"
                        src="../../../assets/images/gou.png" width="20" height="20"/>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="211" width="50" prop="sf211">
                    <template slot-scope="scope">
                        <img v-if="scope.row.sf211===1"
                        src="../../../assets/images/gou.png" width="20" height="20"/>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="招生计划">
                    <el-table-column show-overflow-tooltip label="上年" width="50" prop="snjhs"></el-table-column>
                    <el-table-column show-overflow-tooltip label="当年" width="50" prop="jnjhs"></el-table-column>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="入档位次">
                    <el-table-column show-overflow-tooltip label="上年" width="50" prop="snrdwc"></el-table-column>
                    <el-table-column show-overflow-tooltip label="平均" width="50" prop="rdwc"></el-table-column>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="投档线">
                    <el-table-column show-overflow-tooltip label="上年" width="70" prop="tdx"></el-table-column>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="等效分">
                    <el-table-column show-overflow-tooltip label="最低" width="50" prop="zdtwf"></el-table-column>
                    <el-table-column show-overflow-tooltip label="平均" width="50" prop="pjtwf"></el-table-column>
                    <el-table-column show-overflow-tooltip label="最高" width="50" prop="zgtwf"></el-table-column>
                </el-table-column>
                <el-table-column width="114" label="操作">
                    <template slot-scope="scope">
                        <div v-if="scope.row.yxmc">
                            <div style="display: flex;justify-content: center;">
                            <el-button type="primary" size="small" @click="tableMovePrev(scope.row)">
                                <span class="el-icon-top"></span>
                            </el-button>
                            <el-button type="primary" size="small" @click="tableMoveNext(scope.row)" style="margin-left: 6px;">
                                <span class="el-icon-bottom"></span>
                            </el-button>
                            <!-- <a-popover 
                                placement="bottomLeft"
                                trigger="click"
                                :visible="scope.row.moveTrVisible"
                                @visibleChange="clickShowMoveWherePopover(scope.row)"
                                :tabindex="scope.row.index-1">
                            <div style="display: flex;align-items: center;" slot="content">
                                    将院校移动到
                                <el-input v-model="moveToTr" size="small" style="width: 60px;margin:0 6px;" @input="changeMoveToTr"></el-input>
                                                行
                                <el-button type="primary" size="small" style="margin-left: 6px;" @click="moveToWhereTr(scope.row,$event)">确定</el-button>
                            </div>
                                <el-button type="primary" size="small" style="margin-left: 6px;"
                                >
                                    <span class="el-icon-thumb"></span>
                                </el-button>
                            </a-popover> -->
                            </div>
                        </div>
                        <div v-else></div>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="专业服从" width="60" prop="sffc">
                    <!-- <template slot-scope="scope">
                        <el-select v-model="scope.row.sffc" @change="changeSffc($event,scope.row.index)" size="small">
                            <el-option label="服从" value="1"></el-option>
                            <el-option label="不服从" value="0"></el-option>
                        </el-select>
                    </template> -->
                    <template slot-scope="scope">
                        <span v-if="scope.row.yxmc">服从</span>
                        <span v-else></span>
                    </template>
                </el-table-column>
            </el-table>

                <div style="display: flex;flex-direction: column;">
                <!-- <div style="display: flex;padding-left: 20px;background-color: rgba(192, 192, 192, 0.1);
                padding-bottom: 10px;padding-top: 10px;">
                    <div style="width: 64px;text-align: left;">序号</div>
                    <div style="width: 75px;text-align: left;">院校代码</div>
                    <div style="width: 75px;text-align: center;">院校信息</div>
                    <div style="width: 64px;text-align: center;">专业组</div>
                    <div style="width: 100px;text-align: center;">开设专业</div>
                    <div style="width: 150px;text-align: center;">招生计划</div>
                    <div style="width: 150px;text-align: center;">入档位次</div>
                    <div style="width: 225px;text-align: center;">等效分</div>
                    <div style="width: 160px;text-align: center;">操作</div>
                    <div style="width: 90px;text-align: center;">专业服从</div>
                </div> -->
                <!-- <div style="display: flex;padding-left: 20px;background-color: rgba(192, 192, 192, 0.1);padding-bottom: 10px;">
                    <div style="width: 64px;text-align: left;"></div>
                    <div style="width: 75px;text-align: center;"></div>
                    <div style="width: 75px;text-align: center;"></div>
                    <div style="width: 64px;text-align: center;"></div>
                    <div style="width: 100px;text-align: center;"></div>
                    <div style="width:75px;text-align: center;">上年</div>
                    <div style="width:75px;text-align: center;">当年</div>
                    <div style="width:75px;text-align: center;">上年</div>
                    <div style="width:75px;text-align: center;">当年</div>
                    <div style="width:75px;text-align: center;">最低</div>
                    <div style="width:75px;text-align: center;">平均</div>
                    <div style="width:75px;text-align: center;">最高</div>
                    <div style="width: 160px;text-align: center;"></div>
                    <div style="width: 90px;text-align: center;"></div>
                </div> -->
                <div style="max-height: 500px;overflow-y: auto;">
                    <!-- <el-collapse v-model="bkHandleYx" accordion>
                        <el-collapse-item v-for="(item,index) in bkCollectYx" :key="index" :name="item.yxmc+item.zyz+index">
                                <template slot="title">
                                    <div style="width: 64px;text-align:  center;" :class="item.radioChecked?'radio-row-checked':
                                            item.checked?'checkBox-row-checked':''">
                                        {{ item.index }}</div>
                                     <div style="width: 75px;text-align: center;padding-left: 10px;" :class="item.radioChecked?'radio-row-checked':
                                            item.checked?'checkBox-row-checked':''">{{ item.sb }}</div>
                                    <el-tooltip placement="top">
                                        <div slot="content">{{ item.yxmc }}</div>
                                        <div style="width: 75px;text-align: left;overflow: hidden;
                                        text-overflow: ellipsis;white-space: nowrap;margin-left: 32px;">{{ item.yxmc }}</div>
                                    </el-tooltip>
                                    <div style="width: 64px;text-align: left;padding-left: 8px;">{{ item.zyz }}</div>
                                </template>
                                <div style="display: flex;align-items: center;" :class="item.radioChecked?'radio-row-checked':
                                item.checked?'checkBox-row-checked':''" @click="tableRadioChange($event,item)">
                                    <div style="width: 64px;text-align:  center;cursor: pointer;">
                                        {{ item.index }}
                                    </div>
                                    <div style="width: 75px;text-align: center;padding-left: 10px;">
                                        {{ item.sb }}
                                    </div>
                                    <div style="width: 75px;text-align: center;margin-left: 32px;">
                                        <el-tooltip placement="top">
                                            <div slot="content">{{ item.yxmc }}</div>
                                            <div style="width: 75px;text-align: left;">
                                                <router-link
                                                tag="a"
                                                target="_blank"
                                                :to="{
                                                    path: '/main/schoolDetail',
                                                    query: { gbdm: item.gbdm,pc:item.pc,yxmc:item.yxmc,yxxh:item.yxxh }
                                                }"
                                                v-if="item.yxmc"
                                                >{{ item.yxmc }}</router-link>
                                            </div>
                                        </el-tooltip>
                                        <div style="width: 75px;text-align: left;">
                                            <img src="../../../assets/images/ico2.png" width="24" alt="985" title="985" v-if="item.sf985&&item.sf985===1">
                                            <img src="../../../assets/images/ico1.png" width="24" alt="211" title="211" v-if="item.sf211&&item.sf211===1">
                                        </div>
                                    </div>
                                    <div style="width: 64px;text-align: left;padding-left: 8px;">
                                        {{ item.zyz }}
                                    </div>
                                    <div style="width: 100px;text-align: left;">
                                        <el-button type="primary" size="small" v-if="item.yxmc" @click="chooseZy(item)">选择专业</el-button>
                                    </div>
                                    <el-tooltip placement="top">
                                        <div slot="content">{{ item.snjhs }}</div>
                                        <div style="width:75px;text-align: left;padding-left: 16px;overflow: hidden;
                                        text-overflow: ellipsis;white-space: nowrap;">{{ item.snjhs }}</div>
                                    </el-tooltip>
                                    <el-tooltip placement="top">
                                        <div slot="content">{{ item.jnjhs }}</div>
                                        <div style="width:75px;text-align: left;padding-left: 16px;overflow: hidden;
                                        text-overflow: ellipsis;white-space: nowrap;">{{ item.jnjhs }}</div>
                                    </el-tooltip>
                                    <el-tooltip placement="top">
                                        <div slot="content">{{ item.snrdwc }}</div>
                                        <div style="width:75px;text-align: left;overflow: hidden;
                                        text-overflow: ellipsis;white-space: nowrap;padding-left: 8px;">{{ item.snrdwc }}</div>
                                    </el-tooltip>
                                    <el-tooltip placement="top">
                                        <div slot="content">{{ item.rdwc }}</div>     
                                        <div style="width:75px;text-align: left;overflow: hidden;
                                        text-overflow: ellipsis;white-space: nowrap;padding-left: 8px;">{{ item.rdwc }}</div>
                                    </el-tooltip>
                                    <el-tooltip placement="top">
                                        <div slot="content">{{ item.zdtwf }}</div>
                                        <div style="width:75px;text-align: left;overflow: hidden;
                                        text-overflow: ellipsis;white-space: nowrap;padding-left: 14px;">{{ item.zdtwf }}</div>
                                    </el-tooltip>
                                    <el-tooltip placement="top">
                                        <div slot="content">{{ item.pjtwf }}</div>
                                        <div style="width:75px;text-align: left;overflow: hidden;
                                        text-overflow: ellipsis;white-space: nowrap;padding-left: 14px;">{{ item.pjtwf }}</div>
                                    </el-tooltip>
                                    <el-tooltip placement="top">
                                        <div slot="content">{{ item.zgtwf }}</div>
                                        <div style="width:75px;text-align: left;overflow: hidden;
                                        text-overflow: ellipsis;white-space: nowrap;padding-left: 14px;">{{ item.zgtwf }}</div>
                                    </el-tooltip>
                                    <div style="width: 90px;text-align: left;">
                                        <el-select v-model="item.sffc" style="width: 80px;" size="small">
                                            <el-option label="服从" value="1"></el-option>
                                            <el-option label="不服从" value="0"></el-option>
                                        </el-select>
                                    </div>
                                    <div style="width: 160px;text-align: left;">
                                        <el-button type="primary" size="small" v-if="item.yxmc" @click="tableMovePrev(item)">
                                            <span class="el-icon-top"></span>
                                        </el-button>
                                        <el-button type="primary" size="small" v-if="item.yxmc" @click="tableMoveNext(item)">
                                            <span class="el-icon-bottom"></span>
                                        </el-button>
                                        <el-popover 
                                            placement="bottom-start"
                                            trigger="manual"
                                            v-model="moveTrVisibleabc" :tabindex="index">
                                            <div style="display: flex;align-items: center;">
                                                将院校移动到
                                                <el-input v-model="moveToTr" size="small" style="width: 40px;margin:0 6px;"></el-input>
                                                行
                                                <el-button type="primary" size="small" style="margin-left: 6px;" @click="moveToWhereTr(item)">确定</el-button>
                                            </div>
                                            <el-button type="primary" size="small" slot="reference" style="margin-left: 10px;"
                                            @click="moveTrVisibleabc=!moveTrVisibleabc">
                                                <span class="el-icon-thumb"></span>
                                            </el-button>
                                        </el-popover>
                                    </div>
                                </div>
                        </el-collapse-item>
                    </el-collapse> -->
                    
                    <!-- <div style="display: flex;align-items: center;padding: 20px 0;
                                border-bottom: 1px solid #F2F2F2;"
                                :class="item.radioChecked?'radio-row-checked':''"
                                 v-for="(item,index) in bkTqpCollectYx" :key="index"
                                @click="tableRadioChange($event,item)">
                                  <div style="width: 64px;text-align:  center;cursor: pointer;overflow: hidden;
                                        text-overflow: ellipsis;white-space: nowrap;">
                                        <el-tag type="info" @click="tableCheckChange($event,item)"
                                        v-if="!item.checked">
                                        {{ item.index }}</el-tag>
                                        <el-tag @click="tableCheckChange($event,item)"
                                        v-if="item.checked">
                                        {{ item.index }}</el-tag>
                                    </div>
                                    <div style="width: 75px;text-align: center;padding-left: 10px;">
                                        {{ item.sb }}
                                    </div>
                                    <div style="width: 75px;text-align: center;margin-left: 32px;
                                        overflow: hidden; text-overflow: ellipsis;
                                        white-space: nowrap;">
                                        <el-tooltip placement="top">
                                            <div slot="content">
                                                {{ item.yxmc }}
                                                <el-divider direction="vertical"></el-divider>
                                                <div style="width: auto;text-align: left;display: inline-block;">{{ item.szdqmc }}</div>
                                                <el-divider direction="vertical" v-if="item.sf985===1||item.sf211===1"></el-divider>
                                                <div style="width: 50px;text-align: left;display: inline-block;" v-if="item.sf985===1||item.sf211===1">
                                                    <img src="../../../assets/images/ico2.png" width="24" alt="985" title="985" v-if="item.sf985&&item.sf985===1">
                                                    <img src="../../../assets/images/ico1.png" width="24" alt="211" title="211" v-if="item.sf211&&item.sf211===1">
                                                </div>
                                            </div>
                                            <div style="width: 75px;text-align: left;
                                        overflow: hidden; text-overflow: ellipsis;
                                        white-space: nowrap;">
                                                <router-link
                                                tag="a"
                                                target="_blank"
                                                :to="{
                                                    path: '/main/schoolDetail',
                                                    query: { gbdm: item.gbdm,pc:item.pc,yxmc:item.yxmc,yxxh:item.yxxh }
                                                }"
                                                v-if="item.yxmc"
                                                >
                                                {{ item.yxmc }} |
                                                <div style="width: 50px;text-align: left;display: inline-block;">{{ item.szdqmc }}</div>
                                                <div style="width: 50px;text-align: left;display: inline-block;" v-if="item.sf985===1||item.sf211===1">
                                                     | 
                                                    <img src="../../../assets/images/ico2.png" width="24" alt="985" title="985" v-if="item.sf985&&item.sf985===1">
                                                    <img src="../../../assets/images/ico1.png" width="24" alt="211" title="211" v-if="item.sf211&&item.sf211===1">
                                                </div>
                                            </router-link>
                                            </div>
                                        </el-tooltip>
                                    </div>
                                    <div style="width: 64px;text-align: left;padding-left: 8px;">
                                        {{ item.zyz }}
                                    </div>
                                    <div style="width: 100px;text-align: left;">
                                        <el-button type="primary" size="small" v-if="item.yxmc" @click="chooseZy(item)">选择专业</el-button>
                                    </div>
                                    <el-tooltip placement="top">
                                        <div slot="content">{{ item.snjhs }}</div>
                                        <div style="width:75px;text-align: left;padding-left: 16px;
                                        overflow: hidden; text-overflow: ellipsis;
                                        white-space: nowrap;">{{ item.snjhs }}</div>
                                    </el-tooltip>
                                    <el-tooltip placement="top">
                                        <div slot="content">{{ item.jnjhs }}</div>
                                        <div style="width:75px;text-align: left;padding-left: 16px;
                                                overflow: hidden;text-overflow: ellipsis;
                                                white-space: nowrap;">{{ item.jnjhs }}</div>
                                    </el-tooltip>
                                    <el-tooltip placement="top">
                                        <div slot="content">{{ item.snrdwc }}</div>
                                        <div style="width:75px;text-align: left;overflow: hidden;
                                        text-overflow: ellipsis;white-space: nowrap;padding-left: 8px;">{{ item.snrdwc }}</div>
                                    </el-tooltip>
                                    <el-tooltip placement="top">
                                        <div slot="content">{{ item.rdwc }}</div>     
                                        <div style="width:75px;text-align: left;overflow: hidden;
                                        text-overflow: ellipsis;white-space: nowrap;padding-left: 8px;">{{ item.rdwc }}</div>
                                    </el-tooltip>
                                    <el-tooltip placement="top">
                                        <div slot="content">{{ item.zdtwf }}</div>
                                        <div style="width:75px;text-align: left;overflow: hidden;
                                        text-overflow: ellipsis;white-space: nowrap;padding-left: 14px;">{{ item.zdtwf }}</div>
                                    </el-tooltip>
                                    <el-tooltip placement="top">
                                        <div slot="content">{{ item.pjtwf }}</div>
                                        <div style="width:75px;text-align: left;overflow: hidden;
                                        text-overflow: ellipsis;white-space: nowrap;padding-left: 14px;">{{ item.pjtwf }}</div>
                                    </el-tooltip>
                                    <el-tooltip placement="top">
                                        <div slot="content">{{ item.zgtwf }}</div>
                                        <div style="width:75px;text-align: left;overflow: hidden;
                                        text-overflow: ellipsis;white-space: nowrap;padding-left: 14px;">{{ item.zgtwf }}</div>
                                    </el-tooltip>
                                    <div style="width: 160px;text-align: left;">
                                        <el-button type="primary" size="small" v-if="item.yxmc" @click="tableMovePrev(item)">
                                            <span class="el-icon-top"></span>
                                        </el-button>
                                        <el-button type="primary" size="small" v-if="item.yxmc" @click="tableMoveNext(item)">
                                            <span class="el-icon-bottom"></span>
                                        </el-button>
                                        <el-popover 
                                            placement="bottom-start"
                                            trigger="manual"
                                            v-if="item.yxmc"
                                            v-model="item.moveTrVisible" :tabindex="index">
                                            <div style="display: flex;align-items: center;">
                                                将院校移动到
                                                <el-input v-model="moveToTr" size="small" style="width: 60px;margin:0 6px;"></el-input>
                                                行
                                                <el-button type="primary" size="small" style="margin-left: 6px;" @click="moveToWhereTr(item)">确定</el-button>
                                            </div>
                                            <el-button type="primary" size="small" slot="reference" style="margin-left: 10px;"
                                            @click="clickShowMoveWherePopover(item)">
                                                <span class="el-icon-thumb"></span>
                                            </el-button>
                                        </el-popover>
                                    </div>
                                    <div style="width: 90px;text-align: left;">
                                        <el-select v-model="item.sffc" style="width: 80px;" size="small" v-if="item.yxmc">
                                            <el-option label="服从" value="1"></el-option>
                                            <el-option label="不服从" value="0"></el-option>
                                        </el-select>
                                    </div>
                    </div> -->
                </div>
                </div>
                </div>
            </el-tab-pane>
            <el-tab-pane label="专科提前批" name="9">
                <div id="zkTqp-data">
                        <!-- <el-checkbox v-model="scope.row.checked" @change="zkCheckChange($event,scope.row)">
                        </el-checkbox> -->
                <!-- <el-table-column show-overflow-tooltip type="index" label="序号" width="40"></el-table-column> -->
                <!-- <el-table :data="zkTqpCollectYx" height="600" :key="updateZkTqp" ref="zkTqpTab"
                 :row-class-name="tableRowClassName" @cell-click="rowClickChecked"
                :header-cell-style="{'background-color':'#5287c6','border': '1px solid #1f4778',
                'color': '#FFF','text-align':'center','font-size':'14px'}"
                :cell-style="{'border': '1px solid #1f4778','text-align':'center'}" size="small">
                <el-table-column show-overflow-tooltip label="选择" width="40" prop="checked">
                    <template slot-scope="scope">
                        <span style="margin-left: 2px;">{{ scope.row.index }}</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="院校代码" width="60" prop="sb"></el-table-column>
                <el-table-column show-overflow-tooltip label="院校名称" width="80" prop="yxmc">
                    <template slot-scope="scope">
                        <router-link
                        tag="a"
                        target="_blank"
                        :to="{
                            path: '/main/schoolDetail',
                            query: { gbdm: scope.row.gbdm,pc:scope.row.pc,yxmc:scope.row.yxmc,yxxh:scope.row.yxxh }
                        }"
                        v-if="scope.row.yxmc"
                        >{{scope.row.yxmc}}</router-link>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="专业组" width="50" prop="zyz"></el-table-column>
                <el-table-column show-overflow-tooltip label="所在省市" width="80" prop="szdqmc"></el-table-column>
                <el-table-column show-overflow-tooltip label="批次" width="70" prop="pc">
                    <template slot-scope="scope">
                        <span v-if="scope.row.pc===6">本科批</span>
                        <span v-if="scope.row.pc===7">专科批</span>
                        <span v-if="scope.row.pc===0">本科提前批</span>
                        <span v-if="scope.row.pc===9">专科提前批</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="985" width="50" prop="sf985">
                    <template slot-scope="scope">
                        <img v-if="scope.row.sf985===1"
                        src="../../../assets/images/gou.png" width="20" height="20"/>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="211" width="50" prop="sf211">
                    <template slot-scope="scope">
                        <img v-if="scope.row.sf211===1"
                        src="../../../assets/images/gou.png" width="20" height="20"/>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="招生计划">
                    <el-table-column label="上年" width="60" prop="snjhs"></el-table-column>
                    <el-table-column label="当年" width="60" prop="jnjhs"></el-table-column>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="入档位次">
                    <el-table-column label="上年" width="60" prop="snrdwc"></el-table-column>
                    <el-table-column label="当年" width="60" prop="rdwc"></el-table-column>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="投档线">
                    <el-table-column label="上年" width="70" prop="tdx"></el-table-column>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="等效分">
                    <el-table-column label="最低" width="70" prop="zdtwf"></el-table-column>
                    <el-table-column label="平均" width="70" prop="pjtwf"></el-table-column>
                    <el-table-column label="最高" width="70" prop="zgtwf"></el-table-column>
                </el-table-column>
                <el-table-column width="150" label="操作">
                    <template slot-scope="scope">
                        <el-button type="primary" size="small" @click="tableMovePrev(scope.row)">上移</el-button>
                        <el-button type="primary" size="small" @click="tableMoveNext(scope.row)">下移</el-button>
                    </template>
                </el-table-column>
            </el-table> -->

            
                <el-table :data="zkTqpCollectYx" max-height="600" :key="updateZkTqp" ref="zkTqpTab"
                 highlight-current-row @current-change="handleTabCurrentChange"
                :header-cell-style="{'background-color':'#5287c6','border': '1px solid #1f4778',
                'color': '#FFF','text-align':'center','font-size':'14px'}"
                :cell-style="{'border': '1px solid #1f4778','text-align':'center'}" size="small">
                <el-table-column show-overflow-tooltip label="选择" width="62" prop="checked">
                    <template slot-scope="scope">
                            <el-tag type="info" @click="tableCheckChange($event,scope.row)"
                                    v-if="!scope.row.checked" style="cursor: pointer;">
                                    {{ scope.row.index }}</el-tag>
                            <el-tag @click="tableCheckChange($event,scope.row)"
                                    v-if="scope.row.checked" style="cursor: pointer;border:2px solid black;">
                                    {{ scope.row.index }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="院校代码" width="60" prop="sb">
                    <template slot-scope="scope">
                        <div v-if="scope.row.yxmc">
                            <a-popover 
                                placement="bottomLeft"
                                trigger="click"
                                :visible="scope.row.inputSbVisible"
                                @visibleChange="clickShowInputSbPopover($event,scope.row)">
                            <div style="display: flex;align-items: center;" slot="content">
                                <el-input style="width: 80px;" type="number"
                                v-model="scope.row.writeSb" size="mini"
                                @input="changeTabSb($event,scope.row)"
                                @change="setSbNoSave($event,scope.row)"></el-input>
                                <div>
                                    <el-button type="primary" size="small" style="margin-left: 6px;" @click="submitUpdateSb(scope.row)">确定</el-button>
                                </div>
                            </div>
                                <el-button type="primary" size="mini"
                                     style="width: 40px;display: flex;justify-content: center;
                                     text-overflow:ellipsis;overflow: hidden;white-space: nowrap;"
                                    >
                                    {{ scope.row.submitSb?scope.row.submitSb+'(未保存)'
                                    :scope.row.submitSb||scope.row.sb }}
                                </el-button>
                            </a-popover>
                        </div>
                        <!-- <div v-else>
                            <a-popover 
                                placement="bottomLeft"
                                trigger="click"
                                :visible="scope.row.inputSbVisible"
                                @visibleChange="clickShowInputSbPopover($event,scope.row)">
                            <div style="display: flex;align-items: center;" slot="content">
                                <el-input style="width: 80px;" type="number"
                                v-model="scope.row.writeSb" size="mini"
                                @input="changeTabSb($event,scope.row)"
                                @change="setSbNoSave($event,scope.row)"></el-input>
                                <div>
                                <el-button type="primary" size="small" style="margin-left: 6px;" @click="submitUpdateSb(scope.row)">确认</el-button>
                                </div>
                            </div>
                                <el-button type="primary" size="mini"
                                     style="width: 40px;display: flex;justify-content: center;
                                     text-overflow:ellipsis;overflow: hidden;white-space: nowrap;"
                                    >
                                    {{ scope.row.submitSb?scope.row.submitSb+'(未保存)'
                                    :scope.row.submitSb||scope.row.sb||'添加' }}
                                </el-button>
                            </a-popover>
                        </div> -->
                        <div v-else></div>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="院校名称" width="120" prop="yxmc">
                    <template slot-scope="scope">
                        <!-- <router-link
                        tag="a"
                        target="_blank"
                        :to="{
                            path: '/main/schoolDetail',
                            query: { gbdm: scope.row.gbdm,pc:scope.row.pc,yxmc:scope.row.yxmc,yxxh:scope.row.yxxh }
                        }"
                        v-if="scope.row.yxmc"
                        >{{scope.row.yxmc}}</router-link> -->
                        <div v-if="scope.row.yxmc">
                            <el-popover 
                                placement="bottom-start"
                                trigger="click"
                                v-model="scope.row.chooseYxxhVisible"
                                :tabindex="scope.row.index+Math.random()*10"
                                >
                            <div style="display: flex;align-items: center;">
                                <el-select v-model="scope.row.selectedYxxh" style="width: 100px;" size="mini"
                                @change="changeSelectedYxxh($event,scope.row)" @click.capture="$event.stopPropagation();">
                                    <template v-if="scope.row.yxmcs.length>0">
                                        <el-option v-for="(item,index) in scope.row.yxmcs" :key="index"
                                        :label="item.yxmc" :value="item.yxxh" @click.capture="$event.stopPropagation();"></el-option>
                                    </template>
                                </el-select>
                                <el-tooltip placement="top">
                                    <div slot="content">{{scope.row.yxmc}}</div>
                                <div
                                    style="width: 60px;display: flex;justify-content: flex-start;
                                    text-overflow:ellipsis;overflow: hidden;white-space: nowrap;margin-left: 10px;">
                                    <router-link
                                    tag="a"
                                    target="_blank"
                                    :to="{
                                        path: '/main/schoolDetail',
                                        query: { gbdm: scope.row.gbdm,pc:scope.row.pc,yxmc:scope.row.yxmc,yxxh:scope.row.yxxh,
                                            type:scope.row.type
                                         }
                                    }"
                                    @click="$store.commit('initIsUpdateToken');"
                                    v-if="scope.row.yxmc"
                                    >院校详情</router-link>
                                </div>
                                </el-tooltip>
                                <el-button type="primary" size="small" style="margin-left: 6px;"
                                @click="submitUpdateYxxh(scope.row)">确认</el-button>
                            </div>
                                <div slot="reference">
                                    <el-button type="primary" size="mini"
                                        style="width: 100px;display: flex;justify-content: center;
                                        text-overflow:ellipsis;overflow: hidden;white-space: nowrap;padding: 7px 0;"
                                        :ref="'editYxmc'+scope.row.index"
                                        @click="clickShowChooseYxxhPopover($event,scope.row)">
                                        {{ scope.row.submitYxmc?scope.row.submitYxmc+'(未保存)'
                                        :scope.row.submitYxmc||scope.row.yxmc }}
                                    </el-button>
                                </div>
                            </el-popover>
                        </div>
                        <!-- <div v-else>
                            <el-popover 
                                placement="bottom-start"
                                trigger="click"
                                v-model="scope.row.chooseYxxhVisible"
                                :tabindex="scope.row.index+Math.random()*10"
                                >
                            <div style="display: flex;align-items: center;">
                                <el-select v-model="scope.row.selectedYxxh" style="width: 100px;" size="mini"
                                @change="changeSelectedYxxh($event,scope.row)" @click.capture="$event.stopPropagation();">
                                    <template v-if="scope.row.yxmcs.length>0">
                                        <el-option v-for="(item,index) in scope.row.yxmcs" :key="index"
                                        :label="item.yxmc" :value="item.yxxh" @click.capture="$event.stopPropagation();"></el-option>
                                    </template>
                                </el-select>
                                <el-button type="primary" size="small" style="margin-left: 6px;"
                                @click="submitUpdateYxxh(scope.row)">确认</el-button>
                            </div>
                                <div slot="reference">
                                    <el-button type="primary" size="mini"
                                        style="width: 100px;display: flex;justify-content: center;
                                        text-overflow:ellipsis;overflow: hidden;white-space: nowrap;padding: 7px 0;"
                                        :ref="'editYxmc'+scope.row.index"
                                        @click="clickShowChooseYxxhPopover($event,scope.row)">
                                        {{ scope.row.submitYxmc?scope.row.submitYxmc+'(未保存)'
                                        :scope.row.submitYxmc||scope.row.yxmc||'空' }}
                                    </el-button>
                                </div>
                            </el-popover>
                        </div> -->
                        <div v-else></div>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="专业组" width="90" prop="zyz">
                    <template slot-scope="scope">
                        <div v-if="scope.row.yxmc">
                            <el-popover 
                                placement="bottom-start"
                                trigger="click"
                                v-model="scope.row.chooseZyzVisible"
                                :tabindex="scope.row.index+Math.random()*10"
                                >
                            <div style="display: flex;align-items: center;">
                                <el-select v-model="scope.row.selectedZyz"
                                style="width: 100px;" size="mini"
                                @change="changeSelectedZyz($event,scope.row)" @click.capture="$event.stopPropagation();"
                                >
                                    <template v-if="scope.row.zyzs.length>0">
                                        <el-option v-for="(item,index) in scope.row.zyzs" :key="index"
                                        :label="item.zyz" :value="item.zyz" @click.capture="$event.stopPropagation();"></el-option>
                                    </template>
                                </el-select>
                                <el-button type="primary" size="small" style="margin-left: 6px;"
                                @click="submitUpdateZyz(scope.row)">保存</el-button>
                            </div>
                                <div slot="reference">
                                    <el-button type="primary" size="mini"
                                        style="width: 70px;display: flex;justify-content: center;
                                        text-overflow:ellipsis;overflow: hidden;white-space: nowrap;"
                                         :ref="'editZyz'+scope.row.index"
                                        @click="clickShowChooseZyzPopover($event,scope.row)"
                                        >
                                        {{ scope.row.submitZyz?scope.row.submitZyz+'(未保存)'
                                        :scope.row.submitZyz||scope.row.zyz }}
                                    </el-button>
                                </div>
                            </el-popover>
                        </div>
                        <!-- <div v-else>
                            <el-popover 
                                placement="bottom-start"
                                trigger="click"
                                v-model="scope.row.chooseZyzVisible"
                                :tabindex="scope.row.index+Math.random()*10"
                                >
                            <div style="display: flex;align-items: center;">
                                <el-select v-model="scope.row.selectedZyz"
                                style="width: 100px;" size="mini"
                                @change="changeSelectedZyz($event,scope.row)" @click.capture="$event.stopPropagation();">
                                    <template v-if="scope.row.zyzs.length>0">
                                        <el-option v-for="(item,index) in scope.row.zyzs" :key="index"
                                        :label="item.zyz" :value="item.zyz" @click.capture="$event.stopPropagation();"></el-option>
                                    </template>
                                </el-select>
                                <el-button type="primary" size="small" style="margin-left: 6px;"
                                @click="submitUpdateZyz(scope.row)">保存</el-button>
                            </div>
                                <div slot="reference">
                                    <el-button type="primary" size="mini"
                                        style="width: 70px;display: flex;justify-content: center;
                                        text-overflow:ellipsis;overflow: hidden;white-space: nowrap;"
                                        :ref="'editZyz'+scope.row.index"
                                        @click="clickShowChooseZyzPopover($event,scope.row)">
                                        {{ scope.row.submitZyz?scope.row.submitZyz+'(未保存)'
                                        :scope.row.submitZyz||scope.row.zyz||'空' }}
                                    </el-button>
                                </div>
                            </el-popover>
                        </div> -->
                        <div v-else></div>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="开设专业" width="100">
                    <template slot-scope="scope">
                        <div v-if="scope.row.yxmc">
                            <el-button v-if="scope.row.chooseFlag" type="primary" size="small"
                            style="background-color: #ff861a;border: 1px solid white;"
                            @click="chooseZy2(scope.row)">选择专业</el-button>
                            <el-button v-else type="primary" size="small"
                            @click="chooseZy2(scope.row)">选择专业</el-button>
                        </div>
                        <div v-else></div>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="所在省市" width="60" prop="szdqmc"></el-table-column>
                <el-table-column show-overflow-tooltip label="985" width="50" prop="sf985">
                    <template slot-scope="scope">
                        <img v-if="scope.row.sf985===1"
                        src="../../../assets/images/gou.png" width="20" height="20"/>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="211" width="50" prop="sf211">
                    <template slot-scope="scope">
                        <img v-if="scope.row.sf211===1"
                        src="../../../assets/images/gou.png" width="20" height="20"/>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="招生计划">
                    <el-table-column show-overflow-tooltip label="上年" width="50" prop="snjhs"></el-table-column>
                    <el-table-column show-overflow-tooltip label="当年" width="50" prop="jnjhs"></el-table-column>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="入档位次">
                    <el-table-column show-overflow-tooltip label="上年" width="50" prop="snrdwc"></el-table-column>
                    <el-table-column show-overflow-tooltip label="平均" width="50" prop="rdwc"></el-table-column>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="投档线">
                    <el-table-column show-overflow-tooltip label="上年" width="70" prop="tdx"></el-table-column>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="等效分">
                    <el-table-column show-overflow-tooltip label="最低" width="50" prop="zdtwf"></el-table-column>
                    <el-table-column show-overflow-tooltip label="平均" width="50" prop="pjtwf"></el-table-column>
                    <el-table-column show-overflow-tooltip label="最高" width="50" prop="zgtwf"></el-table-column>
                </el-table-column>
                <el-table-column width="114" label="操作">
                    <template slot-scope="scope">
                        <div v-if="scope.row.yxmc">
                            <div style="display: flex;justify-content: center;">
                            <el-button type="primary" size="small" @click="tableMovePrev(scope.row)">
                                <span class="el-icon-top"></span>
                            </el-button>
                            <el-button type="primary" size="small" @click="tableMoveNext(scope.row)" style="margin-left: 6px;">
                                <span class="el-icon-bottom"></span>
                            </el-button>
                            <!-- <a-popover 
                                placement="bottomLeft"
                                trigger="click"
                                :visible="scope.row.moveTrVisible"
                                @visibleChange="clickShowMoveWherePopover(scope.row)"
                                :tabindex="scope.row.index-1">
                            <div style="display: flex;align-items: center;" slot="content">
                                    将院校移动到
                                <el-input v-model="moveToTr" size="small" style="width: 60px;margin:0 6px;" @input="changeMoveToTr"></el-input>
                                                行
                                <el-button type="primary" size="small" style="margin-left: 6px;" @click="moveToWhereTr(scope.row,$event)">确定</el-button>
                            </div>
                                <el-button type="primary" size="small" style="margin-left: 6px;"
                                >
                                    <span class="el-icon-thumb"></span>
                                </el-button>
                            </a-popover> -->
                            </div>
                        </div>
                        <div v-else></div>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="专业服从" width="60" prop="sffc">
                    <!-- <template slot-scope="scope">
                        <el-select v-model="scope.row.sffc" @change="changeSffc($event,scope.row.index)" size="small">
                            <el-option label="服从" value="1"></el-option>
                            <el-option label="不服从" value="0"></el-option>
                        </el-select>
                    </template> -->
                    <template slot-scope="scope">
                        <span v-if="scope.row.yxmc">服从</span>
                        <span v-else></span>
                    </template>
                </el-table-column>
            </el-table>
                
                <div style="display: flex;flex-direction: column;">
                    <!-- <div style="display: flex;padding-left: 20px;background-color: rgba(192, 192, 192, 0.1);
                    padding-bottom: 10px;padding-top: 10px;">
                        <div style="width: 64px;text-align: left;">序号</div>
                        <div style="width: 75px;text-align: left;">院校代码</div>
                        <div style="width: 75px;text-align: center;">院校信息</div>
                        <div style="width: 64px;text-align: center;">专业组</div>
                        <div style="width: 100px;text-align: center;">开设专业</div>
                        <div style="width: 150px;text-align: center;">招生计划</div>
                        <div style="width: 150px;text-align: center;">入档位次</div>
                        <div style="width: 225px;text-align: center;">等效分</div>
                        <div style="width: 160px;text-align: center;">操作</div>
                        <div style="width: 90px;text-align: center;">专业服从</div>
                    </div> -->
                    <!-- <div style="display: flex;padding-left: 20px;background-color: rgba(192, 192, 192, 0.1);padding-bottom: 10px;">
                        <div style="width: 64px;text-align: left;"></div>
                        <div style="width: 75px;text-align: center;"></div>
                        <div style="width: 75px;text-align: center;"></div>
                        <div style="width: 64px;text-align: center;"></div>
                        <div style="width: 100px;text-align: center;"></div>
                        <div style="width:75px;text-align: center;">上年</div>
                        <div style="width:75px;text-align: center;">当年</div>
                        <div style="width:75px;text-align: center;">上年</div>
                        <div style="width:75px;text-align: center;">当年</div>
                        <div style="width:75px;text-align: center;">最低</div>
                        <div style="width:75px;text-align: center;">平均</div>
                        <div style="width:75px;text-align: center;">最高</div>
                        <div style="width: 160px;text-align: center;"></div>
                        <div style="width: 90px;text-align: center;"></div>
                    </div> -->
                <div style="max-height: 500px;overflow-y: auto;">
                    <!-- <el-collapse v-model="bkHandleYx" accordion>
                        <el-collapse-item v-for="(item,index) in bkCollectYx" :key="index" :name="item.yxmc+item.zyz+index">
                                <template slot="title">
                                    <div style="width: 64px;text-align:  center;" :class="item.radioChecked?'radio-row-checked':
                                            item.checked?'checkBox-row-checked':''">
                                        {{ item.index }}</div>
                                     <div style="width: 75px;text-align: center;padding-left: 10px;" :class="item.radioChecked?'radio-row-checked':
                                            item.checked?'checkBox-row-checked':''">{{ item.sb }}</div>
                                    <el-tooltip placement="top">
                                        <div slot="content">{{ item.yxmc }}</div>
                                        <div style="width: 75px;text-align: left;overflow: hidden;
                                        text-overflow: ellipsis;white-space: nowrap;margin-left: 32px;">{{ item.yxmc }}</div>
                                    </el-tooltip>
                                    <div style="width: 64px;text-align: left;padding-left: 8px;">{{ item.zyz }}</div>
                                </template>
                                <div style="display: flex;align-items: center;" :class="item.radioChecked?'radio-row-checked':
                                item.checked?'checkBox-row-checked':''" @click="tableRadioChange($event,item)">
                                    <div style="width: 64px;text-align:  center;cursor: pointer;">
                                        {{ item.index }}
                                    </div>
                                    <div style="width: 75px;text-align: center;padding-left: 10px;">
                                        {{ item.sb }}
                                    </div>
                                    <div style="width: 75px;text-align: center;margin-left: 32px;">
                                        <el-tooltip placement="top">
                                            <div slot="content">{{ item.yxmc }}</div>
                                            <div style="width: 75px;text-align: left;">
                                                <router-link
                                                tag="a"
                                                target="_blank"
                                                :to="{
                                                    path: '/main/schoolDetail',
                                                    query: { gbdm: item.gbdm,pc:item.pc,yxmc:item.yxmc,yxxh:item.yxxh }
                                                }"
                                                v-if="item.yxmc"
                                                >{{ item.yxmc }}</router-link>
                                            </div>
                                        </el-tooltip>
                                        <div style="width: 75px;text-align: left;">
                                            <img src="../../../assets/images/ico2.png" width="24" alt="985" title="985" v-if="item.sf985&&item.sf985===1">
                                            <img src="../../../assets/images/ico1.png" width="24" alt="211" title="211" v-if="item.sf211&&item.sf211===1">
                                        </div>
                                    </div>
                                    <div style="width: 64px;text-align: left;padding-left: 8px;">
                                        {{ item.zyz }}
                                    </div>
                                    <div style="width: 100px;text-align: left;">
                                        <el-button type="primary" size="small" v-if="item.yxmc" @click="chooseZy(item)">选择专业</el-button>
                                    </div>
                                    <el-tooltip placement="top">
                                        <div slot="content">{{ item.snjhs }}</div>
                                        <div style="width:75px;text-align: left;padding-left: 16px;overflow: hidden;
                                        text-overflow: ellipsis;white-space: nowrap;">{{ item.snjhs }}</div>
                                    </el-tooltip>
                                    <el-tooltip placement="top">
                                        <div slot="content">{{ item.jnjhs }}</div>
                                        <div style="width:75px;text-align: left;padding-left: 16px;overflow: hidden;
                                        text-overflow: ellipsis;white-space: nowrap;">{{ item.jnjhs }}</div>
                                    </el-tooltip>
                                    <el-tooltip placement="top">
                                        <div slot="content">{{ item.snrdwc }}</div>
                                        <div style="width:75px;text-align: left;overflow: hidden;
                                        text-overflow: ellipsis;white-space: nowrap;padding-left: 8px;">{{ item.snrdwc }}</div>
                                    </el-tooltip>
                                    <el-tooltip placement="top">
                                        <div slot="content">{{ item.rdwc }}</div>     
                                        <div style="width:75px;text-align: left;overflow: hidden;
                                        text-overflow: ellipsis;white-space: nowrap;padding-left: 8px;">{{ item.rdwc }}</div>
                                    </el-tooltip>
                                    <el-tooltip placement="top">
                                        <div slot="content">{{ item.zdtwf }}</div>
                                        <div style="width:75px;text-align: left;overflow: hidden;
                                        text-overflow: ellipsis;white-space: nowrap;padding-left: 14px;">{{ item.zdtwf }}</div>
                                    </el-tooltip>
                                    <el-tooltip placement="top">
                                        <div slot="content">{{ item.pjtwf }}</div>
                                        <div style="width:75px;text-align: left;overflow: hidden;
                                        text-overflow: ellipsis;white-space: nowrap;padding-left: 14px;">{{ item.pjtwf }}</div>
                                    </el-tooltip>
                                    <el-tooltip placement="top">
                                        <div slot="content">{{ item.zgtwf }}</div>
                                        <div style="width:75px;text-align: left;overflow: hidden;
                                        text-overflow: ellipsis;white-space: nowrap;padding-left: 14px;">{{ item.zgtwf }}</div>
                                    </el-tooltip>
                                    <div style="width: 90px;text-align: left;">
                                        <el-select v-model="item.sffc" style="width: 80px;" size="small">
                                            <el-option label="服从" value="1"></el-option>
                                            <el-option label="不服从" value="0"></el-option>
                                        </el-select>
                                    </div>
                                    <div style="width: 160px;text-align: left;">
                                        <el-button type="primary" size="small" v-if="item.yxmc" @click="tableMovePrev(item)">
                                            <span class="el-icon-top"></span>
                                        </el-button>
                                        <el-button type="primary" size="small" v-if="item.yxmc" @click="tableMoveNext(item)">
                                            <span class="el-icon-bottom"></span>
                                        </el-button>
                                        <el-popover 
                                            placement="bottom-start"
                                            trigger="manual"
                                            v-model="moveTrVisibleabc" :tabindex="index">
                                            <div style="display: flex;align-items: center;">
                                                将院校移动到
                                                <el-input v-model="moveToTr" size="small" style="width: 40px;margin:0 6px;"></el-input>
                                                行
                                                <el-button type="primary" size="small" style="margin-left: 6px;" @click="moveToWhereTr(item)">确定</el-button>
                                            </div>
                                            <el-button type="primary" size="small" slot="reference" style="margin-left: 10px;"
                                            @click="moveTrVisibleabc=!moveTrVisibleabc">
                                                <span class="el-icon-thumb"></span>
                                            </el-button>
                                        </el-popover>
                                    </div>
                                </div>
                        </el-collapse-item>
                    </el-collapse> -->
                    
                    <!-- <div style="display: flex;align-items: center;padding: 20px 0;
                                border-bottom: 1px solid #F2F2F2;"
                                :class="item.radioChecked?'radio-row-checked':''"
                                 v-for="(item,index) in zkTqpCollectYx" :key="index"
                                @click="tableRadioChange($event,item)">
                                  <div style="width: 64px;text-align:  center;cursor: pointer;overflow: hidden;
                                        text-overflow: ellipsis;white-space: nowrap;">
                                        <el-tag type="info" @click="tableCheckChange($event,item)"
                                        v-if="!item.checked">
                                        {{ item.index }}</el-tag>
                                        <el-tag @click="tableCheckChange($event,item)"
                                        v-if="item.checked">
                                        {{ item.index }}</el-tag>
                                    </div>
                                    <div style="width: 75px;text-align: center;padding-left: 10px;">
                                        {{ item.sb }}
                                    </div>
                                    <div style="width: 75px;text-align: center;margin-left: 32px;
                                        overflow: hidden; text-overflow: ellipsis;
                                        white-space: nowrap;">
                                        <el-tooltip placement="top">
                                            <div slot="content">
                                                {{ item.yxmc }}
                                                <el-divider direction="vertical"></el-divider>
                                                <div style="width: auto;text-align: left;display: inline-block;">{{ item.szdqmc }}</div>
                                                <el-divider direction="vertical" v-if="item.sf985===1||item.sf211===1"></el-divider>
                                                <div style="width: 50px;text-align: left;display: inline-block;" v-if="item.sf985===1||item.sf211===1">
                                                    <img src="../../../assets/images/ico2.png" width="24" alt="985" title="985" v-if="item.sf985&&item.sf985===1">
                                                    <img src="../../../assets/images/ico1.png" width="24" alt="211" title="211" v-if="item.sf211&&item.sf211===1">
                                                </div>
                                            </div>
                                            <div style="width: 75px;text-align: left;
                                        overflow: hidden; text-overflow: ellipsis;
                                        white-space: nowrap;">
                                                <router-link
                                                tag="a"
                                                target="_blank"
                                                :to="{
                                                    path: '/main/schoolDetail',
                                                    query: { gbdm: item.gbdm,pc:item.pc,yxmc:item.yxmc,yxxh:item.yxxh }
                                                }"
                                                v-if="item.yxmc"
                                                >
                                                {{ item.yxmc }} |
                                                <div style="width: 50px;text-align: left;display: inline-block;">{{ item.szdqmc }}</div>
                                                <div style="width: 50px;text-align: left;display: inline-block;" v-if="item.sf985===1||item.sf211===1">
                                                     | 
                                                    <img src="../../../assets/images/ico2.png" width="24" alt="985" title="985" v-if="item.sf985&&item.sf985===1">
                                                    <img src="../../../assets/images/ico1.png" width="24" alt="211" title="211" v-if="item.sf211&&item.sf211===1">
                                                </div>
                                            </router-link>
                                            </div>
                                        </el-tooltip>
                                    </div>
                                    <div style="width: 64px;text-align: left;padding-left: 8px;">
                                        {{ item.zyz }}
                                    </div>
                                    <div style="width: 100px;text-align: left;">
                                        <el-button type="primary" size="small" v-if="item.yxmc" @click="chooseZy(item)">选择专业</el-button>
                                    </div>
                                    <el-tooltip placement="top">
                                        <div slot="content">{{ item.snjhs }}</div>
                                        <div style="width:75px;text-align: left;padding-left: 16px;
                                        overflow: hidden; text-overflow: ellipsis;
                                        white-space: nowrap;">{{ item.snjhs }}</div>
                                    </el-tooltip>
                                    <el-tooltip placement="top">
                                        <div slot="content">{{ item.jnjhs }}</div>
                                        <div style="width:75px;text-align: left;padding-left: 16px;
                                                overflow: hidden;text-overflow: ellipsis;
                                                white-space: nowrap;">{{ item.jnjhs }}</div>
                                    </el-tooltip>
                                    <el-tooltip placement="top">
                                        <div slot="content">{{ item.snrdwc }}</div>
                                        <div style="width:75px;text-align: left;overflow: hidden;
                                        text-overflow: ellipsis;white-space: nowrap;padding-left: 8px;">{{ item.snrdwc }}</div>
                                    </el-tooltip>
                                    <el-tooltip placement="top">
                                        <div slot="content">{{ item.rdwc }}</div>     
                                        <div style="width:75px;text-align: left;overflow: hidden;
                                        text-overflow: ellipsis;white-space: nowrap;padding-left: 8px;">{{ item.rdwc }}</div>
                                    </el-tooltip>
                                    <el-tooltip placement="top">
                                        <div slot="content">{{ item.zdtwf }}</div>
                                        <div style="width:75px;text-align: left;overflow: hidden;
                                        text-overflow: ellipsis;white-space: nowrap;padding-left: 14px;">{{ item.zdtwf }}</div>
                                    </el-tooltip>
                                    <el-tooltip placement="top">
                                        <div slot="content">{{ item.pjtwf }}</div>
                                        <div style="width:75px;text-align: left;overflow: hidden;
                                        text-overflow: ellipsis;white-space: nowrap;padding-left: 14px;">{{ item.pjtwf }}</div>
                                    </el-tooltip>
                                    <el-tooltip placement="top">
                                        <div slot="content">{{ item.zgtwf }}</div>
                                        <div style="width:75px;text-align: left;overflow: hidden;
                                        text-overflow: ellipsis;white-space: nowrap;padding-left: 14px;">{{ item.zgtwf }}</div>
                                    </el-tooltip>
                                    <div style="width: 160px;text-align: left;">
                                        <el-button type="primary" size="small" v-if="item.yxmc" @click="tableMovePrev(item)">
                                            <span class="el-icon-top"></span>
                                        </el-button>
                                        <el-button type="primary" size="small" v-if="item.yxmc" @click="tableMoveNext(item)">
                                            <span class="el-icon-bottom"></span>
                                        </el-button>
                                        <el-popover 
                                            placement="bottom-start"
                                            trigger="manual"
                                            v-if="item.yxmc"
                                            v-model="item.moveTrVisible" :tabindex="index">
                                            <div style="display: flex;align-items: center;">
                                                将院校移动到
                                                <el-input v-model="moveToTr" size="small" style="width: 60px;margin:0 6px;"></el-input>
                                                行
                                                <el-button type="primary" size="small" style="margin-left: 6px;" @click="moveToWhereTr(item)">确定</el-button>
                                            </div>
                                            <el-button type="primary" size="small" slot="reference" style="margin-left: 10px;"
                                            @click="clickShowMoveWherePopover(item)">
                                                <span class="el-icon-thumb"></span>
                                            </el-button>
                                        </el-popover>
                                    </div>
                                    <div style="width: 90px;text-align: left;">
                                        <el-select v-model="item.sffc" style="width: 80px;" size="small" v-if="item.yxmc">
                                            <el-option label="服从" value="1"></el-option>
                                            <el-option label="不服从" value="0"></el-option>
                                        </el-select>
                                    </div>
                    </div> -->
                </div>
                </div>
                </div>
            </el-tab-pane>
            </el-tabs>
            <div style="width:1200px;margin:20px auto;display:flex;justify-content:space-between;">
                <div>
                <el-button type="primary" style="background-color: #ff861a;border: 1px solid white;" @click="moveFirst"><i class="el-icon-d-arrow-left" style="color:blue"></i> 移 动 到 第 一 行 </el-button>
                </div>
                <!--  style="margin-right: 200px;" -->
                <div v-if="userInfo.yhlb===7||userInfo.yhlb===9||userInfo.yhlb===2||yfFreePg===true">
                    <template>
                        <el-button type="primary" style="background-color: red;border: 1px solid white;font-size:16px"
                        @click="submitZypg">志愿评估</el-button>
                    </template>
                </div>
                <div style="margin-left: 50px;"  v-if="userInfo.yhlb===4&&yfFreePg===false">
                    <template>
                        <el-button type="primary" style="background-color: red;border: 1px solid white;"
                        @click="zypgOne">评估(仅1次)</el-button>
                        <el-button type="primary" style="background-color: red;border: 1px solid white;"
                        @click="foroverZypg">评估(次数不限)</el-button>
                    </template>
                </div>
                <!-- userInfo.yhlb===7||userInfo.yhlb===9||userInfo.yhlb===2||yfFreeDown===true -->
                <div v-if="userInfo.yhlb===7||userInfo.yhlb===9||userInfo.yhlb===2||yfFreeDown===true">
                    <template>
                    <!-- <el-button type="primary" @click="totalFreeDownload">下载</el-button> -->
                    <el-button type="primary" @click="freeDownload">下载院校专业组对比表</el-button>
                    <el-button type="primary" @click="freeDownExcel">下载模拟志愿表</el-button>
                    </template>
                </div>
                <!-- userInfo.yhlb===4&&yfFreeDown===false -->
                <div v-if="userInfo.yhlb===4&&yfFreeDown===false">
                    <template>
                        <!-- <el-button type="primary" @click="yhDownload">下载(5元/次)</el-button>
                        <el-button type="primary" @click="yjDownload">下载(20元/永久)</el-button> -->
                        <el-button type="primary" size="small" @click="yhDownload2">下载院校专业组对比表(5元/次)</el-button>
                        <el-button type="primary" size="small" @click="yjDownload2">下载院校专业组对比表(20元/永久)</el-button>
                        <el-button type="primary" size="small" @click="yhDownload3">下载模拟志愿表(5元/次)</el-button>
                        <el-button type="primary" size="small" @click="yjDownload3">下载模拟志愿表(20元/永久)</el-button>
                    </template>
                </div>
            </div>
            <el-dialog  title="金榜志愿通-支付" :visible.sync="dialogBuyVisible" width="30%">
                <el-form>
                <el-form-item label="适用省份">
                    <el-select v-model="buyInfo.sssf" style="width:150px;">
                        <template v-if="buyInfo.sssf===43||buyInfo.sssf==='43'">
                            <el-option value="43" label="湖南"></el-option>
                        </template>
                        <template v-if="buyInfo.sssf===44||buyInfo.sssf==='44'">
                            <el-option value="44" label="广东"></el-option>
                        </template>
                        <template v-if="buyInfo.sssf===51||buyInfo.sssf==='51'">
                            <el-option value="51" label="四川"></el-option>
                        </template>
                        <!-- <el-option value="44" label="广东"></el-option>
                        <el-option value="51" label="四川"></el-option> -->
                    </el-select>
                </el-form-item>
                <el-form-item label="商品类型">
                    <el-select v-model="buyInfo.type" style="width:150px;">
                        <el-option :value="buyInfo.type" :label="buyInfo.cpmc"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="商品数量">
                    <span>1份</span>
                </el-form-item>
                <el-form-item label="支付金额">
                    <span class="pay-price">￥{{buyInfo.payPrice}}</span>
                </el-form-item>
                <el-form-item label="付款方式">
                    <el-radio-group v-model="buyInfo.payType">
                        <el-radio :label="1">支付宝</el-radio>
                        <el-radio :label="2">微信</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item>
                    <div style="margin: 0 auto;width:100px;">
                        <el-button type="primary" @click="payZypg">立即支付</el-button>
                    </div>
                </el-form-item>
                <div class="note">
                    <span style="color: red;">特别提示：</span>
                    <p style="margin:10px 0;">1、手机端下载表格可能存在不兼容问题，请到电脑端下载！</p>
                    <p style="margin:10px 0;">2、本商品一经售出，一经出售，概不退换！如有问题，可与客服联系4000-190-550;本卡不记名、不挂一经出售，概不退换!如有问题，可与我们的 客服联系4000-190-550</p>
                </div>
            </el-form>
            </el-dialog>
            <el-dialog title="提示" width="30%" :visible.sync="dialogZkMsgVisible">
                <div>你有评估历史，是否使用折扣价？</div>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="confirmZk">是</el-button>
                    <el-button @click="cancelZk">否</el-button>
                </div>
            </el-dialog>
            <el-dialog
            :title="innerTitle"
            width="30%"
            :visible.sync="innerdialogVisible"
            @close="closeDialog"
        >
            <div class="weixin-panel">
            <div id="qrcode" class="qrcode" ref="qrCodeDiv"></div>
            <div class="qrcode-time">
                <i style="color:#ff7e00">{{ qrcodeTime }}s </i>后二维码过期
            </div>
            </div>
            </el-dialog>
            
            <el-dialog
            title="选择专业"
            width="60%"
            :visible.sync="dialogZyVisible"  :destroy-on-close="true"
            @opened="openChooseZy">
            <div style="margin: 0 20px;">
            <!-- <el-transfer v-model="selectedZys" @change="chooseDialogZy" target-order="push"
            :titles="['专业1','专业2']" :data="zyData" @right-check-change="choose"
            @left-check-change="leftChoose" filterable>
            <div slot-scope="{ option }">
            <div class="default-tranfer-item" @mouseenter="indexKey = option.key"
                 @mouseleave="indexKey = null">
              <div style="height:60px;white-space:pre-line;">{{ option.label }}</div>
            </div>
            </div>
            <div class="transer-footer" slot="right-footer">
                <el-button @click="moveUp">上移</el-button>
                <el-button @click="moveDown">下移</el-button>
            </div>
            </el-transfer> -->
                <!-- <a-transfer
                :data-source="zyData"
                :titles="['未选','已选']"
                :operations="['右移', '左移']"
                :filter-option="filterOption"
                :target-keys="selectedZys"
                :render="item => item.title"
                :locale="{ itemUnit: '项', itemsUnit: '项', notFoundContent: '列表为空', searchPlaceholder: '请输入搜索内容' }"
                @change="handleChange"
                @search="handleSearch"
                @selectChange="handleZySelect"
                :show-select-all="false">
                
      <template
        slot="children"
        slot-scope="{
          props: { direction, filteredItems, selectedKeys, disabled: listDisabled },
          on: { itemSelectAll, itemSelect },
        }"
      >
        <a-table
          :row-selection="
            getRowSelection({ disabled: listDisabled, selectedKeys, itemSelectAll, itemSelect })
          "
          :columns="direction === 'left' ? leftColumns : rightColumns"
          :data-source="filteredItems"
          size="small"
          :style="{ pointerEvents: listDisabled ? 'none' : null }"
          :custom-row="
            ({ key, disabled: itemDisabled }) => ({
              on: {
                click: () => {
                  if (itemDisabled || listDisabled) return;
                  itemSelect(key, !selectedKeys.includes(key));
                },
              },
            })
          "
          :locale="{filterConfirm: '确定',
            filterReset: '重置',
            emptyText: '暂无数据'}"
          bordered :pagination="false" :scroll="{'y':300}"
        />
      </template>
                    <div slot="footer" slot-scope="scope" v-if="scope.direction==='right'">
                        <el-button size="small" @click="moveUp">上移</el-button>
                        <el-button size="small" @click="moveDown">下移</el-button>
                    </div>
                </a-transfer> -->
                <!-- <el-row :gutter="20">
                    <el-col :span="11">
                        <div style="border: 1px solid #d9d9d9;height: 384px;border-radius: 4px;
                                overflow: hidden;background: #FFF;box-sizing: border-box;
                                position: relative; vertical-align: middle;">
                            <div class="h" style="padding: 9px 12px 9px 19px;border-bottom: 1px solid #e8e8e8;margin-bottom: 4px;">
                                <div><span style="color: blue;font-weight: 700;">{{ searchYxmc }}</span>{{ searchZyz }}组共{{ zyData.length }}个专业</div>
                                <div></div>
                            </div>
                            <div class="b zdy-list" ref="zdyTransferTab">
                                <a-table :data-source="filterZyDataLeft" :columns="leftColumns"
                                    size="small"
                                    :locale="{filterConfirm: '确定',
                                    filterReset: '重置',
                                    emptyText: '暂无数据'}"
                                    :row-selection="aRowSelection"
                                    :rowClassName="aTabRowClassName"
                                    :expanded-row-keys.sync="expandedRowKeys"
                                    @change="leftTabChange"
                                    :rowKey="(record)=>record.key"
                                     bordered :pagination="false" :scroll="{'y':300}"
                                     ></a-table>
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="2" style="display: flex;flex-direction: column;align-items: center;
                     justify-content: center;height: 384px;">
                                <el-button
                                @click="addRightZy"
                                type="primary"
                                :disabled="!leftSelectRows.length"
                                icon="el-icon-arrow-right"
                                size="mini"
                            >右移</el-button>
                            <el-button
                                @click="addLeftZy"
                                type="primary"
                                :disabled="!rightSelectRows.length"
                                icon="el-icon-arrow-left"
                                size="mini"
                                style="margin-left: 0;margin-top: 10px;"
                            >左移</el-button>
                    </el-col>
                    <el-col :span="11">
                        <div style="border: 1px solid #d9d9d9;height: 384px;border-radius: 4px;
                                overflow: hidden;background: #FFF;box-sizing: border-box;
                                position: relative; vertical-align: middle;">
                        <div class="h" style="padding: 9px 12px 9px 19px;border-bottom: 1px solid #e8e8e8;margin-bottom: 4px;">
                                <div>已选择<span style="color: blue;font-weight: 700;">{{ selectedZys.length }}</span>个专业填报</div>
                                <div></div>
                        </div>
                        <div class="b zdy-list" :style="{'height':rightContentHeight}">
                            <a-table :data-source="filterZyData" :columns="rightColumns"
                                size="small"
                                :locale="{filterConfirm: '确定',
                                    filterReset: '重置',
                                    emptyText: '暂无数据'}"
                                    :row-selection="aRowSelection2"
                                    :expanded-row-keys.sync="expandedRowKeys2"
                                    :row-key="(record)=>record.key"
                                    @change="rightTabChange"
                                bordered :pagination="false" :scroll="{'y':300}"></a-table>
                        </div>
                        <div class="f" style="border-top:1px solid #e8e8e8;padding: 6px 10px;">
                                <el-button size="small" @click="moveUp2">上移</el-button>
                                <el-button size="small" @click="moveDown2">下移</el-button>
                        </div>
                        </div>
                    </el-col>
                </el-row> -->

                <xp-transfer :left-columns="leftColumns" :left-data="filterZyDataLeft"
                :left-expanded-row-keys="expandedRowKeys" :left-select-rows="leftSelectRows"
                :left-row-selection="aRowSelection" :left-tab-row-class-name="aTabRowClassName"
                :left-top-title="leftTopTitle" :left-custom-row="aCustomRow.customRow"
                :right-columns="rightColumns" :right-data="filterZyData" :right-custom-row="bCustomRow.customRow"
                :right-expanded-row-keys="expandedRowKeys2" :right-row-selection="aRowSelection2"
                :right-select-rows="rightSelectRows" :right-top-title="rightTopTitle"
                @leftTabChange="leftTabChange" @rightTabChange="rightTabChange" @addRightZy="addRightZy"
                @addLeftZy="addLeftZy" @moveUp="moveUp2" @moveDown="moveDown2"
                >
                        <div class="h" slot="left-header"
                        style="padding: 9px 12px 9px 19px;border-bottom: 1px solid #e8e8e8;margin-bottom: 4px;">
                                <div>
                                    <span style="color: blue;font-weight: 700;">{{searchYxmc}}</span>
                                        {{searchZyz}}组共{{zyData.length}}个专业
                                </div>
                                <div></div>
                        </div>
                        <div class="h" slot="right-header"
                        style="padding: 9px 12px 9px 19px;border-bottom: 1px solid #e8e8e8;margin-bottom: 4px;">
                                <div>
                                    已选择
                                    <span style="color: blue;font-weight: 700;">{{ selectedZys.length }}</span>个专业填报
                                </div>
                                <div></div>
                        </div>
                        <!-- <div slot="footer" class="f" style="border-top:1px solid #e8e8e8;padding: 6px 10px;">
                                <el-button size="small" @click="moveUp2">上移</el-button>
                                <el-button size="small" @click="moveDown2">下移</el-button>
                        </div> -->
                </xp-transfer>
        </div>
            <div style="width:200px;margin:0 auto;margin-top:20px;">
                <el-button type="primary" @click="saveCheckedZy">保存</el-button>
                <el-button @click="closeZyDialog">取消</el-button>
            </div>
            </el-dialog>
            <form action="/yhgz/down" method="post" id="down_form">
            <!-- <input id="down_param" name="param" type="hidden" value="" /> -->
            <input id="down_list" name="list" type="hidden" value="" />
            </form>
        </div>
        </div>
    </div>
</template>
<script>
import QRCode from "qrcodejs2"; // 引入qrcode
import {mapState} from 'vuex';
import { batchDownload } from "../../../utils/downExcel";
import { apiFlag } from '../../../common/commonVariable';
import axios from "axios";
import { time } from "../../../utils/timeFormat";
import xpTransfer from "../../../components/xpTransfer.vue";
import { MessageBox } from "element-ui";
/**
 * 
                            customRender:( text, record, index )=>{
                                return <div onClick={()=>{
                                        if(record.isDisabled){
                                            return;
                                        }
                                        if(this.leftSelectRows.indexOf(record.key)<0){
                                            this.$message({
                                                message:"你已经选中了"+(this.leftSelectRows.length+1)+"个专业",
                                                type:"success",
                                                showClose:true
                                            });
                                        }else{
                                            if(this.leftSelectRows.length-1>0){
                                                this.$message({
                                                    message:"你已经选中了"+(this.leftSelectRows.length-1)+"个专业",
                                                    type:"success",
                                                    showClose:true
                                                });
                                            }
                                        }
                                        const selectedRows=this.leftSelectRows;
                                        console.log(selectedRows.length);
                                        if(selectedRows.length===5){
                                            this.filterZyDataLeft.forEach((item,index)=>{
                                                for(let i=0;i<selectedRows.length;i++){
                                                    if(item.key!==selectedRows[i]&&item.key!==record.key){
                                                        if(item.isChecked&&selectedRows.indexOf(item.key)>=0){
                                                            item.isDisabled=false;
                                                        }else if(item.isChecked&&selectedRows.indexOf(item.key)===-1){
                                                            item.isChecked=false;
                                                            item.isDisabled=true;
                                                        }else{
                                                            item.isDisabled=true;
                                                        }
                                                    }else{
                                                        item.isChecked=true;
                                                        item.isDisabled=false;
                                                    }
                                                }
                                            });
                                        }else{
                                            this.filterZyDataLeft.forEach((item,index)=>{
                                                item.isDisabled=false;
                                            });
                                        }
                                        this.filterZyDataLeft=[...this.filterZyDataLeft];
                                        this.leftSelectRows.indexOf(record.key)<0?this.leftSelectRows.push(record.key):
                                        this.leftSelectRows.splice(this.leftSelectRows.indexOf(record.key),1);
                                    }}
                                title={text} style="width:93px;line-height:1.6;text-align: left;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;'box-sizing':'border-box';">{text}</div>
                            }


                            
                            customRender:( text, record, index )=>{
                                return <div onClick={()=>{
                                        if(record.isDisabled){
                                            return;
                                        }
                                        if(this.rightSelectRows.indexOf(record.key)<0){
                                            this.$message({
                                                message:"你已经选中了"+(this.rightSelectRows.length+1)+"个专业",
                                                type:"success",
                                                showClose:true
                                            });
                                        }else{
                                            if(this.rightSelectRows.length-1>0){
                                                this.$message({
                                                    message:"你已经选中了"+(this.rightSelectRows.length-1)+"个专业",
                                                    type:"success",
                                                    showClose:true
                                                });
                                            }
                                        }
                                        const selectedRows=this.rightSelectRows;
                                        console.log(selectedRows.length);
                                        if(selectedRows.length===5){
                                            this.filterZyData.forEach((item,index)=>{
                                                for(let i=0;i<selectedRows.length;i++){
                                                    if(item.key!==selectedRows[i]&&item.key!==record.key){
                                                        if(item.isChecked&&selectedRows.indexOf(item.key)>=0){
                                                            item.isDisabled=false;
                                                        }else if(item.isChecked&&selectedRows.indexOf(item.key)===-1){
                                                            item.isChecked=false;
                                                            item.isDisabled=true;
                                                        }else{
                                                            item.isDisabled=true;
                                                        }
                                                    }else{
                                                        item.isChecked=true;
                                                        item.isDisabled=false;
                                                    }
                                                }
                                            });
                                        }else{
                                            this.filterZyData.forEach((item,index)=>{
                                                item.isDisabled=false;
                                            });
                                        }
                                        this.filterZyData=[...this.filterZyData];
                                        this.rightSelectRows.indexOf(record.key)<0?this.rightSelectRows.push(record.key):
                                        this.rightSelectRows.splice(this.rightSelectRows.indexOf(record.key),1);
                                    }}
                                title={text} style="width:93px;line-height:1.6;text-align: left;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;'box-sizing':'border-box';">{text}</div>
                            }
 */
export default {
  components: { xpTransfer },
props:['reloadGzYx'],
data(){
    return{
        activePcName:"6",
        bkCollectYx:[],
        zkCollectYx:[],
        buyInfo:{
            type:"1",
            sssf:"43",
            num:"1",
            payPrice:"688",
            payType:1,
            sjhm:"",
            yzm:"",
            dj:"",
            cpmc:""
        },
        dialogTableVisible:false,
        dialogPlanVisible:false,
        dialogOtherVisible:false,
        dialogBuyVisible:false,
        yxzyzList:[],
        selectedYxzyz:'',
        otherPlan:'',
        bkIndex:-1,
        zkIndex:-1,
        updateBk:false,
        updateZk:false,
        isOpen:false,
        planObj:{
            plan:"",
            time:"",
            id:''
        },
        qrcodeTime:0,
        innerdialogVisible:false,
        innerTitle:"",
        yfFreeDown:false,
        intervalQrcodeTime:null,
        filename:'院校专业组对比表',
        filename2:'模拟志愿表',
        reloadTimer:null,
        currentRow:null,
        bkTqpCollectYx:[],
        updateBKTqp:false,
        bkTqpIndex:-1,
        zkTqpCollectYx:[],
        updateZkTqp:false,
        zkTqpIndex:-1,
        bkHandleYx:"",
        zyData:[],
        selectedZys:[],
        dialogZyVisible:false,
        moveToTr:'',
        moveTrVisible:false,
        item:[],
        oldZySelected:[],
        leftCheckAll:false,
        rightCheckAll:false,
        leftIndeterminate:false,
        rightIndeterminate:false,
        leftColumns:[
            {
                            dataIndex: 'title',
                            title: '专业',
                            ellipsis:true,
                            width:140,
                            align:'left'
            },
            {
                            dataIndex: 'xf',
                            title: '学费',
                            align:'left'
            },
        ],
        rightColumns:[
            {
                            dataIndex: 'xh',
                            title: '序号',
                            ellipsis:true,
                            width:50,
                            align:'center'
            },
            {
                            dataIndex: 'title',
                            title: '专业',
                            ellipsis:true,
                            width:110,
                            align:'left'
            },
            {
                            dataIndex: 'xf',
                            title: '学费',
                            align:'left'
            },
        ],
        searchYxxh:'',
        searchZyz:'',
        searchIndex:-1,
        yfFreePg:false,
        wxSuccess:false,
        yfPg:false,
        dialogProVisble:false,
        dialogZkMsgVisible:false,
        payFlag:false,
        yfPay:false,
        pgPlan:'',
        dialogPgPlanZyVisible:false,
        fileList: [
            { url: '/down/downYhgzYxZyz', name: '院校专业组对比表.xlsx' },
            { url: '/down/downMnzyb', name: '模拟志愿表.xlsx' },
        ],
        downloading: false,
        currentIndex: 0,
        currentFile: null,
        totalCount: 0,
        progressPercent: 0,
        rightShowCount:0,
        filterZyData:[],
        filterZyDataLeft:[],
        searchYxmc:"",
        leftSelectRows:[],
        rightSelectRows:[],
        TabSelection:{
            onSelect(changeableRowKeys){
                console.log(changeableRowKeys);
            },
        },
        aCustomRow:{
            customRow:(record)=>{
                const that=this;
                                        return {
                                                props: {
                                                },
                                                on: { // 事件
                                                    click: (event) => {
                                                        if(record.isDisabled){
                                                            return;
                                                        }
                                                        const leftArr=that.filterZyDataLeft;
                                                        for(let i=0;i<leftArr.length;i++){
                                                            if(record.key===leftArr[i].key){
                                                                leftArr[i].isChecked=!leftArr[i].isChecked;
                                                                break;
                                                            }
                                                        }
                                                        that.filterZyDataLeft=leftArr;
                                                        if(that.leftSelectRows.indexOf(record.key)>=0){
                                                            that.leftSelectRows.splice(that.leftSelectRows.indexOf(record.key),1);
                                                        }else{
                                                            that.leftSelectRows.push(record.key);
                                                        }
                                                        if(that.leftSelectRows.length>0){
                                                            that.$message({
                                                                message:"已选择"+that.leftSelectRows.length+"所院校",
                                                                type:"success",
                                                                showClose:true
                                                            });
                                                        }
                                                        const selectedRows=that.leftSelectRows;
                                                        console.log(selectedRows.length);
                                                        if(selectedRows.length===6){
                                                            this.filterZyDataLeft.forEach((item,index)=>{
                                                                for(let i=0;i<selectedRows.length;i++){
                                                                    if(item.key!==selectedRows[i]&&item.key!==record.key){
                                                                        if(item.isChecked&&selectedRows.indexOf(item.key)>=0){
                                                                            item.isDisabled=false;
                                                                        }else if(item.isChecked&&selectedRows.indexOf(item.key)===-1){
                                                                            item.isChecked=false;
                                                                            item.isDisabled=true;
                                                                        }else{
                                                                            item.isDisabled=true;
                                                                        }
                                                                    }else{
                                                                        item.isChecked=true;
                                                                        item.isDisabled=false;
                                                                    }
                                                                }
                                                            });
                                                        }else{
                                                            that.filterZyDataLeft.forEach((item,index)=>{
                                                                item.isDisabled=false;
                                                            });
                                                        }
                                                        that.filterZyDataLeft=[...that.filterZyDataLeft];
                                                        that.leftSelectRows=[...that.leftSelectRows];
                                                        console.log(record,leftArr);
                                                    },       // 点击行
                                                    dblclick: (event) => {},
                                                    contextmenu: (event) => {},
                                                    mouseenter: (event) => {},  // 鼠标移入行
                                                    mouseleave: (event) => {}
                                                },

                                                };
                        },
        },
        bCustomRow:{
            customRow:(record)=>{
                const that=this;
                                        return {
                                                props: {
                                                },
                                                on: { // 事件
                                                    click: (event) => {
                                                        if(record.isDisabled){
                                                            return;
                                                        }
                                                        const leftArr=that.filterZyData;
                                                        for(let i=0;i<leftArr.length;i++){
                                                            if(record.key===leftArr[i].key){
                                                                leftArr[i].isChecked=!leftArr[i].isChecked;
                                                                break;
                                                            }
                                                        }
                                                        that.filterZyData=leftArr;
                                                        if(that.rightSelectRows.indexOf(record.key)>=0){
                                                            that.rightSelectRows.splice(that.rightSelectRows.indexOf(record.key),1);
                                                        }else{
                                                            that.rightSelectRows.push(record.key);
                                                        }
                                                        if(that.rightSelectRows.length>0){
                                                            that.$message({
                                                                message:"已选择"+that.rightSelectRows.length+"所院校",
                                                                type:"success",
                                                                showClose:true
                                                            });
                                                        }
                                                        const selectedRows=that.rightSelectRows;
                                                        console.log(selectedRows.length);
                                                        if(selectedRows.length===6){
                                                            this.filterZyData.forEach((item,index)=>{
                                                                for(let i=0;i<selectedRows.length;i++){
                                                                    if(item.key!==selectedRows[i]&&item.key!==record.key){
                                                                        if(item.isChecked&&selectedRows.indexOf(item.key)>=0){
                                                                            item.isDisabled=false;
                                                                        }else if(item.isChecked&&selectedRows.indexOf(item.key)===-1){
                                                                            item.isChecked=false;
                                                                            item.isDisabled=true;
                                                                        }else{
                                                                            item.isDisabled=true;
                                                                        }
                                                                    }else{
                                                                        item.isChecked=true;
                                                                        item.isDisabled=false;
                                                                    }
                                                                }
                                                            });
                                                        }else{
                                                            that.filterZyData.forEach((item,index)=>{
                                                                item.isDisabled=false;
                                                            });
                                                        }
                                                        that.filterZyData=[...that.filterZyData];
                                                        that.rightSelectRows=[...that.rightSelectRows];
                                                        console.log(record,leftArr);
                                                    },       // 点击行
                                                    dblclick: (event) => {},
                                                    contextmenu: (event) => {},
                                                    mouseenter: (event) => {},  // 鼠标移入行
                                                    mouseleave: (event) => {}
                                                },

                                                };
                        },
        },
        expandedRowKeys:[],
        expandedRowKeys2:[],
        aTabKey:false,
        rightContentHeight:"",
        bkYxmcUpdateKey:false,
        bkZyzUpdateKey:false,
        leftTopTitle:"",
        rightTopTitle:"",
        payMnzybFlag:false,
        inputObj:{
            xm:"",
            school:"",
            bz:""
        },
        xbs:[
            {name:"男",value:1},
            {name:"女",value:2}
        ],
    };
},
methods:{
    // 查询本科关注院校
    async getBkGzyx(){
        const obj={fs:this.userInfo.gkfs,kl:this.userInfo.sxkm,pc:6,xm:this.userInfo.xm,yhid:this.userInfo.yhid};
        const loading=this.$loading({fullscreen:true,target:document.getElementById("out-load-tab"),text:"正在加载中"});
        const res=await this.$http.postHttp("/yhgz/selectYhgzYx",obj);
        if(res.data.code===200){
            this.bkCollectYx=res.data.obj;
            const len=res.data.obj.length;
            for(let i=0;i<len;i++){
                this.bkCollectYx[i].checked=this.bkCollectYx[i].isRed||false;
                this.bkCollectYx[i].index=(i+1);
            }
            if(len<10){
                for(let i=0;i<10-len;i++){
                const obj={};
                obj.index=len+(i+1);
                obj.checked=false;
                obj.sb=null;
                obj.yxmc=null;
                obj.zyz=null;
                obj.szdqmc=null;
                obj.pc=null;
                obj.sf985=null;
                obj.sf211=null;
                this.bkCollectYx.push(obj);
            }
            }
        }else if(res.data.code===500){
            if(res.data.message){
                this.$message({message:res.data.message,type:'error'});
            }
        }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.data.code===0){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.status===409||res.status===410||res.status===411){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:"warning"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }
        loading.close();
    },
    // 获取专科关注院校
    async getZkGzyx(){
        const obj={fs:this.userInfo.gkfs,kl:this.userInfo.sxkm,pc:7,xm:this.userInfo.xm,yhid:this.userInfo.yhid};
        const loading=this.$loading({fullscreen:true,target:document.getElementById("out-load-tab"),text:"正在加载中"});
        const res=await this.$http.postHttp("/yhgz/selectYhgzYx",obj);
        if(res.data.code===200){
            this.zkCollectYx=res.data.obj;
            const len=res.data.obj.length;
            for(let i=0;i<len;i++){
                this.zkCollectYx[i].checked=this.zkCollectYx[i].isRed||false;
                this.zkCollectYx[i].index=(i+1);
            }
            if(len<10){
                for(let i=0;i<10-len;i++){
                const obj={};
                obj.index=len+(i+1);
                obj.checked=false;
                obj.sb=null;
                obj.yxmc=null;
                obj.zyz=null;
                obj.szdqmc=null;
                obj.pc=null;
                obj.sf985=null;
                obj.sf211=null;
                this.zkCollectYx.push(obj);
            }
            }
        }else if(res.data.code===500){
            if(res.data.message){
                this.$message({message:res.data.message,type:'error'});
            }
        }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.data.code===0){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.status===409||res.status===410||res.status===411){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:"warning"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }
        loading.close();
    },
    // 获取所有的关注院校
    async getYhGzYx(){
        const loading=this.$loading({fullscreen:true,target:document.getElementById("out-load-tab"),text:"正在加载中"});
        const res=await this.$http.getHttp("/yhgz/selectYhgzYx");
        console.log(res);
        if(res.data.code===200){
            if(!(res.data.obj.zk)&&!(res.data.obj.bk)&&!(res.data.obj.bktqp)&&!(res.data.obj.zktqp)){
                this.bkCollectYx=[...res.data.obj];
                const len=res.data.obj.length;
                for(let i=0;i<len;i++){
                    this.bkCollectYx[i].checked=this.bkCollectYx[i].isRed||false;
                    this.bkCollectYx[i].index=(i+1);
                    this.bkCollectYx[i].xh=res.data.obj[i].xh||null;
                    this.bkCollectYx[i].sffc='1';
                    this.bkCollectYx[i].yxmcs=[];
                    this.bkCollectYx[i].zyzs=[];
                    this.bkCollectYx[i].zy1=this.bkCollectYx[i].zydh1?this.bkCollectYx[i].zydh1:'';
                    this.bkCollectYx[i].zy2=this.bkCollectYx[i].zydh2?this.bkCollectYx[i].zydh2:'';
                    this.bkCollectYx[i].zy3=this.bkCollectYx[i].zydh3?this.bkCollectYx[i].zydh3:'';
                    this.bkCollectYx[i].zy4=this.bkCollectYx[i].zydh4?this.bkCollectYx[i].zydh4:'';
                    this.bkCollectYx[i].zy5=this.bkCollectYx[i].zydh5?this.bkCollectYx[i].zydh5:'';
                    this.bkCollectYx[i].zy6=this.bkCollectYx[i].zydh6?this.bkCollectYx[i].zydh6:'';
                    let flag1=false;
                    for(let j=1;j<=6;j++){
                        if(this.bkCollectYx[i]['zy'+j]){
                            flag1=true;
                            break;
                        }
                    }
                    console.log(flag1);
                    this.bkCollectYx[i].chooseFlag=flag1;
                }
            if(len<10){
                for(let i=0;i<10-len;i++){
                    const obj={};
                    obj.index=len+(i+1);
                    obj.checked=false;
                    obj.sb=null;
                    obj.yxmc=null;
                    obj.yxmcs=[];
                    obj.zyz=null;
                    obj.zyzs=[]
                    obj.szdqmc=null;
                    obj.pc=null;
                    obj.sf985=null;
                    obj.sf211=null;
                    obj.sffc='1';
                    obj.zy1='';
                    obj.zy2='';
                    obj.zy3='';
                    obj.zy4='';
                    obj.zy5='';
                    obj.zy6='';
                    this.bkCollectYx.push(obj);
            }
            }
            }else{
                this.createBkNullData();
                this.createZkNullData();
                this.createBkTqpNullData();
                this.createZkTqpNullData();
                this.sortBkYhgzYx(res);
                this.sortZkYhgzYx(res);
                this.sortBkTqpYhgzYx(res);
                this.sortZkTqpYhgzYx(res);
            }
        }else if(res.data.code===500){
            if(res.data.message){
                this.$message({message:res.data.message,type:'error'});
            }
        }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.data.code===0){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.status===409||res.status===410||res.status===411){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:"warning"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }
        loading.close();
    },
    sortBkYhgzYx(res){
                this.bkCollectYx=[...res.data.obj.bk];
                const len=res.data.obj.bk.length;
                for(let i=0;i<len;i++){
                    this.bkCollectYx[i].checked=this.bkCollectYx[i].isRed||false;
                    this.bkCollectYx[i].index=(i+1);
                    this.bkCollectYx[i].xh=res.data.obj.bk[i].xh;
                    this.bkCollectYx[i].radioChecked=false;
                    this.bkCollectYx[i].sffc='1';
                    this.bkCollectYx[i].yxmcs=[];
                    this.bkCollectYx[i].zyzs=[];
                    this.bkCollectYx[i].moveTrVisible=false;
                    this.bkCollectYx[i].chooseZyzVisible=false;
                    this.bkCollectYx[i].inputSbVisible=false;
                    this.bkCollectYx[i].chooseYxxhVisible=false;
                    this.bkCollectYx[i].submitSb='';
                    this.bkCollectYx[i].submitYxmc='';
                    this.bkCollectYx[i].submitZyz='';
                    this.bkCollectYx[i].selectedZyz=this.bkCollectYx[i].zyz;
                    this.bkCollectYx[i].selectedYxxh=this.bkCollectYx[i].yxxh;
                    this.bkCollectYx[i].writeSb=this.bkCollectYx[i].sb;
                    this.bkCollectYx[i].isChangeYxxh=false;
                    this.bkCollectYx[i].isChangeZyz=false;
                    this.bkCollectYx[i].type=this.bkCollectYx[i].sfjsl===2?3:
                    this.bkCollectYx[i].sfjsl===3?2:this.bkCollectYx[i].sfjsl;
                    this.bkCollectYx[i].isSaveTr=true;
                    this.bkCollectYx[i].zy1=this.bkCollectYx[i].zydh1?this.bkCollectYx[i].zydh1:'';
                    this.bkCollectYx[i].zy2=this.bkCollectYx[i].zydh2?this.bkCollectYx[i].zydh2:'';
                    this.bkCollectYx[i].zy3=this.bkCollectYx[i].zydh3?this.bkCollectYx[i].zydh3:'';
                    this.bkCollectYx[i].zy4=this.bkCollectYx[i].zydh4?this.bkCollectYx[i].zydh4:'';
                    this.bkCollectYx[i].zy5=this.bkCollectYx[i].zydh5?this.bkCollectYx[i].zydh5:'';
                    this.bkCollectYx[i].zy6=this.bkCollectYx[i].zydh6?this.bkCollectYx[i].zydh6:'';
                    let flag1=false;
                    for(let j=1;j<=6;j++){
                        if(this.bkCollectYx[i]['zy'+j]){
                            flag1=true;
                            break;
                        }
                    }
                    this.bkCollectYx[i].chooseFlag=flag1;
                }
                if(len<45){
                    for(let i=0;i<45-len;i++){
                    const obj={};
                    obj.index=len+(i+1);
                    obj.xh=len+(i+1);
                    obj.checked=false;
                    obj.sb=null;
                    obj.yxmc=null;
                    obj.yxmcs=[];
                    obj.zyz=null;
                    obj.zyzs=[];
                    obj.szdqmc=null;
                    obj.pc=6;
                    obj.sf985=null;
                    obj.sf211=null;
                    obj.radioChecked=false;
                    obj.sffc='1';
                    obj.moveTrVisible=false;
                    obj.chooseZyzVisible=false;
                    obj.inputSbVisible=false;
                    obj.chooseYxxhVisible=false;
                    obj.submitSb='';
                    obj.submitYxmc='';
                    obj.submitZyz='';
                    obj.selectedZyz='';
                    obj.selectedYxxh=''
                    obj.writeSb='';
                    obj.isChangeYxxh=false;
                    obj.isChangeZyz=false;
                    obj.sfjsl=null;
                    obj.type=null;
                    obj.isSaveTr=false;
                    obj.zy1='';
                    obj.zy2='';
                    obj.zy3='';
                    obj.zy4='';
                    obj.zy5='';
                    obj.zy6='';
                    obj.chooseFlag=false;
                    this.bkCollectYx.push(obj);
                }
                }
                const bkArr=[...this.bkCollectYx];
                const bkContentArr=[];
                const bkNullArr=[];
                for(let i=0;i<bkArr.length;i++){
                    if(bkArr[i].yxmc){
                        bkContentArr.push(bkArr[i]);
                    }else{
                        bkNullArr.push(bkArr[i]);
                    }
                }
                const bkArrLen=bkContentArr.length;
                for(let i=0;i<bkArrLen-1;i++){
                    for(let j=0;j<bkArrLen-1-i;j++){
                            if(bkContentArr[j].xh>bkContentArr[j+1].xh){
                                let temp=bkContentArr[j];
                                bkContentArr[j]=bkContentArr[j+1];
                                bkContentArr[j+1]=temp;
                            }
                    }
                }
                const bkConcatArr=bkContentArr.concat(bkNullArr);
                // for(let i=0;i<bkConcatArr.length;i++){
                //     console.log(bkConcatArr[i].xh);
                // }
                this.bkCollectYx=[...bkConcatArr];
                console.log(bkConcatArr);
                this.resetTableIndex();
    },
    sortZkYhgzYx(res){
                this.zkCollectYx=[...res.data.obj.zk];
                const len2=res.data.obj.zk.length;
                for(let i=0;i<len2;i++){
                    this.zkCollectYx[i].checked=this.zkCollectYx[i].isRed||false;
                    this.zkCollectYx[i].index=(i+1);
                    this.zkCollectYx[i].xh=res.data.obj.zk[i].xh||null;
                    this.zkCollectYx[i].radioChecked=false;
                    this.zkCollectYx[i].sffc='1';
                    this.zkCollectYx[i].yxmcs=[];
                    this.zkCollectYx[i].zyzs=[];
                    this.zkCollectYx[i].moveTrVisible=false;
                    this.zkCollectYx[i].chooseZyzVisible=false;
                    this.zkCollectYx[i].inputSbVisible=false;
                    this.zkCollectYx[i].chooseYxxhVisible=false;
                    this.zkCollectYx[i].submitSb='';
                    this.zkCollectYx[i].submitYxmc='';
                    this.zkCollectYx[i].submitZyz='';
                    this.zkCollectYx[i].selectedZyz=this.zkCollectYx[i].zyz;
                    this.zkCollectYx[i].selectedYxxh=this.zkCollectYx[i].yxxh;
                    this.zkCollectYx[i].writeSb=this.zkCollectYx[i].sb;
                    this.zkCollectYx[i].isChangeYxxh=false;
                    this.zkCollectYx[i].isChangeZyz=false;
                    this.zkCollectYx[i].type=this.zkCollectYx[i].sfjsl===2?3:
                    this.zkCollectYx[i].sfjsl===3?2:this.zkCollectYx[i].sfjsl;
                    this.zkCollectYx[i].isSaveTr=true;
                    this.zkCollectYx[i].zy1=this.zkCollectYx[i].zydh1?this.zkCollectYx[i].zydh1:'';
                    this.zkCollectYx[i].zy2=this.zkCollectYx[i].zydh2?this.zkCollectYx[i].zydh2:'';
                    this.zkCollectYx[i].zy3=this.zkCollectYx[i].zydh3?this.zkCollectYx[i].zydh3:'';
                    this.zkCollectYx[i].zy4=this.zkCollectYx[i].zydh4?this.zkCollectYx[i].zydh4:'';
                    this.zkCollectYx[i].zy5=this.zkCollectYx[i].zydh5?this.zkCollectYx[i].zydh5:'';
                    this.zkCollectYx[i].zy6=this.zkCollectYx[i].zydh6?this.zkCollectYx[i].zydh6:'';                    let flag1=false;
                    for(let j=1;j<=6;j++){
                        if(this.zkCollectYx[i]['zy'+j]){
                            flag1=true;
                            break;
                        }
                    }
                    console.log(flag1);
                    this.zkCollectYx[i].chooseFlag=flag1;
                }
                if(len2<30){
                    for(let i=0;i<30-len2;i++){
                    const obj={};
                    obj.index=len2+(i+1);
                    obj.xh=len2+(i+1);
                    obj.checked=false;
                    obj.sb=null;
                    obj.yxmc=null;
                    obj.yxmcs=[];
                    obj.zyz=null;
                    obj.zyzs=[];
                    obj.szdqmc=null;
                    obj.pc=7;
                    obj.sf985=null;
                    obj.sf211=null;
                    obj.radioChecked=false;
                    obj.sffc='1';
                    obj.moveTrVisible=false;
                    obj.chooseZyzVisible=false;
                    obj.inputSbVisible=false;
                    obj.chooseYxxhVisible=false;
                    obj.submitSb='';
                    obj.submitYxmc='';
                    obj.submitZyz='';
                    obj.selectedZyz='';
                    obj.selectedYxxh=''
                    obj.writeSb='';
                    obj.isChangeYxxh=false;
                    obj.isChangeZyz=false;
                    obj.sfjsl=null;
                    obj.type=null;
                    obj.isSaveTr=false;
                    obj.zy1='';
                    obj.zy2='';
                    obj.zy3='';
                    obj.zy4='';
                    obj.zy5='';
                    obj.zy6='';
                    obj.chooseFlag=false;
                    this.zkCollectYx.push(obj);
                }
                }
                const zkArr=[...this.zkCollectYx];
                const zkContentArr=[];
                const zkNullArr=[];
                for(let i=0;i<zkArr.length;i++){
                    if(zkArr[i].yxmc){
                        zkContentArr.push(zkArr[i]);
                    }else{
                        zkNullArr.push(zkArr[i]);
                    }
                }
                const zkArrLen=zkContentArr.length;
                for(let i=0;i<zkArrLen-1;i++){
                    for(let j=0;j<zkArrLen-1-i;j++){
                        if(zkContentArr[j].xh>zkContentArr[j+1].xh){
                            let temp=zkContentArr[j];
                            zkContentArr[j]=zkContentArr[j+1];
                            zkContentArr[j+1]=temp;
                        }
                    }
                }
                const zkConcatArr=zkContentArr.concat(zkNullArr);
                this.zkCollectYx=[...zkConcatArr];
                console.log(this.zkCollectYx);
                this.resetTableIndex();
    },
    sortBkTqpYhgzYx(res){
                this.bkTqpCollectYx=[...res.data.obj.bktqp];
                const len3=res.data.obj.bktqp.length;
                for(let i=0;i<len3;i++){
                    this.bkTqpCollectYx[i].checked=this.bkTqpCollectYx[i].isRed||false;
                    this.bkTqpCollectYx[i].index=(i+1);
                    this.bkTqpCollectYx[i].xh=res.data.obj.bktqp[i].xh;
                    this.bkTqpCollectYx[i].radioChecked=false;
                    this.bkTqpCollectYx[i].sffc='1';
                    this.bkTqpCollectYx[i].yxmcs=[];
                    this.bkTqpCollectYx[i].zyzs=[];
                    this.bkTqpCollectYx[i].moveTrVisible=false;
                    this.bkTqpCollectYx[i].chooseZyzVisible=false;
                    this.bkTqpCollectYx[i].inputSbVisible=false;
                    this.bkTqpCollectYx[i].chooseYxxhVisible=false;
                    this.bkTqpCollectYx[i].submitSb='';
                    this.bkTqpCollectYx[i].submitYxmc='';
                    this.bkTqpCollectYx[i].submitZyz='';
                    this.bkTqpCollectYx[i].selectedZyz=this.bkTqpCollectYx[i].zyz;
                    this.bkTqpCollectYx[i].selectedYxxh=this.bkTqpCollectYx[i].yxxh;
                    this.bkTqpCollectYx[i].writeSb=this.bkTqpCollectYx[i].sb;
                    this.bkTqpCollectYx[i].isChangeYxxh=false;
                    this.bkTqpCollectYx[i].isChangeZyz=false;
                    this.bkTqpCollectYx[i].type=this.bkTqpCollectYx[i].sfjsl===2?3:
                    this.bkTqpCollectYx[i].sfjsl===3?2:this.bkTqpCollectYx[i].sfjsl;
                    this.bkTqpCollectYx[i].isSaveTr=true;
                    this.bkTqpCollectYx[i].zy1=this.bkTqpCollectYx[i].zydh1?this.bkTqpCollectYx[i].zydh1:'';
                    this.bkTqpCollectYx[i].zy2=this.bkTqpCollectYx[i].zydh2?this.bkTqpCollectYx[i].zydh2:'';
                    this.bkTqpCollectYx[i].zy3=this.bkTqpCollectYx[i].zydh3?this.bkTqpCollectYx[i].zydh3:'';
                    this.bkTqpCollectYx[i].zy4=this.bkTqpCollectYx[i].zydh4?this.bkTqpCollectYx[i].zydh4:'';
                    this.bkTqpCollectYx[i].zy5=this.bkTqpCollectYx[i].zydh5?this.bkTqpCollectYx[i].zydh5:'';
                    this.bkTqpCollectYx[i].zy6=this.bkTqpCollectYx[i].zydh6?this.bkTqpCollectYx[i].zydh6:'';
                    let flag1=false;
                    for(let j=1;j<=6;j++){
                        if(this.bkTqpCollectYx[i]['zy'+j]){
                            flag1=true;
                            break;
                        }
                    }
                    this.bkTqpCollectYx[i].chooseFlag=flag1;
                }
                if(len3<45){
                    for(let i=0;i<45-len3;i++){
                    const obj={};
                    obj.index=len3+(i+1);
                    obj.xh=len3+(i+1);
                    obj.checked=false;
                    obj.sb=null;
                    obj.yxmc=null;
                    obj.yxmcs=[];
                    obj.zyz=null;
                    obj.zyzs=[];
                    obj.szdqmc=null;
                    obj.pc=0;
                    obj.sf985=null;
                    obj.sf211=null;
                    obj.radioChecked=false;
                    obj.sffc='1';
                    obj.moveTrVisible=false;
                    obj.chooseZyzVisible=false;
                    obj.inputSbVisible=false;
                    obj.chooseYxxhVisible=false;
                    obj.submitSb='';
                    obj.submitYxmc='';
                    obj.submitZyz='';
                    obj.selectedZyz='';
                    obj.selectedYxxh=''
                    obj.writeSb='';
                    obj.isChangeYxxh=false;
                    obj.isChangeZyz=false;
                    obj.sfjsl=null;
                    obj.type=null;
                    obj.isSaveTr=false;
                    obj.zy1='';
                    obj.zy2='';
                    obj.zy3='';
                    obj.zy4='';
                    obj.zy5='';
                    obj.zy6='';
                    obj.chooseFlag=false;
                    this.bkTqpCollectYx.push(obj);
                }
                }
                const bkTqpArr=[...this.bkTqpCollectYx];
                const bkTqpContentArr=[];
                const bkTqpNullArr=[];
                for(let i=0;i<bkTqpArr.length;i++){
                    if(bkTqpArr[i].yxmc){
                        bkTqpContentArr.push(bkTqpArr[i]);
                    }else{
                        bkTqpNullArr.push(bkTqpArr[i]);
                    }
                }
                const bkTqpLen=bkTqpContentArr.length;
                for(let i=0;i<bkTqpLen-1;i++){
                    for(let j=0;j<bkTqpLen-1-i;j++){
                        if(bkTqpContentArr[j].xh>bkTqpContentArr[j+1].xh){
                            let temp=bkTqpContentArr[j];
                            bkTqpContentArr[j]=bkTqpContentArr[j+1];
                            bkTqpContentArr[j+1]=temp;
                        }
                    }
                }
                const bkTqpConcatArr=bkTqpContentArr.concat(bkTqpNullArr);
                this.bkTqpCollectYx=[...bkTqpConcatArr];
                this.resetTableIndex();
    },
    sortZkTqpYhgzYx(res){
                this.zkTqpCollectYx=[...res.data.obj.zktqp];
                const len4=res.data.obj.zktqp.length;
                for(let i=0;i<len4;i++){
                    this.zkTqpCollectYx[i].checked=this.zkTqpCollectYx[i].isRed||false;
                    this.zkTqpCollectYx[i].index=(i+1);
                    this.zkTqpCollectYx[i].xh=res.data.obj.zktqp[i].xh;
                    this.zkTqpCollectYx[i].radioChecked=false;
                    this.zkTqpCollectYx[i].sffc='1';
                    this.zkTqpCollectYx[i].yxmcs=[];
                    this.zkTqpCollectYx[i].zyzs=[];
                    this.zkTqpCollectYx[i].moveTrVisible=false;
                    this.zkTqpCollectYx[i].chooseZyzVisible=false;
                    this.zkTqpCollectYx[i].inputSbVisible=false;
                    this.zkTqpCollectYx[i].chooseYxxhVisible=false;
                    this.zkTqpCollectYx[i].submitSb='';
                    this.zkTqpCollectYx[i].submitYxmc='';
                    this.zkTqpCollectYx[i].submitZyz='';
                    this.zkTqpCollectYx[i].selectedZyz=this.zkTqpCollectYx[i].zyz;
                    this.zkTqpCollectYx[i].selectedYxxh=this.zkTqpCollectYx[i].yxxh;
                    this.zkTqpCollectYx[i].writeSb=this.zkTqpCollectYx[i].sb;
                    this.zkTqpCollectYx[i].isChangeYxxh=false;
                    this.zkTqpCollectYx[i].isChangez=false;
                    this.zkTqpCollectYx[i].type=this.zkTqpCollectYx[i].sfjsl===2?3:
                    this.zkTqpCollectYx[i].sfjsl===3?2:this.zkTqpCollectYx[i].sfjsl;
                    this.zkTqpCollectYx[i].isSaveTr=true;
                    this.zkTqpCollectYx[i].zy1=this.zkTqpCollectYx[i].zydh1?this.zkTqpCollectYx[i].zydh1:'';
                    this.zkTqpCollectYx[i].zy2=this.zkTqpCollectYx[i].zydh2?this.zkTqpCollectYx[i].zydh2:'';
                    this.zkTqpCollectYx[i].zy3=this.zkTqpCollectYx[i].zydh3?this.zkTqpCollectYx[i].zydh3:'';
                    this.zkTqpCollectYx[i].zy4=this.zkTqpCollectYx[i].zydh4?this.zkTqpCollectYx[i].zydh4:'';
                    this.zkTqpCollectYx[i].zy5=this.zkTqpCollectYx[i].zydh5?this.zkTqpCollectYx[i].zydh5:'';
                    this.zkTqpCollectYx[i].zy6=this.zkTqpCollectYx[i].zydh6?this.zkTqpCollectYx[i].zydh6:'';
                    let flag1=false;
                    for(let j=1;j<=6;j++){
                        if(this.zkTqpCollectYx[i]['zy'+j]){
                            flag1=true;
                            break;
                        }
                    }
                    this.zkTqpCollectYx[i].chooseFlag=flag1;
                }
                if(len4<30){
                    for(let i=0;i<30-len4;i++){
                        const obj={};
                        obj.index=len4+(i+1);
                        obj.xh=len4+(i+1);
                        obj.checked=false;
                        obj.sb=null;
                        obj.yxmc=null;
                        obj.yxmcs=[];
                        obj.zyz=null;
                        obj.zyzs=[];
                        obj.szdqmc=null;
                        obj.pc=9;
                        obj.sf985=null;
                        obj.sf211=null;
                        obj.radioChecked=false;
                        obj.sffc='1';
                        obj.moveTrVisible=false;
                        obj.chooseZyzVisible=false;
                        obj.inputSbVisible=false;
                        obj.chooseYxxhVisible=false;
                        obj.submitSb='';
                        obj.submitYxmc='';
                        obj.submitZyz='';
                        obj.selectedZyz='';
                        obj.selectedYxxh=''
                        obj.writeSb='';
                        obj.isChangeYxxh=false;
                        obj.isChangeZyz=false;
                        obj.sfjsl=null;
                        obj.type=null;
                        obj.isSaveTr=false;
                        obj.zy1='';
                        obj.zy2='';
                        obj.zy3='';
                        obj.zy4='';
                        obj.zy5='';
                        obj.zy6='';
                        obj.chooseFlag=false;
                        this.zkTqpCollectYx.push(obj);
                    }
                }
                const zkTqpArr=[...this.zkTqpCollectYx];
                const zkTqpContentArr=[];
                const zkTqpNullArr=[];
                for(let i=0;i<zkTqpArr.length;i++){
                    if(zkTqpArr[i].yxmc){
                        zkTqpContentArr.push(zkTqpArr[i]);
                    }else{
                        zkTqpNullArr.push(zkTqpArr[i]);
                    }
                }
                const zkTqpLen=zkTqpContentArr.length;
                for(let i=0;i<zkTqpLen-1;i++){
                    for(let j=0;j<zkTqpLen-1-i;j++){
                        if(zkTqpContentArr[j].xh>zkTqpContentArr[j+1].xh){
                            let temp=zkTqpContentArr[j];
                            zkTqpContentArr[j]=zkTqpContentArr[j+1];
                            zkTqpContentArr[j+1]=temp;
                        }
                    }
                }
                const zktqpConcatArr=zkTqpContentArr.concat(zkTqpNullArr);
                this.zkTqpCollectYx=[...zktqpConcatArr];
                console.log(zkTqpArr);
                this.resetTableIndex();
    },
    // 本科选中的行
    handleBkCurrentChange(val) {
        if(val){
            if(val.zyz){
            this.bkIndex=(val.index-1);
            }
            this.currentRow=val;
        }
    },
    // 专科选中的行
    handleZkCurrentChange(val) {
        if(val){
            if(val.zyz){
            this.zkIndex=(val.index-1);
        }
        }
    },
    handleBkTqpCurrentChange(val){
        if(val){
            if(val.zyz){
                this.bkTqpIndex=(val.index-1);
            }
            this.currentRow=val;
        }
    },
    handleZKTqpCurrentChange(val){
        if(val){
            if(val.zyz){
                this.zkTqpIndex=(val.index-1);
            }
            this.currentRow=val;
        }
    },
    handleTabCurrentChange(val){
        const pc=this.activePcName;
        if(pc==='6'){
            if(val){
                if(val.zyz){
                    this.bkIndex=(val.index-1);
                }
            }
        }else if(pc==='7'){
            if(val){
                if(val.zyz){
                    this.zkIndex=(val.index-1);
                }
            }
        }else if(pc==='0'){
            if(val){
                if(val.zyz){
                    this.bkTqpIndex=(val.index-1);
                }
            }
        }else{
            if(val){
                if(val.zyz){
                    this.zkTqpIndex=(val.index-1);
                }
            }
        }
    },
    // 本科和专科的切换
    async handleClick(tab,event){
        // const activePcName=this.activePcName;
        const id=this.$route.query.id;
        const pc=this.$route.query.pc;
        const isto=this.$route.query.isto;
        if(id){
            if(isto){
            }else{
                // await this.getYxzyzById(id,pc);
            }
        }else{
            // if(activePcName==='6'){
            // await this.getBkGzyx();
            // }else if(activePcName==='7'){
            //     await this.getZkGzyx();
            // }
        }
    },
    // 获取已保存的院校专业组列表
    async getMyYxzyz(){
        const yhid=this.userInfo.yhid;
        const res=await this.$http.getHttp("/yhgzfa/selectYxZyzFaByYhid?yhid="+yhid);
        if(res.data.code===200){
            this.yxzyzList=[...res.data.obj];
            this.isOpen=true;
        }else if(res.data.code===500){
            if(res.data.message){
                this.$message({message:res.dataa.message,type:"error"});
            }
        }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.data.code===0){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.status===409||res.status===410||res.status===411){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:"warning"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }
    },
    // 打开已保存的院校专业组
    async openYxzyz(){
        await this.getZyfaList();
        if(this.isOpen){
            this.dialogTableVisible=true;
        }
    },
    // 升序代码
    ascTableData(){
        const activePcName=this.activePcName;
        if(activePcName==='6'){
            const arr=[...this.bkCollectYx];
            const compareArr=[];
            const nullArr=[];
            for(let i=0;i<arr.length;i++){
                if(arr[i].pjtwf){
                    compareArr.push(arr[i]);
                }else{
                    nullArr.push(arr[i]);
                }
            }
            for(let i=0;i<compareArr.length;i++){
                for(let j=0;j<compareArr.length-i-1;j++){
                    if(compareArr[j].pjtwf>compareArr[j+1].pjtwf){
                        const temp=compareArr[j];
                        compareArr[j]=compareArr[j+1];
                        compareArr[j+1]=temp;
                    }
                }
            }
            if(nullArr.length>0){
                const bkArr=[...compareArr.concat(nullArr)];
                for(let i=0;i<bkArr.length;i++){
                    if(bkArr[i]){
                        bkArr[i].index=i+1;
                    }
                }
                this.bkCollectYx=[...bkArr];
                this.bkIndex=-1;
                // this.$store.dispatch("saveCollectSchool",{collectSchool:bkArr,pc:this.activePcName});
            }else{
                const bkArr=[...compareArr];
                for(let i=0;i<bkArr.length;i++){
                    if(bkArr[i]){
                        bkArr[i].index=i+1;
                    }
                }
                this.bkCollectYx=[...bkArr];
                this.bkIndex=-1;
                // this.$store.dispatch("saveCollectSchool",{collectSchool:bkArr,pc:this.activePcName});
            }
        }else if(activePcName==='7'){
            const arr=[...this.zkCollectYx];
            const compareArr=[];
            const nullArr=[];
            for(let i=0;i<arr.length;i++){
                if(arr[i].pjtwf){
                    compareArr.push(arr[i]);
                }else{
                    nullArr.push(arr[i]);
                }
            }
            for(let i=0;i<compareArr.length;i++){
                for(let j=0;j<compareArr.length-i-1;j++){
                    if(compareArr[j].pjtwf>compareArr[j+1].pjtwf){
                        const temp=compareArr[j];
                        compareArr[j]=compareArr[j+1];
                        compareArr[j+1]=temp;
                    }
                }
            }
            if(nullArr.length>0){
                const zkArr=[...compareArr.concat(nullArr)];
                for(let i=0;i<zkArr.length;i++){
                    if(zkArr[i]){
                        zkArr[i].index=i+1;
                    }
                }
                this.zkCollectYx=[...zkArr];
                this.zkIndex=-1;
                // if(!(this.planObj.plan)){
                //     this.$store.dispatch("saveCollectSchool",{collectSchool:zkArr,pc:this.activePcName});
                // }
            }else{
                const zkArr=[...compareArr];
                for(let i=0;i<zkArr.length;i++){
                    if(zkArr[i]){
                        zkArr[i].index=i+1;
                    }
                }
                this.zkCollectYx=[...zkArr];
                this.zkIndex=-1;
                // if(!(this.planObj.plan)){
                //     this.$store.dispatch("saveCollectSchool",{collectSchool:zkArr,pc:this.activePcName});
                // }
            }
        }else if(activePcName==='0'){
            const arr=[...this.bkTqpCollectYx];
            const compareArr=[];
            const nullArr=[];
            for(let i=0;i<arr.length;i++){
                if(arr[i].pjtwf){
                    compareArr.push(arr[i]);
                }else{
                    nullArr.push(arr[i]);
                }
            }
            for(let i=0;i<compareArr.length;i++){
                for(let j=0;j<compareArr.length-i-1;j++){
                    if(compareArr[j].pjtwf>compareArr[j+1].pjtwf){
                        const temp=compareArr[j];
                        compareArr[j]=compareArr[j+1];
                        compareArr[j+1]=temp;
                    }
                }
            }
            if(nullArr.length>0){
                const bkTqpArr=[...compareArr.concat(nullArr)];
                for(let i=0;i<bkTqpArr.length;i++){
                    if(bkTqpArr[i]){
                        bkTqpArr[i].index=i+1;
                    }
                }
                this.bkTqpCollectYx=[...bkTqpArr];
                this.bkTqpIndex=-1;
                // if(!(this.planObj.plan)){
                //     this.$store.dispatch("saveCollectSchool",{collectSchool:zkArr,pc:this.activePcName});
                // }
            }else{
                const bkTqpArr=[...compareArr];
                for(let i=0;i<bkTqpArr.length;i++){
                    if(bkTqpArr[i]){
                        bkTqpArr[i].index=i+1;
                    }
                }
                this.bkTqpCollectYx=[...bkTqpArr];
                this.bkTqpIndex=-1;
                // if(!(this.planObj.plan)){
                //     this.$store.dispatch("saveCollectSchool",{collectSchool:zkArr,pc:this.activePcName});
                // }
            }
        }else{
            const arr=[...this.zkTqpCollectYx];
            const compareArr=[];
            const nullArr=[];
            for(let i=0;i<arr.length;i++){
                if(arr[i].pjtwf){
                    compareArr.push(arr[i]);
                }else{
                    nullArr.push(arr[i]);
                }
            }
            for(let i=0;i<compareArr.length;i++){
                for(let j=0;j<compareArr.length-i-1;j++){
                    if(compareArr[j].pjtwf>compareArr[j+1].pjtwf){
                        const temp=compareArr[j];
                        compareArr[j]=compareArr[j+1];
                        compareArr[j+1]=temp;
                    }
                }
            }
            if(nullArr.length>0){
                const zkTqpArr=[...compareArr.concat(nullArr)];
                for(let i=0;i<zkTqpArr.length;i++){
                    if(zkTqpArr[i]){
                        zkTqpArr[i].index=i+1;
                    }
                }
                this.zkTqpCollectYx=[...zkTqpArr];
                this.zkTqpIndex=-1;
                // if(!(this.planObj.plan)){
                //     this.$store.dispatch("saveCollectSchool",{collectSchool:zkArr,pc:this.activePcName});
                // }
            }else{
                const zkTqpArr=[...compareArr];
                for(let i=0;i<zkTqpArr.length;i++){
                    if(zkTqpArr[i]){
                        zkTqpArr[i].index=i+1;
                    }
                }
                this.zkTqpCollectYx=[...zkTqpArr];
                this.zkTqpIndex=-1;
                // if(!(this.planObj.plan)){
                //     this.$store.dispatch("saveCollectSchool",{collectSchool:zkArr,pc:this.activePcName});
                // }
            }
        }
    },
    // 降序代码
    descTableData(){
        const activePcName=this.activePcName;
        if(activePcName==='6'){
            const arr=[...this.bkCollectYx];
            const compareArr=[];
            const nullArr=[];
            for(let i=0;i<arr.length;i++){
                if(arr[i].pjtwf){
                    compareArr.push(arr[i]);
                }else{
                    nullArr.push(arr[i]);
                }
            }
            for(let i=0;i<compareArr.length;i++){
                for(let j=0;j<compareArr.length-i-1;j++){
                    if(compareArr[j].pjtwf<compareArr[j+1].pjtwf){
                        const temp=compareArr[j];
                        compareArr[j]=compareArr[j+1];
                        compareArr[j+1]=temp;
                    }
                }
            }
            if(nullArr.length>0){
                const bkArr=[...compareArr.concat(nullArr)];
                for(let i=0;i<bkArr.length;i++){
                    if(bkArr[i]){
                        bkArr[i].index=i+1;
                    }
                }
                this.bkCollectYx=[...bkArr];
                this.bkIndex=-1;
                // if(!(this.planObj.plan)){
                //     this.$store.dispatch("saveCollectSchool",{collectSchool:bkArr,pc:this.activePcName});
                // }
            }else{
                const bkArr=[...compareArr];
                for(let i=0;i<bkArr.length;i++){
                    if(bkArr[i]){
                        bkArr[i].index=i+1;
                    }
                }
                this.bkCollectYx=[...bkArr];
                this.bkIndex=-1;
                // if(!(this.planObj.plan)){
                //     this.$store.dispatch("saveCollectSchool",{collectSchool:bkArr,pc:this.activePcName});
                // }
            }
        }else if(activePcName==='7'){
            const arr=[...this.zkCollectYx];
            const compareArr=[];
            const nullArr=[];
            for(let i=0;i<arr.length;i++){
                if(arr[i].pjtwf){
                    compareArr.push(arr[i]);
                }else{
                    nullArr.push(arr[i]);
                }
            }
            for(let i=0;i<compareArr.length;i++){
                for(let j=0;j<compareArr.length-i-1;j++){
                    if(compareArr[j].pjtwf<compareArr[j+1].pjtwf){
                        const temp=compareArr[j];
                        compareArr[j]=compareArr[j+1];
                        compareArr[j+1]=temp;
                    }
                }
            }
            if(nullArr.length>0){
                const zkArr=[...compareArr.concat(nullArr)];
                for(let i=0;i<zkArr.length;i++){
                    if(zkArr[i]){
                        zkArr[i].index=i+1;
                    }
                }
                this.zkCollectYx=[...zkArr];
                this.zkIndex=-1;
                // if(!(this.planObj.plan)){
                //     this.$store.dispatch("saveCollectSchool",{collectSchool:zkArr,pc:this.activePcName});
                // }
            }else{
                const zkArr=[...compareArr];
                for(let i=0;i<zkArr.length;i++){
                    if(zkArr[i]){
                        zkArr[i].index=i+1;
                    }
                }
                this.zkCollectYx=[...zkArr];
                this.zkIndex=-1;
                // if(!(this.planObj.plan)){
                //     this.$store.dispatch("saveCollectSchool",{collectSchool:zkArr,pc:this.activePcName});
                // }
            }
        }else if(activePcName==='0'){
            const arr=[...this.bkTqpCollectYx];
            const compareArr=[];
            const nullArr=[];
            for(let i=0;i<arr.length;i++){
                if(arr[i].pjtwf){
                    compareArr.push(arr[i]);
                }else{
                    nullArr.push(arr[i]);
                }
            }
            for(let i=0;i<compareArr.length;i++){
                for(let j=0;j<compareArr.length-i-1;j++){
                    if(compareArr[j].pjtwf<compareArr[j+1].pjtwf){
                        const temp=compareArr[j];
                        compareArr[j]=compareArr[j+1];
                        compareArr[j+1]=temp;
                    }
                }
            }
            if(nullArr.length>0){
                const bkTqpArr=[...compareArr.concat(nullArr)];
                for(let i=0;i<bkTqpArr.length;i++){
                    if(bkTqpArr[i]){
                        bkTqpArr[i].index=i+1;
                    }
                }
                this.bkTqpCollectYx=[...bkTqpArr];
                this.bkTqpIndex=-1;
                // if(!(this.planObj.plan)){
                //     this.$store.dispatch("saveCollectSchool",{collectSchool:zkArr,pc:this.activePcName});
                // }
            }else{
                const bkTqpArr=[...compareArr];
                for(let i=0;i<bkTqpArr.length;i++){
                    if(bkTqpArr[i]){
                        bkTqpArr[i].index=i+1;
                    }
                }
                this.bkTqpCollectYx=[...bkTqpArr];
                this.bkTqpIndex=-1;
                // if(!(this.planObj.plan)){
                //     this.$store.dispatch("saveCollectSchool",{collectSchool:zkArr,pc:this.activePcName});
                // }
            }
        }else{
            const arr=[...this.zkTqpCollectYx];
            const compareArr=[];
            const nullArr=[];
            for(let i=0;i<arr.length;i++){
                if(arr[i].pjtwf){
                    compareArr.push(arr[i]);
                }else{
                    nullArr.push(arr[i]);
                }
            }
            for(let i=0;i<compareArr.length;i++){
                for(let j=0;j<compareArr.length-i-1;j++){
                    if(compareArr[j].pjtwf<compareArr[j+1].pjtwf){
                        const temp=compareArr[j];
                        compareArr[j]=compareArr[j+1];
                        compareArr[j+1]=temp;
                    }
                }
            }
            if(nullArr.length>0){
                const zkTqpArr=[...compareArr.concat(nullArr)];
                for(let i=0;i<zkTqpArr.length;i++){
                    if(zkTqpArr[i]){
                        zkTqpArr[i].index=i+1;
                    }
                }
                this.zkTqpCollectYx=[...zkTqpArr];
                this.zkTqpIndex=-1;
                // if(!(this.planObj.plan)){
                //     this.$store.dispatch("saveCollectSchool",{collectSchool:zkArr,pc:this.activePcName});
                // }
            }else{
                const zkTqpArr=[...compareArr];
                for(let i=0;i<zkTqpArr.length;i++){
                    if(zkTqpArr[i]){
                        zkTqpArr[i].index=i+1;
                    }
                }
                this.zkTqpCollectYx=[...zkTqpArr];
                this.zkTqpIndex=-1;
                // if(!(this.planObj.plan)){
                //     this.$store.dispatch("saveCollectSchool",{collectSchool:zkArr,pc:this.activePcName});
                // }
            }
        }
    },
    // 移动到第一行
    moveFirst(){
        const pc=this.activePcName;
        // if(pc==='6'){
        //     const index=this.bkIndex;
        //     if(index===-1){
        //         this.$message({message:"请选择某一行",type:'warning',showClose:true});
        //         return;
        //     }
        // let bkArr=[...this.bkCollectYx];
        // const moveObj=bkArr[index];
        // bkArr.unshift(moveObj);
        // // this.$set(this.bkCollectYx[index],'index',1);
        // // this.$set(this.zkCollectYx[index],'index',index+1);
        // bkArr[index+1]=null;
        // bkArr=bkArr.filter((item)=>item!=null);
        // this.bkCollectYx=bkArr;
        // this.resetTableIndex();
        // this.bkIndex=0;
        // // if(!(this.planObj.plan)){
        // //     this.$store.dispatch("saveCollectSchool",{collectSchool:bkArr,pc:pc});
        // // }
        // }else if(pc==='7'){
        // const index=this.zkIndex;
        // if(index===-1){
        //         this.$message({message:"请选择某一行",type:'warning',showClose:true});
        //         return;
        // }
        // let zkArr=[...this.zkCollectYx];
        // const moveObj=zkArr[index];
        // zkArr.unshift(moveObj);
        // console.log(moveObj);
        // // this.$set(this.zkCollectYx[index],'index',1);
        // // this.$set(this.zkCollectYx[index-1],'index',index+1);
        // zkArr[index+1]=null;
        // zkArr=zkArr.filter((item)=>item!=null);
        // this.zkCollectYx=zkArr;
        // this.resetTableIndex();
        // this.zkIndex=0;
        // // if(!(this.planObj.plan)){
        // //     this.$store.dispatch("saveCollectSchool",{collectSchool:zkArr,pc:pc});
        // // }
        // }else if(pc==='0'){
        //     const index=this.bkTqpIndex;
        //     if(index===-1){
        //             this.$message({message:"请选择某一行",type:'warning',showClose:true});
        //             return;
        //     }
        //     let bkTqpArr=[...this.bkTqpCollectYx];
        //     const moveObj=bkTqpArr[index];
        //     bkTqpArr.unshift(moveObj);
        //     console.log(moveObj);
        //     // this.$set(this.zkCollectYx[index],'index',1);
        //     // this.$set(this.zkCollectYx[index-1],'index',index+1);
        //     bkTqpArr[index+1]=null;
        //     bkTqpArr=bkTqpArr.filter((item)=>item!=null);
        //     this.bkTqpCollectYx=bkTqpArr;
        //     this.resetTableIndex();
        //     this.bkTqpIndex=0;
        //     // if(!(this.planObj.plan)){
        //     //     this.$store.dispatch("saveCollectSchool",{collectSchool:zkArr,pc:pc});
        //     // }
        // }else{
        //     const index=this.zkTqpIndex;
        //     if(index===-1){
        //             this.$message({message:"请选择某一行",type:'warning',showClose:true});
        //             return;
        //     }
        //     let zkTqpArr=[...this.zkTqpCollectYx];
        //     const moveObj=zkTqpArr[index];
        //     zkTqpArr.unshift(moveObj);
        //     console.log(moveObj);
        //     // this.$set(this.zkCollectYx[index],'index',1);
        //     // this.$set(this.zkCollectYx[index-1],'index',index+1);
        //     zkTqpArr[index+1]=null;
        //     zkTqpArr=zkTqpArr.filter((item)=>item!=null);
        //     this.zkTqpCollectYx=zkTqpArr;
        //     this.resetTableIndex();
        //     this.zkTqpIndex=0;
        //     // if(!(this.planObj.plan)){
        //     //     this.$store.dispatch("saveCollectSchool",{collectSchool:zkArr,pc:pc});
        //     // }
        // }
        if(pc==='6'){
            const index=this.bkIndex;
            const obj=this.bkCollectYx[index];
            const haveArr=[];
            const nullArr=[];
            const tabArr=[...this.bkCollectYx];
            for(let i=0;i<tabArr.length;i++){
                if(tabArr[i].yxmc){
                    haveArr.push(tabArr[i]);
                }else{
                    nullArr.push(tabArr[i]);
                }
            }
            if(obj&&obj.yxmc&&haveArr.length>0){
                if(haveArr.length<10){
                    const arr1=this.moveElement(haveArr,obj,0);
                    this.bkCollectYx=arr1.concat(nullArr);
                    this.bkIndex=0;
                }else{
                    const arr1=this.moveElement(this.bkCollectYx,obj,0);
                    this.bkCollectYx=[...arr1];
                    this.bkIndex=0;
                }
            }
            this.bkHandleYx="";
        }else if(pc==='7'){
            const index=this.zkIndex;
            const obj=this.zkCollectYx[index];
            const haveArr=[];
            const nullArr=[];
            const tabArr=[...this.zkCollectYx];
            for(let i=0;i<tabArr.length;i++){
                if(tabArr[i].yxmc){
                    haveArr.push(tabArr[i]);
                }else{
                    nullArr.push(tabArr[i]);
                }
            }
            if(obj&&obj.yxmc&&haveArr.length>0){
                if(haveArr.length<10){
                    const arr1=this.moveElement(haveArr,obj,0);
                    this.zkCollectYx=arr1.concat(nullArr);
                    this.zkIndex=0;
                }else{
                    const arr1=this.moveElement(this.zkCollectYx,obj,0);
                    this.zkCollectYx=[...arr1];
                    this.zkIndex=0;
                }
            }
        }else if(pc==='0'){
            const index=this.bkTqpIndex;
            const obj=this.bkTqpCollectYx[index];
            const haveArr=[];
            const nullArr=[];
            const tabArr=[...this.bkTqpCollectYx];
            for(let i=0;i<tabArr.length;i++){
                if(tabArr[i].yxmc){
                    haveArr.push(tabArr[i]);
                }else{
                    nullArr.push(tabArr[i]);
                }
            }
            if(obj&&obj.yxmc&&haveArr.length>0){
                if(haveArr.length<10){
                    const arr1=this.moveElement(haveArr,obj,0);
                    this.bkTqpCollectYx=arr1.concat(nullArr);
                    this.bkTqpIndex=0;
                }else{
                    const arr1=this.moveElement(this.bkTqpCollectYx,obj,0);
                    this.bkTqpCollectYx=[...arr1];
                    this.bkTqpIndex=0;
                }
            }
        }else{
            const index=this.zkTqpIndex;
            const obj=this.zkTqpCollectYx[index];
            const haveArr=[];
            const nullArr=[];
            const tabArr=[...this.zkTqpCollectYx];
            for(let i=0;i<tabArr.length;i++){
                if(tabArr[i].yxmc){
                    haveArr.push(tabArr[i]);
                }else{
                    nullArr.push(tabArr[i]);
                }
            }
            if(obj&&obj.yxmc&&haveArr.length>0){
                if(haveArr.length<10){
                    const arr1=this.moveElement(haveArr,obj,0);
                    this.zkTqpCollectYx=arr1.concat(nullArr);
                    this.zkTqpIndex=0;
                }else{
                    const arr1=this.moveElement(this.zkTqpCollectYx,obj,0);
                    this.zkTqpCollectYx=[...arr1];
                    this.zkTqpIndex=0;
                }
            }
        }
        this.resetTableIndex();
    },
    // 重置表格内容每行的index属性
    resetTableIndex(){
            const bkArr=[...this.bkCollectYx];
            bkArr.forEach((item,index)=>{
                item.index=index+1;
            });
            this.bkCollectYx=bkArr;
            const zkArr=[...this.zkCollectYx];
            zkArr.forEach((item,index)=>{
                item.index=index+1;
            });
            this.zkCollectYx=zkArr;
            const bkTqpArr=[...this.bkTqpCollectYx];
            bkTqpArr.forEach((item,index)=>{
                item.index=index+1;
            });
            this.bkTqpCollectYx=bkTqpArr;
            const zkTqpArr=[...this.zkTqpCollectYx];
            zkTqpArr.forEach((item,index)=>{
                item.index=index+1;
            });
            this.zkTqpCollectYx=zkTqpArr;
        // const pc=this.activePcName;
        // if(pc==='6'){
        //     const bkArr=[...this.bkCollectYx];
        //     bkArr.forEach((item,index)=>{
        //         item.index=index+1;
        //     });
        //     this.bkCollectYx=bkArr;
        // }else if(pc==='7'){
        //     const zkArr=[...this.zkCollectYx];
        //     zkArr.forEach((item,index)=>{
        //         item.index=index+1;
        //     });
        //     this.zkCollectYx=zkArr;
        // }else if(pc==='0'){
        //     const bkTqpArr=[...this.bkTqpCollectYx];
        //     bkTqpArr.forEach((item,index)=>{
        //         item.index=index+1;
        //     });
        //     this.bkTqpCollectYx=bkTqpArr;
        // }else{
        //     const zkTqpArr=[...this.zkTqpCollectYx];
        //     zkTqpArr.forEach((item,index)=>{
        //         item.index=index+1;
        //     });
        //     this.zkTqpCollectYx=zkTqpArr;
        // }
    },
    // 前移一行
    movePrev(){
        const pc=this.activePcName;
        if(pc==='6'){
            const index=this.bkIndex;
            if(index===-1){
                this.$message({message:"请选择某一行",type:'warning',showClose:true});
                return;
            }else if(index===0){
                return false;
            }
            const obj=this.bkCollectYx[index];
            const prevObj=this.bkCollectYx[index-1];
            obj.index=index;
            prevObj.index=index+1;
            this.$set(this.bkCollectYx,index,prevObj);
            this.$set(this.bkCollectYx,index-1,obj);
            this.bkIndex=index-1;
            // if(!(this.planObj.plan)){
            //     this.$store.dispatch("saveCollectSchool",{collectSchool:this.bkCollectYx,pc:pc});
            // }
        }else{
            const index=this.zkIndex;
            if(index===-1){
                this.$message({message:"请选择某一行",type:'warning',showClose:true});
                return;
            }else if(index===0){
                return;
            }
            const obj=this.zkCollectYx[index];
            const prevObj=this.zkCollectYx[index-1];
            obj.index=index;
            prevObj.index=index+1;
            this.$set(this.zkCollectYx,index,prevObj);
            this.$set(this.zkCollectYx,index-1,obj);
            this.zkIndex=index-1;
            // if(!(this.planObj.plan)){
            //     this.$store.dispatch("saveCollectSchool",{collectSchool:this.zkCollectYx,pc:pc});
            // }
        }
    },
    // 移动到最后一行
    moveEnd(){
        const pc=this.activePcName;
        // if(pc==='6'){
        //     const index=this.bkIndex;
        //     if(index===-1){
        //         this.$message({message:"请选择某一行",type:'warning',showClose:true});
        //         return;
        //     }
        //     let bkArr=[...this.bkCollectYx];
        //     let dataCount=0;
        //     for(let i=0;i<bkArr.length;i++){
        //         if(bkArr[i].yxmc){
        //             dataCount++;
        //         }
        //     }
        //     let haveData=[];
        //     const nullData=[];
        //     for(let i=0;i<bkArr.length;i++){
        //         if(i<dataCount){
        //             haveData.push(bkArr[i]);
        //         }else{
        //             nullData.push(bkArr[i]);
        //         }
        //     }
        //     const obj=haveData[index];
        //     haveData.push(obj);
        //     this.$set(this.bkCollectYx[index+1],"index",index+1);
        //     haveData[index]=null;
        //     haveData=haveData.filter(item=>item!=null);
        //     bkArr=haveData.concat(nullData);
        //     // this.$set(this.bkCollectYx[index],"index",haveData.length);
        //     // this.$set(this.bkCollectYx[haveData.length-1],"index",haveData.length-1);
        //     this.bkCollectYx=bkArr;
        //     this.resetTableIndex();
        //     this.bkIndex=haveData.length-1;
        //     // if(!(this.planObj.plan)){
        //     //     this.$store.dispatch("saveCollectSchool",{collectSchool:this.bkCollectYx,pc:pc});
        //     // }
        // }else if(pc==='7'){
        //     const index=this.zkIndex;
        //     if(index===-1){
        //         this.$message({message:"请选择某一行",type:'warning',showClose:true});
        //         return;
        //     }
        //     let zkArr=[...this.zkCollectYx];
        //     let dataCount=0;
        //     for(let i=0;i<zkArr.length;i++){
        //         if(zkArr[i].yxmc){
        //             dataCount++;
        //         }
        //     }
        //     let haveData=[];
        //     const nullData=[];
        //     for(let i=0;i<zkArr.length;i++){
        //         if(i<dataCount){
        //             haveData.push(zkArr[i]);
        //         }else{
        //             nullData.push(zkArr[i]);
        //         }
        //     }
        //     const obj=haveData[index];
        //     haveData.push(obj);
        //     console.log(this.zkCollectYx[index+1],index);
        //     this.$set(this.zkCollectYx[index+1],"index",index+1);
        //     haveData[index]=null;
        //     haveData=haveData.filter(item=>item!=null);
        //     zkArr=haveData.concat(nullData);
        //     // this.$set(this.zkCollectYx[index],"index",haveData.length);
        //     // this.$set(this.zkCollectYx[haveData.length-1],"index",haveData.length-1);
        //     this.zkCollectYx=zkArr;
        //     this.resetTableIndex();
        //     this.zkIndex=haveData.length-1;
        //     // if(!(this.planObj.plan)){
        //     //     this.$store.dispatch("saveCollectSchool",{collectSchool:zkArr,pc:pc});
        //     // }
        // }else if(pc==='0'){
        //     const index=this.bkTqpIndex;
        //     if(index===-1){
        //         this.$message({message:"请选择某一行",type:'warning',showClose:true});
        //         return;
        //     }
        //     let bkTqpArr=[...this.bkTqpCollectYx];
        //     let dataCount=0;
        //     for(let i=0;i<bkTqpArr.length;i++){
        //         if(bkTqpArr[i].yxmc){
        //             dataCount++;
        //         }
        //     }
        //     let haveData=[];
        //     const nullData=[];
        //     for(let i=0;i<bkTqpArr.length;i++){
        //         if(i<dataCount){
        //             haveData.push(bkTqpArr[i]);
        //         }else{
        //             nullData.push(bkTqpArr[i]);
        //         }
        //     }
        //     const obj=haveData[index];
        //     haveData.push(obj);
        //     console.log(this.bkTqpCollectYx[index+1],index);
        //     this.$set(this.bkTqpCollectYx[index+1],"index",index+1);
        //     haveData[index]=null;
        //     haveData=haveData.filter(item=>item!=null);
        //     bkTqpArr=haveData.concat(nullData);
        //     console.log(haveData.length);
        //     // this.$set(this.zkCollectYx[index],"index",haveData.length);
        //     // this.$set(this.zkCollectYx[haveData.length-1],"index",haveData.length-1);
        //     this.bkTqpCollectYx=bkTqpArr;
        //     this.resetTableIndex();
        //     this.bkTqpIndex=haveData.length-1;
        //     // if(!(this.planObj.plan)){
        //     //     this.$store.dispatch("saveCollectSchool",{collectSchool:zkArr,pc:pc});
        //     // }
        // }else{
        //     const index=this.zkTqpIndex;
        //     if(index===-1){
        //         this.$message({message:"请选择某一行",type:'warning',showClose:true});
        //         return;
        //     }
        //     let zkTqpArr=[...this.bkTqpCollectYx];
        //     let dataCount=0;
        //     for(let i=0;i<zkTqpArr.length;i++){
        //         if(bkTqpArr[i].yxmc){
        //             dataCount++;
        //         }
        //     }
        //     let haveData=[];
        //     const nullData=[];
        //     for(let i=0;i<zkTqpArr.length;i++){
        //         if(i<dataCount){
        //             haveData.push(zkTqpArr[i]);
        //         }else{
        //             nullData.push(zkTqpArr[i]);
        //         }
        //     }
        //     const obj=haveData[index];
        //     haveData.push(obj);
        //     console.log(this.zkTqpCollectYx[index+1],index);
        //     this.$set(this.zkTqpCollectYx[index+1],"index",index+1);
        //     haveData[index]=null;
        //     haveData=haveData.filter(item=>item!=null);
        //     zkTqpArr=haveData.concat(nullData);
        //     console.log(haveData.length);
        //     // this.$set(this.zkCollectYx[index],"index",haveData.length);
        //     // this.$set(this.zkCollectYx[haveData.length-1],"index",haveData.length-1);
        //     this.zkTqpCollectYx=zkTqpArr;
        //     this.resetTableIndex();
        //     this.zkTqpIndex=haveData.length-1;
        //     // if(!(this.planObj.plan)){
        //     //     this.$store.dispatch("saveCollectSchool",{collectSchool:zkArr,pc:pc});
        //     // }
        // }
        if(pc==='6'){
            const index=this.bkIndex;
            const obj=this.bkCollectYx[index];
            const haveArr=[];
            const nullArr=[];
            const tabArr=[...this.bkCollectYx];
            for(let i=0;i<tabArr.length;i++){
                if(tabArr[i].yxmc){
                    haveArr.push(tabArr[i]);
                }else{
                    nullArr.push(tabArr[i]);
                }
            }
            if(obj&&obj.yxmc&&haveArr.length>0){
                if(haveArr.length<45){
                    const arr1=this.moveElement(haveArr,obj,haveArr.length-1);
                    this.bkCollectYx=arr1.concat(nullArr);
                    this.bkIndex=haveArr.length-1;
                }else{
                    const arr1=this.moveElement(this.bkCollectYx,obj,this.bkCollectYx.length-1);
                    this.bkCollectYx=[...arr1];
                    this.bkIndex=this.bkCollectYx.length-1;
                }
            }
            this.bkHandleYx="";
        }else if(pc==='7'){
            const index=this.zkIndex;
            const obj=this.zkCollectYx[index];
            const haveArr=[];
            const nullArr=[];
            const tabArr=[...this.zkCollectYx];
            for(let i=0;i<tabArr.length;i++){
                if(tabArr[i].yxmc){
                    haveArr.push(tabArr[i]);
                }else{
                    nullArr.push(tabArr[i]);
                }
            }
            if(obj&&obj.yxmc&&haveArr.length>0){
                if(haveArr.length<45){
                    const arr1=this.moveElement(haveArr,obj,haveArr.length-1);
                    this.zkCollectYx=arr1.concat(nullArr);
                    this.zkIndex=haveArr.length-1;
                }else{
                    const arr1=this.moveElement(this.zkCollectYx,obj,this.zkCollectYx.length-1);
                    this.zkCollectYx=[...arr1];
                    this.zkIndex=this.zkCollectYx.length-1;
                }
            }
        }else if(pc==='0'){
            const index=this.bkTqpIndex;
            const obj=this.bkTqpCollectYx[index];
            const haveArr=[];
            const nullArr=[];
            const tabArr=[...this.bkTqpCollectYx];
            for(let i=0;i<tabArr.length;i++){
                if(tabArr[i].yxmc){
                    haveArr.push(tabArr[i]);
                }else{
                    nullArr.push(tabArr[i]);
                }
            }
            if(obj&&obj.yxmc&&haveArr.length>0){
                if(haveArr.length<45){
                    const arr1=this.moveElement(haveArr,obj,haveArr.length-1);
                    this.bkTqpCollectYx=arr1.concat(nullArr);
                    this.bkTqpIndex=haveArr.length-1;
                }else{
                    const arr1=this.moveElement(this.bkTqpCollectYx,obj,this.bkTqpCollectYx.length-1);
                    this.bkTqpCollectYx=[...arr1];
                    this.bkTqpIndex=this.bkTqpCollectYx.length-1;
                }
            }
        }else{
            const index=this.zkTqpIndex;
            const obj=this.zkTqpCollectYx[index];
            const haveArr=[];
            const nullArr=[];
            const tabArr=[...this.zkTqpCollectYx];
            for(let i=0;i<tabArr.length;i++){
                if(tabArr[i].yxmc){
                    haveArr.push(tabArr[i]);
                }else{
                    nullArr.push(tabArr[i]);
                }
            }
            if(obj&&obj.yxmc&&haveArr.length>0){
                if(haveArr.length<45){
                    const arr1=this.moveElement(haveArr,obj,haveArr.length-1);
                    this.zkTqpCollectYx=arr1.concat(nullArr);
                    this.zkTqpIndex=haveArr.length-1;
                }else{
                    const arr1=this.moveElement(this.zkTqpCollectYx,obj,this.zkTqpCollectYx.length-1);
                    this.zkTqpCollectYx=[...arr1];
                    this.zkTqpIndex=this.zkTqpCollectYx.length-1;
                }
            }
        }
        this.resetTableIndex();
    },
    // 后移一行
    moveNext(){
        const pc=this.activePcName;
        if(pc==='6'){
            const index=this.bkIndex;
            if(index===-1){
                this.$message({message:"请选择某一行",type:'warning',showClose:true});
                return;
            }
            const bkArr=[...this.bkCollectYx];
            const obj=bkArr[index];
            const nextObj=bkArr[index+1];
            let count=0;
            for(let i=0;i<bkArr.length;i++){
                if(bkArr[i].yxmc){
                    count++;
                }
            }
            if(index+1>=count){
                return;
            }
            nextObj.index=index+1;
            obj.index=index+2;
            this.$set(this.bkCollectYx,index,nextObj);
            this.$set(this.bkCollectYx,index+1,obj);
            this.bkIndex=index+1;
            // if(!(this.planObj.plan)){
            //     this.$store.dispatch("saveCollectSchool",{collectSchool:this.bkCollectYx,pc:pc});
            // }
        }else{
            const index=this.zkIndex;
            if(index===-1){
                this.$message({message:"请选择某一行",type:'warning',showClose:true});
                return;
            }
            const zkArr=[...this.zkCollectYx];
            const obj=zkArr[index];
            const nextObj=zkArr[index+1];
            let count=0;
            for(let i=0;i<zkArr.length;i++){
                if(zkArr[i].yxmc){
                    count++;
                }
            }
            if(index+1>=count){
                return;
            }
            nextObj.index=index+1;
            obj.index=index+2;
            this.$set(this.zkCollectYx,index,nextObj);
            this.$set(this.zkCollectYx,index+1,obj);
            this.zkIndex=index+1;
            // if(!(this.planObj.plan)){
            //     this.$store.dispatch("saveCollectSchool",{collectSchool:this.zkCollectYx,pc:pc});
            // }
        }
    },
    // 表格中前移一行
    tableMovePrev(obj){
        const pc=this.activePcName;
        if(pc==='6'){
            const bkArr=[...this.bkCollectYx];
            console.log(bkArr);
            let index=0;
            if(obj){
                index=obj.index-1;
            }
            if(index===0){
                return;
            }
            const dqobj={...obj};
            const prevObj=bkArr[index-1];
            console.log(dqobj,prevObj);
            if(!(bkArr[index].yxmc)||!(bkArr[index-1].yxmc)){
                return;
            }
            this.$set(this.bkCollectYx,index,prevObj);
            this.$set(this.bkCollectYx,index-1,dqobj);
            this.resetTableIndex();
            this.bkIndex=index-1;
            this.bkHandleYx="";
        }else if(pc==='7'){
            const zkArr=[...this.zkCollectYx];
            let index=0;
            if(obj){
                index=obj.index-1;
            }
            if(index===0){
                return;
            }
            const dqobj={...obj};
            const prevObj=zkArr[index-1];
            if(!(zkArr[index].yxmc)||!(zkArr[index-1].yxmc)){
                return;
            }
            this.$set(this.zkCollectYx,index,prevObj);
            this.$set(this.zkCollectYx,index-1,dqobj);
            this.resetTableIndex();
            this.zkIndex=index-1;
        }else if(pc==='0'){
            const bkTqpArr=[...this.bkTqpCollectYx];
            let index=0;
            if(obj){
                index=obj.index-1;
            }
            if(index===0){
                return;
            }
            const dqobj={...obj};
            const prevObj=bkTqpArr[index-1];
            if(!(bkTqpArr[index].yxmc)||!(bkTqpArr[index-1].yxmc)){
                return;
            }
            this.$set(this.bkTqpCollectYx,index,prevObj);
            this.$set(this.bkTqpCollectYx,index-1,dqobj);
            this.resetTableIndex();
            this.bkTqpIndex=index-1;
        }else{
            const zkTqpArr=[...this.zkTqpCollectYx];
            let index=0;
            if(obj){
                index=obj.index-1;
            }
            if(index===0){
                return;
            }
            const dqobj={...obj};
            const prevObj=zkTqpArr[index-1];
            if(!(zkTqpArr[index].yxmc)||!(zkTqpArr[index-1].yxmc)){
                return;
            }
            this.$set(this.zkTqpCollectYx,index,prevObj);
            this.$set(this.zkTqpCollectYx,index-1,dqobj);
            this.resetTableIndex();
            this.zkTqpIndex=index-1;
        }
    },
    // 表格中的后移一行
    tableMoveNext(obj){
        const pc=this.activePcName;
        if(pc==='6'){
            const bkArr=[...this.bkCollectYx];
            let index=0;
            if(obj){
                index=obj.index-1;
            }
            if(index===bkArr.length-1){
                return;
            }
            const dqObj={...obj};
            const nextObj=bkArr[index+1];
            if(!(bkArr[index].yxmc)||!(bkArr[index+1].yxmc)){
                return;
            }
            this.$set(this.bkCollectYx,index,nextObj);
            this.$set(this.bkCollectYx,index+1,dqObj);
            this.resetTableIndex();
            this.bkIndex=index+1;
            this.bkHandleYx="";
        }else if(pc==='7'){
            const zkArr=[...this.zkCollectYx];
            let index=0;
            if(obj){
                index=obj.index-1;
            }
            if(index===zkArr.length-1){
                return;
            }
            const dqObj={...obj};
            const nextObj=zkArr[index+1];
            if(!(zkArr[index].yxmc)||!(zkArr[index+1].yxmc)){
                return;
            }
            this.$set(this.zkCollectYx,index,nextObj);
            this.$set(this.zkCollectYx,index+1,dqObj);
            this.resetTableIndex();
            this.zkIndex=index+1;
        }else if(pc==='0'){
            const bkTqpArr=[...this.bkTqpCollectYx];
            let index=0;
            if(obj){
                index=obj.index-1;
            }
            if(index===bkTqpArr.length-1){
                return;
            }
            const dqObj={...obj};
            const nextObj=bkTqpArr[index+1];
            if(!(bkTqpArr[index].yxmc)||!(bkTqpArr[index+1].yxmc)){
                return;
            }
            this.$set(this.bkTqpCollectYx,index,nextObj);
            this.$set(this.bkTqpCollectYx,index+1,dqObj);
            this.resetTableIndex();
            this.bkTqpIndex=index+1;
        }else{
            const zkTqpArr=[...this.zkTqpCollectYx];
            let index=0;
            if(obj){
                index=obj.index-1;
            }
            if(index===zkTqpArr.length-1){
                return;
            }
            const dqObj={...obj};
            const nextObj=zkTqpArr[index+1];
            if(!(zkTqpArr[index].yxmc)||!(zkTqpArr[index+1].yxmc)){
                return;
            }
            this.$set(this.zkTqpCollectYx,index,nextObj);
            this.$set(this.zkTqpCollectYx,index+1,dqObj);
            this.resetTableIndex();
            this.zkTqpIndex=index+1;
        }
    },
    // 全选
    allCheck(){
        const pc=this.activePcName;
        if(pc==='6'){
            const bkArr=[...this.bkCollectYx];
            for(let i=0;i<bkArr.length;i++){
                if(bkArr[i]){
                    bkArr[i].checked=true;
                }
            }
            this.bkCollectYx=bkArr;
            {/* this.updateBk=!this.updateBk; */}
            this.bkCollectYx=[...this.bkCollectYx];
        }else if(pc==='7'){
            const zkArr=[...this.zkCollectYx];
            for(let i=0;i<zkArr.length;i++){
                zkArr[i].checked=true;
            }
            this.zkCollectYx=zkArr;
            this.updateZk=!this.updateZk;
        }else if(pc==='0'){
            const bkTqpArr=[...this.bkTqpCollectYx];
            for(let i=0;i<bkTqpArr.length;i++){
                bkTqpArr[i].checked=true;
            }
            this.bkTqpCollectYx=bkTqpArr;
            this.updateBKTqp=!this.updateBKTqp;
        }else{
            const zkTqpArr=[...this.zkTqpCollectYx];
            for(let i=0;i<zkTqpArr.length;i++){
                zkTqpArr[i].checked=true;
            }
            this.zkTqpCollectYx=zkTqpArr;
            this.updateZkTqp=!this.updateZkTqp;
        }
    },
    // 取消全选
    allNoCheck(){
        const pc=this.activePcName;
        if(pc==='6'){
            const bkArr=[...this.bkCollectYx];
            for(let i=0;i<bkArr.length;i++){
                bkArr[i].checked=false;
            }
            this.bkCollectYx=bkArr;
            {/* this.updateBk=!this.updateBk; */}
            this.bkCollectYx=[...this.bkCollectYx];
        }else if(pc==='7'){
            const zkArr=[...this.zkCollectYx];
            for(let i=0;i<zkArr.length;i++){
                zkArr[i].checked=false;
            }
            this.zkCollectYx=zkArr;
            {/* this.updateZk=!this.updateZk; */}
            this.zkCollectYx=[...this.zkCollectYx];
        }else if(pc==='0'){
            const bkTqpArr=[...this.bkTqpCollectYx];
            for(let i=0;i<bkTqpArr.length;i++){
                bkTqpArr[i].checked=false;
            }
            this.bkTqpCollectYx=bkTqpArr;
            {/* this.updateBKTqp=!this.updateBKTqp; */}
            this.bkTqpCollectYx=[...this.bkTqpCollectYx];
        }else{
            const zkTqpArr=[...this.zkTqpCollectYx];
            for(let i=0;i<zkTqpArr.length;i++){
                zkTqpArr[i].checked=false;
            }
            this.zkTqpCollectYx=zkTqpArr;
            {/* this.updateZkTqp=!this.updateZkTqp; */}
            this.zkTqpCollectYx=[...this.zkTqpCollectYx];
        }
    },
    tableRadioChange(checked,obj){
        const pc=this.activePcName;
        if(obj.yxmc){
            if(pc==='6'){
                const bkYxs=[...this.bkCollectYx];
                for(let i=0;i<bkYxs.length;i++){
                    if(bkYxs[i]){
                        bkYxs[i].radioChecked=false;
                    }
                }
                let index=obj.index-1;
                bkYxs[index].radioChecked=true
                this.bkCollectYx=bkYxs;
                this.bkIndex=index;
            }else if(pc==='7'){
                const zkYxs=[...this.zkCollectYx];
                for(let i=0;i<zkYxs.length;i++){
                    if(zkYxs[i]){
                        zkYxs[i].radioChecked=false;
                    }
                }
                let index=obj.index-1;
                zkYxs[index].radioChecked=true;
                this.zkCollectYx=zkYxs;
                this.zkIndex=index;
            }else if(pc==='0'){
                const bkYxs=[...this.bkTqpCollectYx];
                for(let i=0;i<bkYxs.length;i++){
                    if(bkYxs[i]){
                        bkYxs[i].radioChecked=false;
                    }
                }
                let index=obj.index-1;
                bkYxs[index].radioChecked=true;
                this.bkTqpCollectYx=bkYxs;
                this.bkTqpIndex=index;
            }else if(pc==='9'){
                const zkYxs=[...this.zkTqpCollectYx];
                for(let i=0;i<zkYxs.length;i++){
                    if(zkYxs[i]){
                        zkYxs[i].radioChecked=false;
                    }
                }
                let index=obj.index-1;
                zkYxs[index].radioChecked=true;
                this.zkTqpCollectYx=zkYxs;
                this.zkTqpIndex=index;
            }
        }
        this.$forceUpdate();
    },
    tableCheckChange(checked,obj){
        const pc=this.activePcName;
        if(pc==='6'){
            const bkYxs=[...this.bkCollectYx];
            let index=obj.index-1;
            bkYxs[index].checked=!bkYxs[index].checked;
            bkYxs.forEach((item)=>item.radioChecked=false);
            bkYxs[index].radioChecked=true;
            this.bkCollectYx=bkYxs;
        }else if(pc==='7'){
            const zkYxs=[...this.zkCollectYx];
            let index=obj.index-1;
            zkYxs[index].checked=!zkYxs[index].checked;
            zkYxs.forEach((item)=>item.radioChecked=false);
            zkYxs[index].radioChecked=true;
            this.zkCollectYx=zkYxs;
        }else if(pc==='0'){
            const bkYxs=[...this.bkTqpCollectYx];
            let index=obj.index-1;
            bkYxs[index].checked=!bkYxs[index].checked;
            bkYxs.forEach((item)=>item.radioChecked=false);
            bkYxs[index].radioChecked=true;
            this.bkTqpCollectYx=bkYxs;
        }else if(pc==='9'){
            const zkYxs=[...this.zkTqpCollectYx];
            let index=obj.index-1;
            zkYxs[index].checked=!zkYxs[index].checked;
            zkYxs.forEach((item)=>item.radioChecked=false);
            zkYxs[index].radioChecked=true;
            this.zkTqpCollectYx=zkYxs;
        }
        this.$forceUpdate();
    },
    // 改变本科多选框
    bkCheckChange(checked,obj){
        // this.updateBk=!this.updateBk;
        console.log(checked);
        this.$forceUpdate();
    },
    // 改变专科多选框
    zkCheckChange(checked,obj){
        // this.updateZk=!this.updateZk;
        this.$forceUpdate();
    },
    // 保存院校专业组
    async saveYxzyz(){
        this.dialogPlanVisible=true;
        await this.getZyfaList();
        const id=this.planObj.id;
        if(id){
            this.selectedYxzyz=parseInt(id);
        }
    },
    // 获取我的方案列表
    async getZyfaList(){
        const res=await this.$http.getHttp("/mnzy/getMnzyList");
        if(res.data.code===200){
            const data=[...res.data.obj];
            for(let i=0;i<data.length;i++){
                if(data[i].plan){
                    data[i].checked=false;
                }
            }
            this.yxzyzList=data;
            this.isOpen=true;
        }else if(res.data.code===500){
            if(res.data.message){
                this.$message({message:res.data.message,type:'error'});
            }
        }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.data.code===0){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }
    },
    // 保存代码
    async saveYxzyzCode(){
        const pc=this.activePcName;
        if(pc==='6'){
            const obj={};
            obj.bz=this.userInfo.bz;
            obj.date=new Date().toLocaleString();
            obj.dfzxzg=this.userInfo.dfzxzg;
            obj.flag=0;
            obj.gjzxzg=this.userInfo.gjzxzg;
            obj.gkfs=this.userInfo.gkfs;
            obj.id=this.selectedYxzyz;
            if(this.selectedYxzyz===''){
                this.$message({message:"请选择方案",showClose:true});
                return false;
            }
            obj.kl=this.userInfo.sxkm;
            obj.param="";
            const id=this.selectedYxzyz;
            const planObj=this.yxzyzList.find(item=>item.id===id);
            if(planObj){
                obj.plan=planObj.plan;
            }
            if(planObj.plan.indexOf('(原始)')>=0){
                this.$message({
                    message:'原始方案不允许修改',
                    type:'warning',
                    showClose:true
                });
                return;
            }
            obj.school=this.userInfo.school;
            obj.sjhm=this.userInfo.sjhm;
            obj.sssf=this.userInfo.sssf;
            obj.sxcj=this.userInfo.sxcj;
            obj.sxkm=this.userInfo.sxkm;
            obj.sxkmcj=this.userInfo.sxkmcj;
            obj.wycj=this.userInfo.wycj;
            obj.xb=this.userInfo.xb;
            obj.xm=this.userInfo.xm;
            obj.yfjf=this.userInfo.yfjf;
            obj.yhid=this.userInfo.yhid;
            obj.yhlb=this.userInfo.yhlb;
            obj.ywcj=this.userInfo.ywcj;
            obj.zckh=this.userInfo.zckh;
            obj.zxkma=this.userInfo.zxkma;
            obj.zxkmacj=this.userInfo.zxkmacj;
            obj.zxkmb=this.userInfo.zxkmb;
            obj.zxkmbcj=this.userInfo.zxkmbcj;
            obj.pc=pc;
            const list=[];
            const bkArr=[...this.bkCollectYx];
            let count=0;
            for(let i=0;i<bkArr.length;i++){
                if(bkArr[i].yxmc&&bkArr[i].checked){
                    count++;
                }
            }
            for(let i=0;i<bkArr.length;i++){
                if(bkArr[i].yxmc){
                if(count>0){
                    if(bkArr[i].checked){
                        const o={};
                        o.createtime="";
                        o.faid=this.selectedYxzyz;
                        o.id="";
                        // o.fs=this.userInfo.gkfs;
                        // o.xm=this.userInfo.xm;
                        // o.yhid=this.userInfo.yhid;
                        o.kl=this.userInfo.sxkm;
                        o.pc=pc;
                        o.status=bkArr[i].checked?1:0;
                        o.updatetime="";
                        o.xh=i+1;
                        o.yxxh=bkArr[i].yxxh;
                        o.zyz=bkArr[i].zyz;
                        o.yxmc=bkArr[i].yxmc;
                        o.sb=bkArr[i].sb;
                        list.push(o);
                    }
                }else{
                    const o={};
                    o.createtime="";
                    o.faid=this.selectedYxzyz;
                    o.id="";
                    // o.fs=this.userInfo.gkfs;
                    // o.xm=this.userInfo.xm;
                    // o.yhid=this.userInfo.yhid;
                    o.kl=this.userInfo.sxkm;
                    o.pc=pc;
                    o.status=bkArr[i].checked?1:0;
                    o.updatetime="";
                    o.xh=i+1;
                    o.yxxh=bkArr[i].yxxh;
                    o.zyz=bkArr[i].zyz;
                    o.yxmc=bkArr[i].yxmc;
                    o.sb=bkArr[i].sb;
                    list.push(o);
                }
                }
            }
            obj.list=list;
            const res=await this.$http.postHttp("/yhgzfa/saveOrUpdateGzyxFa",obj);
            if(res.data.code===200){
                if(res.data.message){
                    this.$message({message:res.data.message,type:'success',showClose:true});
                }else{
                    this.$message({message:"保存成功",type:"success",showClose:true});
                }
                this.dialogPlanVisible=false;
            }else if(res.data.code===500){
                if(res.data.message){
                    this.$message({message:res.data.message,type:'error'});
                }
            }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
            }else if(res.data.code===0){
                this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
            }else if(res.status===409||res.status===410||res.status===411){
                this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:"warning"});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
            }
        }else if(pc==='7'){
            const obj={};
            obj.bz=this.userInfo.bz;
            obj.date=new Date().toLocaleString();
            obj.dfzxzg=this.userInfo.dfzxzg;
            obj.flag=0;
            obj.gjzxzg=this.userInfo.gjzxzg;
            obj.gkfs=this.userInfo.gkfs;
            obj.id=this.selectedYxzyz;
            if(this.selectedYxzyz===''){
                this.$message({message:"请选择方案",showClose:true});
                return false;
            }
            obj.kl=this.userInfo.sxkm;
            obj.param="";
            const id=this.selectedYxzyz;
            const planObj=this.yxzyzList.find(item=>item.id===id);
            if(planObj){
                obj.plan=planObj.plan;
            }
            if(planObj.plan.indexOf('(原始)')>=0){
                this.$message({
                    message:'原始方案不允许修改',
                    type:'warning',
                    showClose:true
                });
                return;
            }
            obj.school=this.userInfo.school;
            obj.sjhm=this.userInfo.sjhm;
            obj.sssf=this.userInfo.sssf;
            obj.sxcj=this.userInfo.sxcj;
            obj.sxkm=this.userInfo.sxkm;
            obj.sxkmcj=this.userInfo.sxkmcj;
            obj.wycj=this.userInfo.wycj;
            obj.xb=this.userInfo.xb;
            obj.xm=this.userInfo.xm;
            obj.yfjf=this.userInfo.yfjf;
            obj.yhid=this.userInfo.yhid;
            obj.yhlb=this.userInfo.yhlb;
            obj.ywcj=this.userInfo.ywcj;
            obj.zckh=this.userInfo.zckh;
            obj.zxkma=this.userInfo.zxkma;
            obj.zxkmacj=this.userInfo.zxkmacj;
            obj.zxkmb=this.userInfo.zxkmb;
            obj.zxkmbcj=this.userInfo.zxkmbcj;
            obj.pc=pc;
            const list=[];
            const zkArr=[...this.zkCollectYx];
            let count=0;
            for(let i=0;i<zkArr.length;i++){
                if(zkArr[i].checked){
                    count++;
                }
            }
            for(let i=0;i<zkArr.length;i++){
                if(zkArr[i].yxmc){
                if(count>0){
                    if(zkArr[i].checked){
                        const o={};
                        o.createtime="";
                        o.faid=this.selectedYxzyz;
                        o.id="";
                        o.kl=this.userInfo.sxkm;
                        o.pc=pc;
                        o.status=zkArr[i].checked?1:0;
                        o.updatetime="";
                        o.xh=i+1;
                        o.yxxh=zkArr[i].yxxh;
                        o.zyz=zkArr[i].zyz;
                        o.yxmc=zkArr[i].yxmc;
                        o.sb=zkArr[i].sb;
                        list.push(o);
                    }
                }else{
                    const o={};
                    o.createtime="";
                    o.faid=this.selectedYxzyz;
                    o.id="";
                    o.kl=this.userInfo.sxkm;
                    o.pc=pc;
                    o.status=zkArr[i].checked?1:0;
                    o.updatetime="";
                    o.xh=i+1;
                    o.yxxh=zkArr[i].yxxh;
                    o.zyz=zkArr[i].zyz;
                    o.yxmc=zkArr[i].yxmc;
                    o.sb=zkArr[i].sb;
                    list.push(o);
                }
                }
            }
            obj.list=list;
            const res=await this.$http.postHttp("/yhgzfa/saveOrUpdateGzyxFa",obj);
            if(res.data.code===200){
                if(res.data.message){
                    this.$message({message:res.data.message,type:'success',showClose:true});
                }else{
                    this.$message({message:"保存成功",type:"success",showClose:true});
                }
                this.dialogPlanVisible=false;
            }else if(res.data.code===500){
                if(res.data.message){
                    this.$message({message:res.data.message,type:'error'});
                }
            }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
            }else if(res.data.code===0){
                this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
            }else if(res.status===409||res.status===410||res.status===411){
                this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:"warning"});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
            }
        }else if(pc==='0'){
            const obj={};
            obj.bz=this.userInfo.bz;
            obj.date=new Date().toLocaleString();
            obj.dfzxzg=this.userInfo.dfzxzg;
            obj.flag=0;
            obj.gjzxzg=this.userInfo.gjzxzg;
            obj.gkfs=this.userInfo.gkfs;
            obj.id=this.selectedYxzyz;
            if(this.selectedYxzyz===''){
                this.$message({message:"请选择方案",showClose:true});
                return false;
            }
            obj.kl=this.userInfo.sxkm;
            obj.param="";
            const id=this.selectedYxzyz;
            const planObj=this.yxzyzList.find(item=>item.id===id);
            if(planObj){
                obj.plan=planObj.plan;
            }
            if(planObj.plan.indexOf('(原始)')>=0){
                this.$message({
                    message:'原始方案不允许修改',
                    type:'warning',
                    showClose:true
                });
                return;
            }
            obj.school=this.userInfo.school;
            obj.sjhm=this.userInfo.sjhm;
            obj.sssf=this.userInfo.sssf;
            obj.sxcj=this.userInfo.sxcj;
            obj.sxkm=this.userInfo.sxkm;
            obj.sxkmcj=this.userInfo.sxkmcj;
            obj.wycj=this.userInfo.wycj;
            obj.xb=this.userInfo.xb;
            obj.xm=this.userInfo.xm;
            obj.yfjf=this.userInfo.yfjf;
            obj.yhid=this.userInfo.yhid;
            obj.yhlb=this.userInfo.yhlb;
            obj.ywcj=this.userInfo.ywcj;
            obj.zckh=this.userInfo.zckh;
            obj.zxkma=this.userInfo.zxkma;
            obj.zxkmacj=this.userInfo.zxkmacj;
            obj.zxkmb=this.userInfo.zxkmb;
            obj.zxkmbcj=this.userInfo.zxkmbcj;
            obj.pc=pc;
            const list=[];
            const bkTqpArr=[...this.bkTqpCollectYx];
            let count=0;
            for(let i=0;i<bkTqpArr.length;i++){
                if(bkTqpArr[i].checked){
                    count++;
                }
            }
            for(let i=0;i<bkTqpArr.length;i++){
                if(bkTqpArr[i].yxmc){
                if(count>0){
                    if(bkTqpArr[i].checked){
                        const o={};
                        o.createtime="";
                        o.faid=this.selectedYxzyz;
                        o.id="";
                        o.kl=this.userInfo.sxkm;
                        o.pc=pc;
                        o.status=bkTqpArr[i].checked?1:0;
                        o.updatetime="";
                        o.xh=i+1;
                        o.yxxh=bkTqpArr[i].yxxh;
                        o.zyz=bkTqpArr[i].zyz;
                        o.yxmc=bkTqpArr[i].yxmc;
                        o.sb=bkTqpArr[i].sb;
                        list.push(o);
                    }
                }else{
                    const o={};
                    o.createtime="";
                    o.faid=this.selectedYxzyz;
                    o.id="";
                    o.kl=this.userInfo.sxkm;
                    o.pc=pc;
                    o.status=bkTqpArr[i].checked?1:0;
                    o.updatetime="";
                    o.xh=i+1;
                    o.yxxh=bkTqpArr[i].yxxh;
                    o.zyz=bkTqpArr[i].zyz;
                    o.yxmc=bkTqpArr[i].yxmc;
                    o.sb=bkTqpArr[i].sb;
                    list.push(o);
                }
                }
            }
            obj.list=list;
            const res=await this.$http.postHttp("/yhgzfa/saveOrUpdateGzyxFa",obj);
            if(res.data.code===200){
                if(res.data.message){
                    this.$message({message:res.data.message,type:'success',showClose:true});
                }else{
                    this.$message({message:"保存成功",type:"success",showClose:true});
                }
                this.dialogPlanVisible=false;
            }else if(res.data.code===500){
                if(res.data.message){
                    this.$message({message:res.data.message,type:'error'});
                }
            }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
            }else if(res.data.code===0){
                this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
            }else if(res.status===409||res.status===410||res.status===411){
                this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:"warning"});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
            }
        }else{
            const obj={};
            obj.bz=this.userInfo.bz;
            obj.date=new Date().toLocaleString();
            obj.dfzxzg=this.userInfo.dfzxzg;
            obj.flag=0;
            obj.gjzxzg=this.userInfo.gjzxzg;
            obj.gkfs=this.userInfo.gkfs;
            obj.id=this.selectedYxzyz;
            if(this.selectedYxzyz===''){
                this.$message({message:"请选择方案",showClose:true});
                return false;
            }
            obj.kl=this.userInfo.sxkm;
            obj.param="";
            const id=this.selectedYxzyz;
            const planObj=this.yxzyzList.find(item=>item.id===id);
            if(planObj){
                obj.plan=planObj.plan;
            }
            if(planObj.plan.indexOf('(原始)')>=0){
                this.$message({
                    message:'原始方案不允许修改',
                    type:'warning',
                    showClose:true
                });
                return;
            }
            obj.school=this.userInfo.school;
            obj.sjhm=this.userInfo.sjhm;
            obj.sssf=this.userInfo.sssf;
            obj.sxcj=this.userInfo.sxcj;
            obj.sxkm=this.userInfo.sxkm;
            obj.sxkmcj=this.userInfo.sxkmcj;
            obj.wycj=this.userInfo.wycj;
            obj.xb=this.userInfo.xb;
            obj.xm=this.userInfo.xm;
            obj.yfjf=this.userInfo.yfjf;
            obj.yhid=this.userInfo.yhid;
            obj.yhlb=this.userInfo.yhlb;
            obj.ywcj=this.userInfo.ywcj;
            obj.zckh=this.userInfo.zckh;
            obj.zxkma=this.userInfo.zxkma;
            obj.zxkmacj=this.userInfo.zxkmacj;
            obj.zxkmb=this.userInfo.zxkmb;
            obj.zxkmbcj=this.userInfo.zxkmbcj;
            obj.pc=pc;
            const list=[];
            const zkTqpArr=[...this.zkTqpCollectYx];
            let count=0;
            for(let i=0;i<zkTqpArr.length;i++){
                if(zkTqpArr[i].checked){
                    count++;
                }
            }
            for(let i=0;i<zkTqpArr.length;i++){
                if(zkTqpArr[i].yxmc){
                if(count>0){
                    if(zkTqpArr[i].checked){
                        const o={};
                        o.createtime="";
                        o.faid=this.selectedYxzyz;
                        o.id="";
                        o.kl=this.userInfo.sxkm;
                        o.pc=pc;
                        o.status=zkTqpArr[i].checked?1:0;
                        o.updatetime="";
                        o.xh=i+1;
                        o.yxxh=zkTqpArr[i].yxxh;
                        o.zyz=zkTqpArr[i].zyz;
                        o.yxmc=zkTqpArr[i].yxmc;
                        o.sb=zkTqpArr[i].sb;
                        list.push(o);
                    }
                }else{
                    const o={};
                    o.createtime="";
                    o.faid=this.selectedYxzyz;
                    o.id="";
                    o.kl=this.userInfo.sxkm;
                    o.pc=pc;
                    o.status=zkTqpArr[i].checked?1:0;
                    o.updatetime="";
                    o.xh=i+1;
                    o.yxxh=zkTqpArr[i].yxxh;
                    o.zyz=zkTqpArr[i].zyz;
                    o.yxmc=zkTqpArr[i].yxmc;
                    o.sb=zkTqpArr[i].sb;
                    list.push(o);
                }
                }
            }
            obj.list=list;
            const res=await this.$http.postHttp("/yhgzfa/saveOrUpdateGzyxFa",obj);
            if(res.data.code===200){
                if(res.data.message){
                    this.$message({message:res.data.message,type:'success',showClose:true});
                }else{
                    this.$message({message:"保存成功",type:"success",showClose:true});
                }
                this.dialogPlanVisible=false;
            }else if(res.data.code===500){
                if(res.data.message){
                    this.$message({message:res.data.message,type:'error'});
                }
            }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
            }else if(res.data.code===0){
                this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
            }else if(res.status===409||res.status===410||res.status===411){
                this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:"warning"});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
            }
        }
    },
    // 另存为代码
    async saveOtherCode(){
        const pc=this.activePcName;
        if(pc==='6'){
            const obj={};
            obj.bz=this.userInfo.bz;
            obj.date=new Date().toLocaleString();
            obj.dfzxzg=this.userInfo.dfzxzg;
            obj.flag=0;
            obj.gjzxzg=this.userInfo.gjzxzg;
            obj.gkfs=this.userInfo.gkfs;
            obj.id="";
            obj.kl=this.userInfo.sxkm;
            obj.param="";
            if(this.otherPlan===''){
                this.$message({message:"请输入方案名",showClose:true});
                return;
            }
            obj.plan=this.otherPlan;
            obj.school=this.userInfo.school;
            obj.xxmc=this.userInfo.xxmc;
            obj.sjhm=this.userInfo.sjhm;
            obj.sssf=this.userInfo.sssf;
            obj.sxcj=this.userInfo.sxcj;
            obj.sxkm=this.userInfo.sxkm;
            obj.sxkmcj=this.userInfo.sxkmcj;
            obj.wycj=this.userInfo.wycj;
            obj.xb=this.userInfo.xb;
            obj.xm=this.userInfo.xm;
            obj.yfjf=this.userInfo.yfjf;
            obj.yhid=this.userInfo.yhid;
            obj.yhlb=this.userInfo.yhlb;
            obj.ywcj=this.userInfo.ywcj;
            obj.zckh=this.userInfo.zckh;
            obj.zxkma=this.userInfo.zxkma;
            obj.zxkmacj=this.userInfo.zxkmacj;
            obj.zxkmb=this.userInfo.zxkmb;
            obj.zxkmbcj=this.userInfo.zxkmbcj;
            obj.pc=pc;
            const list=[];
            const bkArr=[...this.bkCollectYx];
            let count=0;
            for(let i=0;i<bkArr.length;i++){
                if(bkArr[i].checked){
                    count++;
                }
            }
            for(let i=0;i<bkArr.length;i++){
                if(bkArr[i].yxmc){
                if(count>0){
                    if(bkArr[i].checked){
                        const o={};
                        o.createtime="";
                        o.faid=this.selectedYxzyz;
                        o.id="";
                        // o.fs=this.userInfo.gkfs;
                        // o.xm=this.userInfo.xm;
                        // o.yhid=this.userInfo.yhid;
                        o.kl=this.userInfo.sxkm;
                        o.pc=pc;
                        o.status=bkArr[i].checked?1:0;
                        o.updatetime="";
                        o.xh=(i+1);
                        o.yxxh=bkArr[i].yxxh;
                        o.zyz=bkArr[i].zyz;
                        o.yxmc=bkArr[i].yxmc;
                        o.sb=bkArr[i].sb;
                        list.push(o);
                    }
                }else{
                    const o={};
                    o.createtime="";
                    o.faid=this.selectedYxzyz;
                    o.id="";
                    // o.fs=this.userInfo.gkfs;
                    // o.xm=this.userInfo.xm;
                    // o.yhid=this.userInfo.yhid;
                    o.kl=this.userInfo.sxkm;
                    o.pc=pc;
                    o.status=bkArr[i].checked?1:0;
                    o.updatetime="";
                    o.xh=(i+1);
                    o.yxxh=bkArr[i].yxxh;
                    o.zyz=bkArr[i].zyz;
                    o.yxmc=bkArr[i].yxmc;
                    o.sb=bkArr[i].sb;
                    list.push(o);
                }
                }
            }
            obj.list=list;
            const res=await this.$http.postHttp("/yhgzfa/saveOrUpdateGzyxFa",obj);
            if(res.data.code===200){
                if(res.data.message){
                    this.$message({message:res.data.message,type:'success',showClose:true});
                }else{
                    this.$message({message:"保存成功",type:"success",showClose:true});
                }
                this.dialogOtherVisible=false;
                this.dialogPlanVisible=false;
                this.otherPlan='';
            }else if(res.data.code===500){
                if(res.data.message){
                    this.$message({message:res.data.message,type:'error'});
                }
            }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
            }else if(res.data.code===0){
                this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
            }else if(res.status===409||res.status===410||res.status===411){
                this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:"warning"});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
            }
        }else if(pc==='7'){
            const obj={};
            obj.bz=this.userInfo.bz;
            obj.date=new Date().toLocaleString();
            obj.dfzxzg=this.userInfo.dfzxzg;
            obj.flag=0;
            obj.gjzxzg=this.userInfo.gjzxzg;
            obj.gkfs=this.userInfo.gkfs;
            obj.id="";
            obj.kl=this.userInfo.sxkm;
            obj.param="";
            if(this.otherPlan===''){
                this.$message({message:"请输入方案名",showClose:true});
                return;
            }
            obj.plan=this.otherPlan;
            obj.school=this.userInfo.school;
            obj.xxmc=this.userInfo.xxmc;
            obj.sjhm=this.userInfo.sjhm;
            obj.sssf=this.userInfo.sssf;
            obj.sxcj=this.userInfo.sxcj;
            obj.sxkm=this.userInfo.sxkm;
            obj.sxkmcj=this.userInfo.sxkmcj;
            obj.wycj=this.userInfo.wycj;
            obj.xb=this.userInfo.xb;
            obj.xm=this.userInfo.xm;
            obj.yfjf=this.userInfo.yfjf;
            obj.yhid=this.userInfo.yhid;
            obj.yhlb=this.userInfo.yhlb;
            obj.ywcj=this.userInfo.ywcj;
            obj.zckh=this.userInfo.zckh;
            obj.zxkma=this.userInfo.zxkma;
            obj.zxkmacj=this.userInfo.zxkmacj;
            obj.zxkmb=this.userInfo.zxkmb;
            obj.zxkmbcj=this.userInfo.zxkmbcj;
            obj.pc=pc;
            const list=[];
            const zkArr=[...this.zkCollectYx];
            let count=0;
            for(let i=0;i<zkArr.length;i++){
                if(zkArr[i].checked){
                    count++;
                }
            }
            for(let i=0;i<zkArr.length;i++){
                if(zkArr[i].yxmc){
                if(count>0){
                    if(zkArr[i].checked){
                        const o={};
                        o.createtime="";
                        o.faid=this.selectedYxzyz;
                        o.id="";
                        o.kl=this.userInfo.sxkm;
                        o.pc=pc;
                        o.status=zkArr[i].checked?1:0;
                        o.updatetime="";
                        o.xh=(i+1);
                        o.yxxh=zkArr[i].yxxh;
                        o.zyz=zkArr[i].zyz;
                        o.yxmc=zkArr[i].yxmc;
                        o.sb=zkArr[i].sb;
                        list.push(o);
                    }
                }else{
                    const o={};
                    o.createtime="";
                    o.faid=this.selectedYxzyz;
                    o.id="";
                    o.kl=this.userInfo.sxkm;
                    o.pc=pc;
                    o.status=zkArr[i].checked?1:0;
                    o.updatetime="";
                    o.xh=(i+1);
                    o.yxxh=zkArr[i].yxxh;
                    o.zyz=zkArr[i].zyz;
                    o.yxmc=zkArr[i].yxmc;
                    o.sb=zkArr[i].sb;
                    list.push(o);
                }
                }
            }
            obj.list=list;
            const res=await this.$http.postHttp("/yhgzfa/saveOrUpdateGzyxFa",obj);
            if(res.data.code===200){
                if(res.data.message){
                    this.$message({message:res.data.message,type:"success",showClose:true});
                }else{
                    this.$message({message:"保存成功",type:"success",showClose:true});
                }
                this.dialogOtherVisible=false;
                this.dialogPlanVisible=false;
            }else if(res.data.code===500){
                if(res.data.message){
                    this.$message({message:res.data.message,type:'error'});
                }
            }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
            }else if(res.data.code===0){
                this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
            }else if(res.status===409||res.status===410||res.status===411){
                this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:"warning"});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
            }
        }else if(pc==='0'){
            const obj={};
            obj.bz=this.userInfo.bz;
            obj.date=new Date().toLocaleString();
            obj.dfzxzg=this.userInfo.dfzxzg;
            obj.flag=0;
            obj.gjzxzg=this.userInfo.gjzxzg;
            obj.gkfs=this.userInfo.gkfs;
            obj.id="";
            obj.kl=this.userInfo.sxkm;
            obj.param="";
            if(this.otherPlan===''){
                this.$message({message:"请输入方案名",showClose:true});
                return;
            }
            obj.plan=this.otherPlan;
            obj.school=this.userInfo.school;
            obj.xxmc=this.userInfo.xxmc;
            obj.sjhm=this.userInfo.sjhm;
            obj.sssf=this.userInfo.sssf;
            obj.sxcj=this.userInfo.sxcj;
            obj.sxkm=this.userInfo.sxkm;
            obj.sxkmcj=this.userInfo.sxkmcj;
            obj.wycj=this.userInfo.wycj;
            obj.xb=this.userInfo.xb;
            obj.xm=this.userInfo.xm;
            obj.yfjf=this.userInfo.yfjf;
            obj.yhid=this.userInfo.yhid;
            obj.yhlb=this.userInfo.yhlb;
            obj.ywcj=this.userInfo.ywcj;
            obj.zckh=this.userInfo.zckh;
            obj.zxkma=this.userInfo.zxkma;
            obj.zxkmacj=this.userInfo.zxkmacj;
            obj.zxkmb=this.userInfo.zxkmb;
            obj.zxkmbcj=this.userInfo.zxkmbcj;
            obj.pc=pc;
            const list=[];
            const bkTqpArr=[...this.bkTqpCollectYx];
            let count=0;
            for(let i=0;i<bkTqpArr.length;i++){
                if(bkTqpArr[i].checked){
                    count++;
                }
            }
            for(let i=0;i<bkTqpArr.length;i++){
                if(bkTqpArr[i].yxmc){
                if(count>0){
                    if(bkTqpArr[i].checked){
                        const o={};
                        o.createtime="";
                        o.faid=this.selectedYxzyz;
                        o.id="";
                        o.kl=this.userInfo.sxkm;
                        o.pc=pc;
                        o.status=bkTqpArr[i].checked?1:0;
                        o.updatetime="";
                        o.xh=(i+1);
                        o.yxxh=bkTqpArr[i].yxxh;
                        o.zyz=bkTqpArr[i].zyz;
                        o.yxmc=bkTqpArr[i].yxmc;
                        o.sb=bkTqpArr[i].sb;
                        list.push(o);
                    }
                }else{
                    const o={};
                    o.createtime="";
                    o.faid=this.selectedYxzyz;
                    o.id="";
                    o.kl=this.userInfo.sxkm;
                    o.pc=pc;
                    o.status=bkTqpArr[i].checked?1:0;
                    o.updatetime="";
                    o.xh=(i+1);
                    o.yxxh=bkTqpArr[i].yxxh;
                    o.zyz=bkTqpArr[i].zyz;
                    o.yxmc=bkTqpArr[i].yxmc;
                    o.sb=bkTqpArr[i].sb;
                    list.push(o);
                }
                }
            }
            obj.list=list;
            const res=await this.$http.postHttp("/yhgzfa/saveOrUpdateGzyxFa",obj);
            if(res.data.code===200){
                if(res.data.message){
                    this.$message({message:res.data.message,type:"success",showClose:true});
                }else{
                    this.$message({message:"保存成功",type:"success",showClose:true});
                }
                this.dialogOtherVisible=false;
                this.dialogPlanVisible=false;
            }else if(res.data.code===500){
                if(res.data.message){
                    this.$message({message:res.data.message,type:'error'});
                }
            }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
            }else if(res.data.code===0){
                this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
            }else if(res.status===409||res.status===410||res.status===411){
                this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:"warning"});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
            }
        }else{
            const obj={};
            obj.bz=this.userInfo.bz;
            obj.date=new Date().toLocaleString();
            obj.dfzxzg=this.userInfo.dfzxzg;
            obj.flag=0;
            obj.gjzxzg=this.userInfo.gjzxzg;
            obj.gkfs=this.userInfo.gkfs;
            obj.id="";
            obj.kl=this.userInfo.sxkm;
            obj.param="";
            if(this.otherPlan===''){
                this.$message({message:"请输入方案名",showClose:true});
                return;
            }
            obj.plan=this.otherPlan;
            obj.school=this.userInfo.school;
            obj.xxmc=this.userInfo.xxmc;
            obj.sjhm=this.userInfo.sjhm;
            obj.sssf=this.userInfo.sssf;
            obj.sxcj=this.userInfo.sxcj;
            obj.sxkm=this.userInfo.sxkm;
            obj.sxkmcj=this.userInfo.sxkmcj;
            obj.wycj=this.userInfo.wycj;
            obj.xb=this.userInfo.xb;
            obj.xm=this.userInfo.xm;
            obj.yfjf=this.userInfo.yfjf;
            obj.yhid=this.userInfo.yhid;
            obj.yhlb=this.userInfo.yhlb;
            obj.ywcj=this.userInfo.ywcj;
            obj.zckh=this.userInfo.zckh;
            obj.zxkma=this.userInfo.zxkma;
            obj.zxkmacj=this.userInfo.zxkmacj;
            obj.zxkmb=this.userInfo.zxkmb;
            obj.zxkmbcj=this.userInfo.zxkmbcj;
            obj.pc=pc;
            const list=[];
            const zkTqpArr=[...this.zkTqpCollectYx];
            let count=0;
            for(let i=0;i<zkTqpArr.length;i++){
                if(zkTqpArr[i].checked){
                    count++;
                }
            }
            for(let i=0;i<zkTqpArr.length;i++){
                if(zkTqpArr[i].yxmc){
                if(count>0){
                    if(zkTqpArr[i].checked){
                        const o={};
                        o.createtime="";
                        o.faid=this.selectedYxzyz;
                        o.id="";
                        o.kl=this.userInfo.sxkm;
                        o.pc=pc;
                        o.status=zkTqpArr[i].checked?1:0;
                        o.updatetime="";
                        o.xh=(i+1);
                        o.yxxh=zkTqpArr[i].yxxh;
                        o.zyz=zkTqpArr[i].zyz;
                        o.yxmc=zkTqpArr[i].yxmc;
                        o.sb=zkTqpArr[i].sb;
                        list.push(o);
                    }
                }else{
                    const o={};
                    o.createtime="";
                    o.faid=this.selectedYxzyz;
                    o.id="";
                    o.kl=this.userInfo.sxkm;
                    o.pc=pc;
                    o.status=zkTqpArr[i].checked?1:0;
                    o.updatetime="";
                    o.xh=(i+1);
                    o.yxxh=zkTqpArr[i].yxxh;
                    o.zyz=zkTqpArr[i].zyz;
                    o.yxmc=zkTqpArr[i].yxmc;
                    o.sb=zkTqpArr[i].sb;
                    list.push(o);
                }
                }
            }
            obj.list=list;
            const res=await this.$http.postHttp("/yhgzfa/saveOrUpdateGzyxFa",obj);
            if(res.data.code===200){
                if(res.data.message){
                    this.$message({message:res.data.message,type:"success",showClose:true});
                }else{
                    this.$message({message:"保存成功",type:"success",showClose:true});
                }
                this.dialogOtherVisible=false;
                this.dialogPlanVisible=false;
            }else if(res.data.code===500){
                if(res.data.message){
                    this.$message({message:res.data.message,type:'error'});
                }
            }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
            }else if(res.data.code===0){
                this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
            }else if(res.status===409||res.status===410||res.status===411){
                this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:"warning"});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
            }
        }
    },
    // 打开另存为弹窗
    async openOther(){
        this.dialogOtherVisible=true;
    },
    // 关闭另存为窗口
    closeOther(){
        this.dialogOtherVisible=false;
        this.dialogPlanVisible=false;
        this.otherPlan='';
    },
    // 删除院校
    async deleteSchool(){
        // const pc=this.activePcName;
        // if(pc==='6'){
        //     const checkedIndexArr=[];
        //     let bkArr=[...this.bkCollectYx];
        //     for(let i=0;i<bkArr.length;i++){
        //         if(bkArr[i].checked){
        //             checkedIndexArr.push(i);
        //         }
        //     }
        //     for(let i=0;i<checkedIndexArr.length;i++){
        //             if(checkedIndexArr[i]>=0){
        //                 bkArr[checkedIndexArr[i]]=null;
        //             }
        //     }
        //     bkArr=bkArr.filter(item=>item!=null);
        //     const len=checkedIndexArr.length>45?45:checkedIndexArr.length;
        //     for(let i=0;i<len;i++){
        //             const obj={};
        //             obj.index=bkArr.length;
        //             obj.checked=false;
        //             obj.sb=null;
        //             obj.yxmc=null;
        //             obj.zyz=null;
        //             obj.szdqmc=null;
        //             obj.pc=null;
        //             obj.sf985=null;
        //             obj.sf211=null;
        //             bkArr.push(obj);
        //     }
        //     this.bkCollectYx=bkArr;
        // }else{
        //     const checkedIndexArr=[];
        //     let zkArr=[...this.zkCollectYx];
        //     for(let i=0;i<zkArr.length;i++){
        //         if(zkArr[i].checked){
        //             checkedIndexArr.push(i);
        //         }
        //     }
        //     for(let i=0;i<checkedIndexArr.length;i++){
        //         if(checkedIndexArr[i]>=0){
        //             zkArr[checkedIndexArr[i]]=null;
        //         }
        //     }
        //     zkArr=zkArr.filter(item=>item!=null);
        //     const len=checkedIndexArr.length>45?45:checkedIndexArr.length;
        //     for(let i=0;i<len;i++){
        //             const obj={};
        //             obj.index=zkArr.length;
        //             obj.checked=false;
        //             obj.sb=null;
        //             obj.yxmc=null;
        //             obj.zyz=null;
        //             obj.szdqmc=null;
        //             obj.pc=null;
        //             obj.sf985=null;
        //             obj.sf211=null;
        //             zkArr.push(obj);
        //     }
        //     this.zkCollectYx=zkArr;
        // }
        const pc=this.activePcName;
        if(pc==='6'){
            const bkArr=[...this.bkCollectYx];
            const delArr=[];
            for(let i=0;i<bkArr.length;i++){
                if(bkArr[i].checked&&bkArr[i].yxmc){
                    const obj={};
                    obj.fs=this.userInfo.gkfs;
                    // obj.gzsj=new Date(bkArr[i].gzsj);
                    obj.gzsj=time(bkArr[i].gzsj);
                    obj.kl=this.userInfo.kl;
                    obj.pc=bkArr[i].pc;
                    obj.status=bkArr[i].checked?'1':'0';
                    obj.xh=bkArr[i].xh;
                    obj.xm=this.userInfo.xm;
                    obj.yhid=this.userInfo.yhid;
                    obj.yxmc=bkArr[i].yxmc;
                    obj.yxxh=bkArr[i].yxxh;
                    obj.zyz=bkArr[i].zyz;
                    delArr.push(obj);
                }
            }
            const res=await this.$http.postHttp('/yhgz/delYhgzYx',delArr);
            if(res.data.code===200){
                if(res.data.message){
                    this.$message({
                        message:res.data.message,
                        type:'success',
                        showClose:true
                    });
                }else{
                    this.$message({
                        message:'操作成功',
                        type:'success',
                        showClose:true
                    });
                }
                const id=this.$route.query.id;
                const pc=this.$route.query.pc;
                const isto=this.$route.query.isto;
                const plan=this.$route.query.plan;
                if(id){
                    if(isto){
                        // await this.getYhGzYx();
                        this.reloadTimer=setInterval(async () => {
                            if(this.reloadGzYx&&this.reloadGzYx==='true'){
                                clearInterval(this.reloadTimer);
                                await this.getYhGzYx();
                                // await this.getLastPlan();
                            }
                        }, 1000);
                    }else if(plan){
                        if(delArr.length===0){
                            this.activePcName=pc?pc+'':'6';
                            await this.getPlanContent(plan,pc,id);
                        }else{
                            await this.getYhGzYx();
                        }
                    }
                }else{
                    // await this.getBkGzyx();
                    await this.getYhGzYx();
                }
            }else if(res.data.code===500){
            if(res.data.message){
                this.$message({message:res.data.message,type:'error'});
            }
            }else if(res.status===401){
                this.$message({message: '登录超时，请重新登录',type:"error"});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
            }else if(res.data.code===0){
                this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
            }
        }else if(pc==='7'){
            const zkArr=[...this.zkCollectYx];
            const delArr=[];
            for(let i=0;i<zkArr.length;i++){
                if(zkArr[i].checked&&zkArr[i].yxmc){
                    const obj={};
                    obj.fs=this.userInfo.gkfs;
                    // obj.gzsj=new Date(zkArr[i].gzsj);
                    obj.gzsj=time(zkArr[i].gzsj);
                    obj.kl=this.userInfo.kl;
                    obj.pc=zkArr[i].pc;
                    obj.status=zkArr[i].checked?'1':'0';
                    obj.xh=zkArr[i].xh;
                    obj.xm=this.userInfo.xm;
                    obj.yhid=this.userInfo.yhid;
                    obj.yxmc=zkArr[i].yxmc;
                    obj.yxxh=zkArr[i].yxxh;
                    obj.zyz=zkArr[i].zyz;
                    delArr.push(obj);
                }
            }
            const res=await this.$http.postHttp('/yhgz/delYhgzYx',delArr);
            if(res.data.code===200){
                if(res.data.message){
                    this.$message({
                        message:res.data.message,
                        type:'success',
                        showClose:true
                    });
                }else{
                    this.$message({
                        message:'操作成功',
                        type:'success',
                        showClose:true
                    });
                }
                const id=this.$route.query.id;
                const pc=this.$route.query.pc;
                const isto=this.$route.query.isto;
                const plan=this.$route.query.plan;
                if(id){
                    if(isto){
                        // await this.getYhGzYx();
                        this.reloadTimer=setInterval(async () => {
                            if(this.reloadGzYx&&this.reloadGzYx==='true'){
                                clearInterval(this.reloadTimer);
                                await this.getYhGzYx();
                                // await this.getLastPlan();
                            }
                        }, 1000);
                    }else if(plan){
                        if(delArr.length===0){
                            this.activePcName=pc?pc+'':'6';
                            await this.getPlanContent(plan,pc,id);
                        }else{
                            await this.getYhGzYx();
                        }
                    }
                }else{
                    // await this.getBkGzyx();
                    await this.getYhGzYx();
                }
            }else if(res.data.code===500){
            if(res.data.message){
                this.$message({message:res.data.message,type:'error'});
            }
            }else if(res.status===401){
                this.$message({message: '登录超时，请重新登录',type:"error"});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
            }else if(res.data.code===0){
                this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
            }
        }else if(pc==='0'){
            const bkTqpArr=[...this.bkTqpCollectYx];
            const delArr=[];
            for(let i=0;i<bkTqpArr.length;i++){
                if(bkTqpArr[i].checked&&bkTqpArr[i].yxmc){
                    const obj={};
                    obj.fs=this.userInfo.gkfs;
                    // obj.gzsj=new Date(bkTqpArr[i].gzsj);
                    obj.gzsj=time(bkTqpArr[i].gzsj);
                    obj.kl=this.userInfo.kl;
                    obj.pc=bkTqpArr[i].pc;
                    obj.status=bkTqpArr[i].checked?'1':'0';
                    obj.xh=bkTqpArr[i].xh;
                    obj.xm=this.userInfo.xm;
                    obj.yhid=this.userInfo.yhid;
                    obj.yxmc=bkTqpArr[i].yxmc;
                    obj.yxxh=bkTqpArr[i].yxxh;
                    obj.zyz=bkTqpArr[i].zyz;
                    delArr.push(obj);
                }
            }
            const res=await this.$http.postHttp('/yhgz/delYhgzYx',delArr);
            if(res.data.code===200){
                if(res.data.message){
                    this.$message({
                        message:res.data.message,
                        type:'success',
                        showClose:true
                    });
                }else{
                    this.$message({
                        message:'操作成功',
                        type:'success',
                        showClose:true
                    });
                }
                const id=this.$route.query.id;
                const pc=this.$route.query.pc;
                const isto=this.$route.query.isto;
                const plan=this.$route.query.plan;
                if(id){
                    if(isto){
                        // await this.getYhGzYx();
                        this.reloadTimer=setInterval(async () => {
                            if(this.reloadGzYx&&this.reloadGzYx==='true'){
                                clearInterval(this.reloadTimer);
                                await this.getYhGzYx();
                                // await this.getLastPlan();
                            }
                        }, 1000);
                    }else if(plan){
                        if(delArr.length===0){
                            this.activePcName=pc?pc+'':'6';
                            await this.getPlanContent(plan,pc,id);
                        }else{
                            await this.getYhGzYx();
                        }
                    }
                }else{
                    // await this.getBkGzyx();
                    await this.getYhGzYx();
                }
            }else if(res.data.code===500){
            if(res.data.message){
                this.$message({message:res.data.message,type:'error'});
            }
            }else if(res.status===401){
                this.$message({message: '登录超时，请重新登录',type:"error"});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
            }else if(res.data.code===0){
                this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
            }
        }else{
            const zkTqpArr=[...this.zkTqpCollectYx];
            const delArr=[];
            for(let i=0;i<zkTqpArr.length;i++){
                if(zkTqpArr[i].checked&&zkTqpArr[i].yxmc){
                    const obj={};
                    obj.fs=this.userInfo.gkfs;
                    // obj.gzsj=new Date(zkTqpArr[i].gzsj);
                    obj.gzsj=time(zkTqpArr[i].gzsj);
                    obj.kl=this.userInfo.kl;
                    obj.pc=zkTqpArr[i].pc;
                    obj.status=zkTqpArr[i].checked?'1':'0';
                    obj.xh=zkTqpArr[i].xh;
                    obj.xm=this.userInfo.xm;
                    obj.yhid=this.userInfo.yhid;
                    obj.yxmc=zkTqpArr[i].yxmc;
                    obj.yxxh=zkTqpArr[i].yxxh;
                    obj.zyz=zkTqpArr[i].zyz;
                    delArr.push(obj);
                }
            }
            const res=await this.$http.postHttp('/yhgz/delYhgzYx',delArr);
            if(res.data.code===200){
                if(res.data.message){
                    this.$message({
                        message:res.data.message,
                        type:'success',
                        showClose:true
                    });
                }else{
                    this.$message({
                        message:'操作成功',
                        type:'success',
                        showClose:true
                    });
                }
                const id=this.$route.query.id;
                const pc=this.$route.query.pc;
                const isto=this.$route.query.isto;
                const plan=this.$route.query.plan;
                if(id){
                    if(isto){
                        // await this.getYhGzYx();
                        this.reloadTimer=setInterval(async () => {
                            if(this.reloadGzYx&&this.reloadGzYx==='true'){
                                clearInterval(this.reloadTimer);
                                await this.getYhGzYx();
                                // await this.getLastPlan();
                            }
                        }, 1000);
                    }else if(plan){
                        if(delArr.length===0){
                            this.activePcName=pc?pc+'':'6';
                            await this.getPlanContent(plan,pc,id);
                        }else{
                            await this.getYhGzYx();
                        }
                    }
                }else{
                    // await this.getBkGzyx();
                    await this.getYhGzYx();
                }
            }else if(res.data.code===500){
            if(res.data.message){
                this.$message({message:res.data.message,type:'error'});
            }
            }else if(res.status===401){
                this.$message({message: '登录超时，请重新登录',type:"error"});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
            }else if(res.data.code===0){
                this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
            }
        }
    },
    // 重新设置index属性
    setIndex(arr){
        for(let i=0;i<arr.length;i++){
            arr[i].index=(i+1);
        }
        return arr;
    },
    // 打开已保存的院校专业组
    watchYxzyz(id,pc,plan){
        this.dialogTableVisible=false;
        const url=this.$router.resolve({
            path:"/main/zypg",
            query:{id,pc,plan}
        });
        window.open(url.href,"_blank");
    },
    // 通过id查询关注的院校专业组
    async getYxzyzById(id,pc=6){
        let loadId="bk-data";
        if(pc===6||pc==='6'){
            loadId="bk-data";
            const arr=[];
            for(let i=0;i<10;i++){
                    const obj={};
                    obj.index=(i+1);
                    obj.xh=i+1;
                    obj.checked=false;
                    obj.sb=null;
                    obj.yxmc=null;
                    obj.zyz=null;
                    obj.szdqmc=null;
                    obj.pc=null;
                    obj.sf985=null;
                    obj.sf211=null;
                    arr.push(obj);
                }
                this.zkCollectYx=arr;
                this.bkTqpCollectYx=arr;
                this.zkTqpCollectYx=arr;
        }else if(pc===7||pc==='7'){
            loadId="zk-data";
            const arr=[];
            for(let i=0;i<10;i++){
                    const obj={};
                    obj.index=(i+1);
                    obj.xh=i+1;
                    obj.checked=false;
                    obj.sb=null;
                    obj.yxmc=null;
                    obj.zyz=null;
                    obj.szdqmc=null;
                    obj.pc=null;
                    obj.sf985=null;
                    obj.sf211=null;
                    arr.push(obj);
            }
            this.bkCollectYx=arr;
            this.bkTqpCollectYx=arr;
            this.zkTqpCollectYx=arr;
        }else if(pc===0||pc==='0'){
            loadId="bkTqp-data";
            const arr=[];
            for(let i=0;i<10;i++){
                    const obj={};
                    obj.index=(i+1);
                    obj.xh=i+1;
                    obj.checked=false;
                    obj.sb=null;
                    obj.yxmc=null;
                    obj.zyz=null;
                    obj.szdqmc=null;
                    obj.pc=null;
                    obj.sf985=null;
                    obj.sf211=null;
                    arr.push(obj);
            }
            this.zkTqpCollectYx=arr;
            this.bkCollectYx=arr;
            this.zkCollectYx=arr;
        }else{
            loadId="zkTqp-data";
            const arr=[];
            for(let i=0;i<10;i++){
                    const obj={};
                    obj.index=(i+1);
                    obj.xh=i+1;
                    obj.checked=false;
                    obj.sb=null;
                    obj.yxmc=null;
                    obj.zyz=null;
                    obj.szdqmc=null;
                    obj.pc=null;
                    obj.sf985=null;
                    obj.sf211=null;
                    arr.push(obj);
            }
            this.bkTqpCollectYx=arr;
            this.bkCollectYx=arr;
            this.zkCollectYx=arr;
        }
        this.activePcName=pc+'';
        const loading=this.$loading({fullscreen:true,target:document.getElementById(loadId),text:"正在加载中"});
        const res=await this.$http.getHttp("/yhgzfa/selectFaById?id="+id);
        if(res.data.code===200){
            this.planObj.plan=res.data.obj.plan;
            this.planObj.time=res.data.obj.date;
            this.planObj.id=id;
            if(res.data.obj.users){
                this.$store.dispatch('saveUserInfo',res.data.obj.users);
            }
            const user={};
            user.bz=res.data.obj.users.bz;
            user.gjzxzg=res.data.obj.users.gjzxzg;
            user.dfzxzg=res.data.obj.users.dfzxzg;
            user.gkfs=res.data.obj.users.gkfs;
            user.sxkm=res.data.obj.users.sxkm;
            user.school=res.data.obj.users.school;
            user.sjhm=res.data.obj.users.sjhm;
            user.sssf=res.data.obj.users.sssf;
            user.sxcj=res.data.obj.users.sxcj;
            user.sxkmcj=res.data.obj.users.sxkmcj;
            user.wycj=res.data.obj.users.wycj;
            user.xb=res.data.obj.users.xb;
            user.xm=res.data.obj.users.xm;
            user.yfjf=res.data.obj.users.yfjf;
            user.yhid=res.data.obj.users.yhid;
            user.yhlb=res.data.obj.users.yhlb;
            user.ywcj=res.data.obj.users.ywcj;
            user.zxkma=res.data.obj.users.zxkma;
            user.zxkmacj=res.data.obj.users.zxkmacj;
            user.zxkmb=res.data.obj.users.zxkmb;
            user.zxkmbcj=res.data.obj.users.zxkmbcj;
            // const yhlb=this.userInfo.yhlb;
            // if(yhlb===7||yhlb===9){
            //     await this.updateInfo(user);
            // }
            const arr=[...res.data.obj.obj];
            if(arr){
                for(let i=0;i<arr.length;i++){
                arr[i].checked=arr[i].isRed||false;
                arr[i].index=i+1;
                arr[i].xh=res.data.obj.obj[i].xh||null;
            }
            const len=arr.length;
            if(len<10){
                for(let i=0;i<10-len;i++){
                    const obj={};
                    obj.index=len+(i+1);
                    obj.xh=len+(i+1);
                    obj.checked=false;
                    obj.sb=null;
                    obj.yxmc=null;
                    obj.zyz=null;
                    obj.szdqmc=null;
                    obj.pc=null;
                    obj.sf985=null;
                    obj.sf211=null;
                    arr.push(obj);
                }
                if(pc===6||pc==='6'){
                    this.bkCollectYx=arr;
                }else if(pc===7||pc==='7'){
                    this.zkCollectYx=arr;
                }else if(pc===0||pc==='0'){
                    this.bkTqpCollectYx=arr;
                }else{
                    this.zkTqpCollectYx=arr;
                }
            }
                if(pc===6||pc==='6'){
                    this.bkCollectYx=arr;
                }else if(pc===7||pc==='7'){
                    this.zkCollectYx=arr;
                }else if(pc===0||pc==='0'){
                    this.bkTqpCollectYx=arr;
                }else{
                    this.zkTqpCollectYx=arr;
                }
            }
        }else if(res.data.code===500){
            if(res.data.message){
                this.$message({message:res.data.message,type:'error'});
            }
        }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.data.code===0){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }
        loading.close();
    },
        // 修改分数
    async updateInfo(user){
        const obj={};
        obj.bz=user.bz;
        obj.gjzxzg=user.gjzxzg;
        obj.dfzxzg=user.dfzxzg;
        obj.dzyx="";
        obj.enabled=true;
        obj.gkfs=user.gkfs;
        obj.gkfsxg=this.userInfo.gkfsxg;
        obj.khzcsj=this.userInfo.khzcsj;
        obj.kl=user.sxkm;
        obj.ksxm=this.userInfo.ksxm;
        obj.openid=this.userInfo.openid;
        obj.password=this.userInfo.password;
        obj.school=user.school;
        obj.sjhm=user.sjhm;
        obj.sssf=user.sssf;
        obj.sxcj=user.sxcj;
        obj.sxkm=user.sxkm;
        obj.sxkmcj=user.sxkmcj;
        obj.username=this.userInfo.username;
        obj.wycj=user.wycj;
        obj.xb=user.xb;
        obj.xm=user.xm;
        obj.yfjf=user.yfjf;
        obj.yfjf3=this.userInfo.yfjf3;
        obj.yfjf5=this.userInfo.yfjf5;
        obj.yfjf10=this.userInfo.yfjf10;
        obj.yfjf20=this.userInfo.yfjf20;
        obj.yhid=user.yhid;
        obj.yhlb=user.yhlb;
        obj.yhzcsj=this.userInfo.yhzcsj;
        obj.ywcj=user.ywcj;
        obj.zcjd=this.userInfo.zcjd;
        obj.zckh=this.userInfo.zckh;
        obj.zxkma=user.zxkma;
        obj.zxkmb=user.zxkmb;
        obj.zxkmacj=user.zxkmacj;
        obj.zxkmbcj=user.zxkmbcj;
        const res=await this.$http.postHttp("/users/modifyFs",obj);
        if(res.data.code===200){
            console.log("updateUser");
            // this.$message({message:"修改成功",type:"success",showClose:true});
            await this.getUser();
        }else if(res.data.code===500){
            if(res.data.message){
                this.$message({message:res.data.message,type:'error'});
            }
        }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.data.code===0){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.status===409||res.status===410||res.status===411){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:"warning"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }
    },
        // 获取用户信息
    async getUser(){
        const res=await this.$http.getHttp("/users/getUserInfo?username="+this.userInfo.username);
        if(res.status===200){
            if(res.data.code===0){
                this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
            }else if(res.data.code===500){
                if(res.data.message){
                    this.$message({message:res.data.message,type:'error'});
                }
            }else{
                this.$store.dispatch("saveUserInfo",res.data);
            }
        }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.data.code===0){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }
    },
    // 获取产品信息
    async getCpxx(cpid){
        const res=await this.$http.getHttp("/cpxx/getCpxxById?cpid="+cpid);
        if(res.data.code===200){
            this.buyInfo.type=res.data.obj.id+"";
            this.buyInfo.payPrice=res.data.obj.xsjg;
            this.buyInfo.cpmc=res.data.obj.cpmc;
            this.buyInfo.sssf=this.userInfo.sssf+"";
        }else if(res.data.code===500){
            if(res.data.message){
                this.$message({message:res.data.message,type:'error'});
            }
        }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.data.code===0){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.status===409||res.status===410||res.status===411){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:"warning"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }
    },
    // 获取订单信息
    async getDdxx(type=1){
        if(type===1){
            const that=this;
            this.zfbTime=90;
            this.ddTimer=setInterval(async () => {
                this.zfbTime--;
                const ddh=localStorage.getItem("aipayDdh");
                if(ddh){
                    const res=await this.$http.getHttp("/ddxx/getDdxxByDdh?ddh="+ddh);
                    if(res.data.code===200){
                        const zt=res.data.obj.ddzt;
                        if(zt===2){
                        // this.freeDownload();
                            // this.totalFreeDownload();
                                if(this.yfPg){
                                    await this.submitZypg();
                                }else{
                                    if(this.payMnzybFlag){
                                        await this.freeDownExcel();
                                    }else{
                                        await this.freeDownload();
                                    }
                                }
                            localStorage.removeItem("aipayDdh");
                            clearInterval(this.ddTimer);
                        }
                    }else if(res.data.code===500){
                        if(res.data.message){
                            this.$message({message:res.data.message,type:'error'});
                        }
                    }else if(res.status===401){
                        clearInterval(this.ddTimer);
                        this.$message({message: '登录超时，请重新登录',type:"error"});
                        await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                        this.$router.replace({
                            path: '/main/home',
                            query: {redirect: this.$router.currentRoute.fullPath}
                        });
                    }else if(res.data.code===0){
                        clearInterval(this.ddTimer);
                        this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                        await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                        this.$router.replace({
                            path: '/main/home',
                            query: {redirect: this.$router.currentRoute.fullPath}
                        });
                    }else if(res.status===409||res.status===410||res.status===411){
                        clearInterval(this.ddTimer);
                        this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:"warning"});
                        await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                        this.$router.replace({
                            path: '/main/home',
                            query: {redirect: this.$router.currentRoute.fullPath}
                        });
                    }
                }
                if(this.zfbTime===0){
                    clearInterval(this.ddTimer);
                    this.zfbTime=0;
                    localStorage.removeItem("aipayDdh");
                }
        }, 1000);
        }else{
            const ddh=this.wxDdh;
            const res=await this.$http.getHttp("/ddxx/getDdxxByDdh?ddh="+ddh);
            if(res.data.code===200){
                        const zt=res.data.obj.ddzt;
                        if(zt===2){
                            this.wxSuccess=true;
                        }
            }else if(res.data.code===500){
                        if(res.data.message){
                            this.$message({message:res.data.message,type:'error'});
                        }
            }else if(res.status===401){
                        this.$message({message: '登录超时，请重新登录',type:"error"});
                        await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                        this.$router.replace({
                            path: '/main/home',
                            query: {redirect: this.$router.currentRoute.fullPath}
                        });
            }else if(res.data.code===0){
                        this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                        await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                        this.$router.replace({
                            path: '/main/home',
                            query: {redirect: this.$router.currentRoute.fullPath}
                        });
            }else if(res.status===409||res.status===410||res.status===411){
                this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:"warning"});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
            }
        }
    },
    // 下载一次
    async yhDownload(){
        await this.getCpxx(12);
        this.dialogBuyVisible=true;
    },
    // 永久下载
    async yjDownload(){
        await this.getCpxx(13);
        this.dialogBuyVisible=true;
    },
    // 下载一次
    async yhDownload2(){
        await this.getCpxx(12);
        this.dialogBuyVisible=true;
    },
    // 永久下载
    async yjDownload2(){
        await this.getCpxx(13);
        this.dialogBuyVisible=true;
    },
    // 下载一次
    async yhDownload3(){
        await this.getCpxx(10);
        this.payMnzybFlag=true;
        this.dialogBuyVisible=true;
    },
    // 永久下载
    async yjDownload3(){
        await this.getCpxx(11);
        this.payMnzybFlag=true;
        this.dialogBuyVisible=true;
    },
    // 关闭二维码弹窗
    closeDialog(){
        this.dialogBuyVisible=false;
        this.innerdialogVisible=false;
        clearInterval(this.intervalQrcodeTime);
    },
    // 支付下载
    async payDown(){
        const obj={};
        obj.code="";
        obj.cpid=this.buyInfo.type;
        obj.ddh="";
        obj.payType=this.buyInfo.payType;
        obj.sf=this.buyInfo.sssf;
        obj.sjhm="";
        obj.sum=this.buyInfo.num;
        obj.codeid="";
        const res=await this.$http.postHttp("/ddxx/ddSubmit",obj);
        if(res.data.code===200){
            if(this.buyInfo.payType===1){
            // 支付宝支付
            const ddh=res.data.obj.orderId;
            const res2=await this.$http.getHttp("/pay/aliPay?ddh="+ddh);
            localStorage.setItem("aipayDdh",ddh);
            const routerData = this.$router.resolve({
            path: "/payGateWay",
            query: { htmlData: res2.data }
          });
            await this.getDdxx(1);
            this.dialogBuyVisible=false;
            window.open(routerData.href,"_blank");
            }else {
          // 2.微信支付
          this.innerTitle = `微信支付-￥${this.buyInfo.payPrice}`;
          this.innerdialogVisible = true;
          this.dialogBuyVisible = false;
          this.wxDdh=res.data.obj.orderId;
          const obj={};
          obj.orderId=res.data.obj.orderId;
          obj.productName=this.buyInfo.cpmc;
          obj.orderAmount=this.buyInfo.payPrice;
          const result = await this.$http.postHttp("/pay/wxPay",obj);
          console.log(result,QRCode);
        //   if (result.code === 200) {
        //     this.out_trade_no = result.data.out_trade_no;
        //     this.$refs.qrCodeDiv.innerHTML = "";
        //     let qrcode = new QRCode("qrcode", {
        //       width: 132,
        //       height: 132,
        //       text: result.data.urlCode, // 二维码地址
        //       colorDark: "#000",
        //       colorLight: "#fff"
        //     });
        //     //设置定时器
        //     this.qrcodeTime = 60;
        //     this.intervalQrcodeTime = setInterval(async () => {
        //       this.qrcodeTime--;
        //       if (this.qrcodeTime === 0) {
        //         clearInterval(this.intervalQrcodeTime);
        //         this.innerdialogVisible = false;
        //       }
        //     })
        //     }
            if(result.data.code===200){
                this.qrcodeTime=60;
                        this.$nextTick(()=>{
                            this.$refs.qrCodeDiv.innerHTML = "";
                            const qrcode = new QRCode("qrcode", {
                                width: 132,
                                height: 132,
                                text: result.data.obj.urlCode, // 二维码地址
                                colorDark: "#000",
                                colorLight: "#fff"
                            });
                            console.log(qrcode);
                        });
                this.intervalQrcodeTime=setInterval(async () => {
                    this.qrcodeTime--;
                    if (this.qrcodeTime === 0) {
                    clearInterval(this.intervalQrcodeTime);
                    this.innerdialogVisible = false;
                    }
                    await this.getDdxx(2);
                    if(this.wxSuccess){
                        this.innerdialogVisible=false;
                        this.qrcodeTime=0;
                        // this.freeDownload();
                        // this.totalFreeDownload();
                        if(this.yfPg){
                            this.freeDownExcel();
                        }else{
                            this.freeDownload();
                        }
                        this.wxSuccess=false;
                        clearInterval(this.intervalQrcodeTime);
                    }
                }, 1000);
            }
        }
        }else if(res.data.code===500){
            if(res.data.message){
                this.$message({message:res.data.message,type:'error'});
            }
        }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.data.code===0){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.status===409||res.status===410||res.status===411){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:"warning"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }
    },
    async totalFreeDownload(){
        // await this.freeDownload2();
        // await this.freeDownExcel();
        // this.downloading = true
        // this.currentIndex = 0
        const pc=this.activePcName;
        if(pc==='6'||pc===6){
            const collectYx=this.bkCollectYx;
            const arr=[];
            const list=[];
            for(let i=0;i<collectYx.length;i++){
                if(collectYx[i].yxmc){
                    const pcmc=collectYx[i].pc===6?'本科批':'专科批';
                    const sb=!collectYx[i].sb?0:collectYx[i].sb+"";
                    const yxmc=!collectYx[i].yxmc?0:collectYx[i].yxmc;
                    const zyz=!collectYx[i].zyz?0:collectYx[i].zyz+"";
                    const szdqmc=!collectYx[i].szdqmc?0:collectYx[i].szdqmc;
                    const sf211=collectYx[i].sf211===1?'是':'否';
                    const sf985=collectYx[i].sf985===1?'是':'否';
                    const snjhs=!collectYx[i].snjhs?0:collectYx[i].snjhs+"";
                    const jnjhs=!collectYx[i].jnjhs?0:collectYx[i].jnjhs+"";
                    const rdwc=!collectYx[i].rdwc?0:collectYx[i].rdwc+"";
                    const snrdwc=!collectYx[i].snrdwc?0:collectYx[i].snrdwc+"";
                    const tdx=!collectYx[i].tdx?0:collectYx[i].tdx+"";
                    const zdtwf=!collectYx[i].zdtwf?0:collectYx[i].zdtwf+"";
                    const pjtwf=!collectYx[i].pjtwf?0:collectYx[i].pjtwf+"";
                    const zgtwf=!collectYx[i].zgtwf?0:collectYx[i].zgtwf+"";
                    arr.push(sb+'-'+yxmc+'-'+zyz+'-'+pcmc+'-'+szdqmc+'-'+sf211+'-'+sf985+'-'+
                    snjhs+'-'+jnjhs+'-'+rdwc+'-'+snrdwc+'-'+tdx+'-'+zdtwf+'-'+
                    pjtwf+'-'+zgtwf);
                    list.push({
                        xh:i+1,
                        dnjhs:jnjhs,
                        pc:pcmc,
                        pjRdwc:rdwc,
                        pjtwf,
                        sb,
                        sf211,
                        sf985,
                        sheng:szdqmc,
                        snRdwc:snrdwc,
                        snjhs,
                        tdx,
                        yxmc,
                        zdtwf,
                        zgtwf,
                        zyz
                    });
                }
            }
            const Yxs=[...this.bkCollectYx];
            const downParams=[];
            const obj0={};
                obj0.sssf=this.userInfo.sssf+"";
                obj0.sxkm=this.userInfo.sxkm+"";
                obj0.zxkma=this.userInfo.zxkma+"";
                obj0.zxkmb=this.userInfo.zxkmb+"";
                obj0.sxkmfs=!this.userInfo.sxkmcj?'':this.userInfo.sxkmcj+"";
                obj0.zxkmafs=!this.userInfo.zxkmacj?'':this.userInfo.zxkmacj+"";
                obj0.zxkmbfs=!this.userInfo.zxkmbcj?'':this.userInfo.zxkmbcj+"";
                obj0.xm=!this.userInfo.xm?'':this.userInfo.xm+"";
                obj0.school=(this.inputObj.school||this.userInfo.xxmc)+"";
                obj0.gkzf=this.userInfo.gkfs+"";
                obj0.yu=!this.userInfo.ywcj?'':this.userInfo.ywcj+"";
                obj0.shu=!this.userInfo.sxcj?'':this.userInfo.sxcj+"";
                obj0.wai=!this.userInfo.wycj?'':this.userInfo.wycj+"";
                obj0.bz=(this.inputObj.bz||this.userInfo.bz)+"";
                obj0.jf=this.userInfo.yfjf+"";
                obj0.sjhm=this.userInfo.sjhm+"";
                obj0.gjzxzg=this.userInfo.gjzxzg+"";
                obj0.dfzxzg=this.userInfo.dfzxzg+"";
                let gsh=this.userInfo.sjhm+"";
                const yhlb=this.userInfo.yhlb;
                if(yhlb===7||yhlb===9){
                    gsh=this.userInfo.sjhm;
                }
                obj0.ghs=gsh;
                obj0.xb=this.userInfo.xb+"";
                // obj0.pc=pc==='6'?'本科批':'专科批';
                obj0.pc=pc;
                for(let i=0;i<Yxs.length;i++){
                    if(Yxs[i].zyz){
                        const obj={};
                        obj.sb=Yxs[i].sb;
                        obj.sffc=Yxs[i].sffc===1||Yxs[i].sffc==='1'?'服从':'不服从';
                        obj.xh=(i+1);
                        obj.yxmc=Yxs[i].yxmc;
                        obj.yxxh=Yxs[i].yxxh;
                        obj.zyz=Yxs[i].zyz;
                        obj.zy1=!Yxs[i].zy1?'':Yxs[i].zy1;
                        obj.zy2=!Yxs[i].zy2?'':Yxs[i].zy2;
                        obj.zy3=!Yxs[i].zy3?'':Yxs[i].zy3;
                        obj.zy4=!Yxs[i].zy4?'':Yxs[i].zy4;
                        obj.zy5=!Yxs[i].zy5?'':Yxs[i].zy5;
                        obj.zy6=!Yxs[i].zy6?'':Yxs[i].zy6;
                        downParams.push(obj);
                    }
                }
                let down45School=[];
                if(downParams.length>45){
                    for(let i=0;i<downParams.length;i++){
                        if(i<45){
                            down45School.push(downParams[i]);
                        }
                    }
                }else{
                    down45School=[...downParams];
                }
                obj0.list=down45School;
            // const param=arr.join(",");
            // $("#down_param").val(param);
            // $("#down_list").val(JSON.stringify(list));
            // $("#down_form").submit();
            this.fileList[0].data=list;
            this.fileList[1].data=obj0;
        }else if(pc==='7'||pc===7){
            const collectYx=this.zkCollectYx;
            const arr=[];
            const list=[];
            for(let i=0;i<collectYx.length;i++){
                if(collectYx[i].yxmc){
                    const pcmc=collectYx[i].pc===6?'本科批':'专科批';
                    const sb=!collectYx[i].sb?0:collectYx[i].sb+"";
                    const yxmc=!collectYx[i].yxmc?0:collectYx[i].yxmc;
                    const zyz=!collectYx[i].zyz?0:collectYx[i].zyz+"";
                    const szdqmc=!collectYx[i].szdqmc?0:collectYx[i].szdqmc;
                    const sf211=collectYx[i].sf211===1?'是':'否';
                    const sf985=collectYx[i].sf985===1?'是':'否';
                    const snjhs=!collectYx[i].snjhs?0:collectYx[i].snjhs+"";
                    const jnjhs=!collectYx[i].jnjhs?0:collectYx[i].jnjhs+"";
                    const rdwc=!collectYx[i].rdwc?0:collectYx[i].rdwc+"";
                    const snrdwc=!collectYx[i].snrdwc?0:collectYx[i].snrdwc+"";
                    const tdx=!collectYx[i].tdx?0:collectYx[i].tdx+"";
                    const zdtwf=!collectYx[i].zdtwf?0:collectYx[i].zdtwf+"";
                    const pjtwf=!collectYx[i].pjtwf?0:collectYx[i].pjtwf+"";
                    const zgtwf=!collectYx[i].zgtwf?0:collectYx[i].zgtwf+"";
                    arr.push(sb+'-'+yxmc+'-'+zyz+'-'+pcmc+'-'+szdqmc+'-'+sf211+'-'+sf985+'-'+
                    snjhs+'-'+jnjhs+'-'+rdwc+'-'+snrdwc+'-'+tdx+'-'+zdtwf+'-'+
                    pjtwf+'-'+zgtwf);
                    list.push({
                        xh:i+1,
                        dnjhs:jnjhs,
                        pc:pcmc,
                        pjRdwc:rdwc,
                        pjtwf,
                        sb,
                        sf211,
                        sf985,
                        sheng:szdqmc,
                        snRdwc:snrdwc,
                        snjhs,
                        tdx,
                        yxmc,
                        zdtwf,
                        zgtwf,
                        zyz
                    });
                }
            }
            const Yxs=[...this.zkCollectYx];
            const downParams=[];
            const obj0={};
            obj0.sssf=this.userInfo.sssf+"";
                obj0.sxkm=this.userInfo.sxkm+"";
                obj0.zxkma=this.userInfo.zxkma+"";
                obj0.zxkmb=this.userInfo.zxkmb+"";
                obj0.sxkmfs=!this.userInfo.sxkmcj?'':this.userInfo.sxkmcj+"";
                obj0.zxkmafs=!this.userInfo.zxkmacj?'':this.userInfo.zxkmacj+"";
                obj0.zxkmbfs=!this.userInfo.zxkmbcj?'':this.userInfo.zxkmbcj+"";
                obj0.xm=!this.userInfo.xm?'':this.userInfo.xm+"";
                obj0.school=this.userInfo.school+"";
                obj0.gkzf=this.userInfo.gkfs+"";
                obj0.yu=!this.userInfo.ywcj?'':this.userInfo.ywcj+"";
                obj0.shu=!this.userInfo.sxcj?'':this.userInfo.sxcj+"";
                obj0.wai=!this.userInfo.wycj?'':this.userInfo.wycj+"";
                obj0.bz=this.userInfo.bz+"";
                obj0.jf=this.userInfo.yfjf+"";
                obj0.sjhm=this.userInfo.sjhm+"";
                obj0.gjzxzg=this.userInfo.gjzxzg+"";
                obj0.dfzxzg=this.userInfo.dfzxzg+"";
                let gsh=this.userInfo.sjhm+"";
                const yhlb=this.userInfo.yhlb;
                if(yhlb===7||yhlb===9){
                    gsh=this.userInfo.sjhm;
                }
                obj0.ghs=gsh;
                obj0.xb=this.userInfo.xb+"";
                // obj0.pc=pc==='6'?'本科批':'专科批';
                obj0.pc=pc;
            for(let i=0;i<Yxs.length;i++){
                if(Yxs[i].zyz){
                    const obj={};
                    obj.sb=Yxs[i].sb;
                    obj.sffc=Yxs[i].sffc===1||Yxs[i].sffc==='1'?'服从':'不服从';
                    obj.xh=(i+1);
                    obj.yxmc=Yxs[i].yxmc;
                    obj.yxxh=Yxs[i].yxxh;
                    obj.zyz=Yxs[i].zyz;
                    obj.zy1=!Yxs[i].zy1?'':Yxs[i].zy1;
                    obj.zy2=!Yxs[i].zy2?'':Yxs[i].zy2;
                    obj.zy3=!Yxs[i].zy3?'':Yxs[i].zy3;
                    obj.zy4=!Yxs[i].zy4?'':Yxs[i].zy4;
                    obj.zy5=!Yxs[i].zy5?'':Yxs[i].zy5;
                    obj.zy6=!Yxs[i].zy6?'':Yxs[i].zy6;
                    downParams.push(obj);
                }
            }
                obj0.list=downParams;
            // const param=arr.join(",");
            // $("#down_param").val(param);
            // $("#down_list").val(JSON.stringify(list));
            // $("#down_form").submit();
            this.fileList[0].data=list;
            this.fileList[1].data=obj0;
        }else if(pc==='0'||pc===0){
            const collectYx=this.bkTqpCollectYx;
            const arr=[];
            const list=[];
            for(let i=0;i<collectYx.length;i++){
                if(collectYx[i].yxmc){
                    const pcmc=collectYx[i].pc===6?'本科批':collectYx[0].pc===7?'专科批':
                    collectYx[i].pc===0?'本科提前批':collectYx[0].pc===9?'专科提前批':'' ;
                    const sb=!collectYx[i].sb?0:collectYx[i].sb+"";
                    const yxmc=!collectYx[i].yxmc?0:collectYx[i].yxmc;
                    const zyz=!collectYx[i].zyz?0:collectYx[i].zyz+"";
                    const szdqmc=!collectYx[i].szdqmc?0:collectYx[i].szdqmc;
                    const sf211=collectYx[i].sf211===1?'是':'否';
                    const sf985=collectYx[i].sf985===1?'是':'否';
                    const snjhs=!collectYx[i].snjhs?0:collectYx[i].snjhs+"";
                    const jnjhs=!collectYx[i].jnjhs?0:collectYx[i].jnjhs+"";
                    const rdwc=!collectYx[i].rdwc?0:collectYx[i].rdwc+"";
                    const snrdwc=!collectYx[i].snrdwc?0:collectYx[i].snrdwc+"";
                    const tdx=!collectYx[i].tdx?0:collectYx[i].tdx+"";
                    const zdtwf=!collectYx[i].zdtwf?0:collectYx[i].zdtwf+"";
                    const pjtwf=!collectYx[i].pjtwf?0:collectYx[i].pjtwf+"";
                    const zgtwf=!collectYx[i].zgtwf?0:collectYx[i].zgtwf+"";
                    arr.push(sb+'-'+yxmc+'-'+zyz+'-'+pcmc+'-'+szdqmc+'-'+sf211+'-'+sf985+'-'+
                    snjhs+'-'+jnjhs+'-'+rdwc+'-'+snrdwc+'-'+tdx+'-'+zdtwf+'-'+
                    pjtwf+'-'+zgtwf);
                    list.push({
                        xh:i+1,
                        dnjhs:jnjhs,
                        pc:pcmc,
                        pjRdwc:rdwc,
                        pjtwf,
                        sb,
                        sf211,
                        sf985,
                        sheng:szdqmc,
                        snRdwc:snrdwc,
                        snjhs,
                        tdx,
                        yxmc,
                        zdtwf,
                        zgtwf,
                        zyz
                    });
                }
            }
            const Yxs=[...this.bkTqpCollectYx];
            const downParams=[];
            const obj0={};
                obj0.sssf=this.userInfo.sssf+"";
                obj0.sxkm=this.userInfo.sxkm+"";
                obj0.zxkma=this.userInfo.zxkma+"";
                obj0.zxkmb=this.userInfo.zxkmb+"";
                obj0.sxkmfs=!this.userInfo.sxkmcj?'':this.userInfo.sxkmcj+"";
                obj0.zxkmafs=!this.userInfo.zxkmacj?'':this.userInfo.zxkmacj+"";
                obj0.zxkmbfs=!this.userInfo.zxkmbcj?'':this.userInfo.zxkmbcj+"";
                obj0.xm=!this.userInfo.xm?'':this.userInfo.xm+"";
                obj0.school=this.userInfo.school+"";
                obj0.gkzf=this.userInfo.gkfs+"";
                obj0.yu=!this.userInfo.ywcj?'':this.userInfo.ywcj+"";
                obj0.shu=!this.userInfo.sxcj?'':this.userInfo.sxcj+"";
                obj0.wai=!this.userInfo.wycj?'':this.userInfo.wycj+"";
                obj0.bz=this.userInfo.bz+"";
                obj0.jf=this.userInfo.yfjf+"";
                obj0.sjhm=this.userInfo.sjhm+"";
                obj0.gjzxzg=this.userInfo.gjzxzg+"";
                obj0.dfzxzg=this.userInfo.dfzxzg+"";
                let gsh=this.userInfo.sjhm+"";
                const yhlb=this.userInfo.yhlb;
                if(yhlb===7||yhlb===9){
                    gsh=this.userInfo.sjhm;
                }
                obj0.ghs=gsh;
                obj0.xb=this.userInfo.xb+"";
                // obj0.pc=pc==='6'?'本科批':'专科批';
                obj0.pc=pc;
                for(let i=0;i<Yxs.length;i++){
                    if(Yxs[i].zyz){
                        const obj={};
                        obj.sb=Yxs[i].sb;
                        obj.sffc=Yxs[i].sffc===1||Yxs[i].sffc==='1'?'服从':'不服从';
                        obj.xh=(i+1);
                        obj.yxmc=Yxs[i].yxmc;
                        obj.yxxh=Yxs[i].yxxh;
                        obj.zyz=Yxs[i].zyz;
                        obj.zy1=!Yxs[i].zy1?'':Yxs[i].zy1;
                        obj.zy2=!Yxs[i].zy2?'':Yxs[i].zy2;
                        obj.zy3=!Yxs[i].zy3?'':Yxs[i].zy3;
                        obj.zy4=!Yxs[i].zy4?'':Yxs[i].zy4;
                        obj.zy5=!Yxs[i].zy5?'':Yxs[i].zy5;
                        obj.zy6=!Yxs[i].zy6?'':Yxs[i].zy6;
                        downParams.push(obj);
                    }
                }
                obj0.list=downParams;
            // const param=arr.join(",");
            // $("#down_param").val(param);
            // $("#down_list").val(JSON.stringify(list));
            // $("#down_form").submit();
            this.fileList[0].data=list;
            this.fileList[1].data=obj0;
        }else{
            const collectYx=this.zkTqpCollectYx;
            const arr=[];
            const list=[];
            for(let i=0;i<collectYx.length;i++){
                if(collectYx[i].yxmc){
                    const pcmc=collectYx[i].pc===6?'本科批':collectYx[0].pc===7?'专科批':
                    collectYx[i].pc===0?'本科提前批':collectYx[0].pc===9?'专科提前批':'' ;
                    const sb=!collectYx[i].sb?0:collectYx[i].sb+"";
                    const yxmc=!collectYx[i].yxmc?0:collectYx[i].yxmc;
                    const zyz=!collectYx[i].zyz?0:collectYx[i].zyz+"";
                    const szdqmc=!collectYx[i].szdqmc?0:collectYx[i].szdqmc;
                    const sf211=collectYx[i].sf211===1?'是':'否';
                    const sf985=collectYx[i].sf985===1?'是':'否';
                    const snjhs=!collectYx[i].snjhs?0:collectYx[i].snjhs+"";
                    const jnjhs=!collectYx[i].jnjhs?0:collectYx[i].jnjhs+"";
                    const rdwc=!collectYx[i].rdwc?0:collectYx[i].rdwc+"";
                    const snrdwc=!collectYx[i].snrdwc?0:collectYx[i].snrdwc+"";
                    const tdx=!collectYx[i].tdx?0:collectYx[i].tdx+"";
                    const zdtwf=!collectYx[i].zdtwf?0:collectYx[i].zdtwf+"";
                    const pjtwf=!collectYx[i].pjtwf?0:collectYx[i].pjtwf+"";
                    const zgtwf=!collectYx[i].zgtwf?0:collectYx[i].zgtwf+"";
                    arr.push(sb+'-'+yxmc+'-'+zyz+'-'+pcmc+'-'+szdqmc+'-'+sf211+'-'+sf985+'-'+
                    snjhs+'-'+jnjhs+'-'+rdwc+'-'+snrdwc+'-'+tdx+'-'+zdtwf+'-'+
                    pjtwf+'-'+zgtwf);
                    list.push({
                        xh:i+1,
                        dnjhs:jnjhs,
                        pc:pcmc,
                        pjRdwc:rdwc,
                        pjtwf,
                        sb,
                        sf211,
                        sf985,
                        sheng:szdqmc,
                        snRdwc:snrdwc,
                        snjhs,
                        tdx,
                        yxmc,
                        zdtwf,
                        zgtwf,
                        zyz
                    });
                }
            }
            
            const Yxs=[...this.zkTqpCollectYx];
            const downParams=[];
            const obj0={};
            obj0.sssf=this.userInfo.sssf+"";
                obj0.sxkm=this.userInfo.sxkm+"";
                obj0.zxkma=this.userInfo.zxkma+"";
                obj0.zxkmb=this.userInfo.zxkmb+"";
                obj0.sxkmfs=!this.userInfo.sxkmcj?'':this.userInfo.sxkmcj+"";
                obj0.zxkmafs=!this.userInfo.zxkmacj?'':this.userInfo.zxkmacj+"";
                obj0.zxkmbfs=!this.userInfo.zxkmbcj?'':this.userInfo.zxkmbcj+"";
                obj0.xm=!this.userInfo.xm?'':this.userInfo.xm+"";
                obj0.school=this.userInfo.school+"";
                obj0.gkzf=this.userInfo.gkfs+"";
                obj0.yu=!this.userInfo.ywcj?'':this.userInfo.ywcj+"";
                obj0.shu=!this.userInfo.sxcj?'':this.userInfo.sxcj+"";
                obj0.wai=!this.userInfo.wycj?'':this.userInfo.wycj+"";
                obj0.bz=this.userInfo.bz+"";
                obj0.jf=this.userInfo.yfjf+"";
                obj0.sjhm=this.userInfo.sjhm+"";
                obj0.gjzxzg=this.userInfo.gjzxzg+"";
                obj0.dfzxzg=this.userInfo.dfzxzg+"";
                let gsh=this.userInfo.sjhm+"";
                const yhlb=this.userInfo.yhlb;
                if(yhlb===7||yhlb===9){
                    gsh=this.userInfo.sjhm;
                }
                obj0.ghs=gsh;
                obj0.xb=this.userInfo.xb+"";
                // obj0.pc=pc==='6'?'本科批':'专科批';
                obj0.pc=pc;
            for(let i=0;i<Yxs.length;i++){
                if(Yxs[i].zyz){
                    const obj={};
                    obj.sb=Yxs[i].sb;
                    obj.sffc=Yxs[i].sffc===1||Yxs[i].sffc==='1'?'服从':'不服从';
                    obj.xh=(i+1);
                    obj.yxmc=Yxs[i].yxmc;
                    obj.yxxh=Yxs[i].yxxh;
                    obj.zyz=Yxs[i].zyz;
                    obj.zy1=!Yxs[i].zy1?'':Yxs[i].zy1;
                    obj.zy2=!Yxs[i].zy2?'':Yxs[i].zy2;
                    obj.zy3=!Yxs[i].zy3?'':Yxs[i].zy3;
                    obj.zy4=!Yxs[i].zy4?'':Yxs[i].zy4;
                    obj.zy5=!Yxs[i].zy5?'':Yxs[i].zy5;
                    obj.zy6=!Yxs[i].zy6?'':Yxs[i].zy6;
                    downParams.push(obj);
                }
            }
                obj0.list=downParams;
            // const param=arr.join(",");
            // $("#down_param").val(param);
            // $("#down_list").val(JSON.stringify(list));
            // $("#down_form").submit();
            this.fileList[0].data=list;
            this.fileList[1].data=obj0;
        }
        // this.downloadNext() // 开始下载队列


    //  if (this.downloading) return
      
      // 谷歌浏览器要求必须在用户交互上下文启动第一个下载
    //   this.downloading = true
    //   this.currentIndex = 0
    //   this.currentFile = this.fileList[0]
    //   this.progressPercent = 0
      
      // 立即启动第一个下载（在用户点击事件中）
    //   this.downloadSingleFile2()
          // 第一个文件立即下载
    //   this.downloadSingleFile(this.fileList[0].url, this.fileList[0].name,this.fileList[0].data||{})
      batchDownload(this.fileList);
      // 第二个文件稍微延迟，避免被浏览器阻止
      // 关键：使用setTimeout错开下载时间
      setTimeout(() => {
        // this.downloadSingleFile(this.fileList[1].url, this.fileList[1].name,this.fileList[1].data||{})
        }, 300) // 300ms的延迟通常足够
    },

    // 批量下载入口 - 必须在用户点击事件中启动
    handleBatchDownload() {
      if (this.downloading) return
      
      // 谷歌浏览器要求必须在用户交互上下文启动第一个下载
      this.downloading = true
      this.currentIndex = 0
      this.currentFile = this.fileList[0]
      this.progressPercent = 0
      
      // 立即启动第一个下载（在用户点击事件中）
      this.downloadSingleFile2()
    },
    // 下载单个文件
    downloadSingleFile2() {
      const { url, name,data=null } = this.fileList[this.currentIndex]
      
      axios({
        url:url,
        method: 'post',
        responseType: 'blob',
        data:data,
        headers: {
            'Content-Type': 'application/json'
        }
      })
        .then(response => {
          this.handleBlobDownload(response.data, name)
          this.scheduleNextDownload() // 安排下一个下载
        })
        .catch(error => {
          this.downloading = false
          this.$message.error(`下载失败: ${name} - ${error.message}`)
        })
    },

    // 处理Blob数据并触发下载
    handleBlobDownload(blobData, fileName) {
      // 针对谷歌浏览器优化的MIME类型
      const mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
      const blob = new Blob([blobData], { type: mimeType })
      
      // 创建下载链接
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = fileName
      
      a.target="_blank";

      // 关键：在谷歌浏览器中，需要将a标签添加到DOM后再点击
      document.body.appendChild(a)
      
      // 使用requestAnimationFrame确保在浏览器渲染周期内执行
      requestAnimationFrame(() => {
        a.click()
        // 延迟移除，确保谷歌浏览器能捕获点击事件
        setTimeout(() => {
          document.body.removeChild(a)
          window.URL.revokeObjectURL(url)
        }, 100)
      })
    },

    // 安排下一个文件下载（核心：控制间隔）
    scheduleNextDownload() {
      this.currentIndex++
      
      if (this.currentIndex >= this.fileList.length) {
        // 全部下载完成
        this.downloading = false
        this.$message.success('所有文件下载完成')
        return
      }
      
      // 关键：谷歌浏览器建议至少1秒间隔
      // 使用setTimeout确保在不同的事件循环中处理
      setTimeout(() => {
        this.currentFile = this.fileList[this.currentIndex]
        this.progressPercent = 0
        this.downloadSingleFile2()
      }, 1000) // 1秒间隔是谷歌浏览器比较安全的阈值
    },
    // 递归下载下一个文件
    downloadNext() {
      if (this.currentIndex >= this.fileList.length) {
        // 所有文件下载完成
        this.downloading = false
        this.$message.success('全部文件下载完成')
        return
      }

      const { url, name, data=null } = this.fileList[this.currentIndex]
      this.downloadSingleFile(url, name,data)
        .then(() => {
          // 当前文件下载成功，继续下一个
          this.currentIndex++
          // 延迟500ms避免浏览器拦截（关键）
          setTimeout(() => this.downloadNext(), 2000)
        })
        .catch(err => {
          this.downloading = false
          this.$message.error(`第${this.currentIndex + 1}个文件下载失败: ${err.message}`)
        })
    },

    // 下载单个Excel文件
    downloadSingleFile(url, fileName,data) {
      return new Promise((resolve, reject) => {
        axios({
          url: url,
          method: 'post',
          responseType: 'blob', // 关键：指定响应类型为blob
          headers: {
            'Content-Type': 'application/json'
          },
          data:data
        })
          .then(response => {
            this.handleBlobResponse(response, fileName)
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    // 处理blob流并触发下载
    handleBlobResponse(response, fileName) {
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      })

      // 兼容不同浏览器的URL对象|| window.webkitURL
      const url = window.URL 
      const downloadUrl = url.createObjectURL(blob)

      // 创建a标签并模拟点击
      const a = document.createElement('a')
      a.href = downloadUrl
      a.download = fileName || '未命名文件.xlsx'
      document.body.appendChild(a)
      requestAnimationFrame(()=>{
        a.click()

        // 清理资源
        setTimeout(() => {
            document.body.removeChild(a)
            url.revokeObjectURL(downloadUrl)
        }, 100)
      })
    },
    // 咨询师免费下载
    async freeDownload(){
        const loading=this.$loading({fullscreen:true,target:document.getElementById("out-load-tab"),text:'正在下载中'});
        const pc=this.activePcName;
        if(pc==='6'||pc===6){
            const collectYx=this.bkCollectYx;
            const arr=[];
            const list=[];
            let checkedFlag=false;
            for(let i=0;i<collectYx.length;i++){
                if(collectYx[i].yxmc&&collectYx[i].checked){
                    checkedFlag=true;
                    break;
                }
            }
            if(!checkedFlag){
                for(let i=0;i<collectYx.length;i++){
                    if(collectYx[i].yxmc){
                        const pcmc=collectYx[i].pc===6?'本科批':'专科批';
                        const sb=!collectYx[i].sb?0:collectYx[i].sb+"";
                        const yxmc=!collectYx[i].yxmc?0:collectYx[i].yxmc;
                        const zyz=!collectYx[i].zyz?0:collectYx[i].zyz+"";
                        const szdqmc=!collectYx[i].szdqmc?0:collectYx[i].szdqmc;
                        const sf211=collectYx[i].sf211===1?'是':'否';
                        const sf985=collectYx[i].sf985===1?'是':'否';
                        const snjhs=!collectYx[i].snjhs?0:collectYx[i].snjhs+"";
                        const jnjhs=!collectYx[i].jnjhs?0:collectYx[i].jnjhs+"";
                        const rdwc=!collectYx[i].rdwc?0:collectYx[i].rdwc+"";
                        const snrdwc=!collectYx[i].snrdwc?0:collectYx[i].snrdwc+"";
                        const tdx=!collectYx[i].tdx?0:collectYx[i].tdx+"";
                        const zdtwf=!collectYx[i].zdtwf?0:collectYx[i].zdtwf+"";
                        const pjtwf=!collectYx[i].pjtwf?0:collectYx[i].pjtwf+"";
                        const zgtwf=!collectYx[i].zgtwf?0:collectYx[i].zgtwf+"";
                        arr.push(sb+'-'+yxmc+'-'+zyz+'-'+pcmc+'-'+szdqmc+'-'+sf211+'-'+sf985+'-'+
                        snjhs+'-'+jnjhs+'-'+rdwc+'-'+snrdwc+'-'+tdx+'-'+zdtwf+'-'+
                        pjtwf+'-'+zgtwf);
                        list.push({
                            xh:i+1,
                            dnjhs:jnjhs,
                            pc:pcmc,
                            pjRdwc:rdwc,
                            pjtwf,
                            sb,
                            sf211,
                            sf985,
                            sheng:szdqmc,
                            snRdwc:snrdwc,
                            snjhs,
                            tdx,
                            yxmc,
                            zdtwf,
                            zgtwf,
                            zyz
                        });
                    }
                }
            }else{
                for(let i=0;i<collectYx.length;i++){
                    if(collectYx[i].yxmc&&collectYx[i].checked){
                        const pcmc=collectYx[i].pc===6?'本科批':'专科批';
                        const sb=!collectYx[i].sb?0:collectYx[i].sb+"";
                        const yxmc=!collectYx[i].yxmc?0:collectYx[i].yxmc;
                        const zyz=!collectYx[i].zyz?0:collectYx[i].zyz+"";
                        const szdqmc=!collectYx[i].szdqmc?0:collectYx[i].szdqmc;
                        const sf211=collectYx[i].sf211===1?'是':'否';
                        const sf985=collectYx[i].sf985===1?'是':'否';
                        const snjhs=!collectYx[i].snjhs?0:collectYx[i].snjhs+"";
                        const jnjhs=!collectYx[i].jnjhs?0:collectYx[i].jnjhs+"";
                        const rdwc=!collectYx[i].rdwc?0:collectYx[i].rdwc+"";
                        const snrdwc=!collectYx[i].snrdwc?0:collectYx[i].snrdwc+"";
                        const tdx=!collectYx[i].tdx?0:collectYx[i].tdx+"";
                        const zdtwf=!collectYx[i].zdtwf?0:collectYx[i].zdtwf+"";
                        const pjtwf=!collectYx[i].pjtwf?0:collectYx[i].pjtwf+"";
                        const zgtwf=!collectYx[i].zgtwf?0:collectYx[i].zgtwf+"";
                        arr.push(sb+'-'+yxmc+'-'+zyz+'-'+pcmc+'-'+szdqmc+'-'+sf211+'-'+sf985+'-'+
                        snjhs+'-'+jnjhs+'-'+rdwc+'-'+snrdwc+'-'+tdx+'-'+zdtwf+'-'+
                        pjtwf+'-'+zgtwf);
                        list.push({
                            xh:i+1,
                            dnjhs:jnjhs,
                            pc:pcmc,
                            pjRdwc:rdwc,
                            pjtwf,
                            sb,
                            sf211,
                            sf985,
                            sheng:szdqmc,
                            snRdwc:snrdwc,
                            snjhs,
                            tdx,
                            yxmc,
                            zdtwf,
                            zgtwf,
                            zyz
                        });
                    }
                }
            }
            // const param=arr.join(",");
            // $("#down_param").val(param);
            // $("#down_list").val(JSON.stringify(list));
            // $("#down_form").submit();
            const res=await this.$http.postHttp("/down/downYhgzYxZyz",list,{responseType:'blob'});
            if(res.status===200){
                if(res.data.code===0){
                this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
                }else if(res.data.code===500){
                    if(res.data.message){
                        this.$message({message:res.data.message,type:'error'});
                    }
                }else{
                    if(res.data){
                    const blob=new Blob([res.data],{type:'application/vnd.ms-excel'});
                    if (window.navigator.msSaveOrOpenBlob) { // 兼容IE10
                    navigator.msSaveBlob(blob, this.filename);
                    } else {
                        const href = URL.createObjectURL(blob); // 创建新的URL表示指定的blob对象
                        const a = document.createElement('a'); // 创建a标签
                        a.style.display = 'none';
                        a.href = href; // 指定下载链接
                        a.download = this.filename; // 指定下载文件名
                        a.click(); // 触发下载
                        URL.revokeObjectURL(a.href); // 释放URL对象
                    }
                }
                }
            }else if(res.status===401){
                this.$message({message: '登录超时，请重新登录',type:"error"});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
            }else if(res.status===409||res.status===410||res.status===411){
                this.$message({message: '您的账号在其他地点登陆了',type:'warning'});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
            }
        }else if(pc==='7'||pc===7){
            const collectYx=this.zkCollectYx;
            const arr=[];
            const list=[];
            let checkedFlag=false;
            for(let i=0;i<collectYx.length;i++){
                if(collectYx[i].yxmc&&collectYx[i].checked){
                    checkedFlag=true;
                    break;
                }
            }
            if(!checkedFlag){
                for(let i=0;i<collectYx.length;i++){
                    if(collectYx[i].yxmc){
                        const pcmc=collectYx[i].pc===6?'本科批':'专科批';
                        const sb=!collectYx[i].sb?0:collectYx[i].sb+"";
                        const yxmc=!collectYx[i].yxmc?0:collectYx[i].yxmc;
                        const zyz=!collectYx[i].zyz?0:collectYx[i].zyz+"";
                        const szdqmc=!collectYx[i].szdqmc?0:collectYx[i].szdqmc;
                        const sf211=collectYx[i].sf211===1?'是':'否';
                        const sf985=collectYx[i].sf985===1?'是':'否';
                        const snjhs=!collectYx[i].snjhs?0:collectYx[i].snjhs+"";
                        const jnjhs=!collectYx[i].jnjhs?0:collectYx[i].jnjhs+"";
                        const rdwc=!collectYx[i].rdwc?0:collectYx[i].rdwc+"";
                        const snrdwc=!collectYx[i].snrdwc?0:collectYx[i].snrdwc+"";
                        const tdx=!collectYx[i].tdx?0:collectYx[i].tdx+"";
                        const zdtwf=!collectYx[i].zdtwf?0:collectYx[i].zdtwf+"";
                        const pjtwf=!collectYx[i].pjtwf?0:collectYx[i].pjtwf+"";
                        const zgtwf=!collectYx[i].zgtwf?0:collectYx[i].zgtwf+"";
                        arr.push(sb+'-'+yxmc+'-'+zyz+'-'+pcmc+'-'+szdqmc+'-'+sf211+'-'+sf985+'-'+
                        snjhs+'-'+jnjhs+'-'+rdwc+'-'+snrdwc+'-'+tdx+'-'+zdtwf+'-'+
                        pjtwf+'-'+zgtwf);
                        list.push({
                            xh:i+1,
                            dnjhs:jnjhs,
                            pc:pcmc,
                            pjRdwc:rdwc,
                            pjtwf,
                            sb,
                            sf211,
                            sf985,
                            sheng:szdqmc,
                            snRdwc:snrdwc,
                            snjhs,
                            tdx,
                            yxmc,
                            zdtwf,
                            zgtwf,
                            zyz
                        });
                    }
                }
            }else{
                for(let i=0;i<collectYx.length;i++){
                    if(collectYx[i].yxmc&&collectYx[i].checked){
                        const pcmc=collectYx[i].pc===6?'本科批':'专科批';
                        const sb=!collectYx[i].sb?0:collectYx[i].sb+"";
                        const yxmc=!collectYx[i].yxmc?0:collectYx[i].yxmc;
                        const zyz=!collectYx[i].zyz?0:collectYx[i].zyz+"";
                        const szdqmc=!collectYx[i].szdqmc?0:collectYx[i].szdqmc;
                        const sf211=collectYx[i].sf211===1?'是':'否';
                        const sf985=collectYx[i].sf985===1?'是':'否';
                        const snjhs=!collectYx[i].snjhs?0:collectYx[i].snjhs+"";
                        const jnjhs=!collectYx[i].jnjhs?0:collectYx[i].jnjhs+"";
                        const rdwc=!collectYx[i].rdwc?0:collectYx[i].rdwc+"";
                        const snrdwc=!collectYx[i].snrdwc?0:collectYx[i].snrdwc+"";
                        const tdx=!collectYx[i].tdx?0:collectYx[i].tdx+"";
                        const zdtwf=!collectYx[i].zdtwf?0:collectYx[i].zdtwf+"";
                        const pjtwf=!collectYx[i].pjtwf?0:collectYx[i].pjtwf+"";
                        const zgtwf=!collectYx[i].zgtwf?0:collectYx[i].zgtwf+"";
                        arr.push(sb+'-'+yxmc+'-'+zyz+'-'+pcmc+'-'+szdqmc+'-'+sf211+'-'+sf985+'-'+
                        snjhs+'-'+jnjhs+'-'+rdwc+'-'+snrdwc+'-'+tdx+'-'+zdtwf+'-'+
                        pjtwf+'-'+zgtwf);
                        list.push({
                            xh:i+1,
                            dnjhs:jnjhs,
                            pc:pcmc,
                            pjRdwc:rdwc,
                            pjtwf,
                            sb,
                            sf211,
                            sf985,
                            sheng:szdqmc,
                            snRdwc:snrdwc,
                            snjhs,
                            tdx,
                            yxmc,
                            zdtwf,
                            zgtwf,
                            zyz
                        });
                    }
                }
            }
            // const param=arr.join(",");
            // $("#down_param").val(param);
            // $("#down_list").val(JSON.stringify(list));
            // $("#down_form").submit();
            const res=await this.$http.postHttp("/down/downYhgzYxZyz",list,{responseType:'blob'});
            if(res.status===200){
                if(res.data.code===0){
                this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
                }else if(res.data.code===500){
                    if(res.data.message){
                        this.$message({message:res.data.message,type:'error'});
                    }
                }else{
                    if(res.data){
                    const blob=new Blob([res.data],{type:'application/vnd.ms-excel'});
                    if (window.navigator.msSaveOrOpenBlob) { // 兼容IE10
                    navigator.msSaveBlob(blob, this.filename);
                    } else {
                        const href = URL.createObjectURL(blob); // 创建新的URL表示指定的blob对象
                        const a = document.createElement('a'); // 创建a标签
                        a.style.display = 'none';
                        a.href = href; // 指定下载链接
                        a.download = this.filename; // 指定下载文件名
                        a.click(); // 触发下载
                        URL.revokeObjectURL(a.href); // 释放URL对象
                    }
                }
                }
            }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
            }else if(res.status===409||res.status===410||res.status===411){
                this.$message({message: '您的账号在其他地点登陆了',type:'warning'});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
            }
        }else if(pc==='0'||pc===0){
            const collectYx=this.bkTqpCollectYx;
            const arr=[];
            const list=[];
            let checkedFlag=false;
            for(let i=0;i<collectYx.length;i++){
                if(collectYx[i].yxmc&&collectYx[i].checked){
                    checkedFlag=true;
                    break;
                }
            }
            if(!checkedFlag){
                for(let i=0;i<collectYx.length;i++){
                    if(collectYx[i].yxmc){
                        const pcmc=collectYx[i].pc===6?'本科批':collectYx[0].pc===7?'专科批':
                        collectYx[i].pc===0?'本科提前批':collectYx[0].pc===9?'专科提前批':'' ;
                        const sb=!collectYx[i].sb?0:collectYx[i].sb+"";
                        const yxmc=!collectYx[i].yxmc?0:collectYx[i].yxmc;
                        const zyz=!collectYx[i].zyz?0:collectYx[i].zyz+"";
                        const szdqmc=!collectYx[i].szdqmc?0:collectYx[i].szdqmc;
                        const sf211=collectYx[i].sf211===1?'是':'否';
                        const sf985=collectYx[i].sf985===1?'是':'否';
                        const snjhs=!collectYx[i].snjhs?0:collectYx[i].snjhs+"";
                        const jnjhs=!collectYx[i].jnjhs?0:collectYx[i].jnjhs+"";
                        const rdwc=!collectYx[i].rdwc?0:collectYx[i].rdwc+"";
                        const snrdwc=!collectYx[i].snrdwc?0:collectYx[i].snrdwc+"";
                        const tdx=!collectYx[i].tdx?0:collectYx[i].tdx+"";
                        const zdtwf=!collectYx[i].zdtwf?0:collectYx[i].zdtwf+"";
                        const pjtwf=!collectYx[i].pjtwf?0:collectYx[i].pjtwf+"";
                        const zgtwf=!collectYx[i].zgtwf?0:collectYx[i].zgtwf+"";
                        arr.push(sb+'-'+yxmc+'-'+zyz+'-'+pcmc+'-'+szdqmc+'-'+sf211+'-'+sf985+'-'+
                        snjhs+'-'+jnjhs+'-'+rdwc+'-'+snrdwc+'-'+tdx+'-'+zdtwf+'-'+
                        pjtwf+'-'+zgtwf);
                        list.push({
                            xh:i+1,
                            dnjhs:jnjhs,
                            pc:pcmc,
                            pjRdwc:rdwc,
                            pjtwf,
                            sb,
                            sf211,
                            sf985,
                            sheng:szdqmc,
                            snRdwc:snrdwc,
                            snjhs,
                            tdx,
                            yxmc,
                            zdtwf,
                            zgtwf,
                            zyz
                        });
                    }
                }
            }else{
                for(let i=0;i<collectYx.length;i++){
                    if(collectYx[i].yxmc&&collectYx[i].checked){
                        const pcmc=collectYx[i].pc===6?'本科批':collectYx[0].pc===7?'专科批':
                        collectYx[i].pc===0?'本科提前批':collectYx[0].pc===9?'专科提前批':'' ;
                        const sb=!collectYx[i].sb?0:collectYx[i].sb+"";
                        const yxmc=!collectYx[i].yxmc?0:collectYx[i].yxmc;
                        const zyz=!collectYx[i].zyz?0:collectYx[i].zyz+"";
                        const szdqmc=!collectYx[i].szdqmc?0:collectYx[i].szdqmc;
                        const sf211=collectYx[i].sf211===1?'是':'否';
                        const sf985=collectYx[i].sf985===1?'是':'否';
                        const snjhs=!collectYx[i].snjhs?0:collectYx[i].snjhs+"";
                        const jnjhs=!collectYx[i].jnjhs?0:collectYx[i].jnjhs+"";
                        const rdwc=!collectYx[i].rdwc?0:collectYx[i].rdwc+"";
                        const snrdwc=!collectYx[i].snrdwc?0:collectYx[i].snrdwc+"";
                        const tdx=!collectYx[i].tdx?0:collectYx[i].tdx+"";
                        const zdtwf=!collectYx[i].zdtwf?0:collectYx[i].zdtwf+"";
                        const pjtwf=!collectYx[i].pjtwf?0:collectYx[i].pjtwf+"";
                        const zgtwf=!collectYx[i].zgtwf?0:collectYx[i].zgtwf+"";
                        arr.push(sb+'-'+yxmc+'-'+zyz+'-'+pcmc+'-'+szdqmc+'-'+sf211+'-'+sf985+'-'+
                        snjhs+'-'+jnjhs+'-'+rdwc+'-'+snrdwc+'-'+tdx+'-'+zdtwf+'-'+
                        pjtwf+'-'+zgtwf);
                        list.push({
                            xh:i+1,
                            dnjhs:jnjhs,
                            pc:pcmc,
                            pjRdwc:rdwc,
                            pjtwf,
                            sb,
                            sf211,
                            sf985,
                            sheng:szdqmc,
                            snRdwc:snrdwc,
                            snjhs,
                            tdx,
                            yxmc,
                            zdtwf,
                            zgtwf,
                            zyz
                        });
                    }
                }
            }
            // const param=arr.join(",");
            // $("#down_param").val(param);
            // $("#down_list").val(JSON.stringify(list));
            // $("#down_form").submit();
            const res=await this.$http.postHttp("/down/downYhgzYxZyz",list,{responseType:'blob'});
            if(res.status===200){
                if(res.data.code===0){
                this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
                }else if(res.data.code===500){
                    if(res.data.message){
                        this.$message({message:res.data.message,type:'error'});
                    }
                }else{
                    if(res.data){
                    const blob=new Blob([res.data],{type:'application/vnd.ms-excel'});
                    if (window.navigator.msSaveOrOpenBlob) { // 兼容IE10
                    navigator.msSaveBlob(blob, this.filename);
                    } else {
                        const href = URL.createObjectURL(blob); // 创建新的URL表示指定的blob对象
                        const a = document.createElement('a'); // 创建a标签
                        a.style.display = 'none';
                        a.href = href; // 指定下载链接
                        a.download = this.filename; // 指定下载文件名
                        a.click(); // 触发下载
                        URL.revokeObjectURL(a.href); // 释放URL对象
                    }
                }
                }
            }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
            }else if(res.status===409||res.status===410||res.status===411){
                this.$message({message: '您的账号在其他地点登陆了',type:'warning'});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
            }
        }else{
            const collectYx=this.zkTqpCollectYx;
            const arr=[];
            const list=[];
            let checkedFlag=false;
            for(let i=0;i<collectYx.length;i++){
                if(collectYx[i].yxmc&&collectYx[i].checked){
                    checkedFlag=true;
                    break;
                }
            }
            if(!checkedFlag){
                for(let i=0;i<collectYx.length;i++){
                    if(collectYx[i].yxmc){
                        const pcmc=collectYx[i].pc===6?'本科批':collectYx[0].pc===7?'专科批':
                        collectYx[i].pc===0?'本科提前批':collectYx[0].pc===9?'专科提前批':'' ;
                        const sb=!collectYx[i].sb?0:collectYx[i].sb+"";
                        const yxmc=!collectYx[i].yxmc?0:collectYx[i].yxmc;
                        const zyz=!collectYx[i].zyz?0:collectYx[i].zyz+"";
                        const szdqmc=!collectYx[i].szdqmc?0:collectYx[i].szdqmc;
                        const sf211=collectYx[i].sf211===1?'是':'否';
                        const sf985=collectYx[i].sf985===1?'是':'否';
                        const snjhs=!collectYx[i].snjhs?0:collectYx[i].snjhs+"";
                        const jnjhs=!collectYx[i].jnjhs?0:collectYx[i].jnjhs+"";
                        const rdwc=!collectYx[i].rdwc?0:collectYx[i].rdwc+"";
                        const snrdwc=!collectYx[i].snrdwc?0:collectYx[i].snrdwc+"";
                        const tdx=!collectYx[i].tdx?0:collectYx[i].tdx+"";
                        const zdtwf=!collectYx[i].zdtwf?0:collectYx[i].zdtwf+"";
                        const pjtwf=!collectYx[i].pjtwf?0:collectYx[i].pjtwf+"";
                        const zgtwf=!collectYx[i].zgtwf?0:collectYx[i].zgtwf+"";
                        arr.push(sb+'-'+yxmc+'-'+zyz+'-'+pcmc+'-'+szdqmc+'-'+sf211+'-'+sf985+'-'+
                        snjhs+'-'+jnjhs+'-'+rdwc+'-'+snrdwc+'-'+tdx+'-'+zdtwf+'-'+
                        pjtwf+'-'+zgtwf);
                        list.push({
                            xh:i+1,
                            dnjhs:jnjhs,
                            pc:pcmc,
                            pjRdwc:rdwc,
                            pjtwf,
                            sb,
                            sf211,
                            sf985,
                            sheng:szdqmc,
                            snRdwc:snrdwc,
                            snjhs,
                            tdx,
                            yxmc,
                            zdtwf,
                            zgtwf,
                            zyz
                        });
                    }
                }
            }else{
                for(let i=0;i<collectYx.length;i++){
                    if(collectYx[i].yxmc&&collectYx[i].checked){
                        const pcmc=collectYx[i].pc===6?'本科批':collectYx[0].pc===7?'专科批':
                        collectYx[i].pc===0?'本科提前批':collectYx[0].pc===9?'专科提前批':'' ;
                        const sb=!collectYx[i].sb?0:collectYx[i].sb+"";
                        const yxmc=!collectYx[i].yxmc?0:collectYx[i].yxmc;
                        const zyz=!collectYx[i].zyz?0:collectYx[i].zyz+"";
                        const szdqmc=!collectYx[i].szdqmc?0:collectYx[i].szdqmc;
                        const sf211=collectYx[i].sf211===1?'是':'否';
                        const sf985=collectYx[i].sf985===1?'是':'否';
                        const snjhs=!collectYx[i].snjhs?0:collectYx[i].snjhs+"";
                        const jnjhs=!collectYx[i].jnjhs?0:collectYx[i].jnjhs+"";
                        const rdwc=!collectYx[i].rdwc?0:collectYx[i].rdwc+"";
                        const snrdwc=!collectYx[i].snrdwc?0:collectYx[i].snrdwc+"";
                        const tdx=!collectYx[i].tdx?0:collectYx[i].tdx+"";
                        const zdtwf=!collectYx[i].zdtwf?0:collectYx[i].zdtwf+"";
                        const pjtwf=!collectYx[i].pjtwf?0:collectYx[i].pjtwf+"";
                        const zgtwf=!collectYx[i].zgtwf?0:collectYx[i].zgtwf+"";
                        arr.push(sb+'-'+yxmc+'-'+zyz+'-'+pcmc+'-'+szdqmc+'-'+sf211+'-'+sf985+'-'+
                        snjhs+'-'+jnjhs+'-'+rdwc+'-'+snrdwc+'-'+tdx+'-'+zdtwf+'-'+
                        pjtwf+'-'+zgtwf);
                        list.push({
                            xh:i+1,
                            dnjhs:jnjhs,
                            pc:pcmc,
                            pjRdwc:rdwc,
                            pjtwf,
                            sb,
                            sf211,
                            sf985,
                            sheng:szdqmc,
                            snRdwc:snrdwc,
                            snjhs,
                            tdx,
                            yxmc,
                            zdtwf,
                            zgtwf,
                            zyz
                        });
                    }
                }
            }
            // const param=arr.join(",");
            // $("#down_param").val(param);
            // $("#down_list").val(JSON.stringify(list));
            // $("#down_form").submit();
            const res=await this.$http.postHttp("/down/downYhgzYxZyz",list,{responseType:'blob'});
            if(res.status===200){
                if(res.data.code===0){
                this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
                }else if(res.data.code===500){
                    if(res.data.message){
                        this.$message({message:res.data.message,type:'error'});
                    }
                }else{
                    if(res.data){
                    const blob=new Blob([res.data],{type:'application/vnd.ms-excel'});
                    if (window.navigator.msSaveOrOpenBlob) { // 兼容IE10
                    navigator.msSaveBlob(blob, this.filename);
                    } else {
                        const href = URL.createObjectURL(blob); // 创建新的URL表示指定的blob对象
                        const a = document.createElement('a'); // 创建a标签
                        a.style.display = 'none';
                        a.href = href; // 指定下载链接
                        a.download = this.filename; // 指定下载文件名
                        a.click(); // 触发下载
                        URL.revokeObjectURL(a.href); // 释放URL对象
                    }
                }
                }
            }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
            }else if(res.status===409||res.status===410||res.status===411){
                this.$message({message: '您的账号在其他地点登陆了',type:'warning'});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
            }
        }
        await this.saveOtherCode3();
        loading.close();
    },
    // 咨询师免费下载
    async freeDownload2(){
        const pc=this.activePcName;
        if(pc==='6'||pc===6){
            const collectYx=this.bkCollectYx;
            const arr=[];
            const list=[];
            for(let i=0;i<collectYx.length;i++){
                if(collectYx[i].yxmc){
                    const pcmc=collectYx[i].pc===6?'本科批':'专科批';
                    const sb=!collectYx[i].sb?0:collectYx[i].sb+"";
                    const yxmc=!collectYx[i].yxmc?0:collectYx[i].yxmc;
                    const zyz=!collectYx[i].zyz?0:collectYx[i].zyz+"";
                    const szdqmc=!collectYx[i].szdqmc?0:collectYx[i].szdqmc;
                    const sf211=collectYx[i].sf211===1?'是':'否';
                    const sf985=collectYx[i].sf985===1?'是':'否';
                    const snjhs=!collectYx[i].snjhs?0:collectYx[i].snjhs+"";
                    const jnjhs=!collectYx[i].jnjhs?0:collectYx[i].jnjhs+"";
                    const rdwc=!collectYx[i].rdwc?0:collectYx[i].rdwc+"";
                    const snrdwc=!collectYx[i].snrdwc?0:collectYx[i].snrdwc+"";
                    const tdx=!collectYx[i].tdx?0:collectYx[i].tdx+"";
                    const zdtwf=!collectYx[i].zdtwf?0:collectYx[i].zdtwf+"";
                    const pjtwf=!collectYx[i].pjtwf?0:collectYx[i].pjtwf+"";
                    const zgtwf=!collectYx[i].zgtwf?0:collectYx[i].zgtwf+"";
                    arr.push(sb+'-'+yxmc+'-'+zyz+'-'+pcmc+'-'+szdqmc+'-'+sf211+'-'+sf985+'-'+
                    snjhs+'-'+jnjhs+'-'+rdwc+'-'+snrdwc+'-'+tdx+'-'+zdtwf+'-'+
                    pjtwf+'-'+zgtwf);
                    list.push({
                        xh:i+1,
                        dnjhs:jnjhs,
                        pc:pcmc,
                        pjRdwc:rdwc,
                        pjtwf,
                        sb,
                        sf211,
                        sf985,
                        sheng:szdqmc,
                        snRdwc:snrdwc,
                        snjhs,
                        tdx,
                        yxmc,
                        zdtwf,
                        zgtwf,
                        zyz
                    });
                }
            }
            const Yxs=[...this.bkCollectYx];
            const downParams=[];
            const obj0={};
                obj0.sssf=this.userInfo.sssf+"";
                obj0.sxkm=this.userInfo.sxkm+"";
                obj0.zxkma=this.userInfo.zxkma+"";
                obj0.zxkmb=this.userInfo.zxkmb+"";
                obj0.sxkmfs=!this.userInfo.sxkmcj?'':this.userInfo.sxkmcj+"";
                obj0.zxkmafs=!this.userInfo.zxkmacj?'':this.userInfo.zxkmacj+"";
                obj0.zxkmbfs=!this.userInfo.zxkmbcj?'':this.userInfo.zxkmbcj+"";
                obj0.xm=!this.userInfo.xm?'':this.userInfo.xm+"";
                obj0.school=this.userInfo.school+"";
                obj0.gkzf=this.userInfo.gkfs+"";
                obj0.yu=!this.userInfo.ywcj?'':this.userInfo.ywcj+"";
                obj0.shu=!this.userInfo.sxcj?'':this.userInfo.sxcj+"";
                obj0.wai=!this.userInfo.wycj?'':this.userInfo.wycj+"";
                obj0.bz=this.userInfo.bz+"";
                obj0.jf=this.userInfo.yfjf+"";
                obj0.sjhm=this.userInfo.sjhm+"";
                obj0.gjzxzg=this.userInfo.gjzxzg+"";
                obj0.dfzxzg=this.userInfo.dfzxzg+"";
                let gsh=this.userInfo.sjhm+"";
                const yhlb=this.userInfo.yhlb;
                if(yhlb===7||yhlb===9){
                    gsh=this.userInfo.sjhm;
                }
                obj0.ghs=gsh;
                obj0.xb=this.userInfo.xb+"";
                // obj0.pc=pc==='6'?'本科批':'专科批';
                obj0.pc=pc;
                for(let i=0;i<Yxs.length;i++){
                    if(Yxs[i].zyz){
                        const obj={};
                        obj.sb=Yxs[i].sb;
                        obj.sffc=Yxs[i].sffc===1||Yxs[i].sffc==='1'?'服从':'不服从';
                        obj.xh=(i+1);
                        obj.yxmc=Yxs[i].yxmc;
                        obj.yxxh=Yxs[i].yxxh;
                        obj.zyz=Yxs[i].zyz;
                        obj.zy1=!Yxs[i].zy1?'':Yxs[i].zy1;
                        obj.zy2=!Yxs[i].zy2?'':Yxs[i].zy2;
                        obj.zy3=!Yxs[i].zy3?'':Yxs[i].zy3;
                        obj.zy4=!Yxs[i].zy4?'':Yxs[i].zy4;
                        obj.zy5=!Yxs[i].zy5?'':Yxs[i].zy5;
                        obj.zy6=!Yxs[i].zy6?'':Yxs[i].zy6;
                        downParams.push(obj);
                    }
                }
                obj0.list=downParams;
            // const param=arr.join(",");
            // $("#down_param").val(param);
            // $("#down_list").val(JSON.stringify(list));
            // $("#down_form").submit();
            const res=await this.$http.postHttp("/down/downYhgzYxZyz",{dto:obj0,list},{responseType:'blob'});
            if(res.status===200){
                if(res.data.code===0){
                this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
                }else if(res.data.code===500){
                    if(res.data.message){
                        this.$message({message:res.data.message,type:'error'});
                    }
                }else{
                    if(res.data){
                    const blob=new Blob([res.data],{type:'application/vnd.ms-excel'});
                    if (window.navigator.msSaveOrOpenBlob) { // 兼容IE10
                    navigator.msSaveBlob(blob, this.filename);
                    } else {
                        const href = URL.createObjectURL(blob); // 创建新的URL表示指定的blob对象
                        const a = document.createElement('a'); // 创建a标签
                        a.style.display = 'none';
                        a.href = href; // 指定下载链接
                        a.download = this.filename; // 指定下载文件名
                        a.click(); // 触发下载
                        URL.revokeObjectURL(a.href); // 释放URL对象
                    }
                }
                }
            }else if(res.status===401){
                this.$message({message: '登录超时，请重新登录',type:"error"});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
            }else if(res.status===409||res.status===410||res.status===411){
                this.$message({message: '您的账号在其他地点登陆了',type:'warning'});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
            }
        }else if(pc==='7'||pc===7){
            const collectYx=this.zkCollectYx;
            const arr=[];
            const list=[];
            for(let i=0;i<collectYx.length;i++){
                if(collectYx[i].yxmc){
                    const pcmc=collectYx[i].pc===6?'本科批':'专科批';
                    const sb=!collectYx[i].sb?0:collectYx[i].sb+"";
                    const yxmc=!collectYx[i].yxmc?0:collectYx[i].yxmc;
                    const zyz=!collectYx[i].zyz?0:collectYx[i].zyz+"";
                    const szdqmc=!collectYx[i].szdqmc?0:collectYx[i].szdqmc;
                    const sf211=collectYx[i].sf211===1?'是':'否';
                    const sf985=collectYx[i].sf985===1?'是':'否';
                    const snjhs=!collectYx[i].snjhs?0:collectYx[i].snjhs+"";
                    const jnjhs=!collectYx[i].jnjhs?0:collectYx[i].jnjhs+"";
                    const rdwc=!collectYx[i].rdwc?0:collectYx[i].rdwc+"";
                    const snrdwc=!collectYx[i].snrdwc?0:collectYx[i].snrdwc+"";
                    const tdx=!collectYx[i].tdx?0:collectYx[i].tdx+"";
                    const zdtwf=!collectYx[i].zdtwf?0:collectYx[i].zdtwf+"";
                    const pjtwf=!collectYx[i].pjtwf?0:collectYx[i].pjtwf+"";
                    const zgtwf=!collectYx[i].zgtwf?0:collectYx[i].zgtwf+"";
                    arr.push(sb+'-'+yxmc+'-'+zyz+'-'+pcmc+'-'+szdqmc+'-'+sf211+'-'+sf985+'-'+
                    snjhs+'-'+jnjhs+'-'+rdwc+'-'+snrdwc+'-'+tdx+'-'+zdtwf+'-'+
                    pjtwf+'-'+zgtwf);
                    list.push({
                        xh:i+1,
                        dnjhs:jnjhs,
                        pc:pcmc,
                        pjRdwc:rdwc,
                        pjtwf,
                        sb,
                        sf211,
                        sf985,
                        sheng:szdqmc,
                        snRdwc:snrdwc,
                        snjhs,
                        tdx,
                        yxmc,
                        zdtwf,
                        zgtwf,
                        zyz
                    });
                }
            }
            const Yxs=[...this.zkCollectYx];
            const downParams=[];
            const obj0={};
            obj0.sssf=this.userInfo.sssf+"";
                obj0.sxkm=this.userInfo.sxkm+"";
                obj0.zxkma=this.userInfo.zxkma+"";
                obj0.zxkmb=this.userInfo.zxkmb+"";
                obj0.sxkmfs=!this.userInfo.sxkmcj?'':this.userInfo.sxkmcj+"";
                obj0.zxkmafs=!this.userInfo.zxkmacj?'':this.userInfo.zxkmacj+"";
                obj0.zxkmbfs=!this.userInfo.zxkmbcj?'':this.userInfo.zxkmbcj+"";
                obj0.xm=!this.userInfo.xm?'':this.userInfo.xm+"";
                obj0.school=this.userInfo.school+"";
                obj0.gkzf=this.userInfo.gkfs+"";
                obj0.yu=!this.userInfo.ywcj?'':this.userInfo.ywcj+"";
                obj0.shu=!this.userInfo.sxcj?'':this.userInfo.sxcj+"";
                obj0.wai=!this.userInfo.wycj?'':this.userInfo.wycj+"";
                obj0.bz=this.userInfo.bz+"";
                obj0.jf=this.userInfo.yfjf+"";
                obj0.sjhm=this.userInfo.sjhm+"";
                obj0.gjzxzg=this.userInfo.gjzxzg+"";
                obj0.dfzxzg=this.userInfo.dfzxzg+"";
                let gsh=this.userInfo.sjhm+"";
                const yhlb=this.userInfo.yhlb;
                if(yhlb===7||yhlb===9){
                    gsh=this.userInfo.sjhm;
                }
                obj0.ghs=gsh;
                obj0.xb=this.userInfo.xb+"";
                // obj0.pc=pc==='6'?'本科批':'专科批';
                obj0.pc=pc;
            for(let i=0;i<Yxs.length;i++){
                if(Yxs[i].zyz){
                    const obj={};
                    obj.sb=Yxs[i].sb;
                    obj.sffc=Yxs[i].sffc===1||Yxs[i].sffc==='1'?'服从':'不服从';
                    obj.xh=(i+1);
                    obj.yxmc=Yxs[i].yxmc;
                    obj.yxxh=Yxs[i].yxxh;
                    obj.zyz=Yxs[i].zyz;
                    obj.zy1=!Yxs[i].zy1?'':Yxs[i].zy1;
                    obj.zy2=!Yxs[i].zy2?'':Yxs[i].zy2;
                    obj.zy3=!Yxs[i].zy3?'':Yxs[i].zy3;
                    obj.zy4=!Yxs[i].zy4?'':Yxs[i].zy4;
                    obj.zy5=!Yxs[i].zy5?'':Yxs[i].zy5;
                    obj.zy6=!Yxs[i].zy6?'':Yxs[i].zy6;
                    downParams.push(obj);
                }
            }
                obj0.list=downParams;
            // const param=arr.join(",");
            // $("#down_param").val(param);
            // $("#down_list").val(JSON.stringify(list));
            // $("#down_form").submit();
            const res= this.$http.postHttp("/down/downYhgzYxZyz",list,{responseType:'blob'});
            const res2= this.$http.postHttp("/down/downMnzyb",obj0,{responseType:'blob'});
            const fileUrls=[];
            let fileNames=[];
            // const blob=new Blob([res.data],{type:'application/vnd.ms-excel'});
            // const href = URL.createObjectURL(blob);
            // const blob2=new Blob([res2.data],{type:'application/vnd.ms-excel'});
            // const href2 = URL.createObjectURL(blob);
            // fileUrls.push(href);
            // fileUrls.push(href2);
            fileNames=[this.filename+'.excel',this.filename2+'.excel'];
            const res3=await Promise.all([res,res2]);
            console.log(res3);
            
                    res3.forEach((item,index)=>{
                        const blob=new Blob([item.data],{type:'application/vnd.ms-excel'});
                        const link = document.createElement('a');
                        link.href = URL.createObjectURL(blob);
                        link.download = `file_${index}.xlsx`;
                        document.body.appendChild(link);
                        link.click();
                        setTimeout(() => URL.revokeObjectURL(link.href), 100);
                    });
            if(res.status===200){
                if(res.data.code===0){
                this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
                }else if(res.data.code===500){
                    if(res.data.message){
                        this.$message({message:res.data.message,type:'error'});
                    }
                }else{
                    // if(res.data){
                    //     const blob=new Blob([res.data],{type:'application/vnd.ms-excel'});
                    //     if (window.navigator.msSaveOrOpenBlob) { // 兼容IE10
                    //     navigator.msSaveBlob(blob, this.filename);
                    //     } else {
                    //         const href = URL.createObjectURL(blob); // 创建新的URL表示指定的blob对象
                    //         const a = document.createElement('a'); // 创建a标签
                    //         a.style.display = 'none';
                    //         a.href = href; // 指定下载链接
                    //         a.download = this.filename; // 指定下载文件名
                    //         a.click(); // 触发下载
                    //         URL.revokeObjectURL(a.href); // 释放URL对象
                    //     }
                    // }
                    // console.log(res);
                    // console.log(res2);
                    // if(res.data){
                    //     this.exportDownCode(res.data,"1",1);
                    // }
                    // if(res2.data){
                    //     this.exportDownCode(res2.data,"2",1);
                    // }
                    // if(res.data){
                    //     this.downloadFile(href);
                    // }
                    // if(res2.data){
                    //     this.downloadFile(href2);
                    // }
                }
            }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
            }else if(res.status===409||res.status===410||res.status===411){
                this.$message({message: '您的账号在其他地点登陆了',type:'warning'});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
            }
        }else if(pc==='0'||pc===0){
            const collectYx=this.bkTqpCollectYx;
            const arr=[];
            const list=[];
            for(let i=0;i<collectYx.length;i++){
                if(collectYx[i].yxmc){
                    const pcmc=collectYx[i].pc===6?'本科批':collectYx[0].pc===7?'专科批':
                    collectYx[i].pc===0?'本科提前批':collectYx[0].pc===9?'专科提前批':'' ;
                    const sb=!collectYx[i].sb?0:collectYx[i].sb+"";
                    const yxmc=!collectYx[i].yxmc?0:collectYx[i].yxmc;
                    const zyz=!collectYx[i].zyz?0:collectYx[i].zyz+"";
                    const szdqmc=!collectYx[i].szdqmc?0:collectYx[i].szdqmc;
                    const sf211=collectYx[i].sf211===1?'是':'否';
                    const sf985=collectYx[i].sf985===1?'是':'否';
                    const snjhs=!collectYx[i].snjhs?0:collectYx[i].snjhs+"";
                    const jnjhs=!collectYx[i].jnjhs?0:collectYx[i].jnjhs+"";
                    const rdwc=!collectYx[i].rdwc?0:collectYx[i].rdwc+"";
                    const snrdwc=!collectYx[i].snrdwc?0:collectYx[i].snrdwc+"";
                    const tdx=!collectYx[i].tdx?0:collectYx[i].tdx+"";
                    const zdtwf=!collectYx[i].zdtwf?0:collectYx[i].zdtwf+"";
                    const pjtwf=!collectYx[i].pjtwf?0:collectYx[i].pjtwf+"";
                    const zgtwf=!collectYx[i].zgtwf?0:collectYx[i].zgtwf+"";
                    arr.push(sb+'-'+yxmc+'-'+zyz+'-'+pcmc+'-'+szdqmc+'-'+sf211+'-'+sf985+'-'+
                    snjhs+'-'+jnjhs+'-'+rdwc+'-'+snrdwc+'-'+tdx+'-'+zdtwf+'-'+
                    pjtwf+'-'+zgtwf);
                    list.push({
                        xh:i+1,
                        dnjhs:jnjhs,
                        pc:pcmc,
                        pjRdwc:rdwc,
                        pjtwf,
                        sb,
                        sf211,
                        sf985,
                        sheng:szdqmc,
                        snRdwc:snrdwc,
                        snjhs,
                        tdx,
                        yxmc,
                        zdtwf,
                        zgtwf,
                        zyz
                    });
                }
            }
            const Yxs=[...this.bkTqpCollectYx];
            const downParams=[];
            const obj0={};
                obj0.sssf=this.userInfo.sssf+"";
                obj0.sxkm=this.userInfo.sxkm+"";
                obj0.zxkma=this.userInfo.zxkma+"";
                obj0.zxkmb=this.userInfo.zxkmb+"";
                obj0.sxkmfs=!this.userInfo.sxkmcj?'':this.userInfo.sxkmcj+"";
                obj0.zxkmafs=!this.userInfo.zxkmacj?'':this.userInfo.zxkmacj+"";
                obj0.zxkmbfs=!this.userInfo.zxkmbcj?'':this.userInfo.zxkmbcj+"";
                obj0.xm=!this.userInfo.xm?'':this.userInfo.xm+"";
                obj0.school=this.userInfo.school+"";
                obj0.gkzf=this.userInfo.gkfs+"";
                obj0.yu=!this.userInfo.ywcj?'':this.userInfo.ywcj+"";
                obj0.shu=!this.userInfo.sxcj?'':this.userInfo.sxcj+"";
                obj0.wai=!this.userInfo.wycj?'':this.userInfo.wycj+"";
                obj0.bz=this.userInfo.bz+"";
                obj0.jf=this.userInfo.yfjf+"";
                obj0.sjhm=this.userInfo.sjhm+"";
                obj0.gjzxzg=this.userInfo.gjzxzg+"";
                obj0.dfzxzg=this.userInfo.dfzxzg+"";
                let gsh=this.userInfo.sjhm+"";
                const yhlb=this.userInfo.yhlb;
                if(yhlb===7||yhlb===9){
                    gsh=this.userInfo.sjhm;
                }
                obj0.ghs=gsh;
                obj0.xb=this.userInfo.xb+"";
                // obj0.pc=pc==='6'?'本科批':'专科批';
                obj0.pc=pc;
                for(let i=0;i<Yxs.length;i++){
                    if(Yxs[i].zyz){
                        const obj={};
                        obj.sb=Yxs[i].sb;
                        obj.sffc=Yxs[i].sffc===1||Yxs[i].sffc==='1'?'服从':'不服从';
                        obj.xh=(i+1);
                        obj.yxmc=Yxs[i].yxmc;
                        obj.yxxh=Yxs[i].yxxh;
                        obj.zyz=Yxs[i].zyz;
                        obj.zy1=!Yxs[i].zy1?'':Yxs[i].zy1;
                        obj.zy2=!Yxs[i].zy2?'':Yxs[i].zy2;
                        obj.zy3=!Yxs[i].zy3?'':Yxs[i].zy3;
                        obj.zy4=!Yxs[i].zy4?'':Yxs[i].zy4;
                        obj.zy5=!Yxs[i].zy5?'':Yxs[i].zy5;
                        obj.zy6=!Yxs[i].zy6?'':Yxs[i].zy6;
                        downParams.push(obj);
                    }
                }
                obj0.list=downParams;
            // const param=arr.join(",");
            // $("#down_param").val(param);
            // $("#down_list").val(JSON.stringify(list));
            // $("#down_form").submit();
            const res=await this.$http.postHttp("/down/downYhgzYxZyz",{dto:obj0,list},{responseType:'blob'});
            if(res.status===200){
                if(res.data.code===0){
                this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
                }else if(res.data.code===500){
                    if(res.data.message){
                        this.$message({message:res.data.message,type:'error'});
                    }
                }else{
                    if(res.data){
                    const blob=new Blob([res.data],{type:'application/vnd.ms-excel'});
                    if (window.navigator.msSaveOrOpenBlob) { // 兼容IE10
                    navigator.msSaveBlob(blob, this.filename);
                    } else {
                        const href = URL.createObjectURL(blob); // 创建新的URL表示指定的blob对象
                        const a = document.createElement('a'); // 创建a标签
                        a.style.display = 'none';
                        a.href = href; // 指定下载链接
                        a.download = this.filename; // 指定下载文件名
                        a.click(); // 触发下载
                        URL.revokeObjectURL(a.href); // 释放URL对象
                    }
                }
                }
            }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
            }else if(res.status===409||res.status===410||res.status===411){
                this.$message({message: '您的账号在其他地点登陆了',type:'warning'});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
            }
        }else{
            const collectYx=this.zkTqpCollectYx;
            const arr=[];
            const list=[];
            for(let i=0;i<collectYx.length;i++){
                if(collectYx[i].yxmc){
                    const pcmc=collectYx[i].pc===6?'本科批':collectYx[0].pc===7?'专科批':
                    collectYx[i].pc===0?'本科提前批':collectYx[0].pc===9?'专科提前批':'' ;
                    const sb=!collectYx[i].sb?0:collectYx[i].sb+"";
                    const yxmc=!collectYx[i].yxmc?0:collectYx[i].yxmc;
                    const zyz=!collectYx[i].zyz?0:collectYx[i].zyz+"";
                    const szdqmc=!collectYx[i].szdqmc?0:collectYx[i].szdqmc;
                    const sf211=collectYx[i].sf211===1?'是':'否';
                    const sf985=collectYx[i].sf985===1?'是':'否';
                    const snjhs=!collectYx[i].snjhs?0:collectYx[i].snjhs+"";
                    const jnjhs=!collectYx[i].jnjhs?0:collectYx[i].jnjhs+"";
                    const rdwc=!collectYx[i].rdwc?0:collectYx[i].rdwc+"";
                    const snrdwc=!collectYx[i].snrdwc?0:collectYx[i].snrdwc+"";
                    const tdx=!collectYx[i].tdx?0:collectYx[i].tdx+"";
                    const zdtwf=!collectYx[i].zdtwf?0:collectYx[i].zdtwf+"";
                    const pjtwf=!collectYx[i].pjtwf?0:collectYx[i].pjtwf+"";
                    const zgtwf=!collectYx[i].zgtwf?0:collectYx[i].zgtwf+"";
                    arr.push(sb+'-'+yxmc+'-'+zyz+'-'+pcmc+'-'+szdqmc+'-'+sf211+'-'+sf985+'-'+
                    snjhs+'-'+jnjhs+'-'+rdwc+'-'+snrdwc+'-'+tdx+'-'+zdtwf+'-'+
                    pjtwf+'-'+zgtwf);
                    list.push({
                        xh:i+1,
                        dnjhs:jnjhs,
                        pc:pcmc,
                        pjRdwc:rdwc,
                        pjtwf,
                        sb,
                        sf211,
                        sf985,
                        sheng:szdqmc,
                        snRdwc:snrdwc,
                        snjhs,
                        tdx,
                        yxmc,
                        zdtwf,
                        zgtwf,
                        zyz
                    });
                }
            }
            
            const Yxs=[...this.zkTqpCollectYx];
            const downParams=[];
            const obj0={};
            obj0.sssf=this.userInfo.sssf+"";
                obj0.sxkm=this.userInfo.sxkm+"";
                obj0.zxkma=this.userInfo.zxkma+"";
                obj0.zxkmb=this.userInfo.zxkmb+"";
                obj0.sxkmfs=!this.userInfo.sxkmcj?'':this.userInfo.sxkmcj+"";
                obj0.zxkmafs=!this.userInfo.zxkmacj?'':this.userInfo.zxkmacj+"";
                obj0.zxkmbfs=!this.userInfo.zxkmbcj?'':this.userInfo.zxkmbcj+"";
                obj0.xm=!this.userInfo.xm?'':this.userInfo.xm+"";
                obj0.school=this.userInfo.school+"";
                obj0.gkzf=this.userInfo.gkfs+"";
                obj0.yu=!this.userInfo.ywcj?'':this.userInfo.ywcj+"";
                obj0.shu=!this.userInfo.sxcj?'':this.userInfo.sxcj+"";
                obj0.wai=!this.userInfo.wycj?'':this.userInfo.wycj+"";
                obj0.bz=this.userInfo.bz+"";
                obj0.jf=this.userInfo.yfjf+"";
                obj0.sjhm=this.userInfo.sjhm+"";
                obj0.gjzxzg=this.userInfo.gjzxzg+"";
                obj0.dfzxzg=this.userInfo.dfzxzg+"";
                let gsh=this.userInfo.sjhm+"";
                const yhlb=this.userInfo.yhlb;
                if(yhlb===7||yhlb===9){
                    gsh=this.userInfo.sjhm;
                }
                obj0.ghs=gsh;
                obj0.xb=this.userInfo.xb+"";
                // obj0.pc=pc==='6'?'本科批':'专科批';
                obj0.pc=pc;
            for(let i=0;i<Yxs.length;i++){
                if(Yxs[i].zyz){
                    const obj={};
                    obj.sb=Yxs[i].sb;
                    obj.sffc=Yxs[i].sffc===1||Yxs[i].sffc==='1'?'服从':'不服从';
                    obj.xh=(i+1);
                    obj.yxmc=Yxs[i].yxmc;
                    obj.yxxh=Yxs[i].yxxh;
                    obj.zyz=Yxs[i].zyz;
                    obj.zy1=!Yxs[i].zy1?'':Yxs[i].zy1;
                    obj.zy2=!Yxs[i].zy2?'':Yxs[i].zy2;
                    obj.zy3=!Yxs[i].zy3?'':Yxs[i].zy3;
                    obj.zy4=!Yxs[i].zy4?'':Yxs[i].zy4;
                    obj.zy5=!Yxs[i].zy5?'':Yxs[i].zy5;
                    obj.zy6=!Yxs[i].zy6?'':Yxs[i].zy6;
                    downParams.push(obj);
                }
            }
                obj0.list=downParams;
            // const param=arr.join(",");
            // $("#down_param").val(param);
            // $("#down_list").val(JSON.stringify(list));
            // $("#down_form").submit();
            const res=await this.$http.postHttp("/down/downYhgzYxZyz",{dto:obj0,list},{responseType:'blob'});
            if(res.status===200){
                if(res.data.code===0){
                this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
                }else if(res.data.code===500){
                    if(res.data.message){
                        this.$message({message:res.data.message,type:'error'});
                    }
                }else{
                    if(res.data){
                    const blob=new Blob([res.data],{type:'application/vnd.ms-excel'});
                    if (window.navigator.msSaveOrOpenBlob) { // 兼容IE10
                    navigator.msSaveBlob(blob, this.filename);
                    } else {
                        const href = URL.createObjectURL(blob); // 创建新的URL表示指定的blob对象
                        const a = document.createElement('a'); // 创建a标签
                        a.style.display = 'none';
                        a.href = href; // 指定下载链接
                        a.download = this.filename; // 指定下载文件名
                        a.click(); // 触发下载
                        URL.revokeObjectURL(a.href); // 释放URL对象
                    }
                }
                }
            }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
            }else if(res.status===409||res.status===410||res.status===411){
                this.$message({message: '您的账号在其他地点登陆了',type:'warning'});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
            }
        }
    },
    downloadFile(url){
     const iframe = document.createElement("iframe");
      iframe.style.display = "none";  // 防止影响页面
      iframe.style.height = 0;  // 防止影响页面
      iframe.src = url;
      document.body.appendChild(iframe);
      setTimeout(()=>{
        iframe.remove();
      },1000);
    },
    
    exportDownCode(data,flag="1",i=1){
                    setTimeout(() => {
                        const blob=new Blob([data],{type:'application/vnd.ms-excel'});
                        if (window.navigator.msSaveOrOpenBlob) { // 兼容IE10
                        flag==="1"? navigator.msSaveBlob(blob, this.filename): 
                        navigator.msSaveBlob(blob, this.filename2);
                        } else {
                            const href = URL.createObjectURL(blob); // 创建新的URL表示指定的blob对象
                            const a = document.createElement('a'); // 创建a标签
                            a.style.display = 'none';
                            a.href = href; // 指定下载链接
                            a.download =flag==="1"? this.filename:this.filename2; // 指定下载文件名
                            a.click(); // 触发下载
                            URL.revokeObjectURL(a.href); // 释放URL对象
                        }
                    }, 1000*i);
    },
    // 咨询师免费下载
    async freeDownExcel(){
        const loading=this.$loading({fullscreen:true,target:document.getElementById("out-load-tab"),text:'正在下载中'});
        const pc=this.activePcName;
        if(pc==='6'){
            const Yxs=[...this.bkCollectYx];
            const downParams=[];
            const obj0={};
                obj0.sssf=this.userInfo.sssf+"";
                obj0.sxkm=this.userInfo.sxkm+"";
                obj0.zxkma=this.userInfo.zxkma+"";
                obj0.zxkmb=this.userInfo.zxkmb+"";
                obj0.sxkmfs=!this.userInfo.sxkmcj?'':this.userInfo.sxkmcj+"";
                obj0.zxkmafs=!this.userInfo.zxkmacj?'':this.userInfo.zxkmacj+"";
                obj0.zxkmbfs=!this.userInfo.zxkmbcj?'':this.userInfo.zxkmbcj+"";
                obj0.xm=!this.userInfo.xm?'':this.userInfo.xm+"";
                obj0.school=this.userInfo.school+"";
                obj0.gkzf=this.userInfo.gkfs+"";
                obj0.yu=!this.userInfo.ywcj?'':this.userInfo.ywcj+"";
                obj0.shu=!this.userInfo.sxcj?'':this.userInfo.sxcj+"";
                obj0.wai=!this.userInfo.wycj?'':this.userInfo.wycj+"";
                obj0.bz=this.userInfo.bz+"";
                obj0.jf=this.userInfo.yfjf+"";
                obj0.sjhm=this.userInfo.sjhm+"";
                obj0.gjzxzg=this.userInfo.gjzxzg+"";
                obj0.dfzxzg=this.userInfo.dfzxzg+"";
                let gsh=this.userInfo.sjhm+"";
                const yhlb=this.userInfo.yhlb;
                if(yhlb===7||yhlb===9){
                    gsh=this.userInfo.sjhm;
                }
                obj0.ghs=gsh;
                obj0.xb=this.userInfo.xb+"";
                // obj0.pc=pc==='6'?'本科批':'专科批';
                obj0.pc=pc;
                for(let i=0;i<Yxs.length;i++){
                    if(Yxs[i].zyz){
                        const obj={};
                        obj.sb=Yxs[i].sb;
                        obj.sffc=Yxs[i].sffc===1||Yxs[i].sffc==='1'?'服从':'不服从';
                        obj.xh=(i+1);
                        obj.yxmc=Yxs[i].yxmc;
                        obj.yxxh=Yxs[i].yxxh;
                        obj.zyz=Yxs[i].zyz;
                        obj.zy1=!Yxs[i].zy1?'':Yxs[i].zy1;
                        obj.zy2=!Yxs[i].zy2?'':Yxs[i].zy2;
                        obj.zy3=!Yxs[i].zy3?'':Yxs[i].zy3;
                        obj.zy4=!Yxs[i].zy4?'':Yxs[i].zy4;
                        obj.zy5=!Yxs[i].zy5?'':Yxs[i].zy5;
                        obj.zy6=!Yxs[i].zy6?'':Yxs[i].zy6;
                        obj.checked=Yxs[i].checked;
                        downParams.push(obj);
                    }
                }
                let down45School=[];
                let tabFlag=false;
                let checkedCount=0;
                for(let i=0;i<downParams.length;i++){
                    if(downParams[i].checked){
                        tabFlag=true;
                        checkedCount++;
                    }
                }
                if(!tabFlag){
                    if(downParams.length>45){
                        for(let i=0;i<downParams.length;i++){
                            if(i<45){
                                down45School.push(downParams[i]);
                            }
                        }
                    }else{
                        down45School=[...downParams];
                    }
                }else{
                    if(checkedCount>0&&checkedCount<=45){
                        for(let i=0;i<downParams.length;i++){
                            if(downParams[i].yxmc&&downParams[i].checked){
                                down45School.push(downParams[i]);
                            }
                        }
                    }else{
                        if(downParams.length>45){
                            for(let i=0;i<downParams.length;i++){
                                if(i<45){
                                    down45School.push(downParams[i]);
                                }
                            }
                        }else{
                            down45School=[...downParams];
                        }
                    }
                }
                obj0.list=down45School;
                const res=await this.$http.postHttp("/down/downMnzyb",obj0,{responseType:'blob'});
                if(res.status===200){
                    if(res.data.code===0){
                    this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                    await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                    this.$router.replace({
                        path: '/main/home',
                        query: {redirect: this.$router.currentRoute.fullPath}
                    });
                    }else if(res.data.code===500){
                        if(res.data.message){
                            this.$message({message:res.data.message,type:'error'});
                        }
                    }else{
                        const blob=new Blob([res.data],{type:'application/vnd.ms-excel'});
                    if (window.navigator.msSaveOrOpenBlob) { // 兼容IE10
                    navigator.msSaveBlob(blob, this.filename2);
                    }else{
                        const href=URL.createObjectURL(blob);
                        const a=document.createElement("a");
                        a.style.display="none";
                        a.href=href;
                        a.download=this.filename2;
                        a.click();
                        URL.revokeObjectURL(a.href);
                    }
                    }
                }else if(res.status===401){
                    this.$message({message: '登录超时，请重新登录',type:"error"});
                    await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                    this.$router.replace({
                        path: '/main/home',
                        query: {redirect: this.$router.currentRoute.fullPath}
                    });
                }
        }else if(pc==='7'){
            const Yxs=[...this.zkCollectYx];
            const downParams=[];
            const obj0={};
            obj0.sssf=this.userInfo.sssf+"";
                obj0.sxkm=this.userInfo.sxkm+"";
                obj0.zxkma=this.userInfo.zxkma+"";
                obj0.zxkmb=this.userInfo.zxkmb+"";
                obj0.sxkmfs=!this.userInfo.sxkmcj?'':this.userInfo.sxkmcj+"";
                obj0.zxkmafs=!this.userInfo.zxkmacj?'':this.userInfo.zxkmacj+"";
                obj0.zxkmbfs=!this.userInfo.zxkmbcj?'':this.userInfo.zxkmbcj+"";
                obj0.xm=!this.userInfo.xm?'':this.userInfo.xm+"";
                obj0.school=this.userInfo.school+"";
                obj0.gkzf=this.userInfo.gkfs+"";
                obj0.yu=!this.userInfo.ywcj?'':this.userInfo.ywcj+"";
                obj0.shu=!this.userInfo.sxcj?'':this.userInfo.sxcj+"";
                obj0.wai=!this.userInfo.wycj?'':this.userInfo.wycj+"";
                obj0.bz=this.userInfo.bz+"";
                obj0.jf=this.userInfo.yfjf+"";
                obj0.sjhm=this.userInfo.sjhm+"";
                obj0.gjzxzg=this.userInfo.gjzxzg+"";
                obj0.dfzxzg=this.userInfo.dfzxzg+"";
                let gsh=this.userInfo.sjhm+"";
                const yhlb=this.userInfo.yhlb;
                if(yhlb===7||yhlb===9){
                    gsh=this.userInfo.sjhm;
                }
                obj0.ghs=gsh;
                obj0.xb=this.userInfo.xb+"";
                // obj0.pc=pc==='6'?'本科批':'专科批';
                obj0.pc=pc;
            for(let i=0;i<Yxs.length;i++){
                if(Yxs[i].zyz){
                    const obj={};
                    obj.sb=Yxs[i].sb;
                    obj.sffc=Yxs[i].sffc===1||Yxs[i].sffc==='1'?'服从':'不服从';
                    obj.xh=(i+1);
                    obj.yxmc=Yxs[i].yxmc;
                    obj.yxxh=Yxs[i].yxxh;
                    obj.zyz=Yxs[i].zyz;
                    obj.zy1=!Yxs[i].zy1?'':Yxs[i].zy1;
                    obj.zy2=!Yxs[i].zy2?'':Yxs[i].zy2;
                    obj.zy3=!Yxs[i].zy3?'':Yxs[i].zy3;
                    obj.zy4=!Yxs[i].zy4?'':Yxs[i].zy4;
                    obj.zy5=!Yxs[i].zy5?'':Yxs[i].zy5;
                    obj.zy6=!Yxs[i].zy6?'':Yxs[i].zy6;
                    obj.checked=Yxs[i].checked;
                    downParams.push(obj);
                }
            }
            
                let down45School=[];
                let tabFlag=false;
                let checkedCount=0;
                for(let i=0;i<downParams.length;i++){
                    if(downParams[i].checked){
                        tabFlag=true;
                        checkedCount++;
                    }
                }
                if(!tabFlag){
                    if(downParams.length>30){
                        for(let i=0;i<downParams.length;i++){
                            // if(i<30){
                            //     down45School.push(downParams[i]);
                            // }
                                down45School.push(downParams[i]);
                        }
                    }else{
                        down45School=[...downParams];
                    }
                }else{
                    if(checkedCount>0&&checkedCount<=30){
                        for(let i=0;i<downParams.length;i++){
                            if(downParams[i].yxmc&&downParams[i].checked){
                                down45School.push(downParams[i]);
                            }
                        }
                    }else{
                        if(downParams.length>30){
                            for(let i=0;i<downParams.length;i++){
                                // if(i<30){
                                //     down45School.push(downParams[i]);
                                // }
                                    down45School.push(downParams[i]);
                            }
                        }else{
                            down45School=[...downParams];
                        }
                    }
                }
                obj0.list=down45School;
                const res=await this.$http.postHttp("/down/downMnzyb",obj0,{responseType:'blob'});
                if(res.status===200){
                    if(res.data.code===0){
                    this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                    await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                    this.$router.replace({
                        path: '/main/home',
                        query: {redirect: this.$router.currentRoute.fullPath}
                    });
                    }else if(res.data.code===500){
                        if(res.data.message){
                            this.$message({message:res.data.message,type:'error'});
                        }
                    }else{
                        const blob=new Blob([res.data],{type:'application/vnd.ms-excel'});
                    if (window.navigator.msSaveOrOpenBlob) { // 兼容IE10
                    navigator.msSaveBlob(blob, this.filename2);
                    }else{
                        const href=URL.createObjectURL(blob);
                        const a=document.createElement("a");
                        a.style.display="none";
                        a.href=href;
                        a.download=this.filename2;
                        a.click();
                        URL.revokeObjectURL(a.href);
                    }
                    }
                }else if(res.status===401){
                    this.$message({message: '登录超时，请重新登录',type:"error"});
                    await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                    this.$router.replace({
                        path: '/main/home',
                        query: {redirect: this.$router.currentRoute.fullPath}
                    });
                }
        }else if(pc==='0'){
            const Yxs=[...this.bkTqpCollectYx];
            const downParams=[];
            const obj0={};
                obj0.sssf=this.userInfo.sssf+"";
                obj0.sxkm=this.userInfo.sxkm+"";
                obj0.zxkma=this.userInfo.zxkma+"";
                obj0.zxkmb=this.userInfo.zxkmb+"";
                obj0.sxkmfs=!this.userInfo.sxkmcj?'':this.userInfo.sxkmcj+"";
                obj0.zxkmafs=!this.userInfo.zxkmacj?'':this.userInfo.zxkmacj+"";
                obj0.zxkmbfs=!this.userInfo.zxkmbcj?'':this.userInfo.zxkmbcj+"";
                obj0.xm=!this.userInfo.xm?'':this.userInfo.xm+"";
                obj0.school=this.userInfo.school+"";
                obj0.gkzf=this.userInfo.gkfs+"";
                obj0.yu=!this.userInfo.ywcj?'':this.userInfo.ywcj+"";
                obj0.shu=!this.userInfo.sxcj?'':this.userInfo.sxcj+"";
                obj0.wai=!this.userInfo.wycj?'':this.userInfo.wycj+"";
                obj0.bz=this.userInfo.bz+"";
                obj0.jf=this.userInfo.yfjf+"";
                obj0.sjhm=this.userInfo.sjhm+"";
                obj0.gjzxzg=this.userInfo.gjzxzg+"";
                obj0.dfzxzg=this.userInfo.dfzxzg+"";
                let gsh=this.userInfo.sjhm+"";
                const yhlb=this.userInfo.yhlb;
                if(yhlb===7||yhlb===9){
                    gsh=this.userInfo.sjhm;
                }
                obj0.ghs=gsh;
                obj0.xb=this.userInfo.xb+"";
                // obj0.pc=pc==='6'?'本科批':'专科批';
                obj0.pc=pc;
                for(let i=0;i<Yxs.length;i++){
                    if(Yxs[i].zyz){
                        const obj={};
                        obj.sb=Yxs[i].sb;
                        obj.sffc=Yxs[i].sffc===1||Yxs[i].sffc==='1'?'服从':'不服从';
                        obj.xh=(i+1);
                        obj.yxmc=Yxs[i].yxmc;
                        obj.yxxh=Yxs[i].yxxh;
                        obj.zyz=Yxs[i].zyz;
                        obj.zy1=!Yxs[i].zy1?'':Yxs[i].zy1;
                        obj.zy2=!Yxs[i].zy2?'':Yxs[i].zy2;
                        obj.zy3=!Yxs[i].zy3?'':Yxs[i].zy3;
                        obj.zy4=!Yxs[i].zy4?'':Yxs[i].zy4;
                        obj.zy5=!Yxs[i].zy5?'':Yxs[i].zy5;
                        obj.zy6=!Yxs[i].zy6?'':Yxs[i].zy6;
                        downParams.push(obj);
                    }
                }
                let down45School=[];
                let tabFlag=false;
                let checkedCount=0;
                for(let i=0;i<downParams.length;i++){
                    if(downParams[i].checked){
                        tabFlag=true;
                        checkedCount++;
                    }
                }
                if(!tabFlag){
                    if(downParams.length>45){
                        for(let i=0;i<downParams.length;i++){
                            if(i<45){
                                down45School.push(downParams[i]);
                            }
                        }
                    }else{
                        down45School=[...downParams];
                    }
                }else{
                    if(checkedCount>0&&checkedCount<=45){
                        for(let i=0;i<downParams.length;i++){
                            if(downParams[i].yxmc&&downParams[i].checked){
                                down45School.push(downParams[i]);
                            }
                        }
                    }else{
                        if(downParams.length>45){
                            for(let i=0;i<downParams.length;i++){
                                if(i<45){
                                    down45School.push(downParams[i]);
                                }
                            }
                        }else{
                            down45School=[...downParams];
                        }
                    }
                }
                obj0.list=down45School;
                const res=await this.$http.postHttp("/down/downMnzyb",obj0,{responseType:'blob'});
                if(res.status===200){
                    if(res.data.code===0){
                    this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                    await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                    this.$router.replace({
                        path: '/main/home',
                        query: {redirect: this.$router.currentRoute.fullPath}
                    });
                    }else if(res.data.code===500){
                        if(res.data.message){
                            this.$message({message:res.data.message,type:'error'});
                        }
                    }else{
                        const blob=new Blob([res.data],{type:'application/vnd.ms-excel'});
                    if (window.navigator.msSaveOrOpenBlob) { // 兼容IE10
                    navigator.msSaveBlob(blob, this.filename2);
                    }else{
                        const href=URL.createObjectURL(blob);
                        const a=document.createElement("a");
                        a.style.display="none";
                        a.href=href;
                        a.download=this.filename2;
                        a.click();
                        URL.revokeObjectURL(a.href);
                    }
                    }
                }else if(res.status===401){
                    this.$message({message: '登录超时，请重新登录',type:"error"});
                    await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                    this.$router.replace({
                        path: '/main/home',
                        query: {redirect: this.$router.currentRoute.fullPath}
                    });
                }
        }else{
            const Yxs=[...this.zkTqpCollectYx];
            const downParams=[];
            const obj0={};
            obj0.sssf=this.userInfo.sssf+"";
                obj0.sxkm=this.userInfo.sxkm+"";
                obj0.zxkma=this.userInfo.zxkma+"";
                obj0.zxkmb=this.userInfo.zxkmb+"";
                obj0.sxkmfs=!this.userInfo.sxkmcj?'':this.userInfo.sxkmcj+"";
                obj0.zxkmafs=!this.userInfo.zxkmacj?'':this.userInfo.zxkmacj+"";
                obj0.zxkmbfs=!this.userInfo.zxkmbcj?'':this.userInfo.zxkmbcj+"";
                obj0.xm=!this.userInfo.xm?'':this.userInfo.xm+"";
                obj0.school=this.userInfo.school+"";
                obj0.gkzf=this.userInfo.gkfs+"";
                obj0.yu=!this.userInfo.ywcj?'':this.userInfo.ywcj+"";
                obj0.shu=!this.userInfo.sxcj?'':this.userInfo.sxcj+"";
                obj0.wai=!this.userInfo.wycj?'':this.userInfo.wycj+"";
                obj0.bz=this.userInfo.bz+"";
                obj0.jf=this.userInfo.yfjf+"";
                obj0.sjhm=this.userInfo.sjhm+"";
                obj0.gjzxzg=this.userInfo.gjzxzg+"";
                obj0.dfzxzg=this.userInfo.dfzxzg+"";
                let gsh=this.userInfo.sjhm+"";
                const yhlb=this.userInfo.yhlb;
                if(yhlb===7||yhlb===9){
                    gsh=this.userInfo.sjhm;
                }
                obj0.ghs=gsh;
                obj0.xb=this.userInfo.xb+"";
                // obj0.pc=pc==='6'?'本科批':'专科批';
                obj0.pc=pc;
            for(let i=0;i<Yxs.length;i++){
                if(Yxs[i].zyz){
                    const obj={};
                    obj.sb=Yxs[i].sb;
                    obj.sffc=Yxs[i].sffc===1||Yxs[i].sffc==='1'?'服从':'不服从';
                    obj.xh=(i+1);
                    obj.yxmc=Yxs[i].yxmc;
                    obj.yxxh=Yxs[i].yxxh;
                    obj.zyz=Yxs[i].zyz;
                    obj.zy1=!Yxs[i].zy1?'':Yxs[i].zy1;
                    obj.zy2=!Yxs[i].zy2?'':Yxs[i].zy2;
                    obj.zy3=!Yxs[i].zy3?'':Yxs[i].zy3;
                    obj.zy4=!Yxs[i].zy4?'':Yxs[i].zy4;
                    obj.zy5=!Yxs[i].zy5?'':Yxs[i].zy5;
                    obj.zy6=!Yxs[i].zy6?'':Yxs[i].zy6;
                    downParams.push(obj);
                }
            }
                let down45School=[];
                let tabFlag=false;
                let checkedCount=0;
                for(let i=0;i<downParams.length;i++){
                    if(downParams[i].checked){
                        tabFlag=true;
                        checkedCount++;
                    }
                }
                if(!tabFlag){
                    if(downParams.length>30){
                        for(let i=0;i<downParams.length;i++){
                            // if(i<30){
                            //     down45School.push(downParams[i]);
                            // }
                                down45School.push(downParams[i]);
                        }
                    }else{
                        down45School=[...downParams];
                    }
                }else{
                    if(checkedCount>0&&checkedCount<=30){
                        for(let i=0;i<downParams.length;i++){
                            if(downParams[i].yxmc&&downParams[i].checked){
                                down45School.push(downParams[i]);
                            }
                        }
                    }else{
                        if(downParams.length>30){
                            for(let i=0;i<downParams.length;i++){
                                // if(i<30){
                                //     down45School.push(downParams[i]);
                                // }
                                    down45School.push(downParams[i]);
                            }
                        }else{
                            down45School=[...downParams];
                        }
                    }
                }
                obj0.list=down45School;
                const res=await this.$http.postHttp("/down/downMnzyb",obj0,{responseType:'blob'});
                if(res.status===200){
                    if(res.data.code===0){
                    this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                    await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                    this.$router.replace({
                        path: '/main/home',
                        query: {redirect: this.$router.currentRoute.fullPath}
                    });
                    }else if(res.data.code===500){
                        if(res.data.message){
                            this.$message({message:res.data.message,type:'error'});
                        }
                    }else{
                        const blob=new Blob([res.data],{type:'application/vnd.ms-excel'});
                    if (window.navigator.msSaveOrOpenBlob) { // 兼容IE10
                        navigator.msSaveBlob(blob, this.filename2);
                    }else{
                        const href=URL.createObjectURL(blob);
                        const a=document.createElement("a");
                        a.style.display="none";
                        a.href=href;
                        a.download=this.filename2;
                        a.click();
                        URL.revokeObjectURL(a.href);
                    }
                    }
                }else if(res.status===401){
                    this.$message({message: '登录超时，请重新登录',type:"error"});
                    await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                    this.$router.replace({
                        path: '/main/home',
                        query: {redirect: this.$router.currentRoute.fullPath}
                    });
                }
        }
        await this.saveOtherCode3();
        loading.close();
    },
    tableRowClassName({row, rowIndex}) {
        if (row.checked) {
        // const pc=this.activePcName;
        //   return 'success-row';
            return '';
        }else if(row.radioChecked){
            return 'info-row';
        } 
      },
      rowClickChecked(row, column, cell, event){
        if(column.label==='选择'){
            row.checked=true;
            this.firstCellClick(row.index-1);
        }else{
            row.radioChecked=true;
            const pc=this.activePcName;
            if(pc==='6'){
                this.bkIndex=row.index-1;
            }else if(pc==='7'){
                this.zkIndex=row.index-1;
            }else if(pc==='0'){
                this.bkTqpIndex=row.index-1;
            }else{
                this.zkTqpIndex=row.index-1;
            }
            this.otherCellClick2(row.index-1);
        }
      },
      firstCellClick(index){
        const pc=this.activePcName;
        if(pc==='6'){
            const bkArr=[...this.bkCollectYx];
            bkArr[index].checked=true;
            this.bkCollectYx=bkArr;
        }else if(pc==='7'){
            const zkArr=[...this.zkCollectYx];
            zkArr[index].checked=true;
            this.zkCollectYx=zkArr;
        }else if(pc==='0'){
            const bkArr=[...this.bkTqpCollectYx];
            bkArr[index].checked=true;
            this.bkTqpCollectYx=bkArr;
        }else{
            const zkArr=[...this.zkTqpCollectYx];
            zkArr[index].checked=true;
            this.zkTqpCollectYx=zkArr;
        }
      },
      otherCellClick(index){
        const pc=this.activePcName;
        if(pc==='6'){
            const bkArr=[...this.bkCollectYx];
            for(let i=0;i<bkArr.length;i++){
                bkArr[i].radioChecked=false;
            }
            bkArr[index].checked=false;
            bkArr[index].radioChecked=true;
            this.bkCollectYx=bkArr;
        }else if(pc==='7'){
            const zkArr=[...this.zkCollectYx];
            for(let i=0;i<zkArr.length;i++){
                zkArr[i].radioChecked=false;
            }
            zkArr[index].checked=false;
            zkArr[index].radioChecked=true;
            this.zkCollectYx=zkArr;
        }else if(pc==='0'){
            const bkArr=[...this.bkTqpCollectYx];
            for(let i=0;i<bkArr.length;i++){
                bkArr[i].radioChecked=false;
            }
            bkArr[index].checked=false;
            bkArr[index].radioChecked=true;
            this.bkTqpCollectYx=bkArr;
        }else{
            const zkArr=[...this.zkTqpCollectYx];
            for(let i=0;i<zkArr.length;i++){
                zkArr[i].radioChecked=false;
            }
            zkArr[index].checked=false;
            zkArr[index].radioChecked=true;
            this.zkTqpCollectYx=zkArr;
        }
      },
      otherCellClick2(index){
        const pc=this.activePcName;
        if(pc==='6'){
            const bkArr=[...this.bkCollectYx];
            for(let i=0;i<bkArr.length;i++){
                bkArr[i].radioChecked=false;
            }
            bkArr[index].radioChecked=true;
            this.bkCollectYx=bkArr;
        }else if(pc==='7'){
            const zkArr=[...this.zkCollectYx];
            for(let i=0;i<zkArr.length;i++){
                zkArr[i].radioChecked=false;
            }
            zkArr[index].radioChecked=true;
            this.zkCollectYx=zkArr;
        }else if(pc==='0'){
            const bkArr=[...this.bkTqpCollectYx];
            for(let i=0;i<bkArr.length;i++){
                bkArr[i].radioChecked=false;
            }
            bkArr[index].radioChecked=true;
            this.bkTqpCollectYx=bkArr;
        }else{
            const zkArr=[...this.zkTqpCollectYx];
            for(let i=0;i<zkArr.length;i++){
                zkArr[i].radioChecked=false;
            }
            zkArr[index].radioChecked=true;
            this.zkTqpCollectYx=zkArr;
        }
      },
    // 查询用户是否支付了永久下载
    async getYfFreeDown(){
        const yhid=this.userInfo.yhid;
        const res=await this.$http.getHttp("/pay/getPayXz?yhid="+yhid+"&&mnzyb=1");
        if(res.data.code===200){
            this.yfFreeDown=true;
        }else if(res.data.code===500){
            if(res.data.message){
                if(res.data.message==='不存在永久支付'){
                    return false;
                }else{
                    this.$message({message:res.data.message,type:'error'});
                }
            }
        }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.data.code===0){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }
    },
    filterOption(inputValue, option) {
      return option.title.indexOf(inputValue) > -1;
    },
    handleChange(targetKeys, direction, moveKeys) {
      console.log(targetKeys, direction, moveKeys);
        if(direction==='right'&&(targetKeys.length>6)){
            const selectedZys=this.selectedZys;
            if(selectedZys.length<6){
                const msgCount=6-selectedZys.length;
                this.$message({message:'还能选择'+msgCount+'个专业',type:'warning',showClose:true});
                const outLen=targetKeys.length;
                const inLen=moveKeys.length;
                const arr=[];
                for(let i=0;i<outLen;i++){
                    let haveFlag=false;
                    for(let j=0;j<inLen;j++){
                        if(targetKeys[i]===moveKeys[j]){
                            haveFlag=true;
                            break;
                        }
                    }
                    if(!haveFlag){
                        arr.push(targetKeys[i]);
                    }
                }
                this.selectedZys=arr;
            }else{
                this.$message({message:'已经选择了6个专业',type:'warning',showClose:true});
                const outLen=targetKeys.length;
                const inLen=moveKeys.length;
                const arr=[];
                for(let i=0;i<outLen;i++){
                    let haveFlag=false;
                    for(let j=0;j<inLen;j++){
                        if(targetKeys[i]===moveKeys[j]){
                            haveFlag=true;
                            break;
                        }
                    }
                    if(!haveFlag){
                        arr.push(targetKeys[i]);
                    }
                }
                this.selectedZys=arr;
            }
            return;
        }else if(direction==='right'&&(targetKeys.length<=6)){
            console.log(moveKeys);
            const selectedZys=[...this.selectedZys];
            for(let i=0;i<moveKeys.length;i++){
                selectedZys.push(moveKeys[i]);
            }
            const zyData=[...this.zyData];
            // 选择的专业数量 0 1 2 3 4 5
            let selectZyCount=this.rightShowCount;
            console.log(selectZyCount);
            // 剩余专业数量
            // 
            let remanentCount=6-selectZyCount;
            let addtiveCount=1;
            if(remanentCount<=6){
                for(let i=0;i<zyData.length;i++){
                    if(zyData[i]&&zyData[i].title){
                        zyData[i].xh=0;
                    }
                }
                for(let i=0;i<zyData.length;i++){
                    for(let j=0;j<selectedZys.length;j++){
                        if(zyData[i].key===selectedZys[j]){
                            zyData[i].xh=j+1;
                        }
                    }
                }
            }
            this.selectedZys=selectedZys;
            return;
        }else if(direction==='left'&&(targetKeys.length<=6)){
            const zyData=[...this.zyData];
            // 选择的专业数量 0 1 2 3 4 5
            let selectZyCount=this.rightShowCount;
            console.log(selectZyCount);
            // 剩余专业数量
            // 
            let remanentCount=6-selectZyCount;
            let addtiveCount=1;
            if(remanentCount<=6){
                for(let i=0;i<zyData.length;i++){
                    if(zyData[i]&&zyData[i].title){
                        zyData[i].xh=0;
                    }
                }
                for(let i=0;i<zyData.length;i++){
                    for(let j=0;j<targetKeys.length;j++){
                        if(zyData[i].key===targetKeys[j]){
                            zyData[i].xh=j+1;
                        }
                    }
                }
            }
            this.selectedZys = targetKeys;
            return;
        }
      this.selectedZys = targetKeys;
    },
    handleSearch(dir, value) {
      console.log('search:', dir, value);
    },
    // 上移
    moveUp(){
        const item=[...this.item];
        const selectedZys=[...this.selectedZys];
        const len=item.length;
        if(len>1){
            this.$message({message:'只能移动一个专业',type:'warning',showClose:true});
            return false;
        }
        const zy=item[0];
        let index=-1;
        for(let i=0;i<selectedZys.length;i++){
            if(selectedZys[i]===zy){
                index=i;
            }
        }
        if(index===-1){
            this.$message({message:'请选择某一个专业',type:'warning',showClose:true});
            return false;
        }
        if(index===0){
            return false;
        }
        const obj=selectedZys[index];
        const prevObj=selectedZys[index-1];
        this.$set(this.selectedZys,index,prevObj);
        this.$set(this.selectedZys,index-1,obj);
    },
    // 下移
    moveDown(){
        const item=[...this.item];
        const selectedZys=[...this.selectedZys];
        const len=item.length;
        if(len>1){
            this.$message({message:'只能移动一个专业',type:'warning',showClose:true});
            return false;
        }
        const zy=item[0];
        let index=-1;
        for(let i=0;i<selectedZys.length;i++){
            if(selectedZys[i]===zy){
                index=i;
            }
        }
        if(index===-1){
            this.$message({message:'请选择某一个专业',type:'warning',showClose:true});
            return false;
        }
        if(index===selectedZys.length-1){
            return false;
        }
        const obj=selectedZys[index];
        const nextObj=selectedZys[index+1];
        this.$set(this.selectedZys,index,nextObj);
        this.$set(this.selectedZys,index+1,obj);
    },
    // 上移
    moveUp2(){
        const item=[...this.rightSelectRows];
        const selectedZys=[...this.filterZyData];
        const len=item.length;
        if(len>1){
            this.$message({message:'只能移动一个专业',type:'warning',showClose:true});
            return false;
        }
        const zy=item[0];
        let index=-1;
        for(let i=0;i<selectedZys.length;i++){
            if(selectedZys[i].key===zy){
                index=i;
            }
        }
        if(index===-1){
            this.$message({message:'请选择某一个专业',type:'warning',showClose:true});
            return false;
        }
        if(index===0){
            return false;
        }
        const obj=selectedZys[index];
        const prevObj=selectedZys[index-1];
        this.$set(this.filterZyData,index,prevObj);
        this.$set(this.filterZyData,index-1,obj);
        this.filterZyData.forEach((item,index)=>{
            item.xh=index+1;
        });
        this.filterZyData.sort((a,b)=>{
            return a.xh-b.xh;
        });
        const rightArr=[...this.filterZyData];
        const arrSelectedZy=[];
        for(let i=0;i<rightArr.length;i++){
            if(rightArr[i].title){
                arrSelectedZy.push(rightArr[i].key);
            }
        }
        this.selectedZys=arrSelectedZy;
    },
    // 下移
    moveDown2(){
        const item=[...this.rightSelectRows];
        const selectedZys=[...this.filterZyData];
        const len=item.length;
        if(len>1){
            this.$message({message:'只能移动一个专业',type:'warning',showClose:true});
            return false;
        }
        const zy=item[0];
        let index=-1;
        for(let i=0;i<selectedZys.length;i++){
            if(selectedZys[i].key===zy){
                index=i;
            }
        }
        if(index===-1){
            this.$message({message:'请选择某一个专业',type:'warning',showClose:true});
            return false;
        }
        if(index===selectedZys.length-1){
            return false;
        }
        const obj=selectedZys[index];
        const nextObj=selectedZys[index+1];
        this.$set(this.filterZyData,index,nextObj);
        this.$set(this.filterZyData,index+1,obj);
        this.filterZyData.forEach((item,index)=>{
            item.xh=index+1;
        });
        this.filterZyData.sort((a,b)=>{
            return a.xh-b.xh;
        });
        const rightArr=[...this.filterZyData];
        const arrSelectedZy=[];
        for(let i=0;i<rightArr.length;i++){
            if(rightArr[i].title){
                arrSelectedZy.push(rightArr[i].key);
            }
        }
        this.selectedZys=arrSelectedZy;
    },
    // 打开选择专业的弹窗
    async chooseZy(obj){
        this.searchYxxh=obj.yxxh;
        this.searchZyz=obj.zyz;
        this.searchIndex=obj.index;
        this.searchYxmc=obj.yxmc;
        const pc=this.activePcName;
        if(obj.yxxh&&obj.zyz){
            this.zyData=[];
            let zydhs=[];
            if(pc==='6'){
                const yxObj=this.bkCollectYx[obj.index-1];
                for(let i=1;i<=6;i++){
                    console.log(yxObj['zy'+i]);
                    if(yxObj['zy'+i]){
                        zydhs.push(yxObj['zy'+i]);
                    }
                }
            }else if(pc==='7'){
                const yxObj=this.zkCollectYx[obj.index-1];
                for(let i=1;i<=6;i++){
                    if(yxObj['zy'+i]){
                        zydhs.push(yxObj['zy'+i]);
                    }
                }
            }else if(pc==='0'){
                const yxObj=this.bkTqpCollectYx[obj.index-1];
                for(let i=1;i<=6;i++){
                    if(yxObj['zy'+i]){
                        zydhs.push(yxObj['zy'+i]);
                    }
                }
            }else{
                const yxObj=this.zkTqpCollectYx[obj.index-1];
                for(let i=1;i<=6;i++){
                    if(yxObj['zy'+i]){
                        zydhs.push(yxObj['zy'+i]);
                    }
                }
            }
            console.log(zydhs);
            this.selectedZys=zydhs;
            const res=await this.$http.getHttp("/zsjh/getZyByZyz?yxxh="+obj.yxxh+"&zyz="+obj.zyz);
            if(res.data.code===200){
                const data=res.data.obj;
                const zys=[];
                for(let i=0;i<data.length;i++){
                    if(data[i].zydh){
                        zys.push({
                        key:data[i].zydh,
                        title:data[i].zydh+' '+data[i].zymc,
                        description:'',
                        xf:'￥'+data[i].xf+'/年',
                        xh:0,
                        isDisabled:false,
                        isChecked:false
                    });
                    }
                }
                for(let i=0;i<zys.length;i++){
                    for(let j=0;j<zydhs.length;j++){
                        if(zys[i].key===zydhs[j]){
                            zys[i].xh=j+1;
                        }
                    }
                }
                this.zyData=zys;
                this.rightShowCount=zydhs.length;
            }else if(res.data.code===500){
            if(res.data.message){
                this.$message({message:res.data.message,type:'error'});
            }
            }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
            }else if(res.data.code===0){
                this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
            }else if(res.status===409||res.status===410||res.status===411){
                this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
            }
        }else{
            this.zyData=[];
        }
        this.dialogZyVisible=true;
    },
    // 打开选择专业的弹窗
    async chooseZy2(obj){
        this.searchYxxh=obj.selectedYxxh||obj.yxxh;
        this.searchZyz=obj.selectedZyz||obj.submitZyz||obj.zyz;
        this.searchIndex=obj.index;
        this.searchYxmc=obj.submitYxmc||obj.yxmc;
        const pc=this.activePcName;
        if(obj.selectedYxxh&&obj.selectedZyz){
            this.zyData=[];
            let zydhs=[];
            if(pc==='6'){
                const yxObj=this.bkCollectYx[obj.index-1];
                for(let i=1;i<=6;i++){
                    console.log(yxObj['zy'+i]);
                    if(yxObj['zy'+i]){
                        zydhs.push(yxObj['zy'+i]);
                    }
                }
            }else if(pc==='7'){
                const yxObj=this.zkCollectYx[obj.index-1];
                for(let i=1;i<=6;i++){
                    if(yxObj['zy'+i]){
                        zydhs.push(yxObj['zy'+i]);
                    }
                }
            }else if(pc==='0'){
                const yxObj=this.bkTqpCollectYx[obj.index-1];
                for(let i=1;i<=6;i++){
                    if(yxObj['zy'+i]){
                        zydhs.push(yxObj['zy'+i]);
                    }
                }
            }else{
                const yxObj=this.zkTqpCollectYx[obj.index-1];
                for(let i=1;i<=6;i++){
                    if(yxObj['zy'+i]){
                        zydhs.push(yxObj['zy'+i]);
                    }
                }
            }
            console.log(zydhs);
            this.selectedZys=zydhs;
            const res=await this.$http.getHttp("/zsjh/getZyByZyz?yxxh="+obj.selectedYxxh+"&zyz="+obj.selectedZyz);
            if(res.data.code===200){
                const data=res.data.obj;
                const zys=[];
                for(let i=0;i<data.length;i++){
                    if(data[i].zydh){
                        zys.push({
                        key:data[i].zydh,
                        title:data[i].zydh+' '+data[i].zymc,
                        description:'',
                        xf:'￥'+data[i].xf+'/年',
                        xh:0,
                        isDisabled:false,
                        isChecked:false
                    });
                    }
                }
                for(let i=0;i<zys.length;i++){
                    for(let j=0;j<zydhs.length;j++){
                        if(zys[i].key===zydhs[j]){
                            zys[i].xh=j+1;
                        }
                    }
                }
                const arr=[];
                for(let i=0;i<zys.length;i++){
                    if(zys[i].xh>0){
                        arr[zys[i].xh-1]=zys[i];
                    }
                }
                const leftRemanentArr=zys.filter((item,index)=>{
                    let flag=true;
                    for(let i=0;i<zydhs.length;i++){
                        if(item.key===zydhs[i]){
                            flag=false;
                            break;
                        }
                    }
                    if(flag){
                        return item;
                    }else{
                        return null;
                    }
                });
                this.filterZyDataLeft=leftRemanentArr.filter(item=>item!==null);
                console.log(arr,zys,this.filterZyDataLeft);
                this.zyData=zys;
                this.filterZyData=arr;
                this.rightShowCount=zydhs.length;
                this.leftSelectRows=[];
                this.rightSelectRows=[];
                this.leftTopTitle=`<span style="color: blue;font-weight: 700;">${this.searchYxmc}</span>
                ${this.searchZyz}组共${this.zyData.length}个专业`;
                this.rightTopTitle=`已选择
                <span style="color: blue;font-weight: 700;">${ this.selectedZys.length }</span>个专业填报`;
            }else if(res.data.code===500){
                if(res.data.message){
                    this.$message({message:res.data.message,type:'error'});
                }
                this.filterZyDataLeft=[];
                this.zyData=[];
                this.filterZyData=[];
                this.rightShowCount=0;
                this.leftSelectRows=[];
                this.rightSelectRows=[];
                this.leftTopTitle='';
                this.rightTopTitle='';
                this.selectedZys=[];
            }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
            }else if(res.data.code===0){
                this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
            }else if(res.status===409||res.status===410||res.status===411){
                this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
            }
        }else if(obj.yxxh&&obj.zyz&&obj.selectedYxxh){
            this.zyData=[];
            let zydhs=[];
            if(pc==='6'){
                const yxObj=this.bkCollectYx[obj.index-1];
                for(let i=1;i<=6;i++){
                    console.log(yxObj['zy'+i]);
                    if(yxObj['zy'+i]){
                        zydhs.push(yxObj['zy'+i]);
                    }
                }
            }else if(pc==='7'){
                const yxObj=this.zkCollectYx[obj.index-1];
                for(let i=1;i<=6;i++){
                    if(yxObj['zy'+i]){
                        zydhs.push(yxObj['zy'+i]);
                    }
                }
            }else if(pc==='0'){
                const yxObj=this.bkTqpCollectYx[obj.index-1];
                for(let i=1;i<=6;i++){
                    if(yxObj['zy'+i]){
                        zydhs.push(yxObj['zy'+i]);
                    }
                }
            }else{
                const yxObj=this.zkTqpCollectYx[obj.index-1];
                for(let i=1;i<=6;i++){
                    if(yxObj['zy'+i]){
                        zydhs.push(yxObj['zy'+i]);
                    }
                }
            }
            console.log(zydhs);
            this.selectedZys=zydhs;
            const res=await this.$http.getHttp("/zsjh/getZyByZyz?yxxh="+obj.selectedYxxh+"&zyz="+obj.zyz);
            if(res.data.code===200){
                const data=res.data.obj;
                const zys=[];
                for(let i=0;i<data.length;i++){
                    if(data[i].zydh){
                        zys.push({
                        key:data[i].zydh,
                        title:data[i].zydh+' '+data[i].zymc,
                        description:'',
                        xf:'￥'+data[i].xf+'/年',
                        xh:0,
                        isDisabled:false,
                        isChecked:false
                    });
                    }
                }
                for(let i=0;i<zys.length;i++){
                    for(let j=0;j<zydhs.length;j++){
                        if(zys[i].key===zydhs[j]){
                            zys[i].xh=j+1;
                        }
                    }
                }
                const arr=[];
                for(let i=0;i<zys.length;i++){
                    if(zys[i].xh>0){
                        arr[zys[i].xh-1]=zys[i];
                    }
                }
                const leftRemanentArr=zys.filter((item,index)=>{
                    let flag=true;
                    for(let i=0;i<zydhs.length;i++){
                        if(item.key===zydhs[i]){
                            flag=false;
                            break;
                        }
                    }
                    if(flag){
                        return item;
                    }else{
                        return null;
                    }
                });
                this.filterZyDataLeft=leftRemanentArr.filter(item=>item!==null);
                console.log(arr,zys,this.filterZyDataLeft);
                this.zyData=zys;
                this.filterZyData=arr;
                this.rightShowCount=zydhs.length;
                this.leftSelectRows=[];
                this.rightSelectRows=[];
                this.leftTopTitle=`<span style="color: blue;font-weight: 700;">${this.searchYxmc}</span>
                ${this.searchZyz}组共${this.zyData.length}个专业`;
                this.rightTopTitle=`已选择
                <span style="color: blue;font-weight: 700;">${ this.selectedZys.length }</span>个专业填报`;
            }else if(res.data.code===500){
                if(res.data.message){
                    this.$message({message:res.data.message,type:'error'});
                }
                this.filterZyDataLeft=[];
                this.zyData=[];
                this.filterZyData=[];
                this.rightShowCount=0;
                this.leftSelectRows=[];
                this.rightSelectRows=[];
                this.leftTopTitle='';
                this.rightTopTitle='';
                this.selectedZys=[];
            }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
            }else if(res.data.code===0){
                this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
            }else if(res.status===409||res.status===410||res.status===411){
                this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
            }
        }else if(obj.yxxh&&obj.zyz){
            this.zyData=[];
            let zydhs=[];
            if(pc==='6'){
                const yxObj=this.bkCollectYx[obj.index-1];
                for(let i=1;i<=6;i++){
                    console.log(yxObj['zy'+i]);
                    if(yxObj['zy'+i]){
                        zydhs.push(yxObj['zy'+i]);
                    }
                }
            }else if(pc==='7'){
                const yxObj=this.zkCollectYx[obj.index-1];
                for(let i=1;i<=6;i++){
                    if(yxObj['zy'+i]){
                        zydhs.push(yxObj['zy'+i]);
                    }
                }
            }else if(pc==='0'){
                const yxObj=this.bkTqpCollectYx[obj.index-1];
                for(let i=1;i<=6;i++){
                    if(yxObj['zy'+i]){
                        zydhs.push(yxObj['zy'+i]);
                    }
                }
            }else{
                const yxObj=this.zkTqpCollectYx[obj.index-1];
                for(let i=1;i<=6;i++){
                    if(yxObj['zy'+i]){
                        zydhs.push(yxObj['zy'+i]);
                    }
                }
            }
            console.log(zydhs);
            this.selectedZys=zydhs;
            const res=await this.$http.getHttp("/zsjh/getZyByZyz?yxxh="+obj.yxxh+"&zyz="+obj.zyz);
            if(res.data.code===200){
                const data=res.data.obj;
                const zys=[];
                for(let i=0;i<data.length;i++){
                    if(data[i].zydh){
                        zys.push({
                        key:data[i].zydh,
                        title:data[i].zydh+' '+data[i].zymc,
                        description:'',
                        xf:'￥'+data[i].xf+'/年',
                        xh:0,
                        isDisabled:false,
                        isChecked:false
                    });
                    }
                }
                for(let i=0;i<zys.length;i++){
                    for(let j=0;j<zydhs.length;j++){
                        if(zys[i].key===zydhs[j]){
                            zys[i].xh=j+1;
                        }
                    }
                }
                const arr=[];
                for(let i=0;i<zys.length;i++){
                    if(zys[i].xh>0){
                        arr[zys[i].xh-1]=zys[i];
                    }
                }
                const leftRemanentArr=zys.filter((item,index)=>{
                    let flag=true;
                    for(let i=0;i<zydhs.length;i++){
                        if(item.key===zydhs[i]){
                            flag=false;
                            break;
                        }
                    }
                    if(flag){
                        return item;
                    }else{
                        return null;
                    }
                });
                this.filterZyDataLeft=leftRemanentArr.filter(item=>item!==null);
                console.log(arr,zys,this.filterZyDataLeft);
                this.zyData=zys;
                this.filterZyData=arr;
                this.rightShowCount=zydhs.length;
                this.leftSelectRows=[];
                this.rightSelectRows=[];
                this.leftTopTitle=`<span style="color: blue;font-weight: 700;">${this.searchYxmc}</span>
                ${this.searchZyz}组共${this.zyData.length}个专业`;
                this.rightTopTitle=`已选择
                <span style="color: blue;font-weight: 700;">${ this.selectedZys.length }</span>个专业填报`;
            }else if(res.data.code===500){
                if(res.data.message){
                    this.$message({message:res.data.message,type:'error'});
                }
                this.filterZyDataLeft=[];
                this.zyData=[];
                this.filterZyData=[];
                this.rightShowCount=0;
                this.leftSelectRows=[];
                this.rightSelectRows=[];
                this.leftTopTitle='';
                this.rightTopTitle='';
                this.selectedZys=[];
            }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
            }else if(res.data.code===0){
                this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
            }else if(res.status===409||res.status===410||res.status===411){
                this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
            }
        }else{
            this.zyData=[];
        }
        if(obj.selectedZyz!==obj.zyz&&obj.zyz&&obj.selectedZyz){
            this.zyData=[];
            let zydhs=[];
            if(pc==='6'){
                const yxObj=this.bkCollectYx[obj.index-1];
                for(let i=1;i<=6;i++){
                    console.log(yxObj['zy'+i]);
                    if(yxObj['zy'+i]){
                        zydhs.push(yxObj['zy'+i]);
                    }
                }
            }else if(pc==='7'){
                const yxObj=this.zkCollectYx[obj.index-1];
                for(let i=1;i<=6;i++){
                    if(yxObj['zy'+i]){
                        zydhs.push(yxObj['zy'+i]);
                    }
                }
            }else if(pc==='0'){
                const yxObj=this.bkTqpCollectYx[obj.index-1];
                for(let i=1;i<=6;i++){
                    if(yxObj['zy'+i]){
                        zydhs.push(yxObj['zy'+i]);
                    }
                }
            }else{
                const yxObj=this.zkTqpCollectYx[obj.index-1];
                for(let i=1;i<=6;i++){
                    if(yxObj['zy'+i]){
                        zydhs.push(yxObj['zy'+i]);
                    }
                }
            }
            console.log(zydhs);
            this.selectedZys=[];
            const res=await this.$http.getHttp("/zsjh/getZyByZyz?yxxh="+obj.selectedYxxh+"&zyz="+obj.selectedZyz);
            if(res.data.code===200){
                const data=res.data.obj;
                const zys=[];
                for(let i=0;i<data.length;i++){
                    if(data[i].zydh){
                        zys.push({
                        key:data[i].zydh,
                        title:data[i].zydh+' '+data[i].zymc,
                        description:'',
                        xf:'￥'+data[i].xf+'/年',
                        xh:0,
                        isDisabled:false,
                        isChecked:false
                    });
                    }
                }
                for(let i=0;i<zys.length;i++){
                    for(let j=0;j<zydhs.length;j++){
                        if(zys[i].key===zydhs[j]){
                            zys[i].xh=j+1;
                        }
                    }
                }
                const arr=[];
                for(let i=0;i<zys.length;i++){
                    if(zys[i].xh>0){
                        arr[zys[i].xh-1]=zys[i];
                    }
                }
                const leftRemanentArr=zys.filter((item,index)=>{
                    let flag=true;
                    for(let i=0;i<zydhs.length;i++){
                        if(item.key===zydhs[i]){
                            flag=false;
                            break;
                        }
                    }
                    if(flag){
                        return item;
                    }else{
                        return null;
                    }
                });
                this.filterZyDataLeft=leftRemanentArr.filter(item=>item!==null);
                console.log(arr,zys,this.filterZyDataLeft);
                this.zyData=zys;
                this.filterZyData=arr;
                if(arr.length>0){
                    this.selectedZys=zydhs;
                }
                this.rightShowCount=0;
                this.leftSelectRows=[];
                this.rightSelectRows=[];
                this.leftTopTitle=`<span style="color: blue;font-weight: 700;">${this.searchYxmc}</span>
                ${this.searchZyz}组共${this.zyData.length}个专业`;
                this.rightTopTitle=`已选择
                <span style="color: blue;font-weight: 700;">${ this.selectedZys.length }</span>个专业填报`;
            }else if(res.data.code===500){
                if(res.data.message){
                    this.$message({message:res.data.message,type:'error'});
                }
                this.filterZyDataLeft=[];
                this.zyData=[];
                this.filterZyData=[];
                this.rightShowCount=0;
                this.leftSelectRows=[];
                this.rightSelectRows=[];
                this.leftTopTitle='';
                this.rightTopTitle='';
                this.selectedZys=[];
            }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
            }else if(res.data.code===0){
                this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
            }else if(res.status===409||res.status===410||res.status===411){
                this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
            }
        }
        this.dialogZyVisible=true;
    },
    async saveCheckedZy(){
        const pc=this.activePcName;
        if(this.selectedZys.length===0){
            this.$message({message:'请选择好专业',type:'warning',showClose:true});
            return;
        }
        let dqObj={};
        if(pc==='6'){
            const Yxs=[...this.bkCollectYx];
            const index=this.searchIndex-1;
            const zys=this.selectedZys;
            // const yxxh=this.searchYxxh;
            // const zyz=this.searchZyz;
            for(let i=1;i<7;i++){
                Yxs[index]['zy'+i]='';
            }
            for(let i=0;i<zys.length;i++){
                if(zys[i]&&i<=5){
                    Yxs[index]['zy'+(i+1)]=zys[i];
                }
            }
            this.bkCollectYx=Yxs;
            Yxs[index].chooseFlag=true;
            dqObj={...Yxs[index]};
            // this.updateBk=!this.updateBk;
            // const res=await this.$http.getHttp("/zsjh/getZyByZyz?yxxh="+yxxh+"&zyz="+zyz);
            // if(res.data.code===200){
            //     const data=res.data.obj;
            //     const zymcs=[];
            //     for(let i=0;i<zys.length;i++){
            //         for(let j=0;j<data.length;j++){
            //             if(data[j].zydh===zys[i]&&i<=5){
            //                 zymcs.push(data[j].zymc);
            //             }
            //         }
            //     }
            //     Yxs[index].selectedZymcs=zymcs;
            //     this.bkYxPlan=Yxs;
            //     this.updateBk=!this.updateBk;
            // }else if(res.data.code===500){
            // if(res.data.message){
            //     this.$message({message:res.data.message,type:'error'});
            // }
            // }else if(res.status===401){
            // this.$message({message: '登录超时，请重新登录',type:"error"});
            // await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            // this.$router.replace({
            //     path: '/main/home',
            //     query: {redirect: this.$router.currentRoute.fullPath}
            // });
            // }else if(res.data.code===0){
            //     this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            //     await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            //     this.$router.replace({
            //         path: '/main/home',
            //         query: {redirect: this.$router.currentRoute.fullPath}
            //     });
            // }
        }else if(pc==='7'){
            const Yxs=[...this.zkCollectYx];
            const index=this.searchIndex-1;
            const zys=this.selectedZys;
            // const yxxh=this.searchYxxh;
            // const zyz=this.searchZyz;
            for(let i=1;i<7;i++){
                Yxs[index]['zy'+i]='';
            }
            for(let i=0;i<zys.length;i++){
                if(zys[i]&&i<=5){
                    Yxs[index]['zy'+(i+1)]=zys[i];
                }
            }
            Yxs[index].chooseFlag=true;
            this.zkCollectYx=Yxs;
            dqObj={...Yxs[index]};
            // this.updateZk=!this.updateZk;
            // const res=await this.$http.getHttp("/zsjh/getZyByZyz?yxxh="+yxxh+"&zyz="+zyz);
            // if(res.data.code===200){
            //     const data=res.data.obj;
            //     const zymcs=[];
            //     for(let i=0;i<zys.length;i++){
            //         for(let j=0;j<data.length;j++){
            //             if(data[j].zydh===zys[i]&&i<=5){
            //                 zymcs.push(data[j].zymc);
            //             }
            //         }
            //     }
            //     Yxs[index].selectedZymcs=zymcs;
            //     this.zkYxPlan=Yxs;
            //     this.updateZk=!this.updateZk;
            // }else if(res.data.code===500){
            // if(res.data.message){
            //     this.$message({message:res.data.message,type:'error'});
            // }
            // }else if(res.status===401){
            // this.$message({message: '登录超时，请重新登录',type:"error"});
            // await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            // this.$router.replace({
            //     path: '/main/home',
            //     query: {redirect: this.$router.currentRoute.fullPath}
            // });
            // }else if(res.data.code===0){
            //     this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            //     await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            //     this.$router.replace({
            //         path: '/main/home',
            //         query: {redirect: this.$router.currentRoute.fullPath}
            //     });
            // }
        }else if(pc==='0'){
            const Yxs=[...this.bkTqpCollectYx];
            const index=this.searchIndex-1;
            const zys=this.selectedZys;
            // const yxxh=this.searchYxxh;
            // const zyz=this.searchZyz;
            for(let i=1;i<7;i++){
                Yxs[index]['zy'+i]='';
            }
            for(let i=0;i<zys.length;i++){
                if(zys[i]&&i<=5){
                    Yxs[index]['zy'+(i+1)]=zys[i];
                }
            }
            Yxs[index].chooseFlag=true;
            this.bkTqpCollectYx=Yxs;
            dqObj={...Yxs[index]};
            // this.updateBk=!this.updateBk;
            // const res=await this.$http.getHttp("/zsjh/getZyByZyz?yxxh="+yxxh+"&zyz="+zyz);
            // if(res.data.code===200){
            //     const data=res.data.obj;
            //     const zymcs=[];
            //     for(let i=0;i<zys.length;i++){
            //         for(let j=0;j<data.length;j++){
            //             if(data[j].zydh===zys[i]&&i<=5){
            //                 zymcs.push(data[j].zymc);
            //             }
            //         }
            //     }
            //     Yxs[index].selectedZymcs=zymcs;
            //     this.bkYxPlan=Yxs;
            //     this.updateBk=!this.updateBk;
            // }else if(res.data.code===500){
            // if(res.data.message){
            //     this.$message({message:res.data.message,type:'error'});
            // }
            // }else if(res.status===401){
            // this.$message({message: '登录超时，请重新登录',type:"error"});
            // await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            // this.$router.replace({
            //     path: '/main/home',
            //     query: {redirect: this.$router.currentRoute.fullPath}
            // });
            // }else if(res.data.code===0){
            //     this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            //     await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            //     this.$router.replace({
            //         path: '/main/home',
            //         query: {redirect: this.$router.currentRoute.fullPath}
            //     });
            // }
        }else{
            const Yxs=[...this.zkTqpCollectYx];
            const index=this.searchIndex-1;
            const zys=this.selectedZys;
            // const yxxh=this.searchYxxh;
            // const zyz=this.searchZyz;
            for(let i=1;i<7;i++){
                Yxs[index]['zy'+i]='';
            }
            for(let i=0;i<zys.length;i++){
                if(zys[i]&&i<=5){
                    Yxs[index]['zy'+(i+1)]=zys[i];
                }
            }
            Yxs[index].chooseFlag=true;
            this.zkTqpCollectYx=Yxs;
            dqObj={...Yxs[index]};
            // this.updateBk=!this.updateBk;
            // const res=await this.$http.getHttp("/zsjh/getZyByZyz?yxxh="+yxxh+"&zyz="+zyz);
            // if(res.data.code===200){
            //     const data=res.data.obj;
            //     const zymcs=[];
            //     for(let i=0;i<zys.length;i++){
            //         for(let j=0;j<data.length;j++){
            //             if(data[j].zydh===zys[i]&&i<=5){
            //                 zymcs.push(data[j].zymc);
            //             }
            //         }
            //     }
            //     Yxs[index].selectedZymcs=zymcs;
            //     this.bkYxPlan=Yxs;
            //     this.updateBk=!this.updateBk;
            // }else if(res.data.code===500){
            // if(res.data.message){
            //     this.$message({message:res.data.message,type:'error'});
            // }
            // }else if(res.status===401){
            // this.$message({message: '登录超时，请重新登录',type:"error"});
            // await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            // this.$router.replace({
            //     path: '/main/home',
            //     query: {redirect: this.$router.currentRoute.fullPath}
            // });
            // }else if(res.data.code===0){
            //     this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            //     await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            //     this.$router.replace({
            //         path: '/main/home',
            //         query: {redirect: this.$router.currentRoute.fullPath}
            //     });
            // }
        }
        const obj={};
        const zys=this.selectedZys;
        for(let i=0;i<zys.length;i++){
            if(i<=5){
                obj['zy'+(i+1)]=zys[i];
            }
        }
        let params={
            yhid:this.userInfo.yhid,
            yxxh:this.searchYxxh,
            yxmc:this.searchYxmc,
            pc,
            kl:this.userInfo.sxkm,
            zyz:this.searchZyz,
            xm:this.userInfo.xm,
            fs:this.userInfo.gkfs+"",
            xh:"",
            gzsj:"",
            zydh1:obj.zy1?obj.zy1:'',
            zydh2:obj.zy2?obj.zy2:'',
            zydh3:obj.zy3?obj.zy3:'',
            zydh4:obj.zy4?obj.zy4:'',
            zydh5:obj.zy5?obj.zy5:'',
            zydh6:obj.zy6?obj.zy6:''
        };
        if(dqObj.selectedZyz&&dqObj.zyz){
            params={
            yhid:this.userInfo.yhid,
            yxxh:dqObj.yxxh,
            newYxxh:dqObj.selectedYxxh,
            yxmc:this.searchYxmc,
            pc,
            kl:this.userInfo.sxkm,
            zyz:dqObj.zyz,
            newZyz:dqObj.selectedZyz,
            xm:this.userInfo.xm,
            fs:this.userInfo.gkfs+"",
            xh:"",
            gzsj:"",
            zydh1:obj.zy1?obj.zy1:'',
            zydh2:obj.zy2?obj.zy2:'',
            zydh3:obj.zy3?obj.zy3:'',
            zydh4:obj.zy4?obj.zy4:'',
            zydh5:obj.zy5?obj.zy5:'',
            zydh6:obj.zy6?obj.zy6:''
            };
        }else{
            params={
            yhid:this.userInfo.yhid,
            yxxh:this.searchYxxh,
            yxmc:this.searchYxmc,
            pc,
            kl:this.userInfo.sxkm,
            zyz:this.searchZyz,
            xm:this.userInfo.xm,
            fs:this.userInfo.gkfs+"",
            xh:"",
            gzsj:"",
            zydh1:obj.zy1?obj.zy1:'',
            zydh2:obj.zy2?obj.zy2:'',
            zydh3:obj.zy3?obj.zy3:'',
            zydh4:obj.zy4?obj.zy4:'',
            zydh5:obj.zy5?obj.zy5:'',
            zydh6:obj.zy6?obj.zy6:''
            };
        }
            const res=await this.$http.postHttp("/yhgz/saveOrUpdateYhgzyxzyz",params);
            if(res.data.code===200){
            }else if(res.data.code===500){
                if(res.data.message){
                    this.$message({message:res.data.message,type:'error'});
                }
            }else if(res.status===401){
                this.$message({message: '登录超时，请重新登录',type:"error"});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
            }else if(res.data.code===0){
                    this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                    await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                    this.$router.replace({
                        path: '/main/home',
                        query: {redirect: this.$router.currentRoute.fullPath}
                    });
            }else if(res.status===409||res.status===410||res.status===411){
                    this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                    await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                    this.$router.replace({
                        path: '/main/home',
                        query: {redirect: this.$router.currentRoute.fullPath}
                    });
            }
        this.mountedCode();
        this.dialogZyVisible=false;
    },
    async saveMnzyOneTr(){
            let obj={};
            const index2=this.searchIndex-1;
            if(pc=='6'){
                obj={...this.bkCollectYx[index2]};
            }else if(pc=='7'){
                obj={...this.zkCollectYx[index2]};
            }else if(pc=='0'){
                obj={...this.bkTqpCollectYx[index2]};
            }else{
                obj={...this.zkTqpCollectYx[index2]};
            }
            const res=await this.$http.postHttp("/mnzy/updateMnzybOne",obj);
            if(res.data.code==200){

            }else if(res.data.code===500){
                if(res.data.message){
                    this.$message({message:res.data.message,type:'error'});
                }
            }else if(res.status===401){
                this.$message({message: '登录超时，请重新登录',type:"error"});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
            }else if(res.data.code===0){
                    this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                    await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                    this.$router.replace({
                        path: '/main/home',
                        query: {redirect: this.$router.currentRoute.fullPath}
                    });
            }else if(res.status===409||res.status===410||res.status===411){
                    this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                    await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                    this.$router.replace({
                        path: '/main/home',
                        query: {redirect: this.$router.currentRoute.fullPath}
                    });
            }
    },
    closeZyDialog(){
        this.dialogZyVisible=false;
    },
    moveToWhereTr(item,e){
        e.stopPropagation();
        const pc=this.activePcName;
        const dqXh=item.index;
        let xh=0;
        try {
             xh=parseInt(this.moveToTr);
        } catch (error) {
            this.$message({message:"请输入数字"});
            return;
        }
        if(dqXh===xh){
            this.$message({message:"请输入正确的序号",type:'error'});
            return;
        }
        if(item.yxmc){
            if(pc==='6'){
                const bkYxs=[...this.bkCollectYx];
                for(let i=0;i<bkYxs.length;i++){
                    if(bkYxs[i].yxmc&&bkYxs[i].index!==item.index){
                        bkYxs[i].moveTrVisible=false;
                    }
                }
                if(bkYxs[xh-1]&&!(bkYxs[xh-1].yxmc)){
                    this.$message({
                        message:"移动到的地方是空行，请重新输入",
                        type:"warning",
                        showClose:true
                    });
                    return;
                }else if(!bkYxs[xh-1]){
                    this.$message({
                        message:"输入的数字有问题，请重新输入",
                        type:"warning",
                        showClose:true
                    });
                    return;
                }
                const obj=bkYxs[dqXh-1];
                obj.moveTrVisible=false;
                const arr1=this.moveElement(bkYxs,obj,xh-1);
                this.bkCollectYx=arr1;
                this.resetTableIndex();
            }else if(pc==='7'){
                const zkYxs=[...this.zkCollectYx];
                for(let i=0;i<zkYxs.length;i++){
                    if(zkYxs[i].yxmc&&zkYxs[i].index!==item.index){
                        zkYxs[i].moveTrVisible=false;
                    }
                }
                if(zkYxs[xh-1]&&!(zkYxs[xh-1].yxmc)){
                    this.$message({
                        message:"移动到的地方是空行，请重新输入",
                        type:"warning",
                        showClose:true
                    });
                    return;
                }else if(!zkYxs[xh-1]){
                    this.$message({
                        message:"输入的数字有问题，请重新输入",
                        type:"warning",
                        showClose:true
                    });
                    return;
                }
                const obj=zkYxs[dqXh-1];
                obj.moveTrVisible=false;
                const arr1=this.moveElement(zkYxs,obj,xh-1);
                this.zkCollectYx=arr1;
                this.resetTableIndex();
            }else if(pc==='0'){
                const bkYxs=[...this.bkTqpCollectYx];
                for(let i=0;i<bkYxs.length;i++){
                    if(bkYxs[i].yxmc&&bkYxs[i].index!==item.index){
                        bkYxs[i].moveTrVisible=false;
                    }
                }
                if(bkYxs[xh-1]&&!(bkYxs[xh-1].yxmc)){
                    this.$message({
                        message:"移动到的地方是空行，请重新输入",
                        type:"warning",
                        showClose:true
                    });
                    return;
                }else if(!bkYxs[xh-1]){
                    this.$message({
                        message:"输入的数字有问题，请重新输入",
                        type:"warning",
                        showClose:true
                    });
                    return;
                }
                const obj=bkYxs[dqXh-1];
                obj.moveTrVisible=false;
                const arr1=this.moveElement(bkYxs,obj,xh-1);
                this.bkTqpCollectYx=arr1;
                this.resetTableIndex();
            }else if(pc==='9'){
                const zkYxs=[...this.zkTqpCollectYx];
                for(let i=0;i<zkYxs.length;i++){
                    if(zkYxs[i].yxmc&&zkYxs[i].index!==item.index){
                        zkYxs[i].moveTrVisible=false;
                    }
                }
                if(zkYxs[xh-1]&&!(zkYxs[xh-1].yxmc)){
                    this.$message({
                        message:"移动到的地方是空行，请重新输入",
                        type:"warning",
                        showClose:true
                    });
                    return;
                }else if(!zkYxs[xh-1]){
                    this.$message({
                        message:"输入的数字有问题，请重新输入",
                        type:"warning",
                        showClose:true
                    });
                    return;
                }
                const obj=zkYxs[dqXh-1];
                obj.moveTrVisible=false;
                const arr1=this.moveElement(zkYxs,obj,xh-1);
                this.zkTqpCollectYx=arr1;
                this.resetTableIndex();
            }
        }else{
            this.$message({
                message:"当前行是空行，不能换行",
                type:"warning",
                showClose:true
            });
            if(pc==='6'){
                const bkYxs=[...this.bkCollectYx];
                bkYxs[item.index-1].moveTrVisible=false;
                this.bkCollectYx=bkYxs;
            }else if(pc==='7'){
                const zkYxs=[...this.zkCollectYx];
                zkYxs[item.index-1].moveTrVisible=false;
                this.zkCollectYx=zkYxs;
            }else if(pc==='0'){
                const bkYxs=[...this.bkTqpCollectYx];
                bkYxs[item.index-1].moveTrVisible=false;
                this.bkTqpCollectYx=bkYxs;
            }else{
                const zkYxs=[...this.zkTqpCollectYx];
                zkYxs[item.index-1].moveTrVisible=false;
                this.zkTqpCollectYx=zkYxs;
            }
        }
        this.moveToTr='';
    },
    // 移动到特定的某一行
    moveElement(arr,element,newIndex){
        if(arr.includes(element)){
            const currentIndex=arr.indexOf(element);
            const fliterArr=arr.filter((_,index)=>index!==currentIndex);
            fliterArr.splice(newIndex,0,element);
            return fliterArr;
        }
        return arr;
    },
    handleZySelect(sourceSelectedKeys, targetSelectedKeys){
        console.log(sourceSelectedKeys, targetSelectedKeys);
        console.log(this.zyData);
        const selectedZys=this.selectedZys;
        const arr=[];
        for(let i=0;i<selectedZys.length;i++){
            for(let j=0;j<targetSelectedKeys.length;j++){
                if(selectedZys[i]===targetSelectedKeys[j]){
                    arr.push(targetSelectedKeys[j]);
                }
            }
        }
        this.item=[...arr];
        const len=sourceSelectedKeys.length;
        if(len>0){
            this.$message({
                message:'你已经选中了'+len+'个专业',
                type:'success',
                showClose:true
            });
            if(len===6){
                const zyData=[...this.zyData];
                for(let i=0;i<sourceSelectedKeys.length;i++){
                    for(let j=0;j<zyData.length;j++){
                        if(sourceSelectedKeys[i]!==zyData[j].key){
                            if(zyData[j].isChecked){
                                zyData[j].isDisabled=false;
                            }else{
                                zyData[j].isDisabled=true;
                            }
                        }else{
                            zyData[j].isChecked=true;
                            zyData[j].isDisabled=false;
                            continue;
                        }
                    }
                }
                console.log(this.zyData,zyData);
                // this.zyData=[...zyData];
            }else if(len<6){
                const zyData=[...this.zyData];
                for(let i=0;i<zyData.length;i++){
                    const label=zyData[i].title;
                    if(label){
                        zyData[i].isDisabled=false;
                        zyData[i].isChecked=undefined;
                    }
                }
                for(let i=0;i<zyData.length;i++){
                    
                }
                console.log(this.zyData,zyData);
                // this.zyData=[...zyData];
            }
        }
        this.rightShowCount=targetSelectedKeys.length;
    },
    getRowSelection({ disabled, selectedKeys, itemSelectAll, itemSelect }) {
      return {
        getCheckboxProps: item => ({ props: { disabled: disabled || item.disabled } }),
        onSelectAll(selected, selectedRows) {
          const treeSelectedKeys = selectedRows
            .filter(item => !item.disabled)
            .map(({ key }) => key);
            console.log(selected,treeSelectedKeys,selectedKeys);
          const diffKeys = selected
            ? treeSelectedKeys
            : selectedKeys;
          itemSelectAll(diffKeys, selected);
        },
        onSelect({ key }, selected) {
          itemSelect(key, selected);
        },
        selectedRowKeys: selectedKeys,
      };
    },
    clickShowMoveWherePopover(obj){
        const pc=this.activePcName;
        if(pc==='6'){
            const index=obj.index-1;
            const bkYxs=[...this.bkCollectYx];
            for(let i=0;i<bkYxs.length;i++){
                if(bkYxs[i].yxmc&&i!==index){
                    bkYxs[i].moveTrVisible=false;
                }
            }
            bkYxs[index].moveTrVisible=!bkYxs[index].moveTrVisible;
            this.bkCollectYx=bkYxs;
        }else if(pc==='7'){
            const index=obj.index-1;
            const zkYxs=[...this.zkCollectYx];
            for(let i=0;i<zkYxs.length;i++){
                if(zkYxs[i].yxmc&&i!==index){
                    zkYxs[i].moveTrVisible=false;
                }
            }
            zkYxs[index].moveTrVisible=!zkYxs[index].moveTrVisible;
            this.zkCollectYx=zkYxs;
        }else if(pc==='0'){
            const index=obj.index-1;
            const bkYxs=[...this.bkTqpCollectYx];
            for(let i=0;i<bkYxs.length;i++){
                if(bkYxs[i].yxmc&&i!==index){
                    bkYxs[i].moveTrVisible=false;
                }
            }
            bkYxs[index].moveTrVisible=!bkYxs[index].moveTrVisible;
            this.bkTqpCollectYx=bkYxs;
        }else{
            const index=obj.index-1;
            const zkYxs=[...this.zkTqpCollectYx];
            for(let i=0;i<zkYxs.length;i++){
                if(zkYxs[i].yxmc&&i!==index){
                    zkYxs[i].moveTrVisible=false;
                }
            }
            zkYxs[index].moveTrVisible=!zkYxs[index].moveTrVisible;
            this.zkTqpCollectYx=zkYxs;
        }
        this.moveToTr='';
    },
    async clickShowChooseZyzPopover(visible,obj,isNullString=false){
        const pc=this.activePcName;
        const kl=this.userInfo.sxkm;
        const yxxh=obj.selectedYxxh||obj.yxxh;
        console.log(visible);
        console.log(obj);
        if(isNullString||obj.isChangeZyz){
            return;
        }
        if(!yxxh){
            return;
        }
        const res=await this.$http.getHttp("/zsjh/getZyzByYxxh?kl="+kl+"&pc="+pc+"&yxxh="+yxxh);
        if(res.data.code===200){
                const arr=res.data.obj;
                const zyzs=[];
                const index=obj.index-1;
                for(let i=0;i<arr.length;i++){
                    if(arr[i]){
                        zyzs.push({zyz:arr[i]});
                    }
                }
                if(pc==='6'){
                    this.$set(this.bkCollectYx[index],"zyzs",zyzs);
                    if(obj.isChangeZyz){
                        this.$set(this.bkCollectYx[index],"chooseZyzVisible",true);
                        this.$set(this.bkCollectYx[index],"isChangeZyz",false);
                        this.$forceUpdate();
                    }
                }else if(pc==='7'){
                    this.$set(this.zkCollectYx[index],"zyzs",zyzs);
                    if(obj.isChangeZyz){
                        this.$set(this.zkCollectYx[index],"chooseZyzVisible",true);
                        this.$set(this.zkCollectYx[index],"isChangeZyz",false);
                        this.$forceUpdate();
                    }
                }else if(pc==='0'){
                    this.$set(this.bkTqpCollectYx[index],"zyzs",zyzs);
                    if(obj.isChangeZyz){
                        this.$set(this.bkTqpCollectYx[index],"chooseZyzVisible",true);
                        this.$set(this.bkTqpCollectYx[index],"isChangeZyz",false);
                        this.$forceUpdate();
                    }
                }else{
                    this.$set(this.zkTqpCollectYx[index],"zyzs",zyzs);
                    if(obj.isChangeZyz){
                        this.$set(this.zkTqpCollectYx[index],"chooseZyzVisible",true);
                        this.$set(this.zkTqpCollectYx[index],"isChangeZyz",false);
                        this.$forceUpdate();
                    }
                }
        }else if(res.data.code===500){
            if(res.data.message){
                this.$message({message:res.data.message,type:'error'});
            }
        }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.data.code===0){
                this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
        }else if(res.status===409||res.status===410||res.status===411){
                this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:"warning"});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
        }
        if(pc==='6'){
            const index=obj.index-1;
            const bkYxs=[...this.bkCollectYx];
            for(let i=0;i<bkYxs.length;i++){
                if((bkYxs[i].yxmc||bkYxs[i].submitYxmc)&&i!==index){
                    bkYxs[i].chooseZyzVisible=false;
                }
            }
            for(let i=0;i<bkYxs.length;i++){
                if(bkYxs[i]){
                    bkYxs[i].inputSbVisible=false;
                    bkYxs[i].chooseYxxhVisible=false;
                }
            }
            {/* bkYxs[index].chooseZyzVisible=!bkYxs[index].chooseZyzVisible; */}
            bkYxs[index].chooseZyzVisible=true;
            this.bkCollectYx=bkYxs;
            console.log("9688:",this.bkCollectYx[index]);
        }else if(pc==='7'){
            const index=obj.index-1;
            const zkYxs=[...this.zkCollectYx];
            for(let i=0;i<zkYxs.length;i++){
                if(zkYxs[i].yxmc&&i!==index){
                    zkYxs[i].chooseZyzVisible=false;
                }
            }
            for(let i=0;i<zkYxs.length;i++){
                if(zkYxs[i]){
                    zkYxs[i].inputSbVisible=false;
                    zkYxs[i].chooseYxxhVisible=false;
                }
            }
            {/* zkYxs[index].chooseZyzVisible=!zkYxs[index].chooseZyzVisible; */}
            zkYxs[index].chooseZyzVisible=true;
            this.zkCollectYx=zkYxs;
        }else if(pc==='0'){
            const index=obj.index-1;
            const bkYxs=[...this.bkTqpCollectYx];
            for(let i=0;i<bkYxs.length;i++){
                if(bkYxs[i].yxmc&&i!==index){
                    bkYxs[i].chooseZyzVisible=false;
                }
            }
            for(let i=0;i<bkYxs.length;i++){
                if(bkYxs[i]){
                    bkYxs[i].inputSbVisible=false;
                    bkYxs[i].chooseYxxhVisible=false;
                }
            }
            {/* bkYxs[index].chooseZyzVisible=!bkYxs[index].chooseZyzVisible; */}
            bkYxs[index].chooseZyzVisible=true;
            this.bkTqpCollectYx=bkYxs;
        }else{
            const index=obj.index-1;
            const zkYxs=[...this.zkTqpCollectYx];
            for(let i=0;i<zkYxs.length;i++){
                if(zkYxs[i].yxmc&&i!==index){
                    zkYxs[i].chooseZyzVisible=false;
                }
            }
            for(let i=0;i<zkYxs.length;i++){
                if(zkYxs[i]){
                    zkYxs[i].inputSbVisible=false;
                    zkYxs[i].chooseYxxhVisible=false;
                }
            }
            {/* zkYxs[index].chooseZyzVisible=!zkYxs[index].chooseZyzVisible; */}
            zkYxs[index].chooseZyzVisible=true;
            this.zkTqpCollectYx=zkYxs;
        }
    },
    async clickShowInputSbPopover(e,obj){
        console.log(obj);
        const pc=this.activePcName;
        if(pc==='6'){
            const index=obj.index-1;
            const bkYxs=[...this.bkCollectYx];
            for(let i=0;i<bkYxs.length;i++){
                if(bkYxs[i].yxmc&&i!==index){
                    bkYxs[i].inputSbVisible=false;
                }
            }
            for(let i=0;i<bkYxs.length;i++){
                if(bkYxs[i]){
                    bkYxs[i].chooseYxxhVisible=false;
                    bkYxs[i].chooseZyzVisible=false;
                }
            }
            bkYxs[index].inputSbVisible=!bkYxs[index].inputSbVisible;
            if(bkYxs[index].inputSbVisible===false){
                bkYxs[index].submitSb=bkYxs[index].writeSb;
            }
            if(bkYxs[index].sb!==bkYxs[index].writeSb){
                bkYxs[index].isSaveTr=false;
            }
            this.bkCollectYx=bkYxs;
        }else if(pc==='7'){
            const index=obj.index-1;
            const zkYxs=[...this.zkCollectYx];
            for(let i=0;i<zkYxs.length;i++){
                if(zkYxs[i].yxmc&&i!==index){
                    zkYxs[i].inputSbVisible=false;
                }
            }
            for(let i=0;i<zkYxs.length;i++){
                if(zkYxs[i]){
                    zkYxs[i].chooseYxxhVisible=false;
                    zkYxs[i].chooseZyzVisible=false;
                }
            }
            zkYxs[index].inputSbVisible=!zkYxs[index].inputSbVisible;
            if(zkYxs[index].inputSbVisible===false){
                zkYxs[index].submitSb=zkYxs[index].writeSb;
            }
            if(zkYxs[index].sb!==zkYxs[index].writeSb){
                zkYxs[index].isSaveTr=false;
            }
            this.zkCollectYx=zkYxs;
        }else if(pc==='0'){
            const index=obj.index-1;
            const bkYxs=[...this.bkTqpCollectYx];
            for(let i=0;i<bkYxs.length;i++){
                if(bkYxs[i].yxmc&&i!==index){
                    bkYxs[i].inputSbVisible=false;
                }
            }
            for(let i=0;i<bkYxs.length;i++){
                if(bkYxs[i]){
                    bkYxs[i].chooseYxxhVisible=false;
                    bkYxs[i].chooseZyzVisible=false;
                }
            }
            bkYxs[index].inputSbVisible=!bkYxs[index].inputSbVisible;
            if(bkYxs[index].inputSbVisible===false){
                bkYxs[index].submitSb=bkYxs[index].writeSb;
            }
            if(bkYxs[index].sb!==bkYxs[index].writeSb){
                bkYxs[index].isSaveTr=false;
            }
            this.bkTqpCollectYx=bkYxs;
        }else{
            const index=obj.index-1;
            const zkYxs=[...this.zkTqpCollectYx];
            for(let i=0;i<zkYxs.length;i++){
                if(zkYxs[i].yxmc&&i!==index){
                    zkYxs[i].inputSbVisible=false;
                }
            }
            for(let i=0;i<zkYxs.length;i++){
                if(zkYxs[i]){
                    zkYxs[i].chooseYxxhVisible=false;
                    zkYxs[i].chooseZyzVisible=false;
                }
            }
            zkYxs[index].inputSbVisible=!zkYxs[index].inputSbVisible;
            if(zkYxs[index].inputSbVisible===false){
                zkYxs[index].submitSb=zkYxs[index].writeSb;
            }
            if(zkYxs[index].sb!==zkYxs[index].writeSb){
                zkYxs[index].isSaveTr=false;
            }
            this.zkTqpCollectYx=zkYxs;
        }
    },
    async clickShowChooseYxxhPopover(visible,obj,isNullString=false){
        console.log(visible);
        console.log(obj);
        const pc=this.activePcName;
        const sb=obj.writeSb||obj.sb;
        const index=obj.index-1;
        if(isNullString||obj.isChangeYxxh){
            return;
        }
        if(!sb){
            return;
        }
        this.$store.commit('initIsUpdateToken');
        const res=await this.$http.getHttp("/dxk/getYxBySb?sb="+sb);
        if(res.data.code===200){
            const arr=[...res.data.obj];
            if(pc==='6'){
                let isHaveFlag=false;
                for(let i=0;i<arr.length;i++){
                    if(arr[i].yxxh===obj.selectedYxxh){
                        isHaveFlag=true;
                        break;
                    }
                }
                if(obj.selectedYxxh.indexOf(obj.submitSb)>=0&&!isHaveFlag){
                    arr.push({sb:obj.writeSb||obj.sb,yxmc:obj.submitYxmc||obj.yxmc,
                        yxxh:obj.selectedYxxh||obj.yxxh});
                }
                this.$set(this.bkCollectYx[index],"yxmcs",arr);
                if(obj.isChangeYxxh){
                    this.$set(this.bkCollectYx[index],"chooseYxxhVisible",true);
                    this.$set(this.bkCollectYx[index],"isChangeYxxh",false);
                    this.$forceUpdate();
                }
            }else if(pc==='7'){
                let isHaveFlag=false;
                for(let i=0;i<arr.length;i++){
                    if(arr[i].yxxh===obj.selectedYxxh){
                        isHaveFlag=true;
                        break;
                    }
                }
                if(obj.selectedYxxh.indexOf(obj.submitSb)>=0&&!isHaveFlag){
                    arr.push({sb:obj.writeSb||obj.sb,yxmc:obj.submitYxmc||obj.yxmc,
                        yxxh:obj.selectedYxxh||obj.yxxh});
                }
                this.$set(this.zkCollectYx[index],"yxmcs",arr);
                if(obj.isChangeYxxh){
                    this.$set(this.zkCollectYx[index],"chooseYxxhVisible",true);
                    this.$set(this.zkCollectYx[index],"isChangeYxxh",false);
                    this.$forceUpdate();
                }
            }else if(pc==='0'){
                let isHaveFlag=false;
                for(let i=0;i<arr.length;i++){
                    if(arr[i].yxxh===obj.selectedYxxh){
                        isHaveFlag=true;
                        break;
                    }
                }
                if(obj.selectedYxxh.indexOf(obj.submitSb)>=0&&!isHaveFlag){
                    arr.push({sb:obj.writeSb||obj.sb,yxmc:obj.submitYxmc||obj.yxmc,
                        yxxh:obj.selectedYxxh||obj.yxxh});
                }
                this.$set(this.bkTqpCollectYx[index],"yxmcs",arr);
                if(obj.isChangeYxxh){
                    this.$set(this.bkTqpCollectYx[index],"chooseYxxhVisible",true);
                    this.$set(this.bkTqpCollectYx[index],"isChangeYxxh",false);
                    this.$forceUpdate();
                }
            }else{
                let isHaveFlag=false;
                for(let i=0;i<arr.length;i++){
                    if(arr[i].yxxh===obj.selectedYxxh){
                        isHaveFlag=true;
                        break;
                    }
                }
                if(obj.selectedYxxh.indexOf(obj.submitSb)>=0&&!isHaveFlag){
                    arr.push({sb:obj.writeSb||obj.sb,yxmc:obj.submitYxmc||obj.yxmc,
                        yxxh:obj.selectedYxxh||obj.yxxh});
                }
                this.$set(this.zkTqpCollectYx[index],"yxmcs",arr);
                if(obj.isChangeYxxh){
                    this.$set(this.zkTqpCollectYx[index],"chooseYxxhVisible",true);
                    this.$set(this.zkTqpCollectYx[index],"isChangeYxxh",false);
                    this.$forceUpdate();
                }
            }
        }else if(res.data.code===500){
            if(res.data.message){
                this.$message({message:res.data.message,type:'error'});
            }
        }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.data.code===0){
                this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
        }else if(res.status===409||res.status===410||res.status===411){
                this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:"warning"});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
        }
        if(pc==='6'){
            const index=obj.index-1;
            const bkYxs=[...this.bkCollectYx];
            for(let i=0;i<bkYxs.length;i++){
                if(bkYxs[i].yxmc&&i!==index){
                    bkYxs[i].chooseYxxhVisible=false;
                }
            }
            for(let i=0;i<bkYxs.length;i++){
                if(bkYxs[i]){
                    bkYxs[i].inputSbVisible=false;
                    bkYxs[i].chooseZyzVisible=false;
                }
            }
            // bkYxs[index].chooseYxxhVisible=!bkYxs[index].chooseYxxhVisible;
            bkYxs[index].chooseYxxhVisible=true;
            this.bkCollectYx=bkYxs;
        }else if(pc==='7'){
            const index=obj.index-1;
            const zkYxs=[...this.zkCollectYx];
            for(let i=0;i<zkYxs.length;i++){
                if(zkYxs[i].yxmc&&i!==index){
                    zkYxs[i].chooseYxxhVisible=false;
                }
            }
            for(let i=0;i<zkYxs.length;i++){
                if(zkYxs[i]){
                    zkYxs[i].inputSbVisible=false;
                    zkYxs[i].chooseZyzVisible=false;
                }
            }
            // zkYxs[index].chooseYxxhVisible=!zkYxs[index].chooseYxxhVisible;
            zkYxs[index].chooseYxxhVisible=true;
            this.zkCollectYx=zkYxs;
        }else if(pc==='0'){
            const index=obj.index-1;
            const bkYxs=[...this.bkTqpCollectYx];
            for(let i=0;i<bkYxs.length;i++){
                if(bkYxs[i].yxmc&&i!==index){
                    bkYxs[i].chooseYxxhVisible=false;
                }
            }
            for(let i=0;i<bkYxs.length;i++){
                if(bkYxs[i]){
                    bkYxs[i].inputSbVisible=false;
                    bkYxs[i].chooseZyzVisible=false;
                }
            }
            // bkYxs[index].chooseYxxhVisible=!bkYxs[index].chooseYxxhVisible;
            bkYxs[index].chooseYxxhVisible=true;
            this.bkTqpCollectYx=bkYxs;
        }else{
            const index=obj.index-1;
            const zkYxs=[...this.zkTqpCollectYx];
            for(let i=0;i<zkYxs.length;i++){
                if(zkYxs[i].yxmc&&i!==index){
                    zkYxs[i].chooseYxxhVisible=false;
                }
            }
            for(let i=0;i<zkYxs.length;i++){
                if(zkYxs[i]){
                    zkYxs[i].inputSbVisible=false;
                    zkYxs[i].chooseZyzVisible=false;
                }
            }
            // zkYxs[index].chooseYxxhVisible=!zkYxs[index].chooseYxxhVisible;
            zkYxs[index].chooseYxxhVisible=true;
            this.zkTqpCollectYx=zkYxs;
        }
    },
    changeSelectedZyz(zyz,obj){
        const index=obj.index-1;
        const pc=this.activePcName;
        if(pc==='6'){
            this.$set(this.bkCollectYx[index],"selectedZyz",zyz);
            this.$set(this.bkCollectYx[index],"submitZyz",zyz);
            this.$set(this.bkCollectYx[index],"isChangeZyz",true);
            this.$set(this.bkCollectYx[index],'isSaveTr',false);
            this.$set(this.bkCollectYx[index],'zy1','');
            this.$set(this.bkCollectYx[index],'zy2','');
            this.$set(this.bkCollectYx[index],'zy3','');
            this.$set(this.bkCollectYx[index],'zy4','');
            this.$set(this.bkCollectYx[index],'zy5','');
            this.$set(this.bkCollectYx[index],'zy6','');
            this.$forceUpdate();
        }else if(pc==='7'){
            this.$set(this.zkCollectYx[index],"selectedZyz",zyz);
            this.$set(this.zkCollectYx[index],"submitZyz",zyz);
            this.$set(this.zkCollectYx[index],"isChangeZyz",true);
            this.$set(this.zkCollectYx[index],'isSaveTr',false);
            this.$set(this.zkCollectYx[index],'zy1','');
            this.$set(this.zkCollectYx[index],'zy2','');
            this.$set(this.zkCollectYx[index],'zy3','');
            this.$set(this.zkCollectYx[index],'zy4','');
            this.$set(this.zkCollectYx[index],'zy5','');
            this.$set(this.zkCollectYx[index],'zy6','');
            this.$forceUpdate();
        }else if(pc==='0'){
            this.$set(this.bkTqpCollectYx[index],"selectedZyz",zyz);
            this.$set(this.bkTqpCollectYx[index],"submitZyz",zyz);
            this.$set(this.bkTqpCollectYx[index],"isChangeZyz",true);
            this.$set(this.bkTqpCollectYx[index],'isSaveTr',false);
            this.$set(this.bkTqpCollectYx[index],'zy1','');
            this.$set(this.bkTqpCollectYx[index],'zy2','');
            this.$set(this.bkTqpCollectYx[index],'zy3','');
            this.$set(this.bkTqpCollectYx[index],'zy4','');
            this.$set(this.bkTqpCollectYx[index],'zy5','');
            this.$set(this.bkTqpCollectYx[index],'zy6','');
            this.$forceUpdate();
        }else{
            this.$set(this.zkTqpCollectYx[index],"selectedZyz",zyz);
            this.$set(this.zkTqpCollectYx[index],"submitZyz",zyz);
            this.$set(this.zkTqpCollectYx[index],"isChangeZyz",true);
            this.$set(this.zkTqpCollectYx[index],'isSaveTr',false);
            this.$set(this.zkTqpCollectYx[index],'zy1','');
            this.$set(this.zkTqpCollectYx[index],'zy2','');
            this.$set(this.zkTqpCollectYx[index],'zy3','');
            this.$set(this.zkTqpCollectYx[index],'zy4','');
            this.$set(this.zkTqpCollectYx[index],'zy5','');
            this.$set(this.zkTqpCollectYx[index],'zy6','');
            this.$forceUpdate();
        }
    },
    changeTabSb(sb,obj){
        console.log(sb);
        const index=obj.index-1;
        const pc=this.activePcName;
        if(pc==='6'){
            this.$set(this.bkCollectYx[index],"writeSb",sb);
            this.$forceUpdate();
        }else if(pc==='7'){
            this.$set(this.zkCollectYx[index],"writeSb",sb);
            this.$forceUpdate();
        }else if(pc==='0'){
            this.$set(this.bkTqpCollectYx[index],"writeSb",sb);
            this.$forceUpdate();
        }else{
            this.$set(this.zkTqpCollectYx[index],"writeSb",sb);
            this.$forceUpdate();
        }
    },
    setSbNoSave(sb,obj){
        console.log(sb);
        const index=obj.index-1;
        const pc=this.activePcName;
        if(pc==='6'){
            this.$set(this.bkCollectYx[index],"isSaveTr",false);
            this.$forceUpdate();
        }else if(pc==='7'){
            this.$set(this.zkCollectYx[index],"isSaveTr",false);
            this.$forceUpdate();
        }else if(pc==='0'){
            this.$set(this.bkTqpCollectYx[index],"isSaveTr",false);
            this.$forceUpdate();
        }else{
            this.$set(this.zkTqpCollectYx[index],"isSaveTr",false);
            this.$forceUpdate();
        }
    },
    changeSelectedYxxh(yxxh,obj){
        const index=obj.index-1;
        const pc=this.activePcName;
        console.log(pc);
        if(pc==='6'){
            this.$set(this.bkCollectYx[index],"selectedYxxh",yxxh);
            const yxmcObj=this.bkCollectYx[index].yxmcs.find((item)=>{
                return item.yxxh===yxxh;
            });
            console.log(yxmcObj);
            this.$set(this.bkCollectYx[index],"submitYxmc",yxmcObj.yxmc||'');
            this.$set(this.bkCollectYx[index],"isChangeYxxh",true);
            this.$set(this.bkCollectYx[index],"isSaveTr",false);
            this.$forceUpdate();
        }else if(pc==='7'){
            this.$set(this.zkCollectYx[index],"selectedYxxh",yxxh);
            const yxmcObj=this.zkCollectYx[index].yxmcs.find((item)=>{
                return item.yxxh===yxxh;
            });
            this.$set(this.zkCollectYx[index],"submitYxmc",yxmcObj.yxmc||'');
            this.$set(this.zkCollectYx[index],"isChangeYxxh",true);
            this.$set(this.zkCollectYx[index],"isSaveTr",false);
            this.$forceUpdate();
        }else if(pc==='0'){
            this.$set(this.bkTqpCollectYx[index],"selectedYxxh",yxxh);
            const yxmcObj=this.bkTqpCollectYx[index].yxmcs.find((item)=>{
                return item.yxxh===yxxh;
            });
            this.$set(this.bkTqpCollectYx[index],"submitYxmc",yxmcObj.yxmc||'');
            this.$set(this.bkTqpCollectYx[index],"isChangeYxxh",true);
            this.$set(this.bkTqpCollectYx[index],"isSaveTr",false);
            this.$forceUpdate();
        }else{
            this.$set(this.zkTqpCollectYx[index],"selectedYxxh",yxxh);
            const yxmcObj=this.zkTqpCollectYx[index].yxmcs.find((item)=>{
                return item.yxxh===yxxh;
            });
            this.$set(this.zkTqpCollectYx[index],"submitYxmc",yxmcObj.yxmc||'');
            this.$set(this.zkTqpCollectYx[index],"isChangeYxxh",true);
            this.$set(this.zkTqpCollectYx[index],"isSaveTr",false);
            this.$forceUpdate();
        }
    },
    async submitUpdateZyz(obj){
        const pc=this.activePcName;
        const index=obj.index-1;
        let list=[];
        if(pc==='6'){
            list=[...this.bkCollectYx];
        }else if(pc=='7'){
            list=[...this.zkCollectYx];
        }else if(pc==='0'){
            list=[...this.bkTqpCollectYx];
        }else{
            list=[...this.zkTqpCollectYx];
        }
        let param={};
        if(obj.zyz){
            param={
                    yhid:this.userInfo.yhid,
                    yxxh:obj.yxxh,
                    newYxxh:obj.selectedYxxh,
                    yxmc:obj.yxmc,
                    pc,
                    kl:this.userInfo.sxkm,
                    zyz:obj.zyz,
                    newZyz:obj.selectedZyz,
                    xm:this.userInfo.xm,
                    fs:this.userInfo.gkfs+"",
                    xh:"",
                    gzsj:"",
                    zydh1:list[index].zy1?list[index].zy1:'',
                    zydh2:list[index].zy2?list[index].zy2:'',
                    zydh3:list[index].zy3?list[index].zy3:'',
                    zydh4:list[index].zy4?list[index].zy4:'',
                    zydh5:list[index].zy5?list[index].zy5:'',
                    zydh6:list[index].zy6?list[index].zy6:''
            };
        }else{
            param={
                    yhid:this.userInfo.yhid,
                    yxxh:obj.selectedYxxh,
                    yxmc:obj.submitYxmc,
                    pc,
                    kl:this.userInfo.sxkm,
                    zyz:obj.selectedZyz,
                    xm:this.userInfo.xm,
                    fs:this.userInfo.gkfs+"",
                    xh:"",
                    gzsj:"",
                    zydh1:list[index].zy1?list[index].zy1:'',
                    zydh2:list[index].zy2?list[index].zy2:'',
                    zydh3:list[index].zy3?list[index].zy3:'',
                    zydh4:list[index].zy4?list[index].zy4:'',
                    zydh5:list[index].zy5?list[index].zy5:'',
                    zydh6:list[index].zy6?list[index].zy6:''
            };
        }
        if(!obj.selectedZyz){
            this.$message({
                message:"请选择专业组",
                type:'warning',
                showClose:true
            });
            return;
        }else if(obj.selectedZyz&&obj.zyzs&&obj.zyzs.length===0){
            this.$message({
                message:"专业组与院校不匹配,请检查两者是否匹配",
                type:"warning",
                showClose:true
            });
            return;
        }else if(obj.selectedZyz&&obj.zyzs&&obj.zyzs.length>0){
            const findObj=obj.zyzs.find(item=>{
                return item.zyz===obj.selectedZyz;
            });
            console.log('findObj',findObj);
            if(!findObj){      
                this.$message({
                    message:"专业组与院校不匹配,请检查两者是否匹配",
                    type:"warning",
                    showClose:true
                });
                return;
            }
        }
        const res=await this.$http.postHttp("/yhgz/saveOrUpdateYhgzyxzyz",param);
        if(res.data.code===200){
            if(pc==='6'){
                this.$set(this.bkCollectYx[index],"chooseZyzVisible",false);
                this.$forceUpdate();
            }else if(pc==='7'){
                this.$set(this.zkCollectYx[index],"chooseZyzVisible",false);
                this.$forceUpdate();
            }else if(pc==='0'){
                this.$set(this.bkTqpCollectYx[index],"chooseZyzVisible",false);
                this.$forceUpdate();
            }else{
                this.$set(this.zkTqpCollectYx[index],"chooseZyzVisible",false);
                this.$forceUpdate();
            }
            await this.mountedCode();
        }else if(res.data.code===500){
                    if(res.data.message){
                        this.$message({message:res.data.message,type:'error'});
                    }
            if(pc==='6'){
                this.$set(this.bkCollectYx[index],"isSaveTr",false);
                this.$forceUpdate();
            }else if(pc==='7'){
                this.$set(this.zkCollectYx[index],"isSaveTr",false);
                this.$forceUpdate();
            }else if(pc==='0'){
                this.$set(this.bkTqpCollectYx[index],"isSaveTr",false);
                this.$forceUpdate();
            }else{
                this.$set(this.zkTqpCollectYx[index],"isSaveTr",false);
                this.$forceUpdate();
            }
        }else if(res.status===401){
                    this.$message({message: '登录超时，请重新登录',type:"error"});
                    await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                    this.$router.replace({
                        path: '/main/home',
                        query: {redirect: this.$router.currentRoute.fullPath}
                    });
        }else if(res.data.code===0){
                        this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                        await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                        this.$router.replace({
                            path: '/main/home',
                            query: {redirect: this.$router.currentRoute.fullPath}
                        });
        }else if(res.status===409||res.status===410||res.status===411){
                        this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                        await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                        this.$router.replace({
                            path: '/main/home',
                            query: {redirect: this.$router.currentRoute.fullPath}
                        });
        }
    },
    async submitUpdateYxxh(obj){
        const pc=this.activePcName;
        const kl=this.userInfo.sxkm;
        const yxxh=obj.selectedYxxh;
        console.log(obj);
        if(!yxxh){
            this.$message({
                message:"请选择院校",
                type:'warning',
                showClose:true
            });
            return;
        }
        const res=await this.$http.getHttp("/zsjh/getZyzByYxxh?kl="+kl+"&pc="+pc+"&yxxh="+yxxh);
        if(res.data.code===200){
                const arr=res.data.obj;
                const zyzs=[];
                const index=obj.index-1;
                for(let i=0;i<arr.length;i++){
                    if(arr[i]){
                        zyzs.push({zyz:arr[i]});
                    }
                }
                if(pc==='6'){
                    const yxmcObj=this.bkCollectYx[index].yxmcs.find(item=>item.yxxh===yxxh);
                    this.$set(this.bkCollectYx[index],'submitYxmc',yxmcObj.yxmc);
                    this.$set(this.bkCollectYx[index],"zyzs",zyzs);
                    this.$set(this.bkCollectYx[index],"selectedZyz","");
                    this.$set(this.bkCollectYx[index],"chooseYxxhVisible",false);
                    this.$set(this.bkCollectYx[index],"chooseZyzVisible",true);
                    this.$set(this.bkCollectYx[index],"isChangeZyz",false);
                    this.$set(this.bkCollectYx[index],"isSaveTr",false);
                    this.$forceUpdate();
                    // this.bkCollectYx=[...this.bkCollectYx];
                    // this.$refs['editZyz'+obj.index].$el.click();
                    // this.bkZyzUpdateKey=!this.bkZyzUpdateKey;
                }else if(pc==='7'){
                    const yxmcObj=this.zkCollectYx[index].yxmcs.find(item=>item.yxxh===yxxh);
                    this.$set(this.zkCollectYx[index],'submitYxmc',yxmcObj.yxmc);
                    this.$set(this.zkCollectYx[index],"zyzs",zyzs);
                    this.$set(this.zkCollectYx[index],"selectedZyz","");
                    this.$set(this.zkCollectYx[index],"chooseYxxhVisible",false);
                    this.$set(this.zkCollectYx[index],"chooseZyzVisible",true);
                    this.$set(this.zkCollectYx[index],"isChangeZyz",false);
                    this.$set(this.zkCollectYx[index],"isSaveTr",false);
                    this.$forceUpdate();
                }else if(pc==='0'){
                    const yxmcObj=this.bkTqpCollectYx[index].yxmcs.find(item=>item.yxxh===yxxh);
                    this.$set(this.bkTqpCollectYx[index],'submitYxmc',yxmcObj.yxmc);
                    this.$set(this.bkTqpCollectYx[index],"zyzs",zyzs);
                    this.$set(this.bkTqpCollectYx[index],"selectedZyz","");
                    this.$set(this.bkTqpCollectYx[index],"chooseYxxhVisible",false);
                    this.$set(this.bkTqpCollectYx[index],"chooseZyzVisible",true);
                    this.$set(this.bkTqpCollectYx[index],"isChangeZyz",false);
                    this.$set(this.bkTqpCollectYx[index],"isSaveTr",false);
                    this.$forceUpdate();
                }else{
                    const yxmcObj=this.zkTqpCollectYx[index].yxmcs.find(item=>item.yxxh===yxxh);
                    this.$set(this.zkTqpCollectYx[index],'submitYxmc',yxmcObj.yxmc);
                    this.$set(this.zkTqpCollectYx[index],"zyzs",zyzs);
                    this.$set(this.zkTqpCollectYx[index],"selectedZyz","");
                    this.$set(this.zkTqpCollectYx[index],"chooseYxxhVisible",false);
                    this.$set(this.zkTqpCollectYx[index],"chooseZyzVisible",true);
                    this.$set(this.zkTqpCollectYx[index],"isChangeZyz",false);
                    this.$set(this.zkTqpCollectYx[index],"isSaveTr",false);
                    this.$forceUpdate();
                }
        }else if(res.data.code===500){
            if(res.data.message){
                this.$message({message:res.data.message,type:'error'});
            }
                const index=obj.index-1;
                if(pc==='6'){
                    const yxmcObj=this.bkCollectYx[index].yxmcs.find(item=>item.yxxh===yxxh);
                    this.$set(this.bkCollectYx[index],'submitYxmc',yxmcObj.yxmc);
                    this.$set(this.bkCollectYx[index],"zyzs",[]);
                    this.$set(this.bkCollectYx[index],"isSaveTr",false);
                    this.$forceUpdate();
                    // this.bkCollectYx=[...this.bkCollectYx];
                    // this.$refs['editZyz'+obj.index].$el.click();
                    // this.bkZyzUpdateKey=!this.bkZyzUpdateKey;
                }else if(pc==='7'){
                    const yxmcObj=this.zkCollectYx[index].yxmcs.find(item=>item.yxxh===yxxh);
                    this.$set(this.zkCollectYx[index],'submitYxmc',yxmcObj.yxmc);
                    this.$set(this.zkCollectYx[index],"zyzs",[]);
                    this.$set(this.zkCollectYx[index],"isSaveTr",false);
                    this.$forceUpdate();
                }else if(pc==='0'){
                    const yxmcObj=this.bkTqpCollectYx[index].yxmcs.find(item=>item.yxxh===yxxh);
                    this.$set(this.bkTqpCollectYx[index],'submitYxmc',yxmcObj.yxmc);
                    this.$set(this.bkTqpCollectYx[index],"zyzs",[]);
                    this.$set(this.bkTqpCollectYx[index],"isSaveTr",false);
                    this.$forceUpdate();
                }else{
                    const yxmcObj=this.zkTqpCollectYx[index].yxmcs.find(item=>item.yxxh===yxxh);
                    this.$set(this.zkTqpCollectYx[index],'submitYxmc',yxmcObj.yxmc);
                    this.$set(this.zkTqpCollectYx[index],"zyzs",[]);
                    this.$set(this.zkTqpCollectYx[index],"isSaveTr",false);
                    this.$forceUpdate();
                }
        }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.data.code===0){
                this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
        }else if(res.status===409||res.status===410||res.status===411){
                this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:"warning"});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
        }
    },
    async submitUpdateSb(obj){
        if(!(obj.writeSb)||(obj.writeSb.length<4)||(obj.writeSb.length>4)){
            this.$message({
                message:"请输入正确的院校代码",
                type:'warning',
                showClose:true
            });
            return;
        }
        const index=obj.index-1;
        const pc=this.activePcName;
        const res=await this.$http.getHttp("/dxk/getYxBySb?sb="+obj.writeSb);
        if(res.data.code===200){
                    const arr=[...res.data.obj];
                    if(pc==='6'){
                        this.$set(this.bkCollectYx[index],"yxmcs",arr);
                        this.$set(this.bkCollectYx[index],"submitSb",obj.writeSb);
                        this.$set(this.bkCollectYx[index],"selectedYxxh","");
                        this.$set(this.bkCollectYx[index],"isSaveTr",false);
                        this.$forceUpdate();
                    }else if(pc==='7'){
                        this.$set(this.zkCollectYx[index],"yxmcs",arr);
                        this.$set(this.zkCollectYx[index],"submitSb",obj.writeSb);
                        this.$set(this.zkCollectYx[index],"selectedYxxh","");
                        this.$set(this.zkCollectYx[index],"isSaveTr",false);
                        this.$forceUpdate();
                    }else if(pc==='0'){
                        this.$set(this.bkTqpCollectYx[index],"yxmcs",arr);
                        this.$set(this.bkTqpCollectYx[index],"submitSb",obj.writeSb);
                        this.$set(this.bkTqpCollectYx[index],"selectedYxxh","");
                        this.$set(this.bkTqpCollectYx[index],"isSaveTr",false);
                        this.$forceUpdate();
                    }else{
                        this.$set(this.zkTqpCollectYx[index],"yxmcs",arr);
                        this.$set(this.zkTqpCollectYx[index],"submitSb",obj.writeSb);
                        this.$set(this.zkTqpCollectYx[index],"selectedYxxh","");
                        this.$set(this.zkTqpCollectYx[index],"isSaveTr",false);
                        this.$forceUpdate();
                    }
        }else if(res.data.code===500){
                if(res.data.message){
                    this.$message({message:res.data.message,type:'error'});
                    return;
                }
                // if(pc==='6'){
                //         this.$set(this.bkCollectYx[index],"isSaveTr",false);
                //         this.$forceUpdate();
                // }else if(pc==='7'){
                //         this.$set(this.zkCollectYx[index],"isSaveTr",false);
                //         this.$forceUpdate();
                // }else if(pc==='0'){
                //         this.$set(this.bkTqpCollectYx[index],"isSaveTr",false);
                //         this.$forceUpdate();
                // }else{
                //         this.$set(this.zkTqpCollectYx[index],"isSaveTr",false);
                //         this.$forceUpdate();
                // }
        }else if(res.status===401){
                this.$message({message: '登录超时，请重新登录',type:"error"});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
                    return;
        }else if(res.data.code===0){
                    this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                    await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                    this.$router.replace({
                        path: '/main/home',
                        query: {redirect: this.$router.currentRoute.fullPath}
                    });
                    return;
        }else if(res.status===409||res.status===410||res.status===411){
                    this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:"warning"});
                    await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                    this.$router.replace({
                        path: '/main/home',
                        query: {redirect: this.$router.currentRoute.fullPath}
                    });
                    return;
        }
        if(pc==='6'){
            this.$set(this.bkCollectYx[index],"inputSbVisible",false);
            this.$set(this.bkCollectYx[index],"chooseYxxhVisible",true);
            if(obj.writeSb!==obj.sb){
                this.$set(this.bkCollectYx[index],"selectedYxxh",'');
            }
            this.$forceUpdate();
        }else if(pc==='7'){
            this.$set(this.zkCollectYx[index],"inputSbVisible",false);
            this.$set(this.zkCollectYx[index],"chooseYxxhVisible",true);
            if(obj.writeSb!==obj.sb){
                this.$set(this.zkCollectYx[index],"selectedYxxh",'');
            }
            this.$forceUpdate();
        }else if(pc==='0'){
            this.$set(this.bkTqpCollectYx[index],"inputSbVisible",false);
            this.$set(this.bkTqpCollectYx[index],"chooseYxxhVisible",true);
            if(obj.writeSb!==obj.sb){
                this.$set(this.bkTqpCollectYx[index],"selectedYxxh",'');
            }
            this.$forceUpdate();
        }else{
            this.$set(this.zkTqpCollectYx[index],"inputSbVisible",false);
            this.$set(this.zkTqpCollectYx[index],"chooseYxxhVisible",true);
            if(obj.writeSb!==obj.sb){
                this.$set(this.zkTqpCollectYx[index],"selectedYxxh",'');
            }
            this.$forceUpdate();
        }
    },
    cancelCloseSb(obj){
        const pc=this.activePcName;
        const index=obj.index-1;
        if(pc==='6'){
            this.$set(this.bkCollectYx[index],"inputSbVisible",false);
            this.bkCollectYx=[...this.bkCollectYx];
        }else if(pc==='7'){
            this.$set(this.zkCollectYx[index],"inputSbVisible",false);
            this.zkCollectYx=[...this.zkCollectYx];
        }else if(pc==='0'){
            this.$set(this.bkTqpCollectYx[index],"inputSbVisible",false);
            this.bkTqpCollectYx=[...this.bkTqpCollectYx];
        }else{
            this.$set(this.zkTqpCollectYx[index],"inputSbVisible",false);
            this.zkTqpCollectYx=[...this.zkTqpCollectYx];
        }
    },
    // 保存代码
    async savePlan(){
        const obj={};
        obj.id=this.selectedYxzyz;
        if(this.selectedYxzyz===''){
            this.$message({
                message:"请选择方案",
                type:'warning',
                showClose:true
            });
        }
        const id=this.selectedYxzyz;
        const planObj=this.yxzyzList.find(item=>item.id===id);
        if(planObj){
            obj.plan=planObj.plan;
        }
        if(planObj.plan.indexOf('(原始)')>=0){
            this.$message({
                message:'原始方案不允许修改',
                type:'warning',
                showClose:true
            });
            return;
        }
        obj.yhid=this.userInfo.yhid;
        obj.user=this.userInfo.xm;
        obj.sssf=this.userInfo.sssf;
        obj.kl=this.userInfo.sxkm;
        obj.pc=this.activePcName;
        obj.fs=this.userInfo.gkfs;
        obj.school=this.userInfo.school;
        obj.ghs=null;
        obj.xb=this.userInfo.xb;
        obj.bz=this.userInfo.bz;
        obj.lx=null;
        obj.sjhm=this.userInfo.sjhm;
        const pc=this.activePcName;
        // if(pc==='6'){
        //     const bkArr=this.bkYxPlan;
        //     const arr=[];
        //     for(let i=0;i<bkArr.length;i++){
        //         if(bkArr[i].zyz){
        //             let strs="";
        //             if(bkArr[i].zy1){
        //                 strs+=bkArr[i].zy1+"_";
        //             }
        //             if(bkArr[i].zy2){
        //                 strs+=bkArr[i].zy2+"_";
        //             }
        //             if(bkArr[i].zy3){
        //                 strs+=bkArr[i].zy3+"_";
        //             }
        //             if(bkArr[i].zy4){
        //                 strs+=bkArr[i].zy4+"_";
        //             }
        //             if(bkArr[i].zy5){
        //                 strs+=bkArr[i].zy5+"_";
        //             }
        //             if(bkArr[i].zy6){
        //                 strs+=bkArr[i].zy6+"_";
        //             }
        //             arr.push(bkArr[i].sb+"-"+bkArr[i].yxmc+"-"+bkArr[i].yxxh+"-"+pc+"-"+bkArr[i].zyz+"-"+bkArr[i].sffc+"-"+strs+"-"+(bkArr[i].checked?1:0));
        //         }
        //     }
        //     obj.param=arr.join(",");
        // }else{
        //     const zkArr=this.zkYxPlan;
        //     const arr=[];
        //     for(let i=0;i<zkArr.length;i++){
        //         if(zkArr[i].zyz){
        //             let strs="";
        //             if(zkArr[i].zy1){
        //                 strs+=zkArr[i].zy1+"_";
        //             }
        //             if(zkArr[i].zy2){
        //                 strs+=zkArr[i].zy2+"_";
        //             }
        //             if(zkArr[i].zy3){
        //                 strs+=zkArr[i].zy3+"_";
        //             }
        //             if(zkArr[i].zy4){
        //                 strs+=zkArr[i].zy4+"_";
        //             }
        //             if(zkArr[i].zy5){
        //                 strs+=zkArr[i].zy5+"_";
        //             }
        //             if(zkArr[i].zy6){
        //                 strs+=zkArr[i].zy6+"_";
        //             }
        //             arr.push(zkArr[i].sb+"-"+zkArr[i].yxmc+"-"+zkArr[i].yxxh+"-"+pc+"-"+zkArr[i].zyz+"-"+zkArr[i].sffc+"-"+strs+"-"+(zkArr[i].checked?1:0));
        //         }
        //     }
        //     obj.param=arr.join(",");
        // }
        if(pc==='6'){
            const list=[];
            const bkArr=[...this.bkCollectYx];
            // let count=0;
            // for(let i=0;i<bkArr.length;i++){
            //     if(bkArr[i].zyz&&bkArr[i].checked){
            //         count++;
            //     }
            // }
            // if(count>45){
            //     this.$message({message:"请选择要保存的45所院校",type:'warning',showClose:true});
            //     return;
            // }else if(bkArr.length>45&&count===0){
            //     this.$message({message:"请选择要保存的45所院校",type:'warning',showClose:true});
            //     return;
            // }
            // for(let i=0;i<bkArr.length;i++){
            //     if(bkArr[i].zyz){
            //         if(count>0){
            //             if(bkArr[i].checked){
            //             let mnzybid='';
            //         if(this.planObj.id){
            //             mnzybid=this.planObj.id;
            //         }
            //         list.push({
            //             id:'',
            //             mnzybid,
            //             sb:bkArr[i].sb,
            //             sffc:bkArr[i].sffc,
            //             xh:i+1,
            //             yxmc:bkArr[i].yxmc,
            //             yxxh:bkArr[i].yxxh,
            //             zyz:bkArr[i].zyz,
            //             zydh1:bkArr[i].zy1,
            //             zydh2:bkArr[i].zy2,
            //             zydh3:bkArr[i].zy3,
            //             zydh4:bkArr[i].zy4,
            //             zydh5:bkArr[i].zy5,
            //             zydh6:bkArr[i].zy6
            //         });
            //             }
            //         }else{
            //             if(i<45){
            //                 let mnzybid='';
            //             if(this.planObj.id){
            //                 mnzybid=this.planObj.id;
            //             }
            //             list.push({
            //                 id:'',
            //                 mnzybid,
            //                 sb:bkArr[i].sb,
            //                 sffc:bkArr[i].sffc,
            //                 xh:i+1,
            //                 yxmc:bkArr[i].yxmc,
            //                 yxxh:bkArr[i].yxxh,
            //                 zyz:bkArr[i].zyz,
            //                 zydh1:bkArr[i].zy1,
            //                 zydh2:bkArr[i].zy2,
            //                 zydh3:bkArr[i].zy3,
            //                 zydh4:bkArr[i].zy4,
            //                 zydh5:bkArr[i].zy5,
            //                 zydh6:bkArr[i].zy6
            //             });
            //             }
            //         }
            //     }
            // }
            let count=0;
            for(let i=0;i<bkArr.length;i++){
                if((bkArr[i].zyz||bkArr[i].submitZyz)&&bkArr[i].checked){
                    count++;
                }
            }
            let noSaveIndex=-1;
            for(let i=0;i<bkArr.length;i++){
                if(count>0){
                    if(bkArr[i].checked&&bkArr[i].isSaveTr===false&&(bkArr[i].submitSb
                    ||bkArr[i].submitYxmc||bkArr[i].submitZyz)){
                        noSaveIndex=i;
                        break;
                    }
                }else{
                    if(bkArr[i].isSaveTr===false&&(bkArr[i].submitSb
                    ||bkArr[i].submitYxmc||bkArr[i].submitZyz)){
                        noSaveIndex=i;
                        break;
                    }
                }
            }
            if(noSaveIndex>=0){
                const noSaveMessage='第'+bkArr[noSaveIndex].index+'行'+(bkArr[noSaveIndex].submitYxmc
                ||bkArr[noSaveIndex].yxmc||'')+((bkArr[noSaveIndex].submitZyz||bkArr[noSaveIndex].selectedZyz)?
                    (bkArr[noSaveIndex].submitZyz||bkArr[noSaveIndex].selectedZyz)+'组':'')+'数据没有保存';
                this.$message({
                    message:noSaveMessage,
                    type:'warning',
                    showClose:true
                });
                return;
            }
            for(let i=0;i<bkArr.length;i++){
                if((bkArr[i].zyz||bkArr[i].submitZyz)&&bkArr[i].isSaveTr===true){
                    if(count>0){
                        if(bkArr[i].checked){
                            let mnzybid='';
                            list.push({
                                id:'',
                                mnzybid,
                                sb:bkArr[i].sb||bkArr[i].writeSb,
                                sffc:bkArr[i].sffc,
                                xh:i+1,
                                yxmc:bkArr[i].yxmc||bkArr[i].submitYxmc,
                                yxxh:bkArr[i].yxxh||bkArr[i].selectedYxxh,
                                zyz:bkArr[i].zyz||bkArr[i].selectedZyz,
                                zydh1:bkArr[i].zy1,
                                zydh2:bkArr[i].zy2,
                                zydh3:bkArr[i].zy3,
                                zydh4:bkArr[i].zy4,
                                zydh5:bkArr[i].zy5,
                                zydh6:bkArr[i].zy6,
                                gzsj:bkArr[i].gzsj
                            });
                        }
                    }else{
                         let mnzybid='';
                        list.push({
                            id:'',
                            mnzybid,
                            sb:bkArr[i].sb||bkArr[i].writeSb,
                            sffc:bkArr[i].sffc,
                            xh:i+1,
                            yxmc:bkArr[i].yxmc||bkArr[i].submitYxmc,
                            yxxh:bkArr[i].yxxh||bkArr[i].selectedYxxh,
                            zyz:bkArr[i].zyz||bkArr[i].selectedZyz,
                            zydh1:bkArr[i].zy1,
                            zydh2:bkArr[i].zy2,
                            zydh3:bkArr[i].zy3,
                            zydh4:bkArr[i].zy4,
                            zydh5:bkArr[i].zy5,
                            zydh6:bkArr[i].zy6,
                            gzsj:bkArr[i].gzsj
                        });
                    }
                }
            }
            obj.list=list;
        }else if(pc==='7'){
            const list=[];
            const zkArr=[...this.zkCollectYx];
            // let count=0;
            // for(let i=0;i<zkArr.length;i++){
            //     if(zkArr[i].zyz&&zkArr[i].checked){
            //         count++;
            //     }
            // }
            // if(count>30){
            //     this.$message({message:"请选择要保存的30所院校",type:'warning',showClose:true});
            //     return;
            // }else if(zkArr.length>30&&count===0){
            //     this.$message({message:"请选择要保存的30所院校",type:'warning',showClose:true});
            //     return;
            // }
            // for(let i=0;i<zkArr.length;i++){
            //     if(zkArr[i].zyz){
            //         if(count>0){
            //             if(zkArr[i].checked){
            //         let mnzybid='';
            //         if(this.planObj.id){
            //             mnzybid=this.planObj.id;
            //         }
            //         list.push({
            //             id:'',
            //             mnzybid,
            //             sb:zkArr[i].sb,
            //             sffc:zkArr[i].sffc,
            //             xh:i+1,
            //             yxmc:zkArr[i].yxmc,
            //             yxxh:zkArr[i].yxxh,
            //             zyz:zkArr[i].zyz,
            //             zydh1:zkArr[i].zy1,
            //             zydh2:zkArr[i].zy2,
            //             zydh3:zkArr[i].zy3,
            //             zydh4:zkArr[i].zy4,
            //             zydh5:zkArr[i].zy5,
            //             zydh6:zkArr[i].zy6
            //         });
            //             }
            //         }else{
            //             if(i<30){
            //         let mnzybid='';
            //         if(this.planObj.id){
            //             mnzybid=this.planObj.id;
            //         }
            //         list.push({
            //             id:'',
            //             mnzybid,
            //             sb:zkArr[i].sb,
            //             sffc:zkArr[i].sffc,
            //             xh:i+1,
            //             yxmc:zkArr[i].yxmc,
            //             yxxh:zkArr[i].yxxh,
            //             zyz:zkArr[i].zyz,
            //             zydh1:zkArr[i].zy1,
            //             zydh2:zkArr[i].zy2,
            //             zydh3:zkArr[i].zy3,
            //             zydh4:zkArr[i].zy4,
            //             zydh5:zkArr[i].zy5,
            //             zydh6:zkArr[i].zy6
            //         });
            //             }
            //         }
            //     }
            // }
            let count=0;
            for(let i=0;i<zkArr.length;i++){
                if((zkArr[i].zyz||zkArr[i].submitZyz)&&zkArr[i].checked){
                    count++;
                }
            }
            let noSaveIndex=-1;
            for(let i=0;i<zkArr.length;i++){
                if(count>0){
                    if(zkArr[i].checked&&zkArr[i].isSaveTr===false&&
                    (zkArr[i].submitSb||zkArr[i].submitYxmc||zkArr[i].submitZyz)){
                        noSaveIndex=i;
                        break;
                    }
                }else{
                    if(zkArr[i].isSaveTr===false&&(zkArr[i].submitSb||zkArr[i].submitYxmc
                    ||zkArr[i].submitZyz)){
                        noSaveIndex=i;
                        break;
                    }
                }
            }
            if(noSaveIndex>=0){
                const noSaveMessage='第'+zkArr[noSaveIndex].index+'行'+(zkArr[noSaveIndex].submitYxmc
                ||zkArr[noSaveIndex].yxmc||'')+((zkArr[noSaveIndex].submitZyz||zkArr[noSaveIndex].selectedZyz)?
                    (zkArr[noSaveIndex].submitZyz||zkArr[noSaveIndex].selectedZyz)+'组':'')+'数据没有保存';
                this.$message({
                    message:noSaveMessage,
                    type:'warning',
                    showClose:true
                });
                return;
            }
            for(let i=0;i<zkArr.length;i++){
                if(zkArr[i].zyz||zkArr[i].submitZyz){
                    if(count>0){
                        if(zkArr[i].checked){
                            let mnzybid='';
                            list.push({
                                id:'',
                                mnzybid,
                                sb:zkArr[i].sb||zkArr[i].writeSb,
                                sffc:zkArr[i].sffc,
                                xh:i+1,
                                yxmc:zkArr[i].yxmc||zkArr[i].submitYxmc,
                                yxxh:zkArr[i].yxxh||zkArr[i].selectedYxxh,
                                zyz:zkArr[i].zyz||zkArr[i].selectedZyz,
                                zydh1:zkArr[i].zy1,
                                zydh2:zkArr[i].zy2,
                                zydh3:zkArr[i].zy3,
                                zydh4:zkArr[i].zy4,
                                zydh5:zkArr[i].zy5,
                                zydh6:zkArr[i].zy6,
                                gzsj:zkArr[i].gzsj
                            });
                        }
                    }else{
                        let mnzybid='';
                        list.push({
                            id:'',
                            mnzybid,
                            sb:zkArr[i].sb||zkArr[i].writeSb,
                            sffc:zkArr[i].sffc,
                            xh:i+1,
                            yxmc:zkArr[i].yxmc||zkArr[i].submitYxmc,
                            yxxh:zkArr[i].yxxh||zkArr[i].selectedYxxh,
                            zyz:zkArr[i].zyz||zkArr[i].selectedZyz,
                            zydh1:zkArr[i].zy1,
                            zydh2:zkArr[i].zy2,
                            zydh3:zkArr[i].zy3,
                            zydh4:zkArr[i].zy4,
                            zydh5:zkArr[i].zy5,
                            zydh6:zkArr[i].zy6,
                            gzsj:zkArr[i].gzsj
                        });
                    }
                }
            }
            obj.list=list;
        }else if(pc==='0'){
            const list=[];
            const bkArr=[...this.bkTqpCollectYx];
            let count=0;
            for(let i=0;i<bkArr.length;i++){
                if((bkArr[i].zyz||bkArr[i].submitZyz)&&bkArr[i].checked){
                    count++;
                }
            }
            let noSaveIndex=-1;
            for(let i=0;i<bkArr.length;i++){
                if(count>0){
                    if(bkArr[i].checked&&bkArr[i].isSaveTr===false&&
                    (bkArr[i].submitSb||bkArr[i].submitYxmc||bkArr[i].submitZyz)){
                        noSaveIndex=i;
                        break;
                    }
                }else{
                    if(bkArr[i].isSaveTr===false&&(bkArr[i].submitSb||bkArr[i].submitYxmc
                    ||bkArr[i].submitZyz)){
                        noSaveIndex=i;
                        break;
                    }
                }
            }
            if(noSaveIndex>=0){
                const noSaveMessage='第'+bkArr[noSaveIndex].index+'行'+(bkArr[noSaveIndex].submitYxmc
                ||bkArr[noSaveIndex].yxmc||'')+((bkArr[noSaveIndex].submitZyz||bkArr[noSaveIndex].selectedZyz)?
                    (bkArr[noSaveIndex].submitZyz||bkArr[noSaveIndex].selectedZyz)+'组':'')+'数据没有保存';
                this.$message({
                    message:noSaveMessage,
                    type:'warning',
                    showClose:true
                });
                return;
            }
            for(let i=0;i<bkArr.length;i++){
                if(bkArr[i].zyz||bkArr[i].submitZyz){
                    if(count>0){
                        if(bkArr[i].checked){
                            let mnzybid='';
                            list.push({
                                id:'',
                                mnzybid,
                                sb:bkArr[i].sb||bkArr[i].writeSb,
                                sffc:bkArr[i].sffc,
                                xh:i+1,
                                yxmc:bkArr[i].yxmc||bkArr[i].submitYxmc,
                                yxxh:bkArr[i].yxxh||bkArr[i].selectedYxxh,
                                zyz:bkArr[i].zyz||bkArr[i].selectedZyz,
                                zydh1:bkArr[i].zy1,
                                zydh2:bkArr[i].zy2,
                                zydh3:bkArr[i].zy3,
                                zydh4:bkArr[i].zy4,
                                zydh5:bkArr[i].zy5,
                                zydh6:bkArr[i].zy6,
                                gzsj:bkArr[i].gzsj
                            });
                        }
                    }else{
                         let mnzybid='';
                        list.push({
                            id:'',
                            mnzybid,
                            sb:bkArr[i].sb||bkArr[i].writeSb,
                            sffc:bkArr[i].sffc,
                            xh:i+1,
                            yxmc:bkArr[i].yxmc||bkArr[i].submitYxmc,
                            yxxh:bkArr[i].yxxh||bkArr[i].selectedYxxh,
                            zyz:bkArr[i].zyz||bkArr[i].selectedZyz,
                            zydh1:bkArr[i].zy1,
                            zydh2:bkArr[i].zy2,
                            zydh3:bkArr[i].zy3,
                            zydh4:bkArr[i].zy4,
                            zydh5:bkArr[i].zy5,
                            zydh6:bkArr[i].zy6,
                            gzsj:bkArr[i].gzsj
                        });
                    }
                }
            }
            obj.list=list;
        }else{
            const list=[];
            const zkArr=[...this.zkTqpCollectYx];
            let count=0;
            for(let i=0;i<zkArr.length;i++){
                if((zkArr[i].zyz||zkArr[i].submitZyz)&&zkArr[i].checked){
                    count++;
                }
            }
            let noSaveIndex=-1;
            for(let i=0;i<zkArr.length;i++){
                if(count>0){
                    if(zkArr[i].checked&&zkArr[i].isSaveTr===false&&
                    (zkArr[i].submitSb&&zkArr[i].submitYxmc||zkArr[i].submitZyz)){
                        noSaveIndex=i;
                        break;
                    }
                }else{
                    if(zkArr[i].isSaveTr===false&&(zkArr[i].submitSb||zkArr[i].submitYxmc
                    ||zkArr[i].submitZyz)){
                        noSaveIndex=i;
                        break;
                    }
                }
            }
            if(noSaveIndex>=0){
                const noSaveMessage='第'+zkArr[noSaveIndex].index+'行'+(zkArr[noSaveIndex].submitYxmc
                ||zkArr[noSaveIndex].yxmc||'')+((zkArr[noSaveIndex].submitZyz||zkArr[noSaveIndex].selectedZyz)?
                (zkArr[noSaveIndex].submitZyz||zkArr[noSaveIndex].selectedZyz)+'组':'')+'数据没有保存';
                this.$message({
                    message:noSaveMessage,
                    type:'warning',
                    showClose:true
                });
                return;
            }
            for(let i=0;i<zkArr.length;i++){
                if(zkArr[i].zyz||zkArr[i].submitZyz){
                    if(count>0){
                        if(zkArr[i].checked){
                            let mnzybid='';
                            list.push({
                                id:'',
                                mnzybid,
                                sb:zkArr[i].sb||zkArr[i].writeSb,
                                sffc:zkArr[i].sffc,
                                xh:i+1,
                                yxmc:zkArr[i].yxmc||zkArr[i].submitYxmc,
                                yxxh:zkArr[i].yxxh||zkArr[i].selectedYxxh,
                                zyz:zkArr[i].zyz||zkArr[i].selectedZyz,
                                zydh1:zkArr[i].zy1,
                                zydh2:zkArr[i].zy2,
                                zydh3:zkArr[i].zy3,
                                zydh4:zkArr[i].zy4,
                                zydh5:zkArr[i].zy5,
                                zydh6:zkArr[i].zy6,
                                gzsj:zkArr[i].gzsj
                            });
                        }
                    }else{
                        let mnzybid='';
                        list.push({
                            id:'',
                            mnzybid,
                            sb:zkArr[i].sb||zkArr[i].writeSb,
                            sffc:zkArr[i].sffc,
                            xh:i+1,
                            yxmc:zkArr[i].yxmc||zkArr[i].submitYxmc,
                            yxxh:zkArr[i].yxxh||zkArr[i].selectedYxxh,
                            zyz:zkArr[i].zyz||zkArr[i].selectedZyz,
                            zydh1:zkArr[i].zy1,
                            zydh2:zkArr[i].zy2,
                            zydh3:zkArr[i].zy3,
                            zydh4:zkArr[i].zy4,
                            zydh5:zkArr[i].zy5,
                            zydh6:zkArr[i].zy6,
                            gzsj:zkArr[i].gzsj
                        });
                    }
                }
            }
            obj.list=list;
        }
        obj.updatetime="";
        obj.zxkma=this.userInfo.zxkma;
        obj.zxkmb=this.userInfo.zxkmb;
        obj.yu=this.userInfo.ywcj;
        obj.shu=this.userInfo.sxcj;
        obj.wai=this.userInfo.wycj;
        obj.sxkmfs=this.userInfo.sxkmcj;
        obj.zxkmafs=this.userInfo.zxkmacj;
        obj.zxkmbfs=this.userInfo.zxkmbcj;
        obj.jf=this.userInfo.yfjf;
        obj.gjzxzg=this.userInfo.gjzxzg;
        obj.dfzxzg=this.userInfo.dfzxzg;
        obj.flag=0;
        if(planObj.plan){
            obj.plan=planObj.plan;
        }else{
            this.openOther();
            return;
        }
        console.log(obj);
        const res=await this.$http.postHttp("/mnzy/saveOrUpdateMnzy",obj);
        if(res.data.code===200){
            if(res.data.message){
                this.$message({message:res.data.message,type:'success',showClose:true});
            }else{
                this.$message({message:"保存成功",type:'success',showClose:true});
            }
            this.dialogPlanVisible=false;
        }else if(res.data.code===500){
            if(res.data.message){
                this.$message({message:res.data.message,type:'error'});
            }
        }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.data.code===0){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.status===409||res.status===410||res.status===411){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }
        // setTimeout(() => {
        //     this.$router.push('/main/zypg?reload=true&&toCollect=true&&time='+new Date().getTime());
        //     window.location.reload();
        // }, 2000);
    },
    // 另存为代码
    async saveOtherCode2(){
        const obj={};
        obj.id="";
        obj.yhid=this.userInfo.yhid;
        obj.plan=this.otherPlan;
        obj.user=this.userInfo.xm;
        obj.sssf=this.userInfo.sssf;
        obj.kl=this.userInfo.sxkm;
        obj.pc=this.activePcName;
        obj.fs=this.userInfo.gkfs;
        obj.school=this.userInfo.school;
        obj.ghs=null;
        obj.xb=this.userInfo.xb;
        obj.bz=this.userInfo.bz;
        obj.lx=null;
        obj.sjhm=this.userInfo.sjhm;
        const pc=this.activePcName;
        // if(pc==='6'){
        //     const bkArr=this.bkYxPlan;
        //     const arr=[];
        //     for(let i=0;i<bkArr.length;i++){
        //         if(bkArr[i].zyz){
        //             let strs="";
        //             if(bkArr[i].zy1){
        //                 strs+=bkArr[i].zy1+"_";
        //             }
        //             if(bkArr[i].zy2){
        //                 strs+=bkArr[i].zy2+"_";
        //             }
        //             if(bkArr[i].zy3){
        //                 strs+=bkArr[i].zy3+"_";
        //             }
        //             if(bkArr[i].zy4){
        //                 strs+=bkArr[i].zy4+"_";
        //             }
        //             if(bkArr[i].zy5){
        //                 strs+=bkArr[i].zy5+"_";
        //             }
        //             if(bkArr[i].zy6){
        //                 strs+=bkArr[i].zy6+"_";
        //             }
        //             const status=bkArr[i].checked?1:0;
        //             arr.push(bkArr[i].sb+"-"+bkArr[i].yxmc+"-"+bkArr[i].yxxh+"-"+pc+"-"+bkArr[i].zyz+"-"+bkArr[i].sffc+"-"+strs+"-"+status);
        //         }
        //     }
        //     obj.param=arr.join(",");
        // }else{
        //     const zkArr=this.zkYxPlan;
        //     const arr=[];
        //     for(let i=0;i<zkArr.length;i++){
        //         if(zkArr[i].zyz){
        //             let strs="";
        //             if(zkArr[i].zy1){
        //                 strs+=zkArr[i].zy1+"_";
        //             }
        //             if(zkArr[i].zy2){
        //                 strs+=zkArr[i].zy2+"_";
        //             }
        //             if(zkArr[i].zy3){
        //                 strs+=zkArr[i].zy3+"_";
        //             }
        //             if(zkArr[i].zy4){
        //                 strs+=zkArr[i].zy4+"_";
        //             }
        //             if(zkArr[i].zy5){
        //                 strs+=zkArr[i].zy5+"_";
        //             }
        //             if(zkArr[i].zy6){
        //                 strs+=zkArr[i].zy6+"_";
        //             }
        //             const status=zkArr[i].checked?1:0;
        //             arr.push(zkArr[i].sb+"-"+zkArr[i].yxmc+"-"+zkArr[i].yxxh+"-"+pc+"-"+zkArr[i].zyz+"-"+zkArr[i].sffc+"-"+strs+"-"+status);
        //         }
        //     }
        //     obj.param=arr.join(",");
        // }
        if(pc==='6'){
            const list=[];
            const bkArr=[...this.bkCollectYx];
            // let count=0;
            // for(let i=0;i<bkArr.length;i++){
            //     if(bkArr[i].zyz&&bkArr[i].checked){
            //         count++;
            //     }
            // }
            // if(count>45){
            //     this.$message({message:"请选择要保存的45所院校",type:'warning',showClose:true});
            //     return;
            // }else if(bkArr.length>45&&count===0){
            //     this.$message({message:"请选择要保存的45所院校",type:'warning',showClose:true});
            //     return;
            // }
            // for(let i=0;i<bkArr.length;i++){
            //     if(bkArr[i].zyz){
            //         if(count>0){
            //             if(bkArr[i].checked){
            //             let mnzybid='';
            //         if(this.planObj.id){
            //             mnzybid=this.planObj.id;
            //         }
            //         list.push({
            //             id:'',
            //             mnzybid,
            //             sb:bkArr[i].sb,
            //             sffc:bkArr[i].sffc,
            //             xh:i+1,
            //             yxmc:bkArr[i].yxmc,
            //             yxxh:bkArr[i].yxxh,
            //             zyz:bkArr[i].zyz,
            //             zydh1:bkArr[i].zy1,
            //             zydh2:bkArr[i].zy2,
            //             zydh3:bkArr[i].zy3,
            //             zydh4:bkArr[i].zy4,
            //             zydh5:bkArr[i].zy5,
            //             zydh6:bkArr[i].zy6
            //         });
            //             }
            //         }else{
            //             if(i<45){
            //                 let mnzybid='';
            //             if(this.planObj.id){
            //                 mnzybid=this.planObj.id;
            //             }
            //             list.push({
            //                 id:'',
            //                 mnzybid,
            //                 sb:bkArr[i].sb,
            //                 sffc:bkArr[i].sffc,
            //                 xh:i+1,
            //                 yxmc:bkArr[i].yxmc,
            //                 yxxh:bkArr[i].yxxh,
            //                 zyz:bkArr[i].zyz,
            //                 zydh1:bkArr[i].zy1,
            //                 zydh2:bkArr[i].zy2,
            //                 zydh3:bkArr[i].zy3,
            //                 zydh4:bkArr[i].zy4,
            //                 zydh5:bkArr[i].zy5,
            //                 zydh6:bkArr[i].zy6
            //             });
            //             }
            //         }
            //     }
            // }
            let count=0;
            for(let i=0;i<bkArr.length;i++){
                if((bkArr[i].zyz||bkArr[i].submitZyz)&&bkArr[i].checked){
                    count++;
                }
            }
            let noSaveIndex=-1;
            for(let i=0;i<bkArr.length;i++){
                if(count>0){
                    if(bkArr[i].checked&&bkArr[i].isSaveTr===false&&(bkArr[i].submitSb
                    ||bkArr[i].submitYxmc||bkArr[i].submitZyz)){
                        noSaveIndex=i;
                        break;
                    }
                }else{
                    if(bkArr[i].isSaveTr===false&&(bkArr[i].submitSb
                    ||bkArr[i].submitYxmc||bkArr[i].submitZyz)){
                        noSaveIndex=i;
                        break;
                    }
                }
            }
            if(noSaveIndex>=0){
                const noSaveMessage='第'+bkArr[noSaveIndex].index+'行'+(bkArr[noSaveIndex].submitYxmc
                ||bkArr[noSaveIndex].yxmc||'')+((bkArr[noSaveIndex].submitZyz||bkArr[noSaveIndex].selectedZyz)?
                    (bkArr[noSaveIndex].submitZyz||bkArr[noSaveIndex].selectedZyz)+'组':'')+'数据没有保存';
                this.$message({
                    message:noSaveMessage,
                    type:'warning',
                    showClose:true
                });
                return;
            }
            for(let i=0;i<bkArr.length;i++){
                if((bkArr[i].zyz||bkArr[i].submitZyz)&&bkArr[i].isSaveTr===true){
                    if(count>0){
                        if(bkArr[i].checked){
                            let mnzybid='';
                            list.push({
                                id:'',
                                mnzybid,
                                sb:bkArr[i].sb||bkArr[i].writeSb,
                                sffc:bkArr[i].sffc,
                                xh:i+1,
                                yxmc:bkArr[i].yxmc||bkArr[i].submitYxmc,
                                yxxh:bkArr[i].yxxh||bkArr[i].selectedYxxh,
                                zyz:bkArr[i].zyz||bkArr[i].selectedZyz,
                                zydh1:bkArr[i].zy1,
                                zydh2:bkArr[i].zy2,
                                zydh3:bkArr[i].zy3,
                                zydh4:bkArr[i].zy4,
                                zydh5:bkArr[i].zy5,
                                zydh6:bkArr[i].zy6,
                                gzsj:bkArr[i].gzsj
                            });
                        }
                    }else{
                         let mnzybid='';
                        list.push({
                            id:'',
                            mnzybid,
                            sb:bkArr[i].sb||bkArr[i].writeSb,
                            sffc:bkArr[i].sffc,
                            xh:i+1,
                            yxmc:bkArr[i].yxmc||bkArr[i].submitYxmc,
                            yxxh:bkArr[i].yxxh||bkArr[i].selectedYxxh,
                            zyz:bkArr[i].zyz||bkArr[i].selectedZyz,
                            zydh1:bkArr[i].zy1,
                            zydh2:bkArr[i].zy2,
                            zydh3:bkArr[i].zy3,
                            zydh4:bkArr[i].zy4,
                            zydh5:bkArr[i].zy5,
                            zydh6:bkArr[i].zy6,
                            gzsj:bkArr[i].gzsj
                        });
                    }
                }
            }
            obj.list=list;
        }else if(pc==='7'){
            const list=[];
            const zkArr=[...this.zkCollectYx];
            // let count=0;
            // for(let i=0;i<zkArr.length;i++){
            //     if(zkArr[i].zyz&&zkArr[i].checked){
            //         count++;
            //     }
            // }
            // if(count>30){
            //     this.$message({message:"请选择要保存的30所院校",type:'warning',showClose:true});
            //     return;
            // }else if(zkArr.length>30&&count===0){
            //     this.$message({message:"请选择要保存的30所院校",type:'warning',showClose:true});
            //     return;
            // }
            // for(let i=0;i<zkArr.length;i++){
            //     if(zkArr[i].zyz){
            //         if(count>0){
            //             if(zkArr[i].checked){
            //         let mnzybid='';
            //         if(this.planObj.id){
            //             mnzybid=this.planObj.id;
            //         }
            //         list.push({
            //             id:'',
            //             mnzybid,
            //             sb:zkArr[i].sb,
            //             sffc:zkArr[i].sffc,
            //             xh:i+1,
            //             yxmc:zkArr[i].yxmc,
            //             yxxh:zkArr[i].yxxh,
            //             zyz:zkArr[i].zyz,
            //             zydh1:zkArr[i].zy1,
            //             zydh2:zkArr[i].zy2,
            //             zydh3:zkArr[i].zy3,
            //             zydh4:zkArr[i].zy4,
            //             zydh5:zkArr[i].zy5,
            //             zydh6:zkArr[i].zy6
            //         });
            //             }
            //         }else{
            //             if(i<30){
            //         let mnzybid='';
            //         if(this.planObj.id){
            //             mnzybid=this.planObj.id;
            //         }
            //         list.push({
            //             id:'',
            //             mnzybid,
            //             sb:zkArr[i].sb,
            //             sffc:zkArr[i].sffc,
            //             xh:i+1,
            //             yxmc:zkArr[i].yxmc,
            //             yxxh:zkArr[i].yxxh,
            //             zyz:zkArr[i].zyz,
            //             zydh1:zkArr[i].zy1,
            //             zydh2:zkArr[i].zy2,
            //             zydh3:zkArr[i].zy3,
            //             zydh4:zkArr[i].zy4,
            //             zydh5:zkArr[i].zy5,
            //             zydh6:zkArr[i].zy6
            //         });
            //             }
            //         }
            //     }
            // }
            let count=0;
            for(let i=0;i<zkArr.length;i++){
                if((zkArr[i].zyz||zkArr[i].submitZyz)&&zkArr[i].checked){
                    count++;
                }
            }
            let noSaveIndex=-1;
            for(let i=0;i<zkArr.length;i++){
                if(count>0){
                    if(zkArr[i].checked&&zkArr[i].isSaveTr===false&&
                    (zkArr[i].submitSb||zkArr[i].submitYxmc||zkArr[i].submitZyz)){
                        noSaveIndex=i;
                        break;
                    }
                }else{
                    if(zkArr[i].isSaveTr===false&&(zkArr[i].submitSb||zkArr[i].submitYxmc
                    ||zkArr[i].submitZyz)){
                        noSaveIndex=i;
                        break;
                    }
                }
            }
            if(noSaveIndex>=0){
                const noSaveMessage='第'+zkArr[noSaveIndex].index+'行'+(zkArr[noSaveIndex].submitYxmc
                ||zkArr[noSaveIndex].yxmc||'')+((zkArr[noSaveIndex].submitZyz||zkArr[noSaveIndex].selectedZyz)?
                    (zkArr[noSaveIndex].submitZyz||zkArr[noSaveIndex].selectedZyz)+'组':'')+'数据没有保存';
                this.$message({
                    message:noSaveMessage,
                    type:'warning',
                    showClose:true
                });
                return;
            }
            for(let i=0;i<zkArr.length;i++){
                if(zkArr[i].zyz||zkArr[i].submitZyz){
                    if(count>0){
                        if(zkArr[i].checked){
                            let mnzybid='';
                            list.push({
                                id:'',
                                mnzybid,
                                sb:zkArr[i].sb||zkArr[i].writeSb,
                                sffc:zkArr[i].sffc,
                                xh:i+1,
                                yxmc:zkArr[i].yxmc||zkArr[i].submitYxmc,
                                yxxh:zkArr[i].yxxh||zkArr[i].selectedYxxh,
                                zyz:zkArr[i].zyz||zkArr[i].selectedZyz,
                                zydh1:zkArr[i].zy1,
                                zydh2:zkArr[i].zy2,
                                zydh3:zkArr[i].zy3,
                                zydh4:zkArr[i].zy4,
                                zydh5:zkArr[i].zy5,
                                zydh6:zkArr[i].zy6,
                                gzsj:zkArr[i].gzsj
                            });
                        }
                    }else{
                        let mnzybid='';
                        list.push({
                            id:'',
                            mnzybid,
                            sb:zkArr[i].sb||zkArr[i].writeSb,
                            sffc:zkArr[i].sffc,
                            xh:i+1,
                            yxmc:zkArr[i].yxmc||zkArr[i].submitYxmc,
                            yxxh:zkArr[i].yxxh||zkArr[i].selectedYxxh,
                            zyz:zkArr[i].zyz||zkArr[i].selectedZyz,
                            zydh1:zkArr[i].zy1,
                            zydh2:zkArr[i].zy2,
                            zydh3:zkArr[i].zy3,
                            zydh4:zkArr[i].zy4,
                            zydh5:zkArr[i].zy5,
                            zydh6:zkArr[i].zy6,
                            gzsj:zkArr[i].gzsj
                        });
                    }
                }
            }
            obj.list=list;
        }else if(pc==='0'){
            const list=[];
            const bkArr=[...this.bkTqpCollectYx];
            let count=0;
            for(let i=0;i<bkArr.length;i++){
                if((bkArr[i].zyz||bkArr[i].submitZyz)&&bkArr[i].checked){
                    count++;
                }
            }
            let noSaveIndex=-1;
            for(let i=0;i<bkArr.length;i++){
                if(count>0){
                    if(bkArr[i].checked&&bkArr[i].isSaveTr===false&&
                    (bkArr[i].submitSb||bkArr[i].submitYxmc||bkArr[i].submitZyz)){
                        noSaveIndex=i;
                        break;
                    }
                }else{
                    if(bkArr[i].isSaveTr===false&&(bkArr[i].submitSb||bkArr[i].submitYxmc
                    ||bkArr[i].submitZyz)){
                        noSaveIndex=i;
                        break;
                    }
                }
            }
            if(noSaveIndex>=0){
                const noSaveMessage='第'+bkArr[noSaveIndex].index+'行'+(bkArr[noSaveIndex].submitYxmc
                ||bkArr[noSaveIndex].yxmc||'')+((bkArr[noSaveIndex].submitZyz||bkArr[noSaveIndex].selectedZyz)?
                    (bkArr[noSaveIndex].submitZyz||bkArr[noSaveIndex].selectedZyz)+'组':'')+'数据没有保存';
                this.$message({
                    message:noSaveMessage,
                    type:'warning',
                    showClose:true
                });
                return;
            }
            for(let i=0;i<bkArr.length;i++){
                if(bkArr[i].zyz||bkArr[i].submitZyz){
                    if(count>0){
                        if(bkArr[i].checked){
                            let mnzybid='';
                            list.push({
                                id:'',
                                mnzybid,
                                sb:bkArr[i].sb||bkArr[i].writeSb,
                                sffc:bkArr[i].sffc,
                                xh:i+1,
                                yxmc:bkArr[i].yxmc||bkArr[i].submitYxmc,
                                yxxh:bkArr[i].yxxh||bkArr[i].selectedYxxh,
                                zyz:bkArr[i].zyz||bkArr[i].selectedZyz,
                                zydh1:bkArr[i].zy1,
                                zydh2:bkArr[i].zy2,
                                zydh3:bkArr[i].zy3,
                                zydh4:bkArr[i].zy4,
                                zydh5:bkArr[i].zy5,
                                zydh6:bkArr[i].zy6,
                                gzsj:bkArr[i].gzsj
                            });
                        }
                    }else{
                         let mnzybid='';
                        list.push({
                            id:'',
                            mnzybid,
                            sb:bkArr[i].sb||bkArr[i].writeSb,
                            sffc:bkArr[i].sffc,
                            xh:i+1,
                            yxmc:bkArr[i].yxmc||bkArr[i].submitYxmc,
                            yxxh:bkArr[i].yxxh||bkArr[i].selectedYxxh,
                            zyz:bkArr[i].zyz||bkArr[i].selectedZyz,
                            zydh1:bkArr[i].zy1,
                            zydh2:bkArr[i].zy2,
                            zydh3:bkArr[i].zy3,
                            zydh4:bkArr[i].zy4,
                            zydh5:bkArr[i].zy5,
                            zydh6:bkArr[i].zy6,
                            gzsj:bkArr[i].gzsj
                        });
                    }
                }
            }
            obj.list=list;
        }else{
            const list=[];
            const zkArr=[...this.zkTqpCollectYx];
            let count=0;
            for(let i=0;i<zkArr.length;i++){
                if((zkArr[i].zyz||zkArr[i].submitZyz)&&zkArr[i].checked){
                    count++;
                }
            }
            let noSaveIndex=-1;
            for(let i=0;i<zkArr.length;i++){
                if(count>0){
                    if(zkArr[i].checked&&zkArr[i].isSaveTr===false&&
                    (zkArr[i].submitSb&&zkArr[i].submitYxmc||zkArr[i].submitZyz)){
                        noSaveIndex=i;
                        break;
                    }
                }else{
                    if(zkArr[i].isSaveTr===false&&(zkArr[i].submitSb||zkArr[i].submitYxmc
                    ||zkArr[i].submitZyz)){
                        noSaveIndex=i;
                        break;
                    }
                }
            }
            if(noSaveIndex>=0){
                const noSaveMessage='第'+zkArr[noSaveIndex].index+'行'+(zkArr[noSaveIndex].submitYxmc
                ||zkArr[noSaveIndex].yxmc||'')+((zkArr[noSaveIndex].submitZyz||zkArr[noSaveIndex].selectedZyz)?
                (zkArr[noSaveIndex].submitZyz||zkArr[noSaveIndex].selectedZyz)+'组':'')+'数据没有保存';
                this.$message({
                    message:noSaveMessage,
                    type:'warning',
                    showClose:true
                });
                return;
            }
            for(let i=0;i<zkArr.length;i++){
                if(zkArr[i].zyz||zkArr[i].submitZyz){
                    if(count>0){
                        if(zkArr[i].checked){
                            let mnzybid='';
                            list.push({
                                id:'',
                                mnzybid,
                                sb:zkArr[i].sb||zkArr[i].writeSb,
                                sffc:zkArr[i].sffc,
                                xh:i+1,
                                yxmc:zkArr[i].yxmc||zkArr[i].submitYxmc,
                                yxxh:zkArr[i].yxxh||zkArr[i].selectedYxxh,
                                zyz:zkArr[i].zyz||zkArr[i].selectedZyz,
                                zydh1:zkArr[i].zy1,
                                zydh2:zkArr[i].zy2,
                                zydh3:zkArr[i].zy3,
                                zydh4:zkArr[i].zy4,
                                zydh5:zkArr[i].zy5,
                                zydh6:zkArr[i].zy6,
                                gzsj:zkArr[i].gzsj
                            });
                        }
                    }else{
                        let mnzybid='';
                        list.push({
                            id:'',
                            mnzybid,
                            sb:zkArr[i].sb||zkArr[i].writeSb,
                            sffc:zkArr[i].sffc,
                            xh:i+1,
                            yxmc:zkArr[i].yxmc||zkArr[i].submitYxmc,
                            yxxh:zkArr[i].yxxh||zkArr[i].selectedYxxh,
                            zyz:zkArr[i].zyz||zkArr[i].selectedZyz,
                            zydh1:zkArr[i].zy1,
                            zydh2:zkArr[i].zy2,
                            zydh3:zkArr[i].zy3,
                            zydh4:zkArr[i].zy4,
                            zydh5:zkArr[i].zy5,
                            zydh6:zkArr[i].zy6,
                            gzsj:zkArr[i].gzsj
                        });
                    }
                }
            }
            obj.list=list;
        }
        obj.updatetime="";
        obj.zxkma=this.userInfo.zxkma;
        obj.zxkmb=this.userInfo.zxkmb;
        obj.yu=this.userInfo.ywcj;
        obj.shu=this.userInfo.sxcj;
        obj.wai=this.userInfo.wycj;
        obj.sxkmfs=this.userInfo.sxkmcj;
        obj.zxkmafs=this.userInfo.zxkmacj;
        obj.zxkmbfs=this.userInfo.zxkmbcj;
        obj.jf=this.userInfo.yfjf;
        obj.gjzxzg=this.userInfo.gjzxzg;
        obj.dfzxzg=this.userInfo.dfzxzg;
        obj.flag=0;
        if(this.otherPlan===''){
            this.$message({message:"请输入方案名",showClose:true});
            return;
        };
        console.log(obj);
        const res=await this.$http.postHttp("/mnzy/saveOrUpdateMnzy",obj);
        if(res.data.code===200){
            if(res.data.message){
                this.$message({message:res.data.message,type:'success',showClose:true});
            }else{
                this.$message({message:"保存成功",type:'success',showClose:true});
            }
            this.dialogOtherVisible=false;
            this.dialogPlanVisible=false;
            this.otherPlan='';
        }else if(res.data.code===500){
            if(res.data.message){
                this.$message({message:res.data.message,type:'error'});
            }
        }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.data.code===0){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.status===409||res.status===410||res.status===411){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }
        this.dialogPlanVisible=false;
        // setTimeout(() => {
        //     this.$router.push('/main/zypg?reload=true&&toCollect=true&&time='+new Date().getTime());
        //     window.location.reload();
        // }, 2000);
    },
    async saveOtherCode3(){
        const obj={};
        obj.id="";
        obj.yhid=this.userInfo.yhid;
        obj.plan=(this.userInfo.xm||'')+''
        +(new Date().getTime());
        obj.user=this.userInfo.xm;
        obj.sssf=this.userInfo.sssf;
        obj.kl=this.userInfo.sxkm;
        obj.pc=this.activePcName;
        obj.fs=this.userInfo.gkfs;
        obj.school=this.userInfo.school;
        obj.ghs=null;
        obj.xb=this.userInfo.xb;
        obj.bz=this.userInfo.bz;
        obj.lx=null;
        obj.sjhm=this.userInfo.sjhm;
        const pc=this.activePcName;
        // if(pc==='6'){
        //     const bkArr=this.bkYxPlan;
        //     const arr=[];
        //     for(let i=0;i<bkArr.length;i++){
        //         if(bkArr[i].zyz){
        //             let strs="";
        //             if(bkArr[i].zy1){
        //                 strs+=bkArr[i].zy1+"_";
        //             }
        //             if(bkArr[i].zy2){
        //                 strs+=bkArr[i].zy2+"_";
        //             }
        //             if(bkArr[i].zy3){
        //                 strs+=bkArr[i].zy3+"_";
        //             }
        //             if(bkArr[i].zy4){
        //                 strs+=bkArr[i].zy4+"_";
        //             }
        //             if(bkArr[i].zy5){
        //                 strs+=bkArr[i].zy5+"_";
        //             }
        //             if(bkArr[i].zy6){
        //                 strs+=bkArr[i].zy6+"_";
        //             }
        //             const status=bkArr[i].checked?1:0;
        //             arr.push(bkArr[i].sb+"-"+bkArr[i].yxmc+"-"+bkArr[i].yxxh+"-"+pc+"-"+bkArr[i].zyz+"-"+bkArr[i].sffc+"-"+strs+"-"+status);
        //         }
        //     }
        //     obj.param=arr.join(",");
        // }else{
        //     const zkArr=this.zkYxPlan;
        //     const arr=[];
        //     for(let i=0;i<zkArr.length;i++){
        //         if(zkArr[i].zyz){
        //             let strs="";
        //             if(zkArr[i].zy1){
        //                 strs+=zkArr[i].zy1+"_";
        //             }
        //             if(zkArr[i].zy2){
        //                 strs+=zkArr[i].zy2+"_";
        //             }
        //             if(zkArr[i].zy3){
        //                 strs+=zkArr[i].zy3+"_";
        //             }
        //             if(zkArr[i].zy4){
        //                 strs+=zkArr[i].zy4+"_";
        //             }
        //             if(zkArr[i].zy5){
        //                 strs+=zkArr[i].zy5+"_";
        //             }
        //             if(zkArr[i].zy6){
        //                 strs+=zkArr[i].zy6+"_";
        //             }
        //             const status=zkArr[i].checked?1:0;
        //             arr.push(zkArr[i].sb+"-"+zkArr[i].yxmc+"-"+zkArr[i].yxxh+"-"+pc+"-"+zkArr[i].zyz+"-"+zkArr[i].sffc+"-"+strs+"-"+status);
        //         }
        //     }
        //     obj.param=arr.join(",");
        // }
        if(pc==='6'){
            const list=[];
            const bkArr=[...this.bkCollectYx];
            // let count=0;
            // for(let i=0;i<bkArr.length;i++){
            //     if(bkArr[i].zyz&&bkArr[i].checked){
            //         count++;
            //     }
            // }
            // if(count>45){
            //     this.$message({message:"请选择要保存的45所院校",type:'warning',showClose:true});
            //     return;
            // }else if(bkArr.length>45&&count===0){
            //     this.$message({message:"请选择要保存的45所院校",type:'warning',showClose:true});
            //     return;
            // }
            // for(let i=0;i<bkArr.length;i++){
            //     if(bkArr[i].zyz){
            //         if(count>0){
            //             if(bkArr[i].checked){
            //             let mnzybid='';
            //         if(this.planObj.id){
            //             mnzybid=this.planObj.id;
            //         }
            //         list.push({
            //             id:'',
            //             mnzybid,
            //             sb:bkArr[i].sb,
            //             sffc:bkArr[i].sffc,
            //             xh:i+1,
            //             yxmc:bkArr[i].yxmc,
            //             yxxh:bkArr[i].yxxh,
            //             zyz:bkArr[i].zyz,
            //             zydh1:bkArr[i].zy1,
            //             zydh2:bkArr[i].zy2,
            //             zydh3:bkArr[i].zy3,
            //             zydh4:bkArr[i].zy4,
            //             zydh5:bkArr[i].zy5,
            //             zydh6:bkArr[i].zy6
            //         });
            //             }
            //         }else{
            //             if(i<45){
            //                 let mnzybid='';
            //             if(this.planObj.id){
            //                 mnzybid=this.planObj.id;
            //             }
            //             list.push({
            //                 id:'',
            //                 mnzybid,
            //                 sb:bkArr[i].sb,
            //                 sffc:bkArr[i].sffc,
            //                 xh:i+1,
            //                 yxmc:bkArr[i].yxmc,
            //                 yxxh:bkArr[i].yxxh,
            //                 zyz:bkArr[i].zyz,
            //                 zydh1:bkArr[i].zy1,
            //                 zydh2:bkArr[i].zy2,
            //                 zydh3:bkArr[i].zy3,
            //                 zydh4:bkArr[i].zy4,
            //                 zydh5:bkArr[i].zy5,
            //                 zydh6:bkArr[i].zy6
            //             });
            //             }
            //         }
            //     }
            // }
            let count=0;
            for(let i=0;i<bkArr.length;i++){
                if((bkArr[i].zyz||bkArr[i].submitZyz)&&bkArr[i].checked){
                    count++;
                }
            }
            let noSaveIndex=-1;
            for(let i=0;i<bkArr.length;i++){
                if(count>0){
                    if(bkArr[i].checked&&bkArr[i].isSaveTr===false&&(bkArr[i].submitSb
                    ||bkArr[i].submitYxmc||bkArr[i].submitZyz)){
                        noSaveIndex=i;
                        break;
                    }
                }else{
                    if(bkArr[i].isSaveTr===false&&(bkArr[i].submitSb
                    ||bkArr[i].submitYxmc||bkArr[i].submitZyz)){
                        noSaveIndex=i;
                        break;
                    }
                }
            }
            if(noSaveIndex>=0){
                const noSaveMessage='第'+bkArr[noSaveIndex].index+'行'+(bkArr[noSaveIndex].submitYxmc
                ||bkArr[noSaveIndex].yxmc||'')+((bkArr[noSaveIndex].submitZyz||bkArr[noSaveIndex].selectedZyz)?
                    (bkArr[noSaveIndex].submitZyz||bkArr[noSaveIndex].selectedZyz)+'组':'')+'数据没有保存';
                this.$message({
                    message:noSaveMessage,
                    type:'warning',
                    showClose:true
                });
                return;
            }
            for(let i=0;i<bkArr.length;i++){
                if((bkArr[i].zyz||bkArr[i].submitZyz)&&bkArr[i].isSaveTr===true){
                    if(count>0){
                        if(bkArr[i].checked){
                            let mnzybid='';
                            list.push({
                                id:'',
                                mnzybid,
                                sb:bkArr[i].sb||bkArr[i].writeSb,
                                sffc:bkArr[i].sffc,
                                xh:i+1,
                                yxmc:bkArr[i].yxmc||bkArr[i].submitYxmc,
                                yxxh:bkArr[i].yxxh||bkArr[i].selectedYxxh,
                                zyz:bkArr[i].zyz||bkArr[i].selectedZyz,
                                zydh1:bkArr[i].zy1,
                                zydh2:bkArr[i].zy2,
                                zydh3:bkArr[i].zy3,
                                zydh4:bkArr[i].zy4,
                                zydh5:bkArr[i].zy5,
                                zydh6:bkArr[i].zy6,
                                gzsj:bkArr[i].gzsj
                            });
                        }
                    }else{
                         let mnzybid='';
                        list.push({
                            id:'',
                            mnzybid,
                            sb:bkArr[i].sb||bkArr[i].writeSb,
                            sffc:bkArr[i].sffc,
                            xh:i+1,
                            yxmc:bkArr[i].yxmc||bkArr[i].submitYxmc,
                            yxxh:bkArr[i].yxxh||bkArr[i].selectedYxxh,
                            zyz:bkArr[i].zyz||bkArr[i].selectedZyz,
                            zydh1:bkArr[i].zy1,
                            zydh2:bkArr[i].zy2,
                            zydh3:bkArr[i].zy3,
                            zydh4:bkArr[i].zy4,
                            zydh5:bkArr[i].zy5,
                            zydh6:bkArr[i].zy6,
                            gzsj:bkArr[i].gzsj
                        });
                    }
                }
            }
            obj.list=list;
        }else if(pc==='7'){
            const list=[];
            const zkArr=[...this.zkCollectYx];
            // let count=0;
            // for(let i=0;i<zkArr.length;i++){
            //     if(zkArr[i].zyz&&zkArr[i].checked){
            //         count++;
            //     }
            // }
            // if(count>30){
            //     this.$message({message:"请选择要保存的30所院校",type:'warning',showClose:true});
            //     return;
            // }else if(zkArr.length>30&&count===0){
            //     this.$message({message:"请选择要保存的30所院校",type:'warning',showClose:true});
            //     return;
            // }
            // for(let i=0;i<zkArr.length;i++){
            //     if(zkArr[i].zyz){
            //         if(count>0){
            //             if(zkArr[i].checked){
            //         let mnzybid='';
            //         if(this.planObj.id){
            //             mnzybid=this.planObj.id;
            //         }
            //         list.push({
            //             id:'',
            //             mnzybid,
            //             sb:zkArr[i].sb,
            //             sffc:zkArr[i].sffc,
            //             xh:i+1,
            //             yxmc:zkArr[i].yxmc,
            //             yxxh:zkArr[i].yxxh,
            //             zyz:zkArr[i].zyz,
            //             zydh1:zkArr[i].zy1,
            //             zydh2:zkArr[i].zy2,
            //             zydh3:zkArr[i].zy3,
            //             zydh4:zkArr[i].zy4,
            //             zydh5:zkArr[i].zy5,
            //             zydh6:zkArr[i].zy6
            //         });
            //             }
            //         }else{
            //             if(i<30){
            //         let mnzybid='';
            //         if(this.planObj.id){
            //             mnzybid=this.planObj.id;
            //         }
            //         list.push({
            //             id:'',
            //             mnzybid,
            //             sb:zkArr[i].sb,
            //             sffc:zkArr[i].sffc,
            //             xh:i+1,
            //             yxmc:zkArr[i].yxmc,
            //             yxxh:zkArr[i].yxxh,
            //             zyz:zkArr[i].zyz,
            //             zydh1:zkArr[i].zy1,
            //             zydh2:zkArr[i].zy2,
            //             zydh3:zkArr[i].zy3,
            //             zydh4:zkArr[i].zy4,
            //             zydh5:zkArr[i].zy5,
            //             zydh6:zkArr[i].zy6
            //         });
            //             }
            //         }
            //     }
            // }
            let count=0;
            for(let i=0;i<zkArr.length;i++){
                if((zkArr[i].zyz||zkArr[i].submitZyz)&&zkArr[i].checked){
                    count++;
                }
            }
            let noSaveIndex=-1;
            for(let i=0;i<zkArr.length;i++){
                if(count>0){
                    if(zkArr[i].checked&&zkArr[i].isSaveTr===false&&
                    (zkArr[i].submitSb||zkArr[i].submitYxmc||zkArr[i].submitZyz)){
                        noSaveIndex=i;
                        break;
                    }
                }else{
                    if(zkArr[i].isSaveTr===false&&(zkArr[i].submitSb||zkArr[i].submitYxmc
                    ||zkArr[i].submitZyz)){
                        noSaveIndex=i;
                        break;
                    }
                }
            }
            if(noSaveIndex>=0){
                const noSaveMessage='第'+zkArr[noSaveIndex].index+'行'+(zkArr[noSaveIndex].submitYxmc
                ||zkArr[noSaveIndex].yxmc||'')+((zkArr[noSaveIndex].submitZyz||zkArr[noSaveIndex].selectedZyz)?
                    (zkArr[noSaveIndex].submitZyz||zkArr[noSaveIndex].selectedZyz)+'组':'')+'数据没有保存';
                this.$message({
                    message:noSaveMessage,
                    type:'warning',
                    showClose:true
                });
                return;
            }
            for(let i=0;i<zkArr.length;i++){
                if(zkArr[i].zyz||zkArr[i].submitZyz){
                    if(count>0){
                        if(zkArr[i].checked){
                            let mnzybid='';
                            list.push({
                                id:'',
                                mnzybid,
                                sb:zkArr[i].sb||zkArr[i].writeSb,
                                sffc:zkArr[i].sffc,
                                xh:i+1,
                                yxmc:zkArr[i].yxmc||zkArr[i].submitYxmc,
                                yxxh:zkArr[i].yxxh||zkArr[i].selectedYxxh,
                                zyz:zkArr[i].zyz||zkArr[i].selectedZyz,
                                zydh1:zkArr[i].zy1,
                                zydh2:zkArr[i].zy2,
                                zydh3:zkArr[i].zy3,
                                zydh4:zkArr[i].zy4,
                                zydh5:zkArr[i].zy5,
                                zydh6:zkArr[i].zy6,
                                gzsj:zkArr[i].gzsj
                            });
                        }
                    }else{
                        let mnzybid='';
                        list.push({
                            id:'',
                            mnzybid,
                            sb:zkArr[i].sb||zkArr[i].writeSb,
                            sffc:zkArr[i].sffc,
                            xh:i+1,
                            yxmc:zkArr[i].yxmc||zkArr[i].submitYxmc,
                            yxxh:zkArr[i].yxxh||zkArr[i].selectedYxxh,
                            zyz:zkArr[i].zyz||zkArr[i].selectedZyz,
                            zydh1:zkArr[i].zy1,
                            zydh2:zkArr[i].zy2,
                            zydh3:zkArr[i].zy3,
                            zydh4:zkArr[i].zy4,
                            zydh5:zkArr[i].zy5,
                            zydh6:zkArr[i].zy6,
                            gzsj:zkArr[i].gzsj
                        });
                    }
                }
            }
            obj.list=list;
        }else if(pc==='0'){
            const list=[];
            const bkArr=[...this.bkTqpCollectYx];
            let count=0;
            for(let i=0;i<bkArr.length;i++){
                if((bkArr[i].zyz||bkArr[i].submitZyz)&&bkArr[i].checked){
                    count++;
                }
            }
            let noSaveIndex=-1;
            for(let i=0;i<bkArr.length;i++){
                if(count>0){
                    if(bkArr[i].checked&&bkArr[i].isSaveTr===false&&
                    (bkArr[i].submitSb||bkArr[i].submitYxmc||bkArr[i].submitZyz)){
                        noSaveIndex=i;
                        break;
                    }
                }else{
                    if(bkArr[i].isSaveTr===false&&(bkArr[i].submitSb||bkArr[i].submitYxmc
                    ||bkArr[i].submitZyz)){
                        noSaveIndex=i;
                        break;
                    }
                }
            }
            if(noSaveIndex>=0){
                const noSaveMessage='第'+bkArr[noSaveIndex].index+'行'+(bkArr[noSaveIndex].submitYxmc
                ||bkArr[noSaveIndex].yxmc||'')+((bkArr[noSaveIndex].submitZyz||bkArr[noSaveIndex].selectedZyz)?
                    (bkArr[noSaveIndex].submitZyz||bkArr[noSaveIndex].selectedZyz)+'组':'')+'数据没有保存';
                this.$message({
                    message:noSaveMessage,
                    type:'warning',
                    showClose:true
                });
                return;
            }
            for(let i=0;i<bkArr.length;i++){
                if(bkArr[i].zyz||bkArr[i].submitZyz){
                    if(count>0){
                        if(bkArr[i].checked){
                            let mnzybid='';
                            list.push({
                                id:'',
                                mnzybid,
                                sb:bkArr[i].sb||bkArr[i].writeSb,
                                sffc:bkArr[i].sffc,
                                xh:i+1,
                                yxmc:bkArr[i].yxmc||bkArr[i].submitYxmc,
                                yxxh:bkArr[i].yxxh||bkArr[i].selectedYxxh,
                                zyz:bkArr[i].zyz||bkArr[i].selectedZyz,
                                zydh1:bkArr[i].zy1,
                                zydh2:bkArr[i].zy2,
                                zydh3:bkArr[i].zy3,
                                zydh4:bkArr[i].zy4,
                                zydh5:bkArr[i].zy5,
                                zydh6:bkArr[i].zy6,
                                gzsj:bkArr[i].gzsj
                            });
                        }
                    }else{
                         let mnzybid='';
                        list.push({
                            id:'',
                            mnzybid,
                            sb:bkArr[i].sb||bkArr[i].writeSb,
                            sffc:bkArr[i].sffc,
                            xh:i+1,
                            yxmc:bkArr[i].yxmc||bkArr[i].submitYxmc,
                            yxxh:bkArr[i].yxxh||bkArr[i].selectedYxxh,
                            zyz:bkArr[i].zyz||bkArr[i].selectedZyz,
                            zydh1:bkArr[i].zy1,
                            zydh2:bkArr[i].zy2,
                            zydh3:bkArr[i].zy3,
                            zydh4:bkArr[i].zy4,
                            zydh5:bkArr[i].zy5,
                            zydh6:bkArr[i].zy6,
                            gzsj:bkArr[i].gzsj
                        });
                    }
                }
            }
            obj.list=list;
        }else{
            const list=[];
            const zkArr=[...this.zkTqpCollectYx];
            let count=0;
            for(let i=0;i<zkArr.length;i++){
                if((zkArr[i].zyz||zkArr[i].submitZyz)&&zkArr[i].checked){
                    count++;
                }
            }
            let noSaveIndex=-1;
            for(let i=0;i<zkArr.length;i++){
                if(count>0){
                    if(zkArr[i].checked&&zkArr[i].isSaveTr===false&&
                    (zkArr[i].submitSb&&zkArr[i].submitYxmc||zkArr[i].submitZyz)){
                        noSaveIndex=i;
                        break;
                    }
                }else{
                    if(zkArr[i].isSaveTr===false&&(zkArr[i].submitSb||zkArr[i].submitYxmc
                    ||zkArr[i].submitZyz)){
                        noSaveIndex=i;
                        break;
                    }
                }
            }
            if(noSaveIndex>=0){
                const noSaveMessage='第'+zkArr[noSaveIndex].index+'行'+(zkArr[noSaveIndex].submitYxmc
                ||zkArr[noSaveIndex].yxmc||'')+((zkArr[noSaveIndex].submitZyz||zkArr[noSaveIndex].selectedZyz)?
                (zkArr[noSaveIndex].submitZyz||zkArr[noSaveIndex].selectedZyz)+'组':'')+'数据没有保存';
                this.$message({
                    message:noSaveMessage,
                    type:'warning',
                    showClose:true
                });
                return;
            }
            for(let i=0;i<zkArr.length;i++){
                if(zkArr[i].zyz||zkArr[i].submitZyz){
                    if(count>0){
                        if(zkArr[i].checked){
                            let mnzybid='';
                            list.push({
                                id:'',
                                mnzybid,
                                sb:zkArr[i].sb||zkArr[i].writeSb,
                                sffc:zkArr[i].sffc,
                                xh:i+1,
                                yxmc:zkArr[i].yxmc||zkArr[i].submitYxmc,
                                yxxh:zkArr[i].yxxh||zkArr[i].selectedYxxh,
                                zyz:zkArr[i].zyz||zkArr[i].selectedZyz,
                                zydh1:zkArr[i].zy1,
                                zydh2:zkArr[i].zy2,
                                zydh3:zkArr[i].zy3,
                                zydh4:zkArr[i].zy4,
                                zydh5:zkArr[i].zy5,
                                zydh6:zkArr[i].zy6,
                                gzsj:zkArr[i].gzsj
                            });
                        }
                    }else{
                        let mnzybid='';
                        list.push({
                            id:'',
                            mnzybid,
                            sb:zkArr[i].sb||zkArr[i].writeSb,
                            sffc:zkArr[i].sffc,
                            xh:i+1,
                            yxmc:zkArr[i].yxmc||zkArr[i].submitYxmc,
                            yxxh:zkArr[i].yxxh||zkArr[i].selectedYxxh,
                            zyz:zkArr[i].zyz||zkArr[i].selectedZyz,
                            zydh1:zkArr[i].zy1,
                            zydh2:zkArr[i].zy2,
                            zydh3:zkArr[i].zy3,
                            zydh4:zkArr[i].zy4,
                            zydh5:zkArr[i].zy5,
                            zydh6:zkArr[i].zy6,
                            gzsj:zkArr[i].gzsj
                        });
                    }
                }
            }
            obj.list=list;
        }
        obj.updatetime="";
        obj.zxkma=this.userInfo.zxkma;
        obj.zxkmb=this.userInfo.zxkmb;
        obj.yu=this.userInfo.ywcj;
        obj.shu=this.userInfo.sxcj;
        obj.wai=this.userInfo.wycj;
        obj.sxkmfs=this.userInfo.sxkmcj;
        obj.zxkmafs=this.userInfo.zxkmacj;
        obj.zxkmbfs=this.userInfo.zxkmbcj;
        obj.jf=this.userInfo.yfjf;
        obj.gjzxzg=this.userInfo.gjzxzg;
        obj.dfzxzg=this.userInfo.dfzxzg;
        obj.flag=0;
        console.log(obj);
        const res=await this.$http.postHttp("/mnzy/saveOrUpdateMnzy",obj);
        if(res.data.code===200){
            // if(res.data.message){
            //     this.$message({message:res.data.message,type:'success',showClose:true});
            // }else{
            //     this.$message({message:"保存成功",type:'success',showClose:true});
            // }
            this.dialogOtherVisible=false;
            this.dialogPlanVisible=false;
            this.otherPlan='';
        }else if(res.data.code===500){
            if(res.data.message){
                this.$message({message:res.data.message,type:'error'});
            }
        }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.data.code===0){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.status===409||res.status===410||res.status===411){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }
        this.dialogPlanVisible=false;
        // setTimeout(() => {
        //     this.$router.push('/main/zypg?reload=true&&toCollect=true&&time='+new Date().getTime());
        //     window.location.reload();
        // }, 2000);
    },
    // 删除方案代码
    async deleteCode(id){
        const resMessageBox=await this.ElementMessageBoxFun();
        if(resMessageBox=='confirm'){
            const res=await this.$http.getHttp("/mnzy/delMnzyById?id="+id);
            if(res.data.code===200){
                if(res.data.message){
                    this.$message({message:res.data.message,type:'success',showClose:true});
                }else{
                    this.$message({message:"删除成功",type:"success",showClose:true});
                }
                await this.getZyfaList();
                // this.planList=[];
                this.$forceUpdate();
                this.updatePlan=!this.updatePlan;
            }else if(res.data.code===500){
                if(res.data.message){
                    this.$message({message:res.data.message,type:'error'});
                }
            }else if(res.status===401){
                this.$message({message: '登录超时，请重新登录',type:"error"});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
            }else if(res.data.code===0){
                this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
            }else if(res.status===409||res.status===410||res.status===411){
                this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
            }
            this.dialogDeleteVisible=false;
        }else{
            this.$message({
                type:'warning',
                message:"您取消了操作"
            });
        }
    },
    ElementMessageBoxFun(){
        return new Promise((resolve,reject)=>{
            MessageBox.confirm('此操作将永久删除该方案, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then((res)=>{
                resolve(res);
            }).catch((err)=>{
                resolve(err)
            });
        });
    },
    // 根据方案名获取方案信息
    async getPlanContent(plan,pc,id){
        let loadId="";
        if(pc===6||pc==='6'){
            loadId="bk-data";
        }else if(pc===7||pc==='7'){
            loadId="zk-data";
        }else if(pc===0||pc==='0'){
            loadId="bkTqp-data";
        }else{
            loadId="zkTqp-data";
        }
        this.activePcName=pc+'';
        if(pc===6||pc==='6'){
            this.activePcName="6";
            const loading=this.$loading({fullscreen:true,target:document.getElementById("bk-data"),text:"正在加载中"});
            const res=await this.$http.getHttp("/mnzy/getMnzyByPlan?plan="+plan);
            console.log(res);
            if(res.data.code===200){
                if(res.data.obj&&res.data.obj.XgkMnzyPojo){
                    const list=[...res.data.obj.XgkMnzyPojo.list];
                    if(list&&list.length>0){
                        const arr=[];
                        for(let i=0;i<list.length;i++){
                            let flag1=false;
                            for(let j=1;j<=6;j++){
                                if(list[i]['zy'+j]){
                                    flag1=true;
                                    break;
                                }
                            }
                            arr.push({
                                sb:list[i].sb,
                                sffc:(list[i].sffc+''),
                                yxmc:list[i].yxmc,
                                yxxh:list[i].yxxh,
                                zyz:list[i].zyz,
                                index:(i+1),
                                checked:list[i].isRed||false,
                                radioChecked:false,
                                pc:6,
                                zy1:list[i].zydh1,
                                zy2:list[i].zydh2,
                                zy3:list[i].zydh3,
                                zy4:list[i].zydh4,
                                zy5:list[i].zydh5,
                                zy6:list[i].zydh6,
                                chooseFlag:flag1
                            });
                        }
                        const nullLen=45-arr.length;
                        const nullArr=[];
                        for(let i=0;i<nullLen;i++){
                            const obj={};
                            obj.checked=false;
                            obj.radioChecked=false;
                            obj.index=arr.length+(i+1);
                            obj.sb="";
                            obj.yxmc="";
                            obj.yxmcs=[];
                            obj.zyzs=[];
                            obj.zys=[];
                            obj.pc=6;
                            obj.zyz="";
                            obj.zy1="";
                            obj.zy2="";
                            obj.zy3="";
                            obj.zy4="";
                            obj.zy5="";
                            obj.zy6="";
                            obj.sffc="1";
                            obj.chooseFlag=false;
                            obj.sffcs=[
                                {name:"服从",value:"1"},
                                {name:"不服从",value:"0"}
                            ];
                            nullArr.push(obj);
                        }
                        this.bkCollectYx=arr.concat(nullArr);
                    }else{
                        this.createBkNullData();
                    }
                    this.planObj.plan=res.data.obj.XgkMnzyPojo.plan;
                    this.planObj.time=res.data.obj.XgkMnzyPojo.updatetime;
                    this.planObj.id=id;
                    if(res.data.obj.users){
                        this.$store.dispatch('saveUserInfo',res.data.obj.users);
                    }
                    // const yhlb=this.userInfo.yhlb;
                    // if(yhlb===7||yhlb===9){
                    //     await this.updateInfo(user);
                    // }
                }else if(res.data.obj&&res.data.obj.yhgzyxList){
                    const list=[...res.data.obj.yhgzyxList];
                    const time=list[0]?list[0].gzsj:'';
                    if(list&&list.length>0){
                        const arr=[];
                        for(let i=0;i<list.length;i++){
                            let flag1=false;
                            for(let j=1;j<=6;j++){
                                if(list[i]['zy'+j]){
                                    flag1=true;
                                    break;
                                }
                            }
                            arr.push({
                                sb:list[i].sb,
                                sffc:(list[i].sffc+''),
                                yxmc:list[i].yxmc,
                                yxxh:list[i].yxxh,
                                zyz:list[i].zyz,
                                index:(i+1),
                                checked:list[i].isRed||false,
                                radioChecked:false,
                                pc:6,
                                zy1:list[i].zydh1,
                                zy2:list[i].zydh2,
                                zy3:list[i].zydh3,
                                zy4:list[i].zydh4,
                                zy5:list[i].zydh5,
                                zy6:list[i].zydh6,
                                chooseFlag:flag1
                            });
                        }
                        const nullLen=45-arr.length;
                        const nullArr=[];
                        for(let i=0;i<nullLen;i++){
                            const obj={};
                            obj.checked=false;
                            obj.radioChecked=false;
                            obj.index=arr.length+(i+1);
                            obj.sb="";
                            obj.yxmc="";
                            obj.yxmcs=[];
                            obj.zyzs=[];
                            obj.zys=[];
                            obj.pc=6;
                            obj.zyz="";
                            obj.zy1="";
                            obj.zy2="";
                            obj.zy3="";
                            obj.zy4="";
                            obj.zy5="";
                            obj.zy6="";
                            obj.sffc="1";
                            obj.sffcs=[
                                {name:"服从",value:"1"},
                                {name:"不服从",value:"0"}
                            ];
                            obj.chooseFlag=false;
                            nullArr.push(obj);
                        }
                        this.bkCollectYx=arr.concat(nullArr);
                    }else{
                        this.createBkNullData();
                    }
                    this.planObj.plan=res.data.obj.plan;
                    this.planObj.time=time;
                    this.planObj.id=id;
                    if(res.data.obj.users){
                        this.$store.dispatch('saveUserInfo',res.data.obj.users);
                    }
                }else if(res.data.obj&&(res.data.obj.bk.length>0||res.data.obj.zk.length>0
                ||res.data.obj.bktqp.length>0||res.data.obj.zktqp.length>0)){
                    this.createBkNullData();
                    this.createZkNullData();
                    this.createBkTqpNullData();
                    this.createZkTqpNullData();
                    this.sortBkYhgzYx(res);
                    this.sortZkYhgzYx(res);
                    this.sortBkTqpYhgzYx(res);
                    this.sortZkTqpYhgzYx(res);
                    this.planObj.plan=res.data.obj.plan;
                    this.planObj.time=res.data.obj.updateTime;
                    this.planObj.id=id;
                    if(res.data.obj.users){
                        this.$store.dispatch('saveUserInfo',res.data.obj.users);
                    }
                }else{
                    this.createBkNullData();
                    this.createZkNullData();
                    this.createBkTqpNullData();
                    this.createZkTqpNullData();
                    this.planObj.plan=res.data.obj.plan;
                    this.planObj.time=res.data.obj.updateTime;
                    this.planObj.id=id;
                    if(res.data.obj.users){
                        this.$store.dispatch('saveUserInfo',res.data.obj.users);
                    }
                }
            }else if(res.data.code===500){
                if(res.data.message){
                    this.$message({message:res.data.message,type:'error'});
                }
            }else if(res.status===401){
                this.$message({message: '登录超时，请重新登录',type:"error"});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
            }else if(res.data.code===0){
                this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
            }
            loading.close();
        }else if(pc===7||pc==='7'){
            this.activePcName="7";
            const loading=this.$loading({fullscreen:true,target:document.getElementById("zk-data"),text:"正在加载中"});
            const res=await this.$http.getHttp("/mnzy/getMnzyByPlan?plan="+plan);
            if(res.data.code===200){
                if(res.data.obj&&res.data.obj.XgkMnzyPojo){
                    const list=[...res.data.obj.XgkMnzyPojo.list];
                    if(list&&list.length>0){
                        const arr=[];
                        for(let i=0;i<list.length;i++){
                            let flag1=false;
                            for(let j=1;j<=6;j++){
                                if(list[i]['zy'+j]){
                                    flag1=true;
                                    break;
                                }
                            }
                            arr.push({
                                sb:list[i].sb,
                                sffc:(list[i].sffc+''),
                                yxmc:list[i].yxmc,
                                yxxh:list[i].yxxh,
                                zyz:list[i].zyz,
                                index:(i+1),
                                checked:list[i].isRed||false,
                                radioChecked:false,
                                pc:7,
                                zy1:list[i].zydh1,
                                zy2:list[i].zydh2,
                                zy3:list[i].zydh3,
                                zy4:list[i].zydh4,
                                zy5:list[i].zydh5,
                                zy6:list[i].zydh6,
                                chooseFlag:flag1
                            });
                        }
                        const nullLen=30-arr.length;
                        const nullArr=[];
                        for(let i=0;i<nullLen;i++){
                            const obj={};
                            obj.checked=false;
                            obj.radioChecked=false;
                            obj.index=arr.length+(i+1);
                            obj.sb="";
                            obj.yxmc="";
                            obj.yxmcs=[];
                            obj.zyzs=[];
                            obj.zys=[];
                            obj.pc=7;
                            obj.zyz="";
                            obj.zy1="";
                            obj.zy2="";
                            obj.zy3="";
                            obj.zy4="";
                            obj.zy5="";
                            obj.zy6="";
                            obj.sffc="1";
                            obj.sffcs=[
                                {name:"服从",value:"1"},
                                {name:"不服从",value:"0"}
                            ];
                            obj.chooseFlag=false;
                            nullArr.push(obj);
                        }
                        this.zkCollectYx=arr.concat(nullArr);
                    }
                    this.planObj.plan=res.data.obj.XgkMnzyPojo.plan;
                    this.planObj.time=res.data.obj.XgkMnzyPojo.updatetime;
                    this.planObj.id=id;
                    if(res.data.obj.users){
                        this.$store.dispatch('saveUserInfo',res.data.obj.users);
                    }
                }else if(res.data.obj&&res.data.obj.yhgzyxList){
                    const list=[...res.data.obj.yhgzyxList];
                    const time=list[0]?list[0].gzsj:'';
                    if(list&&list.length>0){
                        const arr=[];
                        for(let i=0;i<list.length;i++){
                            let flag1=false;
                            for(let j=1;j<=6;j++){
                                if(list[i]['zy'+j]){
                                    flag1=true;
                                    break;
                                }
                            }
                            arr.push({
                                sb:list[i].sb,
                                sffc:(list[i].sffc+''),
                                yxmc:list[i].yxmc,
                                yxxh:list[i].yxxh,
                                zyz:list[i].zyz,
                                index:(i+1),
                                checked:list[i].isRed||false,
                                radioChecked:false,
                                pc:7,
                                zy1:list[i].zydh1,
                                zy2:list[i].zydh2,
                                zy3:list[i].zydh3,
                                zy4:list[i].zydh4,
                                zy5:list[i].zydh5,
                                zy6:list[i].zydh6,
                                chooseFlag:flag1
                            });
                        }
                        const nullLen=30-arr.length;
                        const nullArr=[];
                        for(let i=0;i<nullLen;i++){
                            const obj={};
                            obj.checked=false;
                            obj.radioChecked=false;
                            obj.index=arr.length+(i+1);
                            obj.sb="";
                            obj.yxmc="";
                            obj.yxmcs=[];
                            obj.zyzs=[];
                            obj.zys=[];
                            obj.pc=7;
                            obj.zyz="";
                            obj.zy1="";
                            obj.zy2="";
                            obj.zy3="";
                            obj.zy4="";
                            obj.zy5="";
                            obj.zy6="";
                            obj.sffc="1";
                            obj.sffcs=[
                                {name:"服从",value:"1"},
                                {name:"不服从",value:"0"}
                            ];
                            obj.chooseFlag=false;
                            nullArr.push(obj);
                        }
                        this.zkCollectYx=arr.concat(nullArr);
                    }else{
                        this.createZkNullData();
                    }
                    this.planObj.plan=res.data.obj.plan;
                    this.planObj.time=time;
                    this.planObj.id=id;
                    if(res.data.obj.users){
                        this.$store.dispatch('saveUserInfo',res.data.obj.users);
                    }
                }else if(res.data.obj&&(res.data.obj.bk.length>0||res.data.obj.zk.length>0
                ||res.data.obj.bktqp.length>0||res.data.obj.zktqp.length>0)){
                    this.createBkNullData();
                    this.createZkNullData();
                    this.createBkTqpNullData();
                    this.createZkTqpNullData();
                    this.sortBkYhgzYx(res);
                    this.sortZkYhgzYx(res);
                    this.sortBkTqpYhgzYx(res);
                    this.sortZkTqpYhgzYx(res);
                    this.planObj.plan=res.data.obj.plan;
                    this.planObj.time=res.data.obj.updateTime;
                    this.planObj.id=id;
                    if(res.data.obj.users){
                        this.$store.dispatch('saveUserInfo',res.data.obj.users);
                    }
                }else{               
                    this.createBkNullData();
                    this.createZkNullData();
                    this.createBkTqpNullData();
                    this.createZkTqpNullData();
                }
            }else if(res.data.code===500){
            if(res.data.message){
                this.$message({message:res.data.message,type:'error'});
            }
            }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
            }else if(res.data.code===0){
                this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
            }else if(res.status===409||res.status===410||res.status===411){
                this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
            }
            loading.close();
        }else if(pc===0||pc==='0'){
            this.activePcName="0";
            const loading=this.$loading({fullscreen:true,target:document.getElementById("bkTqp-data"),text:"正在加载中"});
            const res=await this.$http.getHttp("/mnzy/getMnzyByPlan?plan="+plan);
            if(res.data.code===200){
                if(res.data.obj&&res.data.obj.XgkMnzyPojo){
                    const list=[...res.data.obj.XgkMnzyPojo.list];
                    if(list&&list.length>0){
                        const arr=[];
                        for(let i=0;i<list.length;i++){
                            let flag1=false;
                            for(let j=1;j<=6;j++){
                                if(list[i]['zy'+j]){
                                    flag1=true;
                                    break;
                                }
                            }
                            arr.push({
                                sb:list[i].sb,
                                sffc:(list[i].sffc+''),
                                yxmc:list[i].yxmc,
                                yxxh:list[i].yxxh,
                                zyz:list[i].zyz,
                                index:(i+1),
                                checked:list[i].isRed||false,
                                radioChecked:false,
                                pc:0,
                                zy1:list[i].zydh1,
                                zy2:list[i].zydh2,
                                zy3:list[i].zydh3,
                                zy4:list[i].zydh4,
                                zy5:list[i].zydh5,
                                zy6:list[i].zydh6,
                                chooseFlag:flag1
                            });
                        }
                        const nullLen=45-arr.length;
                        const nullArr=[];
                        for(let i=0;i<nullLen;i++){
                            const obj={};
                            obj.checked=false;
                            obj.radioChecked=false;
                            obj.index=arr.length+(i+1);
                            obj.sb="";
                            obj.yxmc="";
                            obj.yxmcs=[];
                            obj.zyzs=[];
                            obj.zys=[];
                            obj.pc=0;
                            obj.zyz="";
                            obj.zy1="";
                            obj.zy2="";
                            obj.zy3="";
                            obj.zy4="";
                            obj.zy5="";
                            obj.zy6="";
                            obj.sffc="1";
                            obj.sffcs=[
                                {name:"服从",value:"1"},
                                {name:"不服从",value:"0"}
                            ];
                            obj.chooseFlag=false;
                            nullArr.push(obj);
                        }
                        this.bkTqpCollectYx=arr.concat(nullArr);
                    }else{
                        this.createBkTqpNullData();
                    }
                    this.planObj.plan=res.data.obj.XgkMnzyPojo.plan;
                    this.planObj.time=res.data.obj.XgkMnzyPojo.updatetime;
                    this.planObj.id=id;
                    if(res.data.obj.users){
                        this.$store.dispatch('saveUserInfo',res.data.obj.users);
                    }
                }else if(res.data.obj&&res.data.obj.yhgzyxList){
                    const list=[...res.data.obj.XgkMnzyPojo.list];
                    const time=list[0]?list[0].time:'';
                    if(list&&list.length>0){
                        const arr=[];
                        for(let i=0;i<list.length;i++){
                            let flag1=false;
                            for(let j=1;j<=6;j++){
                                if(list[i]['zy'+j]){
                                    flag1=true;
                                    break;
                                }
                            }
                            arr.push({
                                sb:list[i].sb,
                                sffc:(list[i].sffc+''),
                                yxmc:list[i].yxmc,
                                yxxh:list[i].yxxh,
                                zyz:list[i].zyz,
                                index:(i+1),
                                checked:list[i].isRed||false,
                                radioChecked:false,
                                pc:0,
                                zy1:list[i].zydh1,
                                zy2:list[i].zydh2,
                                zy3:list[i].zydh3,
                                zy4:list[i].zydh4,
                                zy5:list[i].zydh5,
                                zy6:list[i].zydh6,
                                chooseFlag:flag1
                            });
                        }
                        const nullLen=45-arr.length;
                        const nullArr=[];
                        for(let i=0;i<nullLen;i++){
                            const obj={};
                            obj.checked=false;
                            obj.radioChecked=false;
                            obj.index=arr.length+(i+1);
                            obj.sb="";
                            obj.yxmc="";
                            obj.yxmcs=[];
                            obj.zyzs=[];
                            obj.zys=[];
                            obj.pc=0;
                            obj.zyz="";
                            obj.zy1="";
                            obj.zy2="";
                            obj.zy3="";
                            obj.zy4="";
                            obj.zy5="";
                            obj.zy6="";
                            obj.sffc="1";
                            obj.sffcs=[
                                {name:"服从",value:"1"},
                                {name:"不服从",value:"0"}
                            ];
                            obj.chooseFlag=false;
                            nullArr.push(obj);
                        }
                        this.bkTqpCollectYx=arr.concat(nullArr);
                    }else{
                        this.createBkTqpNullData();
                    }
                    this.planObj.plan=res.data.obj.plan;
                    this.planObj.time=time;
                    this.planObj.id=id;
                    if(res.data.obj.users){
                        this.$store.dispatch('saveUserInfo',res.data.obj.users);
                    }
                }else if(res.data.obj&&(res.data.obj.bk.length>0||res.data.obj.zk.length>0
                ||res.data.obj.bktqp.length>0||res.data.obj.zktqp.length>0)){
                    this.createBkNullData();
                    this.createZkNullData();
                    this.createBkTqpNullData();
                    this.createZkTqpNullData();
                    this.sortBkYhgzYx(res);
                    this.sortZkYhgzYx(res);
                    this.sortBkTqpYhgzYx(res);
                    this.sortZkTqpYhgzYx(res);
                    this.planObj.plan=res.data.obj.plan;
                    this.planObj.time=res.data.obj.updateTime;
                    this.planObj.id=id;
                    if(res.data.obj.users){
                        this.$store.dispatch('saveUserInfo',res.data.obj.users);
                    }
                }else{
                    this.createBkNullData();
                    this.createZkNullData();
                    this.createBkTqpNullData();
                    this.createZkTqpNullData();
                }
            }else if(res.data.code===500){
                if(res.data.message){
                    this.$message({message:res.data.message,type:'error'});
                }
            }else if(res.status===401){
                this.$message({message: '登录超时，请重新登录',type:"error"});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
            }else if(res.data.code===0){
                this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
            }else if(res.status===409||res.status===410||res.status===411){
                this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
            }
            loading.close();
        }else{
            this.activePcName="9";
            const loading=this.$loading({fullscreen:true,target:document.getElementById("zkTqp-data"),text:"正在加载中"});
            const res=await this.$http.getHttp("/mnzy/getMnzyByPlan?plan="+plan);
            if(res.data.code===200){
                if(res.data.obj&&res.data.obj.XgkMnzyPojo){
                    const list=[...res.data.obj.XgkMnzyPojo.list];
                    if(list&&list.length>0){
                        const arr=[];
                        for(let i=0;i<list.length;i++){
                            let flag1=false;
                            for(let j=1;j<=6;j++){
                                if(list[i]['zy'+j]){
                                    flag1=true;
                                    break;
                                }
                            }
                            arr.push({
                                sb:list[i].sb,
                                sffc:(list[i].sffc+''),
                                yxmc:list[i].yxmc,
                                yxxh:list[i].yxxh,
                                zyz:list[i].zyz,
                                index:(i+1),
                                checked:list[i].isRed||false,
                                radioChecked:false,
                                pc:7,
                                zy1:list[i].zydh1,
                                zy2:list[i].zydh2,
                                zy3:list[i].zydh3,
                                zy4:list[i].zydh4,
                                zy5:list[i].zydh5,
                                zy6:list[i].zydh6,
                                chooseFlag:flag1
                            });
                        }
                        const nullLen=30-arr.length;
                        const nullArr=[];
                        for(let i=0;i<nullLen;i++){
                            const obj={};
                            obj.checked=false;
                            obj.radioChecked=false;
                            obj.index=arr.length+(i+1);
                            obj.sb="";
                            obj.yxmc="";
                            obj.yxmcs=[];
                            obj.zyzs=[];
                            obj.zys=[];
                            obj.pc=9;
                            obj.zyz="";
                            obj.zy1="";
                            obj.zy2="";
                            obj.zy3="";
                            obj.zy4="";
                            obj.zy5="";
                            obj.zy6="";
                            obj.sffc="1";
                            obj.sffcs=[
                                {name:"服从",value:"1"},
                                {name:"不服从",value:"0"}
                            ];
                            obj.chooseFlag=false;
                            nullArr.push(obj);
                        }
                        this.zkTqpCollectYx=arr.concat(nullArr);
                    }else{
                        this.createZkTqpNullData();
                    }
                    this.planObj.plan=res.data.obj.XgkMnzyPojo.plan;
                    this.planObj.time=res.data.obj.XgkMnzyPojo.updatetime;
                    this.planObj.id=id;
                    if(res.data.obj.users){
                        this.$store.dispatch('saveUserInfo',res.data.obj.users);
                    }
                }else if(res.data.obj&&res.data.obj.yhgzyxList){
                    const list=[...res.data.obj.XgkMnzyPojo.list];
                    const time=list[0]?list[0].gzsj:'';
                    if(list&&list.length>0){
                        const arr=[];
                        for(let i=0;i<list.length;i++){
                            let flag1=false;
                            for(let j=1;j<=6;j++){
                                if(list[i]['zy'+j]){
                                    flag1=true;
                                    break;
                                }
                            }
                            arr.push({
                                sb:list[i].sb,
                                sffc:(list[i].sffc+''),
                                yxmc:list[i].yxmc,
                                yxxh:list[i].yxxh,
                                zyz:list[i].zyz,
                                index:(i+1),
                                checked:list[i].isRed||false,
                                radioChecked:false,
                                pc:7,
                                zy1:list[i].zydh1,
                                zy2:list[i].zydh2,
                                zy3:list[i].zydh3,
                                zy4:list[i].zydh4,
                                zy5:list[i].zydh5,
                                zy6:list[i].zydh6,
                                chooseFlag:flag1
                            });
                        }
                        const nullLen=30-arr.length;
                        const nullArr=[];
                        for(let i=0;i<nullLen;i++){
                            const obj={};
                            obj.checked=false;
                            obj.radioChecked=false;
                            obj.index=arr.length+(i+1);
                            obj.sb="";
                            obj.yxmc="";
                            obj.yxmcs=[];
                            obj.zyzs=[];
                            obj.zys=[];
                            obj.pc=9;
                            obj.zyz="";
                            obj.zy1="";
                            obj.zy2="";
                            obj.zy3="";
                            obj.zy4="";
                            obj.zy5="";
                            obj.zy6="";
                            obj.sffc="1";
                            obj.sffcs=[
                                {name:"服从",value:"1"},
                                {name:"不服从",value:"0"}
                            ];
                            obj.chooseFlag=false;
                            nullArr.push(obj);
                        }
                        this.zkTqpCollectYx=arr.concat(nullArr);
                    }else{
                        this.createZkTqpNullData();
                    }
                    this.planObj.plan=res.data.obj.plan;
                    this.planObj.time=time;
                    this.planObj.id=id;
                    if(res.data.obj.users){
                        this.$store.dispatch('saveUserInfo',res.data.obj.users);
                    }
                }else if(res.data.obj&&(res.data.obj.bk.length>0||res.data.obj.zk.length>0
                ||res.data.obj.bktqp.length>0||res.data.obj.zktqp.length>0)){
                    this.createBkNullData();
                    this.createZkNullData();
                    this.createBkTqpNullData();
                    this.createZkTqpNullData();
                    this.sortBkYhgzYx(res);
                    this.sortZkYhgzYx(res);
                    this.sortBkTqpYhgzYx(res);
                    this.sortZkTqpYhgzYx(res);
                    this.planObj.plan=res.data.obj.plan;
                    this.planObj.time=res.data.obj.updateTime;
                    this.planObj.id=id;
                    if(res.data.obj.users){
                        this.$store.dispatch('saveUserInfo',res.data.obj.users);
                    }
                }else{
                    this.createBkNullData();
                    this.createZkNullData();
                    this.createBkTqpNullData();
                    this.createZkTqpNullData();
                }
            }else if(res.data.code===500){
                if(res.data.message){
                    this.$message({message:res.data.message,type:'error'});
                }
            }else if(res.status===401){
                this.$message({message: '登录超时，请重新登录',type:"error"});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
            }else if(res.data.code===0){
                this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
            }else if(res.status===409||res.status===410||res.status===411){
                this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
            }
            loading.close();
        }
        if(pc===6||pc==='6'){
            loadId="bk-data";
                this.createZkNullData();
                this.createBkTqpNullData();
                this.createZkTqpNullData();
        }else if(pc===7||pc==='7'){
            loadId="zk-data";
            this.createBkNullData();
            this.createBkTqpNullData();
            this.createZkTqpNullData();
        }else if(pc===0||pc==='0'){
            loadId="bkTqp-data";
            this.createZkTqpNullData();
            this.createBkNullData();
            this.createZkNullData();
        }else{
            loadId="zkTqp-data";
            this.createBkTqpNullData();
            this.createBkNullData();
            this.createZkNullData();
        }
        this.$emit('reloadYhGzYx','true');
    },
    // 获取最后一次保存的方案
    async getLastPlan(){
        // const loading=this.$loading({fullscreen:true,target:document.getElementById('bk-load'),text:'正在加载中'});
        // const loading2=this.$loading({fullscreen:true,target:document.getElementById('zk-load'),text:'正在加载中'});
        const loading=this.$loading({fullscreen:true,target:document.getElementById('out-load-tab'),text:'正在加载中'});
        const res=await this.$http.getHttp("/mnzy/getLastMnzyb");
        console.log(res);
        if(res.data.code===200){
            if(res.data.obj.mnzyb){
                const list=res.data.obj.mnzyb.list;
                // const param=res.data.obj.mnzyb.param;
                // if(list.length===0&&param&&param.indexOf(',')>=0){
                //     const arr1=param.split(',');
                //     const contentArr=[];
                //     for(let i=0;i<arr1.length;i++){
                //         const arr2=arr1[i].split('-');
                //         const obj={};
                //         obj.sb=arr2[0];
                //         obj.index=(i+1);
                //         obj.yxmc=arr2[1];
                //         obj.yxxh=arr2[2];
                //         obj.pc=arr2[3];
                //         obj.zyz=arr2[4];
                //         obj.sffc=arr2[5];
                //         const zys=arr2[6];
                //         if(zys&&zys!==''){
                //             let arr3=zys.split("_");
                //             arr3=arr3.filter(item=>item!=='');
                //             for(let i=0;i<arr3.length;i++){
                //                 if(arr3[i]){
                //                     obj["zy"+(i+1)]=arr3[i];
                //                 }
                //             }
                //         }
                //         obj.checked=arr2[7]===1;
                //         contentArr.push(obj);
                //     }
                //     const pc=res.data.obj.mnzyb.pc;
                //     if(pc===6){
                //         const nullArr=[];
                //         const nullLen=45-contentArr.length;
                //         for(let i=0;i<nullLen;i++){
                //             const obj={};
                //             obj.checked=false;
                //             obj.sb="";
                //             obj.index=(contentArr.length)+i+1;
                //             obj.yxmc="";
                //             obj.yxmcs=[];
                //             obj.zyzs=[];
                //             obj.zys=[];
                //             obj.pc=6;
                //             obj.zyz="";
                //             obj.zy1="";
                //             obj.zy2="";
                //             obj.zy3="";
                //             obj.zy4="";
                //             obj.zy5="";
                //             obj.zy6="";
                //             obj.sffc="1";
                //             obj.sffcs=[
                //                 {name:"服从",value:"1"},
                //                 {name:"不服从",value:"0"}
                //             ];
                //             nullArr.push(obj);
                //         }
                //         this.bkYxPlan=contentArr.concat(nullArr);
                //     }else{
                //         const nullArr=[];
                //         const nullLen=30-contentArr.length;
                //         for(let i=0;i<nullLen;i++){
                //             const obj={};
                //             obj.checked=false;
                //             obj.sb="";
                //             obj.index=contentArr.length+i+1;
                //             obj.yxmc="";
                //             obj.yxmcs=[];
                //             obj.zyzs=[];
                //             obj.zys=[];
                //             obj.pc=7;
                //             obj.zyz="";
                //             obj.zy1="";
                //             obj.zy2="";
                //             obj.zy3="";
                //             obj.zy4="";
                //             obj.zy5="";
                //             obj.zy6="";
                //             obj.sffc="1";
                //             obj.sffcs=[
                //                 {name:"服从",value:"1"},
                //                 {name:"不服从",value:"0"}
                //             ];
                //             nullArr.push(obj);
                //         }
                //         this.zkYxPlan=contentArr.concat(nullArr);
                //     }
                //     this.planObj.plan=res.data.obj.mnzyb.plan;
                //     this.planObj.time=res.data.obj.mnzyb.updatetime;
                //     this.planObj.id=res.data.obj.mnzyb.id;
                // }
                 if(list.length>0){
                    const pc=res.data.obj.mnzyb.pc;
                    const yxZyzs=[];
                    const data=res.data.obj.mnzyb.list;
                    for(let i=0;i<data.length;i++){
                        let flag1=false;
                        for(let j=1;j<7;j++){
                            if(data[i]['zydh'+j]){
                                flag1=true;
                            }
                        }
                        yxZyzs.push({
                            ...data[i],
                            index:(i+1),
                            sb:data[i].sb,
                            sffc:(data[i].sffc+''),
                            xh:i+1,
                            checked:data[i].isRed||false,
                            radioChecked:false,
                            yxmc:data[i].yxmc,
                            yxxh:data[i].yxxh,
                            yxmcs:[],
                            zyzs:[],
                            zyz:data[i].zyz,
                            zy1:data[i].zydh1,
                            zy2:data[i].zydh2,
                            zy3:data[i].zydh3,
                            zy4:data[i].zydh4,
                            zy5:data[i].zydh5,
                            zy6:data[i].zydh6,
                            isSaveTr:true,
                            chooseFlag:flag1
                        });
                    }
                    if(pc===6){
                        const nullArr=[];
                        const nullLen=45-data.length;
                        for(let i=0;i<nullLen;i++){
                                const obj={};
                                obj.checked=false;
                                obj.radioChecked=false;
                                obj.sb="";
                                obj.index=data.length+i+1;
                                obj.yxmc="";
                                obj.yxmcs=[];
                                obj.zyzs=[];
                                obj.zys=[];
                                obj.pc=6;
                                obj.zyz="";
                                obj.zy1="";
                                obj.zy2="";
                                obj.zy3="";
                                obj.zy4="";
                                obj.zy5="";
                                obj.zy6="";
                                obj.sffc="1";
                                obj.sffcs=[
                                    {name:"服从",value:"1"},
                                    {name:"不服从",value:"0"}
                                ];
                                obj.isSaveTr=false;
                                obj.chooseFlag=false;
                                nullArr.push(obj);
                        }
                        this.bkCollectYx=yxZyzs.concat(nullArr);
                        this.createZkNullData();
                        this.createBkTqpNullData();
                        this.createZkTqpNullData();
                        // for(let i=0;i<30;i++){
                        //     const obj={};
                        //     obj.checked=false;
                        //     obj.sb="";
                        //     obj.index=i+1;
                        //     obj.pc=7;
                        //     obj.yxmc="";
                        //     obj.yxmcs=[];
                        //     obj.zyzs=[];
                        //     obj.zys=[];
                        //     obj.zyz="";
                        //     obj.zy1="";
                        //     obj.zy2="";
                        //     obj.zy3="";
                        //     obj.zy4="";
                        //     obj.zy5="";
                        //     obj.zy6="";
                        //     obj.sffc="1";
                        //     obj.sffcs=[
                        //         {name:"服从",value:"1"},
                        //         {name:"不服从",value:"0"}
                        //     ];
                        //     this.zkYxPlan.push(obj);
                        // };
                    }else if(pc===7){
                        const nullArr=[];
                        const nullLen=30-data.length;
                        for(let i=0;i<nullLen;i++){
                                const obj={};
                                obj.checked=false;
                                obj.radioChecked=false;
                                obj.sb="";
                                obj.index=data.length+i+1;
                                obj.yxmc="";
                                obj.yxmcs=[];
                                obj.zyzs=[];
                                obj.zys=[];
                                obj.pc=6;
                                obj.zyz="";
                                obj.zy1="";
                                obj.zy2="";
                                obj.zy3="";
                                obj.zy4="";
                                obj.zy5="";
                                obj.zy6="";
                                obj.sffc="1";
                                obj.sffcs=[
                                    {name:"服从",value:"1"},
                                    {name:"不服从",value:"0"}
                                ];
                                obj.isSaveTr=false;
                                obj.chooseFlag=false;
                                nullArr.push(obj);
                        }
                        this.zkCollectYx=yxZyzs.concat(nullArr);
                        this.createBkNullData();
                        this.createBkTqpNullData();
                        this.createZkTqpNullData();
                    }else if(pc===0){
                        const nullArr=[];
                        const nullLen=45-data.length;
                        for(let i=0;i<nullLen;i++){
                                const obj={};
                                obj.checked=false;
                                obj.radioChecked=false;
                                obj.sb="";
                                obj.index=data.length+i+1;
                                obj.yxmc="";
                                obj.yxmcs=[];
                                obj.zyzs=[];
                                obj.zys=[];
                                obj.pc=0;
                                obj.zyz="";
                                obj.zy1="";
                                obj.zy2="";
                                obj.zy3="";
                                obj.zy4="";
                                obj.zy5="";
                                obj.zy6="";
                                obj.sffc="1";
                                obj.sffcs=[
                                    {name:"服从",value:"1"},
                                    {name:"不服从",value:"0"}
                                ];
                                obj.isSaveTr=false;
                                obj.chooseFlag=false;
                                nullArr.push(obj);
                        }
                        this.bkTqpCollectYx=yxZyzs.concat(nullArr);
                        this.createBkNullData();
                        this.createZkNullData();
                        this.createZkTqpNullData();
                        // for(let i=0;i<30;i++){
                        //     const obj={};
                        //     obj.checked=false;
                        //     obj.sb="";
                        //     obj.index=i+1;
                        //     obj.pc=7;
                        //     obj.yxmc="";
                        //     obj.yxmcs=[];
                        //     obj.zyzs=[];
                        //     obj.zys=[];
                        //     obj.zyz="";
                        //     obj.zy1="";
                        //     obj.zy2="";
                        //     obj.zy3="";
                        //     obj.zy4="";
                        //     obj.zy5="";
                        //     obj.zy6="";
                        //     obj.sffc="1";
                        //     obj.sffcs=[
                        //         {name:"服从",value:"1"},
                        //         {name:"不服从",value:"0"}
                        //     ];
                        //     this.zkYxPlan.push(obj);
                        // };
                    }else{
                        const nullArr=[];
                        const nullLen=30-data.length;
                        for(let i=0;i<nullLen;i++){
                                const obj={};
                                obj.checked=false;
                                obj.radioChecked=false;
                                obj.sb="";
                                obj.index=data.length+i+1;
                                obj.yxmc="";
                                obj.yxmcs=[];
                                obj.zyzs=[];
                                obj.zys=[];
                                obj.pc=9;
                                obj.zyz="";
                                obj.zy1="";
                                obj.zy2="";
                                obj.zy3="";
                                obj.zy4="";
                                obj.zy5="";
                                obj.zy6="";
                                obj.sffc="1";
                                obj.sffcs=[
                                    {name:"服从",value:"1"},
                                    {name:"不服从",value:"0"}
                                ];
                                obj.isSaveTr=false;
                                obj.chooseFlag=false;
                                nullArr.push(obj);
                        }
                        this.zkTqpCollectYx=yxZyzs.concat(nullArr);
                        this.createBkNullData();
                        this.createZkNullData();
                        this.createBkTqpNullData();
                    }
                    this.planObj.plan=res.data.obj.mnzyb.plan;
                    this.planObj.time=res.data.obj.mnzyb.updatetime;
                    this.planObj.id=res.data.obj.mnzyb.id;
                 }else{
                    this.bkCollectYx=[];
                    this.zkCollectYx=[];
                    this.bkTqpCollectYx=[];
                    this.zkTqpCollectYx=[];
                    this.planObj.plan=res.data.obj.mnzyb.plan;
                    this.planObj.time=res.data.obj.mnzyb.updatetime;
                    this.planObj.id=res.data.obj.mnzyb.id;
                 }
            }else if(res.data.obj.bkList&&res.data.obj.zkList&&res.data.obj.bktqpList&&res.data.obj.zktqpList){
                if(res.data.obj.bkList.length>0){
                    const data=[...res.data.obj.bkList];
                    console.log(data);
                    for(let i=0;i<data.length;i++){
                        data[i].index=(i+1); 
                        data[i].checked=false;
                        data[i].radioChecked=false;
                        data[i].sffc='1';
                        data[i].yxmcs=[];
                        data[i].zyzs=[];
                        data[i].zy1=data[i].zydh1?data[i].zydh1:'';
                        data[i].zy2=data[i].zydh2?data[i].zydh2:'';
                        data[i].zy3=data[i].zydh3?data[i].zydh3:'';
                        data[i].zy4=data[i].zydh4?data[i].zydh4:'';
                        data[i].zy5=data[i].zydh5?data[i].zydh5:'';
                        data[i].zy6=data[i].zydh6?data[i].zydh6:'';
                    let flag1=false;
                    for(let j=1;j<=6;j++){
                        if(data[i]['zy'+j]){
                            flag1=true;
                            break;
                        }
                    }
                        console.log(flag1);
                        data[i].chooseFlag=flag1;
                        data[i].isSaveTr=true;
                    }
                    const len=45-data.length;
                    const nullArr=[];
                    for(let i=0;i<len;i++){
                                const obj={};
                                obj.index=data.length+(i+1);
                                obj.xh=data.length+(i+1);
                                obj.checked=false;
                                obj.radioChecked=false;
                                obj.sb="";
                                obj.yxmc="";
                                obj.yxmcs=[];
                                obj.zyzs=[];
                                obj.pc=6;
                                obj.zyz="";
                                obj.zy1="";
                                obj.zy2="";
                                obj.zy3="";
                                obj.zy4="";
                                obj.zy5="";
                                obj.zy6="";
                                obj.sffc="1";
                                obj.sffcs=[
                                    {name:"服从",value:"1"},
                                    {name:"不服从",value:"0"}
                                ];
                                obj.chooseFlag=false;
                                obj.isSaveTr=false;
                                nullArr.push(obj);
                    }
                    this.bkCollectYx=data.concat(nullArr);
                }else{
                    this.createBkNullData();
                }
                 if(res.data.obj.zkList.length>0){
                    const data2=[...res.data.obj.zkList];
                    for(let i=0;i<data2.length;i++){
                        data2[i].index=(i+1);
                        data2[i].checked=false;
                        data2[i].radioChecked=false;
                        data2[i].sffc='1';
                        data2[i].yxmcs=[];
                        data2[i].zyzs=[];
                        data2[i].zy1=data2[i].zydh1?data2[i].zydh1:'';
                        data2[i].zy2=data2[i].zydh2?data2[i].zydh2:'';
                        data2[i].zy3=data2[i].zydh3?data2[i].zydh3:'';
                        data2[i].zy4=data2[i].zydh4?data2[i].zydh4:'';
                        data2[i].zy5=data2[i].zydh5?data2[i].zydh5:'';
                        data2[i].zy6=data2[i].zydh6?data2[i].zydh6:'';
                        let flag2=false;
                        for(let j=1;j<=6;j++){
                            if(data2[i]['zy'+j]){
                                flag2=true;
                                break;
                            }
                        }
                        console.log(flag2);
                        data2[i].chooseFlag=flag2;
                        data2[i].isSaveTr=true;
                    }
                    const len2=30-data2.length;
                    const nullArr2=[];
                    for(let i=0;i<len2;i++){
                        const obj={};
                            obj.index=data2.length+(i+1);
                            obj.checked=false;
                            obj.radioChecked=false;
                            obj.sb="";
                            obj.yxmc="";
                            obj.yxmcs=[];
                            obj.zyzs=[];
                            obj.pc=7;
                            obj.zyz="";
                            obj.zy1="";
                            obj.zy2="";
                            obj.zy3="";
                            obj.zy4="";
                            obj.zy5="";
                            obj.zy6="";
                            obj.sffc="1";
                            obj.sffcs=[
                                {name:"服从",value:"1"},
                                {name:"不服从",value:"0"}
                            ];
                            obj.chooseFlag=false;
                            obj.isSaveTr=false;
                            nullArr2.push(obj);
                    }
                    this.zkCollectYx=data2.concat(nullArr2);
                }else{
                    this.createZkNullData();
                }
                 if(res.data.obj.bktqpList.length>0){
                    const data3=[...res.data.obj.bktqpList];
                    for(let i=0;i<data3.length;i++){
                        data3[i].index=(i+1);
                        data3[i].checked=false;
                        data3[i].radioChecked=false;
                        data3[i].sffc='1';
                        data3[i].zy1=data3[i].zydh1?data3[i].zydh1:'';
                        data3[i].zy2=data3[i].zydh2?data3[i].zydh2:'';
                        data3[i].zy3=data3[i].zydh3?data3[i].zydh3:'';
                        data3[i].zy4=data3[i].zydh4?data3[i].zydh4:'';
                        data3[i].zy5=data3[i].zydh5?data3[i].zydh5:'';
                        data3[i].zy6=data3[i].zydh6?data3[i].zydh6:'';
                        let flag3=false;
                        for(let j=1;j<=6;j++){
                            if(data3[i]['zy'+j]){
                                flag3=true;
                                break;
                            }
                        }
                        console.log(flag3);
                        data3[i].chooseFlag=flag3;
                        data3[i].isSaveTr=true;
                    }
                    const len3=45-data3.length;
                    const nullArr3=[];
                    for(let i=0;i<len3;i++){
                            const obj={};
                            obj.index=data3.length+(i+1);
                            obj.checked=false;
                            obj.radioChecked=false;
                            obj.sb="";
                            obj.yxmc="";
                            obj.yxmcs=[];
                            obj.zyzs=[];
                            obj.pc=0;
                            obj.zyz="";
                            obj.zy1="";
                            obj.zy2="";
                            obj.zy3="";
                            obj.zy4="";
                            obj.zy5="";
                            obj.zy6="";
                            obj.sffc="1";
                            obj.sffcs=[
                                {name:"服从",value:"1"},
                                {name:"不服从",value:"0"}
                            ];
                            obj.chooseFlag=false;
                            obj.isSaveTr=false;
                            nullArr3.push(obj);
                    }
                    this.bkTqpCollectYx=data3.concat(nullArr3);
                }else{
                    this.createBkTqpNullData();
                }
                 if(res.data.obj.zktqpList.length>0){
                    const data4=[...res.data.obj.zktqpList];
                    for(let i=0;i<data4.length;i++){
                        data4[i].index=(i+1);
                        data4[i].checked=false;
                        data4[i].radioChecked=false;
                        data4[i].sffc='1';
                        data4[i].zy1=data4[i].zydh1?data4[i].zydh1:'';
                        data4[i].zy2=data4[i].zydh2?data4[i].zydh2:'';
                        data4[i].zy3=data4[i].zydh3?data4[i].zydh3:'';
                        data4[i].zy4=data4[i].zydh4?data4[i].zydh4:'';
                        data4[i].zy5=data4[i].zydh5?data4[i].zydh5:'';
                        data4[i].zy6=data4[i].zydh6?data4[i].zydh6:'';
                        let flag4=false;
                        for(let j=1;j<=6;j++){
                            if(data4[i]['zy'+j]){
                                flag4=true;
                                break;
                            }
                        }
                        console.log(flag4);
                        data4[i].chooseFlag=flag4;
                        data4[i].isSaveTr=true;
                    }
                    const len4=30-data4.length;
                    const nullArr4=[];
                    for(let i=0;i<len4;i++){
                        const obj={};
                            obj.index=data4.length+(i+1);
                            obj.checked=false;
                            obj.radioChecked=false;
                            obj.sb="";
                            obj.yxmc="";
                            obj.yxmcs=[];
                            obj.zyzs=[];
                            obj.pc=9;
                            obj.zyz="";
                            obj.zy1="";
                            obj.zy2="";
                            obj.zy3="";
                            obj.zy4="";
                            obj.zy5="";
                            obj.zy6="";
                            obj.sffc="1";
                            obj.sffcs=[
                                {name:"服从",value:"1"},
                                {name:"不服从",value:"0"}
                            ];
                            obj.chooseFlag=false;
                            obj.isSaveTr=false;
                            nullArr4.push(obj);
                    }
                    this.zkTqpCollectYx=data4.concat(nullArr4);
                }else{
                    this.createZkTqpNullData();
                }
            }else if(res.data.obj.yxzyzfa){
                const pc=res.data.obj.yxzyzfa.pc;
                this.planObj.plan=res.data.obj.yxzyzfa.plan;
                this.planObj.time=res.data.obj.yxzyzfa.date;
                // this.planObj.id=res.data.obj.yxzyzfa.id;
                if(pc===6||pc==='6'){
                    const bkArr=[...res.data.obj.yxzyzfa.list];
                    for(let i=0;i<bkArr.length;i++){
                        bkArr[i].index=i+1;
                        bkArr[i].checked=false;
                        bkArr[i].radioChecked=false;
                        bkArr[i].sffc='1';
                        bkArr[i].zy1='';
                        bkArr[i].zy2='';
                        bkArr[i].zy3='';
                        bkArr[i].zy4='';
                        bkArr[i].zy5='';
                        bkArr[i].zy6='';
                    }
                    const len=45-bkArr.length;
                    const nullArr=[];
                    for(let i=0;i<len;i++){
                        const obj={};
                        obj.index=bkArr.length+(i+1);
                        obj.checked=false;
                        obj.radioChecked=false;
                        obj.sb="";
                        obj.yxmc="";
                        obj.yxmcs=[];
                        obj.zyzs=[];
                        obj.pc=6;
                        obj.zyz="";
                        obj.zy1="";
                        obj.zy2="";
                        obj.zy3="";
                        obj.zy4="";
                        obj.zy5="";
                        obj.zy6="";
                        obj.sffc="1";
                        obj.sffcs=[
                            {name:"服从",value:"1"},
                            {name:"不服从",value:"0"}
                        ];
                        nullArr.push(obj);
                    }
                    this.bkCollectYx=bkArr.concat(nullArr);
                }else if(pc===7||pc==='7'){
                    const zkArr=[...res.data.obj.yxzyzfa.list];
                    for(let i=0;i<zkArr.length;i++){
                        zkArr[i].index=i+1;
                        zkArr[i].checked=false;
                        zkArr[i].radioChecked=false;
                        zkArr[i].sffc='1';
                        zkArr[i].zy1='';
                        zkArr[i].zy2='';
                        zkArr[i].zy3='';
                        zkArr[i].zy4='';
                        zkArr[i].zy5='';
                        zkArr[i].zy6='';
                    }
                    const len=30-zkArr.length;
                    const nullArr=[];
                    for(let i=0;i<len;i++){
                        const obj={};
                        obj.index=zkArr.length+(i+1);
                        obj.checked=false;
                        obj.radioChecked=false;
                        obj.sb="";
                        obj.yxmc="";
                        obj.yxmcs=[];
                        obj.zyzs=[];
                        obj.pc=7;
                        obj.zyz="";
                        obj.zy1="";
                        obj.zy2="";
                        obj.zy3="";
                        obj.zy4="";
                        obj.zy5="";
                        obj.zy6="";
                        obj.sffc="1";
                        obj.sffcs=[
                            {name:"服从",value:"1"},
                            {name:"不服从",value:"0"}
                        ];
                        nullArr.push(obj);
                    }
                    this.zkCollectYx=zkArr.concat(nullArr);
                }else if(pc===0||pc==='0'){
                    const bkArr=[...res.data.obj.yxzyzfa.list];
                    for(let i=0;i<bkArr.length;i++){
                        bkArr[i].index=i+1;
                        bkArr[i].checked=false;
                        bkArr[i].radioChecked=false;
                        bkArr[i].sffc='1';
                        bkArr[i].zy1='';
                        bkArr[i].zy2='';
                        bkArr[i].zy3='';
                        bkArr[i].zy4='';
                        bkArr[i].zy5='';
                        bkArr[i].zy6='';
                    }
                    const len=45-bkArr.length;
                    const nullArr=[];
                    for(let i=0;i<len;i++){
                        const obj={};
                        obj.index=bkArr.length+(i+1);
                        obj.checked=false;
                        obj.radioChecked=false;
                        obj.sb="";
                        obj.yxmc="";
                        obj.yxmcs=[];
                        obj.zyzs=[];
                        obj.pc=0;
                        obj.zyz="";
                        obj.zy1="";
                        obj.zy2="";
                        obj.zy3="";
                        obj.zy4="";
                        obj.zy5="";
                        obj.zy6="";
                        obj.sffc="1";
                        obj.sffcs=[
                            {name:"服从",value:"1"},
                            {name:"不服从",value:"0"}
                        ];
                        nullArr.push(obj);
                    }
                    this.bkTqpCollectYx=bkArr.concat(nullArr);
                }else{
                    const zkArr=[...res.data.obj.yxzyzfa.list];
                    for(let i=0;i<zkArr.length;i++){
                        zkArr[i].index=i+1;
                        zkArr[i].checked=false;
                        zkArr[i].radioChecked=false;
                        zkArr[i].sffc='1';
                        zkArr[i].zy1='';
                        zkArr[i].zy2='';
                        zkArr[i].zy3='';
                        zkArr[i].zy4='';
                        zkArr[i].zy5='';
                        zkArr[i].zy6='';
                    }
                    const len=30-zkArr.length;
                    const nullArr=[];
                    for(let i=0;i<len;i++){
                        const obj={};
                        obj.index=zkArr.length+(i+1);
                        obj.checked=false;
                        obj.radioChecked=false;
                        obj.sb="";
                        obj.yxmc="";
                        obj.yxmcs=[];
                        obj.zyzs=[];
                        obj.pc=9;
                        obj.zyz="";
                        obj.zy1="";
                        obj.zy2="";
                        obj.zy3="";
                        obj.zy4="";
                        obj.zy5="";
                        obj.zy6="";
                        obj.sffc="1";
                        obj.sffcs=[
                            {name:"服从",value:"1"},
                            {name:"不服从",value:"0"}
                        ];
                        nullArr.push(obj);
                    }
                    this.zkCollectYx=zkArr.concat(nullArr);
                }
            }
        }else if(res.data.code===500){
            if(res.data.message){
                this.$message({message:res.data.message,type:'error'});
            }
        }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.data.code===0){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.data===''){
            this.createBkNullData();
            this.createZkNullData();
            this.createBkTqpNullData();
            this.createZkTqpNullData();
        }
        // loading.close();
        // loading2.close();
        loading.close();
    },
    createBkNullData(){
            const arr=[];
            for(let i=0;i<45;i++){
                    const obj={};
                    obj.index=(i+1);
                    obj.xh=(i+1);
                    obj.checked=false;
                    obj.sb=null;
                    obj.yxmc=null;
                    obj.yxmcs=[];
                    obj.zyz=null;
                    obj.zyzs=[];
                    obj.szdqmc=null;
                    obj.pc=null;
                    obj.sf985=null;
                    obj.sf211=null;
                    obj.radioChecked=false;
                    obj.sffc='1';
                    obj.moveTrVisible=false;
                    obj.chooseZyzVisible=false;
                    obj.inputSbVisible=false;
                    obj.chooseYxxhVisible=false;
                    obj.submitSb='';
                    obj.submitYxmc='';
                    obj.submitZyz='';
                    obj.selectedZyz='';
                    obj.selectedYxxh=''
                    obj.writeSb='';
                    obj.isChangeYxxh=false;
                    obj.isChangeZyz=false;
                    obj.sfjsl=null;
                    obj.type=null;
                    obj.isSaveTr=false;
                    obj.zy1='';
                    obj.zy2='';
                    obj.zy3='';
                    obj.zy4='';
                    obj.zy5='';
                    obj.zy6='';
                    arr.push(obj);
                }
                this.bkCollectYx=arr;
    },
    createZkNullData(){
            const arr=[];
            for(let i=0;i<30;i++){
                    const obj={};
                    obj.index=(i+1);
                    obj.xh=(i+1);
                    obj.checked=false;
                    obj.sb=null;
                    obj.yxmc=null;
                    obj.yxmcs=[];
                    obj.zyz=null;
                    obj.zyzs=[];
                    obj.szdqmc=null;
                    obj.pc=null;
                    obj.sf985=null;
                    obj.sf211=null;
                    obj.radioChecked=false;
                    obj.sffc='1';
                    obj.moveTrVisible=false;
                    obj.chooseZyzVisible=false;
                    obj.inputSbVisible=false;
                    obj.chooseYxxhVisible=false;
                    obj.submitSb='';
                    obj.submitYxmc='';
                    obj.submitZyz='';
                    obj.selectedZyz='';
                    obj.selectedYxxh=''
                    obj.writeSb='';
                    obj.isChangeYxxh=false;
                    obj.isChangeZyz=false;
                    obj.sfjsl=null;
                    obj.type=null;
                    obj.isSaveTr=false;
                    obj.zy1='';
                    obj.zy2='';
                    obj.zy3='';
                    obj.zy4='';
                    obj.zy5='';
                    obj.zy6='';
                    arr.push(obj);
                }
                this.zkCollectYx=arr;
    },
    createBkTqpNullData(){
            const arr=[];
            for(let i=0;i<45;i++){
                    const obj={};
                    obj.index=(i+1);
                    obj.xh=(i+1);
                    obj.checked=false;
                    obj.sb=null;
                    obj.yxmc=null;
                    obj.yxmcs=[];
                    obj.zyz=null;
                    obj.zyzs=[];
                    obj.szdqmc=null;
                    obj.pc=null;
                    obj.sf985=null;
                    obj.sf211=null;
                    obj.radioChecked=false;
                    obj.sffc='1';
                    obj.moveTrVisible=false;
                    obj.chooseZyzVisible=false;
                    obj.inputSbVisible=false;
                    obj.chooseYxxhVisible=false;
                    obj.submitSb='';
                    obj.submitYxmc='';
                    obj.submitZyz='';
                    obj.selectedZyz='';
                    obj.selectedYxxh=''
                    obj.writeSb='';
                    obj.isChangeYxxh=false;
                    obj.isChangeZyz=false;
                    obj.sfjsl=null;
                    obj.type=null;
                    obj.isSaveTr=false;
                    obj.zy1='';
                    obj.zy2='';
                    obj.zy3='';
                    obj.zy4='';
                    obj.zy5='';
                    obj.zy6='';
                    arr.push(obj);
                }
                this.bkTqpCollectYx=arr;
    },
    createZkTqpNullData(){
            const arr=[];
            for(let i=0;i<30;i++){
                    const obj={};
                    obj.index=(i+1);
                    obj.xh=(i+1);
                    obj.checked=false;
                    obj.sb=null;
                    obj.yxmc=null;
                    obj.yxmcs=[];
                    obj.zyz=null;
                    obj.zyzs=[];
                    obj.szdqmc=null;
                    obj.pc=null;
                    obj.sf985=null;
                    obj.sf211=null;
                    obj.radioChecked=false;
                    obj.sffc='1';
                    obj.moveTrVisible=false;
                    obj.chooseZyzVisible=false;
                    obj.inputSbVisible=false;
                    obj.chooseYxxhVisible=false;
                    obj.submitSb='';
                    obj.submitYxmc='';
                    obj.submitZyz='';
                    obj.selectedZyz='';
                    obj.selectedYxxh=''
                    obj.writeSb='';
                    obj.isChangeYxxh=false;
                    obj.isChangeZyz=false;
                    obj.sfjsl=null;
                    obj.type=null;
                    obj.isSaveTr=false;
                    obj.zy1='';
                    obj.zy2='';
                    obj.zy3='';
                    obj.zy4='';
                    obj.zy5='';
                    obj.zy6='';
                    arr.push(obj);
                }
                this.zkTqpCollectYx=arr;
    },
    async mountedCode(){
        const id=this.$route.query.id;
        const pc=this.$route.query.pc;
        const isto=this.$route.query.isto;
        const plan=this.$route.query.plan;
        if(id){
            if(isto){
                // await this.getYhGzYx();
                this.reloadTimer=setInterval(async () => {
                    if(this.reloadGzYx&&this.reloadGzYx==='true'){
                        clearInterval(this.reloadTimer);
                        await this.getYhGzYx();
                        // await this.getLastPlan();
                    }
                }, 1000);
            }else if(plan){
                await this.getYhGzYx();
                // this.activePcName=pc?pc+'':'6';
                // await this.getPlanContent(plan,pc,id);
            }
        }else{
            // await this.getBkGzyx();
            await this.getYhGzYx();
            // await this.getLastPlan();
                const collectInfo=this.collectInfo;
                const collectInfoStr=localStorage.getItem("collectInfo");
                const collectInfo2=collectInfoStr!==null? JSON.parse(collectInfoStr):{};
                const plan=this.planObj.plan;
                const lrzyfaInfo=this.lrzyfaInfo;
                const lrzyfaInfoStr=localStorage.getItem("lrzyfaInfo");
                const lrzyfaInfo2=lrzyfaInfoStr!==null?JSON.parse(lrzyfaInfoStr):{};
                const collectFlag=false;
                if(!plan&&collectFlag){
                    if(lrzyfaInfo.lrzyfaList.length>0){
                        const lrzyfaPc=lrzyfaInfo.pc;
                        const arr=lrzyfaInfo.lrzyfaList;
                        for(let i=0;i<arr.length;i++){
                            arr[i].checked=arr[i].isRed||false;
                            arr[i].index=i+1;
                        }
                        const nullArr=[];
                        if(lrzyfaInfo.lrzyfaList.length<10){
                            const len=lrzyfaInfo.lrzyfaList.length;
                            for(let i=0;i<10-len;i++){
                                    const obj={};
                                    obj.index=len+(i+1);
                                    obj.checked=false;
                                    obj.sb=null;
                                    obj.yxmc=null;
                                    obj.zyz=null;
                                    obj.szdqmc=null;
                                    obj.pc=null;
                                    obj.sf985=null;
                                    obj.sf211=null;
                                    nullArr.push(obj);
                                    if(lrzyfaPc===6||lrzyfaPc==="6"){
                                        this.bkCollectYx=arr.concat(nullArr);
                                    }else{
                                        this.zkCollectYx=arr.concat(nullArr);
                                    }
                            }
                        }else{
                            if(lrzyfaPc===6||lrzyfaPc==="6"){
                                this.bkCollectYx=[...arr];
                            }else{
                                this.zkCollectYx=[...arr];
                            }
                        }
                    }else if(lrzyfaInfo2.value&&lrzyfaInfo2.value.lrzyfaList.length>0){
                        const lrzyfaPc=lrzyfaInfo2.value.pc;
                        const arr=lrzyfaInfo2.value.lrzyfaList;
                        for(let i=0;i<arr.length;i++){
                            arr[i].checked=arr[i].isRed||false;
                            arr[i].index=i+1;
                        }
                        const nullArr=[];
                        if(lrzyfaInfo2.value.lrzyfaList.length<10){
                            const len=lrzyfaInfo2.value.lrzyfaList.length;
                            for(let i=0;i<10-len;i++){
                                    const obj={};
                                    obj.index=len+(i+1);
                                    obj.checked=false;
                                    obj.sb=null;
                                    obj.yxmc=null;
                                    obj.zyz=null;
                                    obj.szdqmc=null;
                                    obj.pc=null;
                                    obj.sf985=null;
                                    obj.sf211=null;
                                    nullArr.push(obj);
                                    if(lrzyfaPc===6||lrzyfaPc==="6"){
                                        this.bkCollectYx=arr.concat(nullArr);
                                    }else{
                                        this.zkCollectYx=arr.concat(nullArr);
                                    }
                            }
                        }else{
                            if(lrzyfaPc===6||lrzyfaPc==="6"){
                                this.bkCollectYx=[...arr];
                            }else{
                                this.zkCollectYx=[...arr];
                            }
                        }
                    }else if(collectInfo.collectSchool.length>0){
                        const collectPc=collectInfo.pc;
                        const arr=collectInfo.collectSchool;
                        let count=0;
                        for(let i=0;i<arr.length;i++){
                            arr[i].checked=arr[i].isRed||false;
                            arr[i].index=i+1;
                            if(arr[i].yxmc){
                                count++;
                            }
                        }
                        const nullArr=[];
                        if(collectInfo.collectSchool.length<10){
                            const len=collectInfo.collectSchool.length;
                            for(let i=0;i<10-len;i++){
                                    const obj={};
                                    obj.index=len+(i+1);
                                    obj.checked=false;
                                    obj.sb=null;
                                    obj.yxmc=null;
                                    obj.zyz=null;
                                    obj.szdqmc=null;
                                    obj.pc=null;
                                    obj.sf985=null;
                                    obj.sf211=null;
                                    nullArr.push(obj);
                                    if(collectPc===6||collectPc==="6"){
                                        this.bkCollectYx=arr.concat(nullArr);
                                    }else{
                                        this.zkCollectYx=arr.concat(nullArr);
                                    }
                            }
                        }else{
                            const arr2=[];
                            for(let i=0;i<count;i++){
                                arr2.push(arr[i]);
                            }
                            if(collectPc===6||collectPc==="6"){
                                this.bkCollectYx=[...arr2];
                            }else{
                                this.zkCollectYx=[...arr2];
                            }
                        }
                    }else if(collectInfo2.value&&collectInfo2.value.collectSchool.length>0){
                        const collectPc=collectInfo2.value.pc;
                        const arr=collectInfo2.value.collectSchool;
                        let count=0;
                        for(let i=0;i<arr.length;i++){
                            arr[i].checked=arr[i].isRed||false;
                            arr[i].index=i+1;
                            if(arr[i].yxmc){
                                count++;
                            }
                        }
                        const nullArr=[];
                        if(collectInfo2.value.collectSchool.length<10){
                            const len=collectInfo2.value.collectSchool.length;
                            for(let i=0;i<10-len;i++){
                                    const obj={};
                                    obj.index=len+(i+1);
                                    obj.checked=false;
                                    obj.sb=null;
                                    obj.yxmc=null;
                                    obj.zyz=null;
                                    obj.szdqmc=null;
                                    obj.pc=null;
                                    obj.sf985=null;
                                    obj.sf211=null;
                                    nullArr.push(obj);
                                    if(collectPc===6||collectPc==="6"){
                                        this.bkCollectYx=arr.concat(nullArr);
                                    }else{
                                        this.zkCollectYx=arr.concat(nullArr);
                                    }
                            }
                        }else{
                            const arr2=[];
                            for(let i=0;i<count;i++){
                                arr2.push(arr[i]);
                            }
                            if(collectPc===6||collectPc==="6"){
                                this.bkCollectYx=[...arr2];
                            }else{
                                this.zkCollectYx=[...arr2];
                            }
                        }
                    }
                }
        }
        const yhlb=this.userInfo.yhlb;
        if(yhlb===4){
            await this.getYfFreeDown();
            await this.getYfFreePg();
        }
    },
    // 志愿评估代码
    async submitZypg(){
        const obj={};
        obj.bz=!this.userInfo.bz?null:this.userInfo.bz;
        obj.createTime="";
        obj.dfzxzg=this.userInfo.dfzxzg;
        obj.flag=0;
        obj.fs=this.userInfo.gkfs;
        obj.fxdj=0;
        obj.ghs=null;
        obj.gjzxzg=this.userInfo.gjzxzg;
        obj.jf=this.userInfo.yfjf;
        obj.kl=this.userInfo.sxkm;
        obj.lx=null;
        const pc=this.activePcName;
        if(pc==='6'){
            const arr=[...this.bkCollectYx];
            // const arr2=[];
            // for(let i=0;i<arr.length;i++){
            //     if(arr[i].zyz){
            //         let strs="";
            //         for(let j=0;j<6;j++){
            //             if(arr[i]["zy"+(j+1)]){
            //                 if(j===5){
            //                     strs+=arr[i]["zy"+(j+1)];
            //                 }else{
            //                     strs+=arr[i]["zy"+(j+1)]+"_";
            //                 }
            //             }
            //         }
            //         const status=arr[i].checked?1:0;
            //         arr2.push(arr[i].sb+"-"+arr[i].yxmc+"-"+
            //         arr[i].yxxh+"-"+pc+"-"+arr[i].zyz+"-"+arr[i].sffc+"-"+strs+"-"+status);
            //     }
            // }
            // obj.param=arr2.join(",");
            const bkList=[];
            for(let i=0;i<arr.length;i++){
                if(arr[i].zyz||arr[i].selectedZyz){
                    let mnzybid=null;
                    if(this.planObj.id){
                        mnzybid=this.planObj.id;
                    }
                    bkList.push({
                        id:null,
                        mnzybid:mnzybid,
                        sb:arr[i].sb||arr[i].writeSb,
                        sffc:arr[i].sffc,
                        xh:(i+1),
                        yxmc:arr[i].yxmc||arr[i].submitYxmc,
                        yxxh:arr[i].yxxh||arr[i].selectedYxxh,
                        zyz:arr[i].zyz||arr[i].selectedZyz,
                        zydh1:arr[i].zy1,
                        zydh2:arr[i].zy2,
                        zydh3:arr[i].zy3,
                        zydh4:arr[i].zy4,
                        zydh5:arr[i].zy5,
                        zydh6:arr[i].zy6
                    });
                }
            }
            obj.list=bkList;
        }else if(pc==='7'){
            const arr=[...this.zkCollectYx];
            // const arr2=[];
            // for(let i=0;i<arr.length;i++){
            //     if(arr[i].zyz){
            //         let strs="";
            //         for(let j=0;j<6;j++){
            //             if(arr[i]["zy"+(j+1)]){
            //                 if(j===5){
            //                     strs+=arr[i]["zy"+(j+1)];
            //                 }else{
            //                     strs+=arr[i]["zy"+(j+1)]+"_";
            //                 }
            //             }
            //         }
            //         const status=arr[i].checked?1:0;
            //         arr2.push(arr[i].sb+"-"+arr[i].yxmc+"-"+
            //         arr[i].yxxh+"-"+pc+"-"+arr[i].zyz+"-"+arr[i].sffc+"-"+strs+"-"+status);
            //     }
            // }
            // obj.param=arr2.join(",");
            const zkList=[];
            for(let i=0;i<arr.length;i++){
                if(arr[i].zyz||arr[i].selectedZyz){
                    let mnzybid=null;
                    if(this.planObj.id){
                        mnzybid=this.planObj.id;
                    }
                    zkList.push({
                        id:null,
                        mnzybid:mnzybid,
                        sb:arr[i].sb||arr[i].writeSb,
                        sffc:arr[i].sffc,
                        xh:(i+1),
                        yxmc:arr[i].yxmc||arr[i].submitYxmc,
                        yxxh:arr[i].yxxh||arr[i].selectedYxxh,
                        zyz:arr[i].zyz||arr[i].selectedZyz,
                        zydh1:arr[i].zy1,
                        zydh2:arr[i].zy2,
                        zydh3:arr[i].zy3,
                        zydh4:arr[i].zy4,
                        zydh5:arr[i].zy5,
                        zydh6:arr[i].zy6
                    });
                }
            }
            obj.list=zkList;
        }else if(pc==='0'){
            this.$message({message:"提前批院校不能评估",type:"warning"});
            return;
            // const arr=[...this.bkTqpYxPlan];
            // const bkList=[];
            // for(let i=0;i<arr.length;i++){
            //     if(arr[i].zyz){
            //         let mnzybid=null;
            //         if(this.planObj.id){
            //             mnzybid=this.planObj.id;
            //         }
            //         bkList.push({
            //             id:null,
            //             mnzybid:mnzybid,
            //             sb:arr[i].sb,
            //             sffc:arr[i].sffc,
            //             xh:(i+1),
            //             yxmc:arr[i].yxmc,
            //             yxxh:arr[i].yxxh,
            //             zydh1:arr[i].zy1,
            //             zydh2:arr[i].zy2,
            //             zydh3:arr[i].zy3,
            //             zydh4:arr[i].zy4,
            //             zydh5:arr[i].zy5,
            //             zydh6:arr[i].zy6,
            //             zyz:arr[i].zyz
            //         });
            //     }
            // }
            // obj.list=bkList;
        }else{
            this.$message({message:"提前批院校不能评估",type:"warning"});
            return;
            // const arr=[...this.zkTqpYxPlan];
            // const zkList=[];
            // for(let i=0;i<arr.length;i++){
            //     if(arr[i].zyz){
            //         let mnzybid=null;
            //         if(this.planObj.id){
            //             mnzybid=this.planObj.id;
            //         }
            //         zkList.push({
            //             id:null,
            //             mnzybid:mnzybid,
            //             sb:arr[i].sb,
            //             sffc:arr[i].sffc,
            //             xh:(i+1),
            //             yxmc:arr[i].yxmc,
            //             yxxh:arr[i].yxxh,
            //             zydh1:arr[i].zy1,
            //             zydh2:arr[i].zy2,
            //             zydh3:arr[i].zy3,
            //             zydh4:arr[i].zy4,
            //             zydh5:arr[i].zy5,
            //             zydh6:arr[i].zy6,
            //             zyz:arr[i].zyz
            //         });
            //     }
            // }
            // obj.list=zkList;
        }
        obj.pc=this.activePcName;
        if(this.planObj.plan){
            obj.plan=this.planObj.plan;
            if(this.planObj.id){
                obj.id=this.planObj.id;
            }else{
                obj.id="";
            }
        }else{
            this.dialogPgPlanZyVisible=true;
            return;
        }
        obj.result=null;
        obj.school=!this.userInfo.school?null:this.userInfo.school;
        obj.shu=!this.userInfo.sxcj?null:this.userInfo.sxcj+"";
        obj.sjhm=this.userInfo.sjhm;
        obj.sssf=this.userInfo.sssf;
        obj.status=0;
        obj.sxkmfs=!this.userInfo.sxkmcj?null:this.userInfo.sxkmcj+"";
        obj.updatetime="";
        obj.user=this.userInfo.xm;
        obj.wai=!this.userInfo.wycj?null:this.userInfo.wycj+"";
        obj.xb=this.userInfo.xb+"";
        obj.yhid=this.userInfo.yhid;
        obj.yu=!this.userInfo.ywcj?null:this.userInfo.ywcj+"";
        obj.zxkma=this.userInfo.zxkma+"";
        obj.zxkmafs=!this.userInfo.zxkmacj?null:this.userInfo.zxkmacj+"";
        obj.zxkmb=this.userInfo.zxkmb+"";
        obj.zxkmbfs=!this.userInfo.zxkmbcj?null:this.userInfo.zxkmbcj+"";
        this.dialogProVisble=true;
        const obj0={};
        obj0.role=99;
        obj0.type='zypg';
        const res0=await this.$http.postHttp('/enumRole/getFlag',obj0);
        if(res0.data.code===200){
            if(res0.data.obj.length>0){
                const flag=res0.data.obj[0].flag;
                if(flag!==1){
                    this.$message({message:'此功能暂不开放',showClose:true});
                    this.dialogProVisble=false;
                    return;
                }
            }
        }
        const res=await this.$http.postHttp("/zypg/zypgSubmit",obj);
        if(res.data.code===200){
            this.dialogProVisble=false;
            this.$message({message:"请到“我的评估报告”查看评估结果",type:"success",showClose:true});
            setTimeout(() => {
                this.$router.push({
                    path:this.$router.currentRoute.fullPath,
                    query:{
                        time:(new Date().getMilliseconds())
                    }
                });
                window.location.reload();
            }, 3000);
        }else if(res.data.code===500){
            if(res.data.message){
                this.$message({message:res.data.message,type:'error'});
            }
        }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.data.code===0){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.status===409||res.status===410||res.status===411){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }
    },
    // 输入评估方案名进行评估
    async runZypg(){
        const obj={};
        obj.bz=!this.userInfo.bz?null:this.userInfo.bz;
        obj.createTime="";
        obj.dfzxzg=this.userInfo.dfzxzg;
        obj.flag=0;
        obj.fs=this.userInfo.gkfs;
        obj.fxdj=0;
        obj.ghs=null;
        obj.gjzxzg=this.userInfo.gjzxzg;
        obj.jf=this.userInfo.yfjf;
        obj.kl=this.userInfo.sxkm;
        obj.lx=null;
        const pc=this.activePcName;
        if(pc==='6'){
            const arr=[...this.bkCollectYx];
            // const arr2=[];
            // for(let i=0;i<arr.length;i++){
            //     if(arr[i].zyz){
            //         let strs="";
            //         for(let j=0;j<6;j++){
            //             if(arr[i]["zy"+(j+1)]){
            //                 if(j===5){
            //                     strs+=arr[i]["zy"+(j+1)];
            //                 }else{
            //                     strs+=arr[i]["zy"+(j+1)]+"_";
            //                 }
            //             }
            //         }
            //         const status=arr[i].checked?1:0;
            //         arr2.push(arr[i].sb+"-"+arr[i].yxmc+"-"+
            //         arr[i].yxxh+"-"+pc+"-"+arr[i].zyz+"-"+arr[i].sffc+"-"+strs+"-"+status);
            //     }
            // }
            // obj.param=arr2.join(",");
            const bkList=[];
            for(let i=0;i<arr.length;i++){
                if(arr[i].zyz||arr[i].selectedZyz){
                    let mnzybid=null;
                    if(this.planObj.id){
                        mnzybid=this.planObj.id;
                    }
                    bkList.push({
                        id:null,
                        mnzybid:mnzybid,
                        sb:arr[i].sb||arr[i].writeSb,
                        sffc:arr[i].sffc,
                        xh:(i+1),
                        yxmc:arr[i].yxmc||arr[i].submitYxmc,
                        yxxh:arr[i].yxxh||arr[i].selectedYxxh,
                        zyz:arr[i].zyz||arr[i].selectedZyz,
                        zydh1:arr[i].zy1,
                        zydh2:arr[i].zy2,
                        zydh3:arr[i].zy3,
                        zydh4:arr[i].zy4,
                        zydh5:arr[i].zy5,
                        zydh6:arr[i].zy6
                    });
                }
            }
            obj.list=bkList;
        }else if(pc==='7'){
            const arr=[...this.zkCollectYx];
            // const arr2=[];
            // for(let i=0;i<arr.length;i++){
            //     if(arr[i].zyz){
            //         let strs="";
            //         for(let j=0;j<6;j++){
            //             if(arr[i]["zy"+(j+1)]){
            //                 if(j===5){
            //                     strs+=arr[i]["zy"+(j+1)];
            //                 }else{
            //                     strs+=arr[i]["zy"+(j+1)]+"_";
            //                 }
            //             }
            //         }
            //         const status=arr[i].checked?1:0;
            //         arr2.push(arr[i].sb+"-"+arr[i].yxmc+"-"+
            //         arr[i].yxxh+"-"+pc+"-"+arr[i].zyz+"-"+arr[i].sffc+"-"+strs+"-"+status);
            //     }
            // }
            // obj.param=arr2.join(",");
            const zkList=[];
            for(let i=0;i<arr.length;i++){
                if(arr[i].zyz||arr[i].selectedZyz){
                    let mnzybid=null;
                    if(this.planObj.id){
                        mnzybid=this.planObj.id;
                    }
                    zkList.push({
                        id:null,
                        mnzybid:mnzybid,
                        sb:arr[i].sb||arr[i].writeSb,
                        sffc:arr[i].sffc,
                        xh:(i+1),
                        yxmc:arr[i].yxmc||arr[i].submitYxmc,
                        yxxh:arr[i].yxxh||arr[i].selectedYxxh,
                        zyz:arr[i].zyz||arr[i].selectedZyz,
                        zydh1:arr[i].zy1,
                        zydh2:arr[i].zy2,
                        zydh3:arr[i].zy3,
                        zydh4:arr[i].zy4,
                        zydh5:arr[i].zy5,
                        zydh6:arr[i].zy6
                    });
                }
            }
            obj.list=zkList;
        }else if(pc==='0'){
            this.$message({message:"提前批院校不能评估",type:"warning"});
            return;
            // const arr=[...this.bkTqpYxPlan];
            // const bkList=[];
            // for(let i=0;i<arr.length;i++){
            //     if(arr[i].zyz){
            //         let mnzybid=null;
            //         if(this.planObj.id){
            //             mnzybid=this.planObj.id;
            //         }
            //         bkList.push({
            //             id:null,
            //             mnzybid:mnzybid,
            //             sb:arr[i].sb,
            //             sffc:arr[i].sffc,
            //             xh:(i+1),
            //             yxmc:arr[i].yxmc,
            //             yxxh:arr[i].yxxh,
            //             zydh1:arr[i].zy1,
            //             zydh2:arr[i].zy2,
            //             zydh3:arr[i].zy3,
            //             zydh4:arr[i].zy4,
            //             zydh5:arr[i].zy5,
            //             zydh6:arr[i].zy6,
            //             zyz:arr[i].zyz
            //         });
            //     }
            // }
            // obj.list=bkList;
        }else{
            this.$message({message:"提前批院校不能评估",type:"warning"});
            return;
            // const arr=[...this.zkTqpYxPlan];
            // const zkList=[];
            // for(let i=0;i<arr.length;i++){
            //     if(arr[i].zyz){
            //         let mnzybid=null;
            //         if(this.planObj.id){
            //             mnzybid=this.planObj.id;
            //         }
            //         zkList.push({
            //             id:null,
            //             mnzybid:mnzybid,
            //             sb:arr[i].sb,
            //             sffc:arr[i].sffc,
            //             xh:(i+1),
            //             yxmc:arr[i].yxmc,
            //             yxxh:arr[i].yxxh,
            //             zydh1:arr[i].zy1,
            //             zydh2:arr[i].zy2,
            //             zydh3:arr[i].zy3,
            //             zydh4:arr[i].zy4,
            //             zydh5:arr[i].zy5,
            //             zydh6:arr[i].zy6,
            //             zyz:arr[i].zyz
            //         });
            //     }
            // }
            // obj.list=zkList;
        }
        obj.pc=this.activePcName;
        if(this.pgPlan===''){
            this.$message({message:'请输入评估的方案名',type:'warning',showClose:true});
            return;
        }else{
            obj.plan=this.pgPlan;
            obj.id=null;
        }
        obj.result=null;
        obj.school=!this.userInfo.school?null:this.userInfo.school;
        obj.shu=!this.userInfo.sxcj?null:this.userInfo.sxcj+"";
        obj.sjhm=this.userInfo.sjhm;
        obj.sssf=this.userInfo.sssf;
        obj.status=0;
        obj.sxkmfs=!this.userInfo.sxkmcj?null:this.userInfo.sxkmcj+"";
        obj.updatetime="";
        obj.user=this.userInfo.xm;
        obj.wai=!this.userInfo.wycj?null:this.userInfo.wycj+"";
        obj.xb=this.userInfo.xb+"";
        obj.yhid=this.userInfo.yhid;
        obj.yu=!this.userInfo.ywcj?null:this.userInfo.ywcj+"";
        obj.zxkma=this.userInfo.zxkma+"";
        obj.zxkmafs=!this.userInfo.zxkmacj?null:this.userInfo.zxkmacj+"";
        obj.zxkmb=this.userInfo.zxkmb+"";
        obj.zxkmbfs=!this.userInfo.zxkmbcj?null:this.userInfo.zxkmbcj+"";
        this.dialogProVisble=true;
        const obj0={};
        obj0.role=99;
        obj0.type='zypg';
        const res0=await this.$http.postHttp('/enumRole/getFlag',obj0);
        if(res0.data.code===200){
            if(res0.data.obj.length>0){
                const flag=res0.data.obj[0].flag;
                if(flag!==1){
                    this.$message({message:'此功能暂不开放',showClose:true});
                    this.dialogProVisble=false;
                    this.dialogPgPlanZyVisible=false;
                    return;
                }
            }
        }
        const res=await this.$http.postHttp("/zypg/zypgSubmit",obj);
        if(res.data.code===200){
            this.dialogProVisble=false;
            this.$message({message:"请到“我的评估报告”查看评估结果",type:"success",showClose:true});
            this.dialogPgPlanZyVisible=false;
            setTimeout(() => {
                this.$router.push({
                    path:this.$router.currentRoute.fullPath,
                    query:{
                        time:(new Date().getMilliseconds())
                    }
                });
                window.location.reload();
            }, 3000);
        }else if(res.data.code===500){
            if(res.data.message){
                this.$message({message:res.data.message,type:'error'});
            }
        }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.data.code===0){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.status===409||res.status===410||res.status===411){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }
    },
    // 评估一次代码
    async zypgOne(){
        const obj0={};
        obj0.role=99;
        obj0.type='zypg';
        const res0=await this.$http.postHttp('/enumRole/getFlag',obj0);
        if(res0.data.code===200){
            if(res0.data.obj.length>0){
                const flag=res0.data.obj[0].flag;
                if(flag!==1){
                    this.$message({message:'此功能暂不开放',showClose:true});
                    this.dialogProVisble=false;
                    this.dialogPgPlanZyVisible=false;
                    return;
                }
            }
        }
        this.yfPg=true;
        // await this.getDdxx();
        await this.getPayDdxx();
        await this.getCpxx(14);
        if(this.yfPay){
            this.dialogBuyVisible=false;
        }else{
            this.dialogBuyVisible=true;
        }
    },
    // 评估n次代码
    async foroverZypg(){
        const obj0={};
        obj0.role=99;
        obj0.type='zypg';
        const res0=await this.$http.postHttp('/enumRole/getFlag',obj0);
        if(res0.data.code===200){
            if(res0.data.obj.length>0){
                const flag=res0.data.obj[0].flag;
                if(flag!==1){
                    this.$message({message:'此功能暂不开放',showClose:true});
                    this.dialogProVisble=false;
                    this.dialogPgPlanZyVisible=false;
                    return;
                }
            }
        }
        this.yfPg=true;
        // await this.getDdxx();
        await this.getPayDdxx();
        await this.getCpxx(15);
        if(this.yfPay){
            this.dialogBuyVisible=false;
        }else{
            this.dialogBuyVisible=true;
        }
    },
    // 查询是否有支付订单
    async getPayDdxx(){
        const res=await this.$http.getHttp("/ddxx/getDdxxByYhid");
        if(res.data.code===200){
            if(res.data.obj===1){
                this.dialogZkMsgVisible=true;
                this.yfPay=true;
            }
        }
    },
    // 志愿评估表单提交
    async payZypg(){
        const obj={};
        obj.code="";
        obj.cpid=this.buyInfo.type;
        obj.ddh="";
        obj.payType=this.buyInfo.payType;
        obj.sf=this.buyInfo.sssf;
        obj.sjhm="";
        obj.sum=this.buyInfo.num;
        obj.codeid="";
        obj.ddje=this.buyInfo.payPrice;
        const res=await this.$http.postHttp("/ddxx/ddSubmit",obj);
        if(res.data.code===200){
            if(this.buyInfo.payType===1){
            // 支付宝支付
            const ddh=res.data.obj.orderId;
            this.$store.commit('initIsUpdateToken');
            const res2=await this.$http.getHttp("/pay/aliPay?ddh="+ddh);
            localStorage.setItem("aipayDdh",ddh);
            const routerData = this.$router.resolve({
            path: "/payGateWay",
            query: { htmlData: res2.data }
          });
        this.dialogBuyVisible=false;
        await this.getDdxx(1);
        window.open(routerData.href,"_blank");
            }else {
          // 2.微信支付
          this.innerTitle = `微信支付-￥${this.buyInfo.payPrice}`;
          this.innerdialogVisible = true;
          this.dialogBuyVisible = false;
          this.wxDdh=res.data.obj.orderId;
          const obj1={};
          obj1.orderId=res.data.obj.orderId;
          obj1.productName=this.buyInfo.cpmc;
          obj1.orderAmount=this.buyInfo.payPrice;
          obj1.sjhm=this.userInfo.sjhm;
          const result = await this.$http.postHttp("/pay/wxPay",obj1);
            if(result.data.code===200){
                // this.wxDdh=result.data.obj.out_trade_no;
                this.$nextTick(()=>{
                    this.$refs.qrCodeDiv.innerHTML = "";
                    const qrcode = new QRCode("qrcode", {
                        width: 132,
                        height: 132,
                        text: result.data.obj.urlCode, // 二维码地址
                        colorDark: "#000",
                        colorLight: "#fff"
                    });
                    console.log(qrcode);
                });
                this.qrcodeTime=60;
                this.intervalQrcodeTime=setInterval(async () => {
                    this.qrcodeTime--;
                    if (this.qrcodeTime === 0) {
                    clearInterval(this.intervalQrcodeTime);
                    this.innerdialogVisible = false;
                    }
                    await this.getDdxx(2);
                    if(this.wxSuccess){
                        this.innerdialogVisible=false;
                        this.qrcodeTime=0;
                        if(this.yfPg){
                            await this.submitZypg();
                        }else{
                            if(this.payMnzybFlag){
                                await this.freeDownExcel();
                            }else{
                                await this.freeDownload();
                            }
                        }
                        this.wxSuccess=false;
                        clearInterval(this.intervalQrcodeTime);
                    }
                }, 1000);
            }
        }
        }else if(res.data.code===500){
            if(res.data.message){
                this.$message({message:res.data.message,type:'error'});
            }
        }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.data.code===0){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.status===409||res.status===410||res.status===411){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }
    },
    // 关闭输入评估方案名弹窗
    closePgPlan(){
        this.dialogPgPlanZyVisible=false;
    },
    // 确定使用折扣
    async confirmZk(){
        this.payFlag=true;
        this.dialogZkMsgVisible=false;
        await this.getCpxx();
        this.dialogBuyVisible=true;
    },
    cancelZk(){
        this.payFlag=false;
        this.dialogBuyVisible=true;
        this.dialogZkMsgVisible=false;
    },
    // 查询用户是否支付了评估n次
    async getYfFreePg(){
        const yhid=this.userInfo.yhid;
        const res=await this.$http.getHttp("/pay/getPayXz?yhid="+yhid+"&&mnzyb=2");
        if(res.data.code===200){
            this.yfFreePg=true;
        }else if(res.data.code===500){
            if(res.data.message){
                if(res.data.message==='不存在永久支付'){
                    return false;
                }else{
                    this.$message({message:res.data.message,type:'error'});
                }
            }
        }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.data.code===0){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }
    },
    changeSffc(sffc,index){
        const pc=this.activePcName;
        if(pc==='6'){
            this.$set(this.bkCollectYx[index-1],"sffc",sffc);
            this.$forceUpdate();
        }else if(pc==='7'){
            this.$set(this.zkCollectYx[index-1],"sffc",sffc);
            this.$forceUpdate();
        }else if(pc==='0'){
            this.$set(this.bkTqpCollectYx[index-1],"sffc",sffc);
            this.$forceUpdate();
        }else{
            this.$set(this.zkTqpCollectYx[index-1],"sffc",sffc);
            this.$forceUpdate();
        }
    },
    addLeftZy(){
        const targetKeys=[];
        this.filterZyData.forEach((item,index)=>{
            const len=this.rightSelectRows.length;
            const rightCheckedArr=[...this.rightSelectRows];
            let haveFlag=false;
            for(let i=0;i<len;i++){
                if(rightCheckedArr[i]===item.key){
                    haveFlag=true;
                    break;
                }
            }
            if(!haveFlag){
                targetKeys.push(item.key);
            }
        });
        console.log(targetKeys);
         if((targetKeys.length<=6)){
            const zyData=[...this.zyData];
            // 选择的专业数量 0 1 2 3 4 5
            let selectZyCount=this.rightShowCount;
            console.log(selectZyCount);
            // 剩余专业数量
            // 
            let remanentCount=6-selectZyCount;
            let addtiveCount=1;
            if(remanentCount<=6){
                for(let i=0;i<zyData.length;i++){
                    if(zyData[i]&&zyData[i].title){
                        zyData[i].xh=0;
                    }
                }
                for(let i=0;i<zyData.length;i++){
                    for(let j=0;j<targetKeys.length;j++){
                        if(zyData[i].key===targetKeys[j]){
                            zyData[i].xh=j+1;
                        }
                    }
                }
            }
            this.selectedZys = targetKeys;
            this.rightSelectRows=[];
            this.filterZyData=this.filterZyData.filter(item=>{
                return item.xh>0;
            });
            this.filterZyDataLeft=this.zyData.filter(item=>{
                return item.xh===0;
            });
            return;
        }
    },
    addRightZy(){
        const targetKeys=[...this.selectedZys,...this.leftSelectRows];
        const moveKeys=[...this.leftSelectRows];
        if((targetKeys.length>6)){
            const selectedZys=[...this.selectedZys];
            if(selectedZys.length<6){
                const msgCount=6-selectedZys.length;
                this.$message({message:'还能选择'+msgCount+'个专业',type:'warning',showClose:true});
                const outLen=targetKeys.length;
                const inLen=moveKeys.length;
                const arr=[];
                for(let i=0;i<outLen;i++){
                    let haveFlag=false;
                    for(let j=0;j<inLen;j++){
                        if(targetKeys[i]===moveKeys[j]){
                            haveFlag=true;
                            break;
                        }
                    }
                    if(!haveFlag){
                        arr.push(targetKeys[i]);
                    }
                }
                this.selectedZys=arr;
            }else{
                this.$message({message:'已经选择了6个专业',type:'warning',showClose:true});
                const outLen=targetKeys.length;
                const inLen=moveKeys.length;
                const arr=[];
                for(let i=0;i<outLen;i++){
                    let haveFlag=false;
                    for(let j=0;j<inLen;j++){
                        if(targetKeys[i]===moveKeys[j]){
                            haveFlag=true;
                            break;
                        }
                    }
                    if(!haveFlag){
                        arr.push(targetKeys[i]);
                    }
                }
                this.selectedZys=arr;
            }
            this.leftSelectRows=[];
            const leftTabData=[...this.filterZyDataLeft];
            for(let i=0;i<leftTabData.length;i++){
                if(leftTabData[i].key){
                    leftTabData[i].isDisabled=false;
                }
            }
            this.filterZyDataLeft=leftTabData;
            console.log("13850 selectedZys=",this.selectedZys);
            return;
        }else if((targetKeys.length<=6)){
            console.log(moveKeys);
            const selectedZys=[...this.selectedZys];
            for(let i=0;i<moveKeys.length;i++){
                selectedZys.push(moveKeys[i]);
            }
            const zyData=[...this.zyData];
            // 选择的专业数量 0 1 2 3 4 5
            let selectZyCount=this.rightShowCount;
            console.log(selectZyCount);
            // 剩余专业数量
            // 
            let remanentCount=6-selectZyCount;
            let addtiveCount=1;
            if(remanentCount<=6){
                for(let i=0;i<zyData.length;i++){
                    if(zyData[i]&&zyData[i].title){
                        zyData[i].xh=0;
                    }
                }
                for(let i=0;i<zyData.length;i++){
                    for(let j=0;j<selectedZys.length;j++){
                        if(zyData[i].key===selectedZys[j]){
                            zyData[i].xh=j+1;
                        }
                    }
                }
            }
            this.selectedZys=selectedZys;
            this.filterZyDataLeft=this.zyData.filter(item=>{
                return item.xh===0;
            });
            this.filterZyDataLeft.forEach(item=>{
                if(item){
                    item.isDisabled=false;
                }
            })
            this.filterZyData=this.zyData.filter(item=>{
                return item.xh>0;
            });
            this.filterZyData.sort((a,b)=>{
                return a.xh-b.xh;
            });
            this.leftSelectRows=[];
            console.log(this.filterZyData);
            return;
        }
    },
    openChooseZy(){
        // if(this.$refs.zdyTransferTab.clientHeight<380){
        //     this.rightContentHeight=(380-45-44)+"px";
        // }else{
        //     this.rightContentHeight=(this.$refs.zdyTransferTab.clientHeight-45)+"px";
        // }
        // console.log(this.$refs.zdyTransferTab.clientHeight);
    },
    leftTabCheckboxChange(arr,obj,status){
        this.aRowSelection.selectedRowKeysTab=[obj.key];
    },
    leftTabChange(pagination, filters, sorter, { currentDataSource }){
        console.log(pagination, filters, sorter, { currentDataSource });
    },
    rightTabChange(pagination, filters, sorter, { currentDataSource }){
        console.log(pagination, filters, sorter, { currentDataSource });
    },
    aTabRowClassName(record, index){
        if(record.isDisabled){
            return 'disabled-row';
        }
    },
    cancelTabCell(obj,cellName){
        const pc=this.activePcName;
        if(pc==='6'){
            if(cellName==='sb'){
                const bkYxs=this.bkCollectYx;
                const index=obj.index-1;
                bkYxs[index].inputSbVisible=false;
                this.bkCollectYx=[...bkYxs];
            }else if(cellName==='yxmc'){
                const bkYxs=this.bkCollectYx;
                const index=obj.index-1;
                bkYxs[index].chooseYxxhVisible=false;
                this.bkCollectYx=bkYxs;
                this.bkCollectYx=[...this.bkCollectYx];
                this.$forceUpdate();
            }else if(cellName==='moveTr'){
                const bkYxs=this.bkCollectYx;
                const index=obj.index-1;
                bkYxs[index].moveTrVisible=false;
                this.bkCollectYx=[...bkYxs];
            }else{
                const bkYxs=this.bkCollectYx;
                const index=obj.index-1;
                bkYxs[index].chooseZyzVisible=false;
                this.bkCollectYx=[...bkYxs];
            }
        }else if(pc==='7'){
            if(cellName==='sb'){
                const zkYxs=this.zkCollectYx;
                const index=obj.index-1;
                zkYxs[index].inputSbVisible=false;
                this.zkCollectYx=[...zkYxs];
            }else if(cellName==='yxmc'){
                const zkYxs=this.zkCollectYx;
                const index=obj.index-1;
                zkYxs[index].chooseYxxhVisible=false;
                this.zkCollectYx=[...zkYxs];
            }else if(cellName==='moveTr'){
                const zkYxs=this.zkCollectYx;
                const index=obj.index-1;
                zkYxs[index].moveTrVisible=false;
                this.zkCollectYx=[...zkYxs];
            }else{
                const zkYxs=this.zkCollectYx;
                const index=obj.index-1;
                zkYxs[index].chooseZyzVisible=false;
                this.zkCollectYx=[...zkYxs];
            }
        }else if(pc==='0'){
            if(cellName==='sb'){
                const bkYxs=this.bkTqpCollectYx;
                const index=obj.index-1;
                bkYxs[index].inputSbVisible=false;
                this.bkTqpCollectYx=[...bkYxs];
            }else if(cellName==='yxmc'){
                const bkYxs=this.bkTqpCollectYx;
                const index=obj.index-1;
                bkYxs[index].chooseYxxhVisible=false;
                this.bkTqpCollectYx=[...bkYxs];
            }else if(cellName==='moveTr'){
                const bkYxs=this.bkTqpCollectYx;
                const index=obj.index-1;
                bkYxs[index].moveTrVisible=false;
                this.bkTqpCollectYx=[...bkYxs];
            }else{
                const bkYxs=this.bkTqpCollectYx;
                const index=obj.index-1;
                bkYxs[index].chooseZyzVisible=false;
                this.bkTqpCollectYx=[...bkYxs];
            }
        }else{
            if(cellName==='sb'){
                const zkYxs=this.zkTqpCollectYx;
                const index=obj.index-1;
                zkYxs[index].inputSbVisible=false;
                this.zkTqpCollectYx=[...zkYxs];
            }else if(cellName==='yxmc'){
                const zkYxs=this.zkTqpCollectYx;
                const index=obj.index-1;
                zkYxs[index].chooseYxxhVisible=false;
                this.zkTqpCollectYx=[...zkYxs];
            }else if(cellName==='moveTr'){
                const zkYxs=this.zkTqpCollectYx;
                const index=obj.index-1;
                zkYxs[index].moveTrVisible=false;
                this.zkTqpCollectYx=[...zkYxs];
            }else{
                const zkYxs=this.zkTqpCollectYx;
                const index=obj.index-1;
                zkYxs[index].chooseZyzVisible=false;
                this.zkTqpCollectYx=[...zkYxs];
            }
        }
    },
    openPopover(){},
    closePopover(){},
    hidePopover(e){
    },
    changeMoveToTr(e){
        const reg=/\d/;
        const whereTr=this.moveToTr;
        if(!reg.test(whereTr)){
            this.moveToTr='';
        }
    },
    // 全选方案
    allDialogChecked(){
        const planList=[...this.yxzyzList];
         if(planList.length>0){
            for(let i=0;i<planList.length;i++){
                planList[i].checked=true;
            }
            this.yxzyzList=planList;
        }
    },
    // 取消全选方案
    allDialogNoChecked(){
        const planList=[...this.yxzyzList];
         if(planList.length>0){
            for(let i=0;i<planList.length;i++){
                planList[i].checked=false;
            }
            this.yxzyzList=planList;
        }
    },
    // 删除选中方案
    async deleteDialogChecked(){
        const isDelete=await this.$confirm('您确定要删除吗?','信息',{
            type:'warning'
        }).catch(()=>{
            return "您取消了操作";
        });
        if(isDelete==='confirm'){
        const idList=[];
        const planList=[...this.yxzyzList];
        if(planList.length>0){
            for(let i=0;i<planList.length;i++){
                if(planList[i].checked){
                    idList.push(planList[i].id);
                }
            }
        }
        if(idList.length===0){
            this.$message({
                message:'请选择您要删除的方案',
                type:'warning',
                showClose:true
            });
            return;
        }
        const res=await this.$http.postHttp('/mnzy/delMnzys',idList);
        if(res.data.code===200){
            if(res.data.message){
                this.$message({
                    message:res.data.message,
                    type:'success',
                    showClose:true
                });
            }else{
                this.$message({
                    message:'操作成功',
                    type:'success',
                    showClose:true
                });
            }
            // this.planList=[];
            await this.getZyfaList();
        }else if(res.data.code===500){
            if(res.data.message){
                this.$message({message:res.data.message,type:'error'});
            }
        }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.data.code===0){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }
        }else{
            this.$message({
                message:isDelete,
                type:'warning',
                showClose:true
            });
        }
    },
    // 方案多选框改变事件
    planCheckChange(){
        this.$forceUpdate();
    },
    // 删除院校专业组方案
    async deleteYxzyz(id){
        const res=await this.$http.getHttp("/yhgzfa/delFaById?id="+id);
        if(res.data.code===200){
            if(res.data.message){
                this.$message({message:res.data.message,type:'success',showClose:true});
            }else{
                this.$message({message:"操作成功",type:'success',showClose:true});
            }
            await this.getMyYxzyz();
        }else if(res.data.code===500){
            if(res.data.message){
                this.$message({message:res.data.message,type:'error'});
            }
        }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.data.code===0){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.status===409||res.status===410||res.status===411){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:"warning"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }
    }
},
created() {
    this.totalCount = this.fileList.length
},
async mounted(){
const id=this.$route.query.id;
const pc=this.$route.query.pc;
const isto=this.$route.query.isto;
const plan=this.$route.query.plan;
if(id){
    if(isto){
        // await this.getYhGzYx();
        this.reloadTimer=setInterval(async () => {
            if(this.reloadGzYx&&this.reloadGzYx==='true'){
                clearInterval(this.reloadTimer);
                await this.getYhGzYx();
                // await this.getLastPlan();
            }
        }, 1000);
    }else if(plan){
        this.activePcName=pc?pc+'':'6';
        await this.getPlanContent(plan,pc,id);
    }
}else{
    // await this.getBkGzyx();
    await this.getYhGzYx();
    // await this.getLastPlan();
        // const collectInfo=this.collectInfo;
        // const collectInfoStr=localStorage.getItem("collectInfo");
        // const collectInfo2=collectInfoStr!==null? JSON.parse(collectInfoStr):{};
        // const plan=this.planObj.plan;
        // const lrzyfaInfo=this.lrzyfaInfo;
        // const lrzyfaInfoStr=localStorage.getItem("lrzyfaInfo");
        // const lrzyfaInfo2=lrzyfaInfoStr!==null?JSON.parse(lrzyfaInfoStr):{};
        // const collectFlag=false;
        // if(!plan&&collectFlag){
        //     if(lrzyfaInfo.lrzyfaList.length>0){
        //         const lrzyfaPc=lrzyfaInfo.pc;
        //         const arr=lrzyfaInfo.lrzyfaList;
        //         for(let i=0;i<arr.length;i++){
        //             arr[i].checked=arr[i].isRed||false;
        //             arr[i].index=i+1;
        //         }
        //         const nullArr=[];
        //         if(lrzyfaInfo.lrzyfaList.length<10){
        //             const len=lrzyfaInfo.lrzyfaList.length;
        //             for(let i=0;i<10-len;i++){
        //                     const obj={};
        //                     obj.index=len+(i+1);
        //                     obj.checked=false;
        //                     obj.sb=null;
        //                     obj.yxmc=null;
        //                     obj.zyz=null;
        //                     obj.szdqmc=null;
        //                     obj.pc=null;
        //                     obj.sf985=null;
        //                     obj.sf211=null;
        //                     nullArr.push(obj);
        //                     if(lrzyfaPc===6||lrzyfaPc==="6"){
        //                         this.bkCollectYx=arr.concat(nullArr);
        //                     }else{
        //                         this.zkCollectYx=arr.concat(nullArr);
        //                     }
        //             }
        //         }else{
        //             if(lrzyfaPc===6||lrzyfaPc==="6"){
        //                 this.bkCollectYx=[...arr];
        //             }else{
        //                 this.zkCollectYx=[...arr];
        //             }
        //         }
        //     }else if(lrzyfaInfo2.value&&lrzyfaInfo2.value.lrzyfaList.length>0){
        //         const lrzyfaPc=lrzyfaInfo2.value.pc;
        //         const arr=lrzyfaInfo2.value.lrzyfaList;
        //         for(let i=0;i<arr.length;i++){
        //             arr[i].checked=arr[i].isRed||false;
        //             arr[i].index=i+1;
        //         }
        //         const nullArr=[];
        //         if(lrzyfaInfo2.value.lrzyfaList.length<10){
        //             const len=lrzyfaInfo2.value.lrzyfaList.length;
        //             for(let i=0;i<10-len;i++){
        //                     const obj={};
        //                     obj.index=len+(i+1);
        //                     obj.checked=false;
        //                     obj.sb=null;
        //                     obj.yxmc=null;
        //                     obj.zyz=null;
        //                     obj.szdqmc=null;
        //                     obj.pc=null;
        //                     obj.sf985=null;
        //                     obj.sf211=null;
        //                     nullArr.push(obj);
        //                     if(lrzyfaPc===6||lrzyfaPc==="6"){
        //                         this.bkCollectYx=arr.concat(nullArr);
        //                     }else{
        //                         this.zkCollectYx=arr.concat(nullArr);
        //                     }
        //             }
        //         }else{
        //             if(lrzyfaPc===6||lrzyfaPc==="6"){
        //                 this.bkCollectYx=[...arr];
        //             }else{
        //                 this.zkCollectYx=[...arr];
        //             }
        //         }
        //     }else if(collectInfo.collectSchool.length>0){
        //         const collectPc=collectInfo.pc;
        //         const arr=collectInfo.collectSchool;
        //         let count=0;
        //         for(let i=0;i<arr.length;i++){
        //             arr[i].checked=arr[i].isRed||false;
        //             arr[i].index=i+1;
        //             if(arr[i].yxmc){
        //                 count++;
        //             }
        //         }
        //         const nullArr=[];
        //         if(collectInfo.collectSchool.length<10){
        //             const len=collectInfo.collectSchool.length;
        //             for(let i=0;i<10-len;i++){
        //                     const obj={};
        //                     obj.index=len+(i+1);
        //                     obj.checked=false;
        //                     obj.sb=null;
        //                     obj.yxmc=null;
        //                     obj.zyz=null;
        //                     obj.szdqmc=null;
        //                     obj.pc=null;
        //                     obj.sf985=null;
        //                     obj.sf211=null;
        //                     nullArr.push(obj);
        //                     if(collectPc===6||collectPc==="6"){
        //                         this.bkCollectYx=arr.concat(nullArr);
        //                     }else{
        //                         this.zkCollectYx=arr.concat(nullArr);
        //                     }
        //             }
        //         }else{
        //             const arr2=[];
        //             for(let i=0;i<count;i++){
        //                 arr2.push(arr[i]);
        //             }
        //             if(collectPc===6||collectPc==="6"){
        //                 this.bkCollectYx=[...arr2];
        //             }else{
        //                 this.zkCollectYx=[...arr2];
        //             }
        //         }
        //     }else if(collectInfo2.value&&collectInfo2.value.collectSchool.length>0){
        //         const collectPc=collectInfo2.value.pc;
        //         const arr=collectInfo2.value.collectSchool;
        //         let count=0;
        //         for(let i=0;i<arr.length;i++){
        //             arr[i].checked=arr[i].isRed||false;
        //             arr[i].index=i+1;
        //             if(arr[i].yxmc){
        //                 count++;
        //             }
        //         }
        //         const nullArr=[];
        //         if(collectInfo2.value.collectSchool.length<10){
        //             const len=collectInfo2.value.collectSchool.length;
        //             for(let i=0;i<10-len;i++){
        //                     const obj={};
        //                     obj.index=len+(i+1);
        //                     obj.checked=false;
        //                     obj.sb=null;
        //                     obj.yxmc=null;
        //                     obj.zyz=null;
        //                     obj.szdqmc=null;
        //                     obj.pc=null;
        //                     obj.sf985=null;
        //                     obj.sf211=null;
        //                     nullArr.push(obj);
        //                     if(collectPc===6||collectPc==="6"){
        //                         this.bkCollectYx=arr.concat(nullArr);
        //                     }else{
        //                         this.zkCollectYx=arr.concat(nullArr);
        //                     }
        //             }
        //         }else{
        //             const arr2=[];
        //             for(let i=0;i<count;i++){
        //                 arr2.push(arr[i]);
        //             }
        //             if(collectPc===6||collectPc==="6"){
        //                 this.bkCollectYx=[...arr2];
        //             }else{
        //                 this.zkCollectYx=[...arr2];
        //             }
        //         }
        //     }
        // }
}
if(apiFlag===1||apiFlag===3){
this.fileList.forEach((item)=>{
    item.url='/api'+item.url
});
}
console.log(this.fileList);
const yhlb=this.userInfo.yhlb;
if(yhlb===4){
    await this.getYfFreeDown();
    await this.getYfFreePg();
}
this.inputObj.xm=!this.userInfo.xm?"":this.userInfo.xm;
this.inputObj.school=!this.userInfo.xxmc?"":this.userInfo.xxmc;
this.inputObj.bz=!this.userInfo.bz?"":this.userInfo.bz;
},
computed:{
    ...mapState(["userInfo","collectInfo","lrzyfaInfo"]),
        aRowSelection(){
            return {
                type:"checkbox",
                selectedRowKeys:this.leftSelectRows,
                getCheckboxProps:record=>({
                    props:{
                        checked:record.isChecked,
                        disabled:record.isDisabled,
                        key:record.key
                    }
                }),
                onChange: (selectedRowKeys, selectedRows) => {
                    this.leftSelectRows=selectedRowKeys;
                    console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
                },
                onSelect: (record, selected, selectedRows) => {
                    if(selectedRows.length>0){
                        this.$message({
                            message:"已经选中了"+selectedRows.length+"个专业",
                            type:'success',
                            showClose:true
                        });
                    }
                    if(selectedRows.length===6){
                        this.filterZyDataLeft.forEach(item=>{
                            const leftSelected=this.leftSelectRows;
                            for(let i=0;i<leftSelected.length;i++){
                                console.log(item,leftSelected[i]);
                                if(item.key===leftSelected[i]){
                                    item.isDisabled=false;
                                    item.isChecked=true;
                                }else if(item.key!==leftSelected[i]&&item.isChecked===true){
                                    let flag=false;
                                    for(let j=0;j<selectedRows.length;j++){
                                        if(selectedRows[j].key===item.key){
                                            flag=true;
                                            break;
                                        }
                                    }
                                    if(flag){
                                        item.isDisabled=false;
                                    }else{
                                        item.isDisabled=true;
                                    }
                                }else{
                                    item.isDisabled=true;
                                }
                            }
                        });
                        this.filterZyDataLeft=[...this.filterZyDataLeft];
                    }else{
                        this.filterZyDataLeft.forEach(item=>{
                            item.isDisabled=false;
                        });
                        this.filterZyDataLeft=[...this.filterZyDataLeft];
                    }
                    console.log(record, selected, selectedRows);
                },
                onSelectAll: (selected, selectedRows, changeRows) => {
                    if(selectedRows.length>0){
                        this.$message({
                            message:"已经选中了"+selectedRows.length+"个专业",
                            type:'success',
                            showClose:true
                        });
                    }else{
                        this.filterZyDataLeft.forEach(item=>{
                            if(item){
                                item.isDisabled=false;
                            }
                        });
                        this.filterZyDataLeft=[...this.filterZyDataLeft];
                    }
                    console.log(selected, selectedRows, changeRows);
                },
            }
        },
        aRowSelection2(){
            return {
                type:"checkbox",
                selectedRowKeys:this.rightSelectRows,
                getCheckboxProps:record=>({
                    props:{
                        checked:record.isChecked,
                        disabled:record.isDisabled,
                        key:record.key
                    }
                }),
                onChange: (selectedRowKeys, selectedRows) => {
                    this.rightSelectRows=selectedRowKeys;
                    console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
                },
                onSelect: (record, selected, selectedRows) => {
                    this.$message({
                        message:"已经选中了"+selectedRows.length+"个专业",
                        type:'success',
                        showClose:true
                    });
                    console.log(record, selected, selectedRows);
                },
                onSelectAll: (selected, selectedRows, changeRows) => {
                    this.$message({
                        message:"已经选中了"+selectedRows.length+"个专业",
                        type:'success',
                        showClose:true
                    });
                    console.log(selected, selectedRows, changeRows);
                },
            }
        },
}
};
</script>
<style lang="less" scoped>
.collect-title{
    width:800px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin:20px auto;
}
.collect-btn{
    width:700px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin:10px auto;
}
.float-btn{
    width:1200px;
    margin:10px auto;
}
.dialog-div{
    margin:10px auto;
    display: flex;
    justify-content: center;
    align-items: center;
}
.weixin-panel{
                width:100%;
                height:300px;
                display:flex;
                justify-content:center;
                align-items:center;
                flex-direction:column;
                .qrcode{
                    width:180px;
                    height:180px;
                    display:flex;
                    justify-content:center;
                    align-items:center;
                    padding:10px;
                    background:url('../../../assets/images/wxcode-bg.png') no-repeat center;
                }
}

.info{
    margin-bottom: 10px;
    margin-top: 8px;
    // padding: 10px;
    border-radius: 5px;
    // border: 1px solid #a9c1d057;
    // background-color: #a9c1d012;
    border: none;
    width: 1130px;
    background-color: white;
    .myinput{
        display: inline-block;
        width: 96px;
        height: 30px;
        line-height: 30px;
        border: 1px solid #D9DDE3;
        border-radius: 3px;
        transition: all 0.3s;
        padding-left: 5px;
        color: #666;
        outline: none;
        box-sizing:content-box;
    }
}

.inputlist{
    display: inline-block;
    line-height: 30px;
    margin-left: 10px;
    margin-bottom: 10px;
    .input-div{
        display: flex;
        justify-content: center;
        align-items: center;
    }
}
            
::v-deep .el-table__body-wrapper::-webkit-scrollbar {
    // width: 20px; /* 纵向滚动条 */
   height: 8px; /* 横向滚动条 必写 */
}
::v-deep .el-table .success-row {
    background: #f0f9eb;
}
::v-deep .el-table .info-row{
    background: #ECF5FF;
}
::v-deep .el-collapse-item__content .radio-row-checked{
    background: #ECF5FF;
}
::v-deep .el-collapse-item__content .checkBox-row-checked{
    background: #f0f9eb !important;
}
::v-deep .el-collapse-item__header .radio-row-checked{
    background: #ECF5FF;
}
::v-deep .el-collapse-item__header .checkBox-row-checked{
    background: #f0f9eb !important;
}
/deep/ .ant-transfer-list{
    border: 1px solid #EBEEF5;
    border-radius: 4px;
    overflow: hidden;
    background: #FFF;
    display: inline-block;
    // vertical-align: top;
    vertical-align: middle;
    // width: 270px;
    width:36% !important;
    // max-height: 100%;
    min-height: 300px;
    box-sizing: border-box;
    position: relative;
}
/deep/ .ant-transfer-operation{
    margin:150px 8px;
    width:8.3%;
}

 div.radio-row-checked{
    background: #ECF5FF;
}
 div.checkBox-row-checked{
    background: #f0f9eb !important;
}
a{
    color: #333;
}
/deep/ .el-table .is-left{
    text-align: left !important;
}
/deep/ .zdy-list .ant-table-wrapper .ant-table-small{
    border: 0;
    border-radius: 0;
}
/deep/ .zdy-list .ant-table-wrapper .disabled-row{
    cursor: not-allowed;
}
</style>
